/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/_assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 44);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(25);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeComponent;
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  scriptExports = scriptExports || {}

  // ES6 modules interop
  var type = typeof scriptExports.default
  if (type === 'object' || type === 'function') {
    scriptExports = scriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AppBase = /** @class */ (function (_super) {
    __extends(AppBase, _super);
    function AppBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AppBase.prototype, "isMobile", {
        get: function () {
            return this.$store.state.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppBase.prototype, "isLoading", {
        get: function () {
            return this.$store.state.isLoading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppBase.prototype, "isAuthenticated", {
        get: function () {
            return this.$store.state.isAuthenticated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppBase.prototype, "user", {
        get: function () {
            return this.$store.state.loggedUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppBase.prototype, "lang", {
        get: function () {
            return this.$store.state.lang;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppBase.prototype, "isPopup", {
        get: function () {
            return this.$route.query.popup;
        },
        enumerable: true,
        configurable: true
    });
    // Utilities
    AppBase.prototype.link = function (name, params) {
        return { name: name, params: params };
    };
    AppBase.prototype.setLoading = function (isLoading) {
        if (isLoading === void 0) { isLoading = true; }
        this.$store.commit('setLoading', isLoading);
    };
    AppBase.prototype.getText = function (texts, key) {
        var lang = this.lang;
        if (lang && texts && texts[lang]) {
            return texts[lang][key];
        }
        return "";
    };
    return AppBase;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (AppBase);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(46).Promise;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = vendor_lib;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__(6);
var prosemirrorTransform = __webpack_require__(7);

var classesById = Object.create(null);

// ::- Superclass for editor selections. Every selection type should
// extend this. Should not be instantiated directly.
var Selection = function Selection($anchor, $head, ranges) {
  // :: [SelectionRange]
  // The ranges covered by the selection.
  this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  // :: ResolvedPos
  // The resolved anchor of the selection (the side that stays in
  // place when the selection is modified).
  this.$anchor = $anchor;
  // :: ResolvedPos
  // The resolved head of the selection (the side that moves when
  // the selection is modified).
  this.$head = $head;
};

var prototypeAccessors = { anchor: {},head: {},from: {},to: {},$from: {},$to: {},empty: {} };

// :: number
// The selection's anchor, as an unresolved position.
prototypeAccessors.anchor.get = function () { return this.$anchor.pos };

// :: number
// The selection's head.
prototypeAccessors.head.get = function () { return this.$head.pos };

// :: number
// The lower bound of the selection's main range.
prototypeAccessors.from.get = function () { return this.$from.pos };

// :: number
// The upper bound of the selection's main range.
prototypeAccessors.to.get = function () { return this.$to.pos };

// :: ResolvedPos
// The resolved lowerbound of the selection's main range.
prototypeAccessors.$from.get = function () {
  return this.ranges[0].$from
};

// :: ResolvedPos
// The resolved upper bound of the selection's main range.
prototypeAccessors.$to.get = function () {
  return this.ranges[0].$to
};

// :: bool
// Indicates whether the selection contains any content.
prototypeAccessors.empty.get = function () {
  var ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++)
    { if (ranges[i].$from.pos != ranges[i].$to.pos) { return false } }
  return true
};

// eq:: (Selection) → bool
// Test whether the selection is the same as another selection.

// map:: (doc: Node, mapping: Mappable) → Selection
// Map this selection through a [mappable](#transform.Mappable) thing. `doc`
// should be the new document to which we are mapping.

// :: () → Slice
// Get the content of this selection as a slice.
Selection.prototype.content = function content () {
  return this.$from.node(0).slice(this.from, this.to, true)
};

// :: (Transaction, ?Slice)
// Replace the selection with a slice or, if no slice is given,
// delete the selection. Will append to the given transaction.
Selection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;

  // Put the new selection at the position after the inserted
  // content. When that ended in an inline node, search backwards,
  // to get the position after that node. If not, search forward.
  var lastNode = content.content.lastChild, lastParent = null;
  for (var i = 0; i < content.openEnd; i++) {
    lastParent = lastNode;
    lastNode = lastNode.lastChild;
  }

  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i$1 = 0; i$1 < ranges.length; i$1++) {
    var ref = ranges[i$1];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? prosemirrorModel.Slice.empty : content);
    if (i$1 == 0)
      { selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1); }
  }
};

// :: (Transaction, Node)
// Replace the selection with the given node, appending the changes
// to the given transaction.
Selection.prototype.replaceWith = function replaceWith (tr, node) {
  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++) {
    var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    var from = mapping.map($from.pos), to = mapping.map($to.pos);
    if (i) {
      tr.deleteRange(from, to);
    } else {
      tr.replaceRangeWith(from, to, node);
      selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
    }
  }
};

// toJSON:: () → Object
// Convert the selection to a JSON representation. When implementing
// this for a custom selection class, make sure to give the object a
// `type` property whose value matches the ID under which you
// [registered](#state.Selection^jsonID) your class.

// :: (ResolvedPos, number, ?bool) → ?Selection
// Find a valid cursor or leaf node selection starting at the given
// position and searching back if `dir` is negative, and forward if
// positive. When `textOnly` is true, only consider cursor
// selections. Will return null when no valid selection position is
// found.
Selection.findFrom = function findFrom ($pos, dir, textOnly) {
  var inner = $pos.parent.inlineContent ? new TextSelection($pos)
      : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
  if (inner) { return inner }

  for (var depth = $pos.depth - 1; depth >= 0; depth--) {
    var found = dir < 0
        ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
        : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
    if (found) { return found }
  }
};

// :: (ResolvedPos, ?number) → Selection
// Find a valid cursor or leaf node selection near the given
// position. Searches forward first by default, but if `bias` is
// negative, it will search backwards first.
Selection.near = function near ($pos, bias) {
    if ( bias === void 0 ) bias = 1;

  return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0))
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the start of
// the given document. Will return an
// [`AllSelection`](#state.AllSelection) if no valid position
// exists.
Selection.atStart = function atStart (doc) {
  return findSelectionIn(doc, doc, 0, 0, 1) || new AllSelection(doc)
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the end of the
// given document.
Selection.atEnd = function atEnd (doc) {
  return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new AllSelection(doc)
};

// :: (Node, Object) → Selection
// Deserialize the JSON representation of a selection. Must be
// implemented for custom classes (as a static class method).
Selection.fromJSON = function fromJSON (doc, json) {
  if (!json || !json.type) { throw new RangeError("Invalid input for Selection.fromJSON") }
  var cls = classesById[json.type];
  if (!cls) { throw new RangeError(("No selection type " + (json.type) + " defined")) }
  return cls.fromJSON(doc, json)
};

// :: (string, constructor<Selection>)
// To be able to deserialize selections from JSON, custom selection
// classes must register themselves with an ID string, so that they
// can be disambiguated. Try to pick something that's unlikely to
// clash with classes from other modules.
Selection.jsonID = function jsonID (id, selectionClass) {
  if (id in classesById) { throw new RangeError("Duplicate use of selection JSON ID " + id) }
  classesById[id] = selectionClass;
  selectionClass.prototype.jsonID = id;
  return selectionClass
};

// :: () → SelectionBookmark
// Get a [bookmark](#state.SelectionBookmark) for this selection,
// which is a value that can be mapped without having access to a
// current document, and later resolved to a real selection for a
// given document again. (This is used mostly by the history to
// track and restore old selections.) The default implementation of
// this method just converts the selection to a text selection and
// returns the bookmark for that.
Selection.prototype.getBookmark = function getBookmark () {
  return TextSelection.between(this.$anchor, this.$head).getBookmark()
};

Object.defineProperties( Selection.prototype, prototypeAccessors );

// :: bool
// Controls whether, when a selection of this type is active in the
// browser, the selected range should be visible to the user. Defaults
// to `true`.
Selection.prototype.visible = true;

// SelectionBookmark:: interface
// A lightweight, document-independent representation of a selection.
// You can define a custom bookmark type for a custom selection class
// to make the history handle it well.
//
//   map:: (mapping: Mapping) → SelectionBookmark
//   Map the bookmark through a set of changes.
//
//   resolve:: (doc: Node) → Selection
//   Resolve the bookmark to a real selection again. This may need to
//   do some error checking and may fall back to a default (usually
//   [`TextSelection.between`](#state.TextSelection^between)) if
//   mapping made the bookmark invalid.

// ::- Represents a selected range in a document.
var SelectionRange = function SelectionRange($from, $to) {
  // :: ResolvedPos
  // The lower bound of the range.
  this.$from = $from;
  // :: ResolvedPos
  // The upper bound of the range.
  this.$to = $to;
};

// ::- A text selection represents a classical editor selection, with
// a head (the moving side) and anchor (immobile side), both of which
// point into textblock nodes. It can be empty (a regular cursor
// position).
var TextSelection = (function (Selection) {
  function TextSelection($anchor, $head) {
    if ( $head === void 0 ) $head = $anchor;

    Selection.call(this, $anchor, $head);
  }

  if ( Selection ) TextSelection.__proto__ = Selection;
  TextSelection.prototype = Object.create( Selection && Selection.prototype );
  TextSelection.prototype.constructor = TextSelection;

  var prototypeAccessors$1 = { $cursor: {} };

  // :: ?ResolvedPos
  // Returns a resolved position if this is a cursor selection (an
  // empty text selection), and null otherwise.
  prototypeAccessors$1.$cursor.get = function () { return this.$anchor.pos == this.$head.pos ? this.$head : null };

  TextSelection.prototype.map = function map (doc, mapping) {
    var $head = doc.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent) { return Selection.near($head) }
    var $anchor = doc.resolve(mapping.map(this.anchor));
    return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head)
  };

  TextSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;

    Selection.prototype.replace.call(this, tr, content);
    if (content == prosemirrorModel.Slice.empty) {
      var marks = this.$from.marksAcross(this.$to);
      if (marks) { tr.ensureMarks(marks); }
    }
  };

  TextSelection.prototype.eq = function eq (other) {
    return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head
  };

  TextSelection.prototype.getBookmark = function getBookmark () {
    return new TextBookmark(this.anchor, this.head)
  };

  TextSelection.prototype.toJSON = function toJSON () {
    return {type: "text", anchor: this.anchor, head: this.head}
  };

  TextSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number")
      { throw new RangeError("Invalid input for TextSelection.fromJSON") }
    return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → TextSelection
  // Create a text selection from non-resolved positions.
  TextSelection.create = function create (doc, anchor, head) {
    if ( head === void 0 ) head = anchor;

    var $anchor = doc.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc.resolve(head))
  };

  // :: (ResolvedPos, ResolvedPos, ?number) → Selection
  // Return a text selection that spans the given positions or, if
  // they aren't text positions, find a text selection near them.
  // `bias` determines whether the method searches forward (default)
  // or backwards (negative number) first. Will fall back to calling
  // [`Selection.near`](#state.Selection^near) when the document
  // doesn't contain a valid text position.
  TextSelection.between = function between ($anchor, $head, bias) {
    var dPos = $anchor.pos - $head.pos;
    if (!bias || dPos) { bias = dPos >= 0 ? 1 : -1; }
    if (!$head.parent.inlineContent) {
      var found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
      if (found) { $head = found.$head; }
      else { return Selection.near($head, bias) }
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
        if (($anchor.pos < $head.pos) != (dPos < 0)) { $anchor = $head; }
      }
    }
    return new TextSelection($anchor, $head)
  };

  Object.defineProperties( TextSelection.prototype, prototypeAccessors$1 );

  return TextSelection;
}(Selection));

Selection.jsonID("text", TextSelection);

var TextBookmark = function TextBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
TextBookmark.prototype.map = function map (mapping) {
  return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
TextBookmark.prototype.resolve = function resolve (doc) {
  return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head))
};

// ::- A node selection is a selection that points at a single node.
// All nodes marked [selectable](#model.NodeSpec.selectable) can be
// the target of a node selection. In such a selection, `from` and
// `to` point directly before and after the selected node, `anchor`
// equals `from`, and `head` equals `to`..
var NodeSelection = (function (Selection) {
  function NodeSelection($pos) {
    var node = $pos.nodeAfter;
    var $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
    Selection.call(this, $pos, $end);
    // :: Node The selected node.
    this.node = node;
  }

  if ( Selection ) NodeSelection.__proto__ = Selection;
  NodeSelection.prototype = Object.create( Selection && Selection.prototype );
  NodeSelection.prototype.constructor = NodeSelection;

  NodeSelection.prototype.map = function map (doc, mapping) {
    var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
    var $pos = doc.resolve(pos);
    if (deleted) { return Selection.near($pos) }
    return new NodeSelection($pos)
  };

  NodeSelection.prototype.content = function content () {
    return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(this.node), 0, 0)
  };

  NodeSelection.prototype.eq = function eq (other) {
    return other instanceof NodeSelection && other.anchor == this.anchor
  };

  NodeSelection.prototype.toJSON = function toJSON () {
    return {type: "node", anchor: this.anchor}
  };

  NodeSelection.prototype.getBookmark = function getBookmark () { return new NodeBookmark(this.anchor) };

  NodeSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number")
      { throw new RangeError("Invalid input for NodeSelection.fromJSON") }
    return new NodeSelection(doc.resolve(json.anchor))
  };

  // :: (Node, number) → NodeSelection
  // Create a node selection from non-resolved positions.
  NodeSelection.create = function create (doc, from) {
    return new this(doc.resolve(from))
  };

  // :: (Node) → bool
  // Determines whether the given node may be selected as a node
  // selection.
  NodeSelection.isSelectable = function isSelectable (node) {
    return !node.isText && node.type.spec.selectable !== false
  };

  return NodeSelection;
}(Selection));

NodeSelection.prototype.visible = false;

Selection.jsonID("node", NodeSelection);

var NodeBookmark = function NodeBookmark(anchor) {
  this.anchor = anchor;
};
NodeBookmark.prototype.map = function map (mapping) {
  var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
  return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos)
};
NodeBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
  if (node && NodeSelection.isSelectable(node)) { return new NodeSelection($pos) }
  return Selection.near($pos)
};

// ::- A selection type that represents selecting the whole document
// (which can not necessarily be expressed with a text selection, when
// there are for example leaf block nodes at the start or end of the
// document).
var AllSelection = (function (Selection) {
  function AllSelection(doc) {
    Selection.call(this, doc.resolve(0), doc.resolve(doc.content.size));
  }

  if ( Selection ) AllSelection.__proto__ = Selection;
  AllSelection.prototype = Object.create( Selection && Selection.prototype );
  AllSelection.prototype.constructor = AllSelection;

  AllSelection.prototype.toJSON = function toJSON () { return {type: "all"} };

  AllSelection.fromJSON = function fromJSON (doc) { return new AllSelection(doc) };

  AllSelection.prototype.map = function map (doc) { return new AllSelection(doc) };

  AllSelection.prototype.eq = function eq (other) { return other instanceof AllSelection };

  AllSelection.prototype.getBookmark = function getBookmark () { return AllBookmark };

  return AllSelection;
}(Selection));

Selection.jsonID("all", AllSelection);

var AllBookmark = {
  map: function map() { return this },
  resolve: function resolve(doc) { return new AllSelection(doc) }
};

// FIXME we'll need some awareness of text direction when scanning for selections

// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function findSelectionIn(doc, node, pos, index, dir, text) {
  if (node.inlineContent) { return TextSelection.create(doc, pos) }
  for (var i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
    var child = node.child(i);
    if (!child.isAtom) {
      var inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
      if (inner) { return inner }
    } else if (!text && NodeSelection.isSelectable(child)) {
      return NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0))
    }
    pos += child.nodeSize * dir;
  }
}

function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;
  if (last < startLen) { return }
  var step = tr.steps[last];
  if (!(step instanceof prosemirrorTransform.ReplaceStep || step instanceof prosemirrorTransform.ReplaceAroundStep)) { return }
  var map = tr.mapping.maps[last], end;
  map.forEach(function (_from, _to, _newFrom, newTo) { if (end == null) { end = newTo; } });
  tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

var UPDATED_SEL = 1;
var UPDATED_MARKS = 2;
var UPDATED_SCROLL = 4;

// ::- An editor state transaction, which can be applied to a state to
// create an updated state. Use
// [`EditorState.tr`](#state.EditorState.tr) to create an instance.
//
// Transactions track changes to the document (they are a subclass of
// [`Transform`](#transform.Transform)), but also other state changes,
// like selection updates and adjustments of the set of [stored
// marks](#state.EditorState.storedMarks). In addition, you can store
// metadata properties in a transaction, which are extra pieces of
// information that client code or plugins can use to describe what a
// transacion represents, so that they can update their [own
// state](#state.StateField) accordingly.
//
// The [editor view](#view.EditorView) uses a few metadata properties:
// it will attach a property `"pointer"` with the value `true` to
// selection transactions directly caused by mouse or touch input, and
// a `"uiEvent"` property of that may be `"paste"`, `"cut"`, or `"drop"`.
var Transaction = (function (Transform$$1) {
  function Transaction(state) {
    Transform$$1.call(this, state.doc);
    // :: number
    // The timestamp associated with this transaction, in the same
    // format as `Date.now()`.
    this.time = Date.now();
    this.curSelection = state.selection;
    // The step count for which the current selection is valid.
    this.curSelectionFor = 0;
    // :: ?[Mark]
    // The stored marks set by this transaction, if any.
    this.storedMarks = state.storedMarks;
    // Bitfield to track which aspects of the state were updated by
    // this transaction.
    this.updated = 0;
    // Object used to store metadata properties for the transaction.
    this.meta = Object.create(null);
  }

  if ( Transform$$1 ) Transaction.__proto__ = Transform$$1;
  Transaction.prototype = Object.create( Transform$$1 && Transform$$1.prototype );
  Transaction.prototype.constructor = Transaction;

  var prototypeAccessors = { selection: {},selectionSet: {},storedMarksSet: {},isGeneric: {},scrolledIntoView: {} };

  // :: Selection
  // The transaction's current selection. This defaults to the editor
  // selection [mapped](#state.Selection.map) through the steps in the
  // transaction, but can be overwritten with
  // [`setSelection`](#state.Transaction.setSelection).
  prototypeAccessors.selection.get = function () {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection
  };

  // :: (Selection) → Transaction
  // Update the transaction's current selection. Will determine the
  // selection that the editor gets when the transaction is applied.
  Transaction.prototype.setSelection = function setSelection (selection) {
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
    this.storedMarks = null;
    return this
  };

  // :: bool
  // Whether the selection was explicitly updated by this transaction.
  prototypeAccessors.selectionSet.get = function () {
    return (this.updated & UPDATED_SEL) > 0
  };

  // :: (?[Mark]) → Transaction
  // Set the current stored marks.
  Transaction.prototype.setStoredMarks = function setStoredMarks (marks) {
    this.storedMarks = marks;
    this.updated |= UPDATED_MARKS;
    return this
  };

  // :: ([Mark]) → Transaction
  // Make sure the current stored marks or, if that is null, the marks
  // at the selection, match the given set of marks. Does nothing if
  // this is already the case.
  Transaction.prototype.ensureMarks = function ensureMarks (marks) {
    if (!prosemirrorModel.Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
      { this.setStoredMarks(marks); }
    return this
  };

  // :: (Mark) → Transaction
  // Add a mark to the set of stored marks.
  Transaction.prototype.addStoredMark = function addStoredMark (mark) {
    return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: (union<Mark, MarkType>) → Transaction
  // Remove a mark or mark type from the set of stored marks.
  Transaction.prototype.removeStoredMark = function removeStoredMark (mark) {
    return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: bool
  // Whether the stored marks were explicitly set for this transaction.
  prototypeAccessors.storedMarksSet.get = function () {
    return (this.updated & UPDATED_MARKS) > 0
  };

  Transaction.prototype.addStep = function addStep (step, doc) {
    Transform$$1.prototype.addStep.call(this, step, doc);
    this.updated = this.updated & ~UPDATED_MARKS;
    this.storedMarks = null;
  };

  // :: (number) → Transaction
  // Update the timestamp for the transaction.
  Transaction.prototype.setTime = function setTime (time) {
    this.time = time;
    return this
  };

  // :: (Slice) → Transaction
  // Replace the current selection with the given slice.
  Transaction.prototype.replaceSelection = function replaceSelection (slice) {
    this.selection.replace(this, slice);
    return this
  };

  // :: (Node, ?bool) → Transaction
  // Replace the selection with the given node. When `inheritMarks` is
  // true and the content is inline, it inherits the marks from the
  // place where it is inserted.
  Transaction.prototype.replaceSelectionWith = function replaceSelectionWith (node, inheritMarks) {
    var selection = this.selection;
    if (inheritMarks !== false)
      { node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || prosemirrorModel.Mark.none))); }
    selection.replaceWith(this, node);
    return this
  };

  // :: () → Transaction
  // Delete the selection.
  Transaction.prototype.deleteSelection = function deleteSelection () {
    this.selection.replace(this);
    return this
  };

  // :: (string, from: ?number, to: ?number) → Transaction
  // Replace the given range, or the selection if no range is given,
  // with a text node containing the given string.
  Transaction.prototype.insertText = function insertText (text, from, to) {
    if ( to === void 0 ) to = from;

    var schema = this.doc.type.schema;
    if (from == null) {
      if (!text) { return this.deleteSelection() }
      return this.replaceSelectionWith(schema.text(text), true)
    } else {
      if (!text) { return this.deleteRange(from, to) }
      var marks = this.storedMarks;
      if (!marks) {
        var $from = this.doc.resolve(from);
        marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
      }
      return this.replaceRangeWith(from, to, schema.text(text, marks))
    }
  };

  // :: (union<string, Plugin, PluginKey>, any) → Transaction
  // Store a metadata property in this transaction, keyed either by
  // name or by plugin.
  Transaction.prototype.setMeta = function setMeta (key, value) {
    this.meta[typeof key == "string" ? key : key.key] = value;
    return this
  };

  // :: (union<string, Plugin, PluginKey>) → any
  // Retrieve a metadata property for a given name or plugin.
  Transaction.prototype.getMeta = function getMeta (key) {
    return this.meta[typeof key == "string" ? key : key.key]
  };

  // :: bool
  // Returns true if this transaction doesn't contain any metadata,
  // and can thus safely be extended.
  prototypeAccessors.isGeneric.get = function () {
    var this$1 = this;

    for (var _ in this$1.meta) { return false }
    return true
  };

  // :: () → Transaction
  // Indicate that the editor should scroll the selection into view
  // when updated to the state produced by this transaction.
  Transaction.prototype.scrollIntoView = function scrollIntoView () {
    this.updated |= UPDATED_SCROLL;
    return this
  };

  prototypeAccessors.scrolledIntoView.get = function () {
    return (this.updated & UPDATED_SCROLL) > 0
  };

  Object.defineProperties( Transaction.prototype, prototypeAccessors );

  return Transaction;
}(prosemirrorTransform.Transform));

function bind(f, self) {
  return !self || !f ? f : f.bind(self)
}

var FieldDesc = function FieldDesc(name, desc, self) {
  this.name = name;
  this.init = bind(desc.init, self);
  this.apply = bind(desc.apply, self);
};

var baseFields = [
  new FieldDesc("doc", {
    init: function init(config) { return config.doc || config.schema.topNodeType.createAndFill() },
    apply: function apply(tr) { return tr.doc }
  }),

  new FieldDesc("selection", {
    init: function init(config, instance) { return config.selection || Selection.atStart(instance.doc) },
    apply: function apply(tr) { return tr.selection }
  }),

  new FieldDesc("storedMarks", {
    init: function init(config) { return config.storedMarks || null },
    apply: function apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null }
  }),

  new FieldDesc("scrollToSelection", {
    init: function init() { return 0 },
    apply: function apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev }
  })
];

// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
var Configuration = function Configuration(schema, plugins) {
  var this$1 = this;

  this.schema = schema;
  this.fields = baseFields.concat();
  this.plugins = [];
  this.pluginsByKey = Object.create(null);
  if (plugins) { plugins.forEach(function (plugin) {
    if (this$1.pluginsByKey[plugin.key])
      { throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")") }
    this$1.plugins.push(plugin);
    this$1.pluginsByKey[plugin.key] = plugin;
    if (plugin.spec.state)
      { this$1.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin)); }
  }); }
};

// ::- The state of a ProseMirror editor is represented by an object
// of this type. A state is a persistent data structure—it isn't
// updated, but rather a new state value is computed from an old one
// using the [`apply`](#state.EditorState.apply) method.
//
// A state holds a number of built-in fields, and plugins can
// [define](#state.PluginSpec.state) additional fields.
var EditorState = function EditorState(config) {
  this.config = config;
};

var prototypeAccessors$1 = { schema: {},plugins: {},tr: {} };

// doc:: Node
// The current document.

// selection:: Selection
// The selection.

// storedMarks:: ?[Mark]
// A set of marks to apply to the next input. Will be null when
// no explicit marks have been set.

// :: Schema
// The schema of the state's document.
prototypeAccessors$1.schema.get = function () {
  return this.config.schema
};

// :: [Plugin]
// The plugins that are active in this state.
prototypeAccessors$1.plugins.get = function () {
  return this.config.plugins
};

// :: (Transaction) → EditorState
// Apply the given transaction to produce a new state.
EditorState.prototype.apply = function apply (tr) {
  return this.applyTransaction(tr).state
};

// : (Transaction) → ?Transaction
EditorState.prototype.filterTransaction = function filterTransaction (tr, ignore) {
    var this$1 = this;
    if ( ignore === void 0 ) ignore = -1;

  for (var i = 0; i < this.config.plugins.length; i++) { if (i != ignore) {
    var plugin = this$1.config.plugins[i];
    if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this$1))
      { return false }
  } }
  return true
};

// :: (Transaction) → {state: EditorState, transactions: [Transaction]}
// Verbose variant of [`apply`](#state.EditorState.apply) that
// returns the precise transactions that were applied (which might
// be influenced by the [transaction
// hooks](#state.PluginSpec.filterTransaction) of
// plugins) along with the new state.
EditorState.prototype.applyTransaction = function applyTransaction (tr) {
    var this$1 = this;

  if (!this.filterTransaction(tr)) { return {state: this, transactions: []} }

  var trs = [tr], newState = this.applyInner(tr), seen = null;
  // This loop repeatedly gives plugins a chance to respond to
  // transactions as new transactions are added, making sure to only
  // pass the transactions the plugin did not see before.
  outer: for (;;) {
    var haveNew = false;
    for (var i = 0; i < this.config.plugins.length; i++) {
      var plugin = this$1.config.plugins[i];
      if (plugin.spec.appendTransaction) {
        var n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this$1;
        var tr$1 = n < trs.length &&
            plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
        if (tr$1 && newState.filterTransaction(tr$1, i)) {
          tr$1.setMeta("appendedTransaction", tr$1);
          if (!seen) {
            seen = [];
            for (var j = 0; j < this.config.plugins.length; j++)
              { seen.push(j < i ? {state: newState, n: trs.length} : {state: this$1, n: 0}); }
          }
          trs.push(tr$1);
          newState = newState.applyInner(tr$1);
          haveNew = true;
        }
        if (seen) { seen[i] = {state: newState, n: trs.length}; }
      }
    }
    if (!haveNew) { return {state: newState, transactions: trs} }
  }
};

// : (Transaction) → EditorState
EditorState.prototype.applyInner = function applyInner (tr) {
    var this$1 = this;

  if (!tr.before.eq(this.doc)) { throw new RangeError("Applying a mismatched transaction") }
  var newInstance = new EditorState(this.config), fields = this.config.fields;
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    newInstance[field.name] = field.apply(tr, this$1[field.name], this$1, newInstance);
  }
  for (var i$1 = 0; i$1 < applyListeners.length; i$1++) { applyListeners[i$1](this$1, tr, newInstance); }
  return newInstance
};

// :: Transaction
// Start a [transaction](#state.Transaction) from this state.
prototypeAccessors$1.tr.get = function () { return new Transaction(this) };

// :: (Object) → EditorState
// Create a new state.
//
// config::- Configuration options. Must contain `schema` or `doc` (or both).
//
//    schema:: ?Schema
//    The schema to use.
//
//    doc:: ?Node
//    The starting document.
//
//    selection:: ?Selection
//    A valid selection in the document.
//
//    storedMarks:: ?[Mark]
//    The initial set of [stored marks](#state.EditorState.storedMarks).
//
//    plugins:: ?[Plugin]
//    The plugins that should be active in this state.
EditorState.create = function create (config) {
  var $config = new Configuration(config.schema || config.doc.type.schema, config.plugins);
  var instance = new EditorState($config);
  for (var i = 0; i < $config.fields.length; i++)
    { instance[$config.fields[i].name] = $config.fields[i].init(config, instance); }
  return instance
};

// :: (Object) → EditorState
// Create a new state based on this one, but with an adjusted set of
// active plugins. State fields that exist in both sets of plugins
// are kept unchanged. Those that no longer exist are dropped, and
// those that are new are initialized using their
// [`init`](#state.StateField.init) method, passing in the new
// configuration object..
//
// config::- configuration options
//
//   schema:: ?Schema
//   New schema to use.
//
//   plugins:: ?[Plugin]
//   New set of active plugins.
EditorState.prototype.reconfigure = function reconfigure (config) {
    var this$1 = this;

  var $config = new Configuration(config.schema || this.schema, config.plugins);
  var fields = $config.fields, instance = new EditorState($config);
  for (var i = 0; i < fields.length; i++) {
    var name = fields[i].name;
    instance[name] = this$1.hasOwnProperty(name) ? this$1[name] : fields[i].init(config, instance);
  }
  return instance
};

// :: (?union<Object<Plugin>, string, number>) → Object
// Serialize this state to JSON. If you want to serialize the state
// of plugins, pass an object mapping property names to use in the
// resulting JSON object to plugin objects. The argument may also be
// a string or number, in which case it is ignored, to support the
// way `JSON.stringify` calls `toString` methods.
EditorState.prototype.toJSON = function toJSON (pluginFields) {
    var this$1 = this;

  var result = {doc: this.doc.toJSON(), selection: this.selection.toJSON()};
  if (this.storedMarks) { result.storedMarks = this.storedMarks.map(function (m) { return m.toJSON(); }); }
  if (pluginFields && typeof pluginFields == 'object') { for (var prop in pluginFields) {
    if (prop == "doc" || prop == "selection")
      { throw new RangeError("The JSON fields `doc` and `selection` are reserved") }
    var plugin = pluginFields[prop], state = plugin.spec.state;
    if (state && state.toJSON) { result[prop] = state.toJSON.call(plugin, this$1[plugin.key]); }
  } }
  return result
};

// :: (Object, Object, ?Object<Plugin>) → EditorState
// Deserialize a JSON representation of a state. `config` should
// have at least a `schema` field, and should contain array of
// plugins to initialize the state with. `pluginFields` can be used
// to deserialize the state of plugins, by associating plugin
// instances with the property names they use in the JSON object.
//
// config::- configuration options
//
//   schema:: Schema
//   The schema to use.
//
//   plugins:: ?[Plugin]
//   The set of active plugins.
EditorState.fromJSON = function fromJSON (config, json, pluginFields) {
  if (!json) { throw new RangeError("Invalid input for EditorState.fromJSON") }
  if (!config.schema) { throw new RangeError("Required config field 'schema' missing") }
  var $config = new Configuration(config.schema, config.plugins);
  var instance = new EditorState($config);
  $config.fields.forEach(function (field) {
    if (field.name == "doc") {
      instance.doc = prosemirrorModel.Node.fromJSON(config.schema, json.doc);
    } else if (field.name == "selection") {
      instance.selection = Selection.fromJSON(instance.doc, json.selection);
    } else if (field.name == "storedMarks") {
      if (json.storedMarks) { instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON); }
    } else {
      if (pluginFields) { for (var prop in pluginFields) {
        var plugin = pluginFields[prop], state = plugin.spec.state;
        if (plugin.key == field.name && state && state.fromJSON &&
            Object.prototype.hasOwnProperty.call(json, prop)) {
          // This field belongs to a plugin mapped to a JSON field, read it from there.
          instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
          return
        }
      } }
      instance[field.name] = field.init(config, instance);
    }
  });
  return instance
};

// Kludge to allow the view to track mappings between different
// instances of a state.
EditorState.addApplyListener = function addApplyListener (f) {
  applyListeners.push(f);
};
EditorState.removeApplyListener = function removeApplyListener (f) {
  var found = applyListeners.indexOf(f);
  if (found > -1) { applyListeners.splice(found, 1); }
};

Object.defineProperties( EditorState.prototype, prototypeAccessors$1 );

var applyListeners = [];

// PluginSpec:: interface
//
// This is the type passed to the [`Plugin`](#state.Plugin)
// constructor. It provides a definition for a plugin.
//
//   props:: ?EditorProps
//   The [view props](#view.EditorProps) added by this plugin. Props
//   that are functions will be bound to have the plugin instance as
//   their `this` binding.
//
//   state:: ?StateField<any>
//   Allows a plugin to define a [state field](#state.StateField), an
//   extra slot in the state object in which it can keep its own data.
//
//   key:: ?PluginKey
//   Can be used to make this a keyed plugin. You can have only one
//   plugin with a given key in a given state, but it is possible to
//   access the plugin's configuration and state through the key,
//   without having access to the plugin instance object.
//
//   view:: ?(EditorView) → Object
//   When the plugin needs to interact with the editor view, or
//   set something up in the DOM, use this field. The function
//   will be called when the plugin's state is associated with an
//   editor view.
//
//     return::-
//     Should return an object with the following optional
//     properties:
//
//       update:: ?(view: EditorView, prevState: EditorState)
//       Called whenever the view's state is updated.
//
//       destroy:: ?()
//       Called when the view is destroyed or receives a state
//       with different plugins.
//
//   filterTransaction:: ?(Transaction, EditorState) → bool
//   When present, this will be called before a transaction is
//   applied by the state, allowing the plugin to cancel it (by
//   returning false).
//
//   appendTransaction:: ?(transactions: [Transaction], oldState: EditorState, newState: EditorState) → ?Transaction
//   Allows the plugin to append another transaction to be applied
//   after the given array of transactions. When another plugin
//   appends a transaction after this was called, it is called again
//   with the new state and new transactions—but only the new
//   transactions, i.e. it won't be passed transactions that it
//   already saw.

function bindProps(obj, self, target) {
  for (var prop in obj) {
    var val = obj[prop];
    if (val instanceof Function) { val = val.bind(self); }
    else if (prop == "handleDOMEvents") { val = bindProps(val, self, {}); }
    target[prop] = val;
  }
  return target
}

// ::- Plugins bundle functionality that can be added to an editor.
// They are part of the [editor state](#state.EditorState) and
// may influence that state and the view that contains it.
var Plugin = function Plugin(spec) {
  // :: EditorProps
  // The [props](#view.EditorProps) exported by this plugin.
  this.props = {};
  if (spec.props) { bindProps(spec.props, this, this.props); }
  // :: Object
  // The plugin's [spec object](#state.PluginSpec).
  this.spec = spec;
  this.key = spec.key ? spec.key.key : createKey("plugin");
};

// :: (EditorState) → any
// Extract the plugin's state field from an editor state.
Plugin.prototype.getState = function getState (state) { return state[this.key] };

// StateField:: interface<T>
// A plugin spec may provide a state field (under its
// [`state`](#state.PluginSpec.state) property) of this type, which
// describes the state it wants to keep. Functions provided here are
// always called with the plugin instance as their `this` binding.
//
//   init:: (config: Object, instance: EditorState) → T
//   Initialize the value of the field. `config` will be the object
//   passed to [`EditorState.create`](#state.EditorState^create). Note
//   that `instance` is a half-initialized state instance, and will
//   not have values for plugin fields initialized after this one.
//
//   apply:: (tr: Transaction, value: T, oldState: EditorState, newState: EditorState) → T
//   Apply the given transaction to this state field, producing a new
//   field value. Note that the `newState` argument is again a partially
//   constructed state does not yet contain the state from plugins
//   coming after this one.
//
//   toJSON:: ?(value: T) → *
//   Convert this field to JSON. Optional, can be left off to disable
//   JSON serialization for the field.
//
//   fromJSON:: ?(config: Object, value: *, state: EditorState) → T
//   Deserialize the JSON representation of this field. Note that the
//   `state` argument is again a half-initialized state.

var keys = Object.create(null);

function createKey(name) {
  if (name in keys) { return name + "$" + ++keys[name] }
  keys[name] = 0;
  return name + "$"
}

// ::- A key is used to [tag](#state.PluginSpec.key)
// plugins in a way that makes it possible to find them, given an
// editor state. Assigning a key does mean only one plugin of that
// type can be active in a state.
var PluginKey = function PluginKey(name) {
if ( name === void 0 ) name = "key";
 this.key = createKey(name); };

// :: (EditorState) → ?Plugin
// Get the active plugin with this key, if any, from an editor
// state.
PluginKey.prototype.get = function get (state) { return state.config.pluginsByKey[this.key] };

// :: (EditorState) → ?any
// Get the plugin's state from an editor state.
PluginKey.prototype.getState = function getState (state) { return state[this.key] };

exports.Selection = Selection;
exports.SelectionRange = SelectionRange;
exports.TextSelection = TextSelection;
exports.NodeSelection = NodeSelection;
exports.AllSelection = AllSelection;
exports.Transaction = Transaction;
exports.EditorState = EditorState;
exports.Plugin = Plugin;
exports.PluginKey = PluginKey;
//# sourceMappingURL=index.js.map


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var OrderedMap = _interopDefault(__webpack_require__(55));

function findDiffStart(a, b, pos) {
  for (var i = 0;; i++) {
    if (i == a.childCount || i == b.childCount)
      { return a.childCount == b.childCount ? null : pos }

    var childA = a.child(i), childB = b.child(i);
    if (childA == childB) { pos += childA.nodeSize; continue }

    if (!childA.sameMarkup(childB)) { return pos }

    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++)
        { pos++; }
      return pos
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) { return inner }
    }
    pos += childA.nodeSize;
  }
}

function findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount;;) {
    if (iA == 0 || iB == 0)
      { return iA == iB ? null : {a: posA, b: posB} }

    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
    if (childA == childB) {
      posA -= size; posB -= size;
      continue
    }

    if (!childA.sameMarkup(childB)) { return {a: posA, b: posB} }

    if (childA.isText && childA.text != childB.text) {
      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++; posA--; posB--;
      }
      return {a: posA, b: posB}
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) { return inner }
    }
    posA -= size; posB -= size;
  }
}

// ::- A fragment represents a node's collection of child nodes.
//
// Like nodes, fragments are persistent data structures, and you
// should not mutate them or their content. Rather, you create new
// instances whenever needed. The API tries to make this easy.
var Fragment = function Fragment(content, size) {
  var this$1 = this;

  this.content = content;
  // :: number
  // The size of the fragment, which is the total of the size of its
  // content nodes.
  this.size = size || 0;
  if (size == null) { for (var i = 0; i < content.length; i++)
    { this$1.size += content[i].nodeSize; } }
};

var prototypeAccessors$1 = { firstChild: {},lastChild: {},childCount: {} };

// :: (number, number, (node: Node, start: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes between the given two
// positions (relative to start of this fragment). Doesn't descend
// into a node when the callback returns `false`.
Fragment.prototype.nodesBetween = function nodesBetween (from, to, f, nodeStart, parent) {
    var this$1 = this;
    if ( nodeStart === void 0 ) nodeStart = 0;

  for (var i = 0, pos = 0; pos < to; i++) {
    var child = this$1.content[i], end = pos + child.nodeSize;
    if (end > from && f(child, nodeStart + pos, parent, i) !== false && child.content.size) {
      var start = pos + 1;
      child.nodesBetween(Math.max(0, from - start),
                         Math.min(child.content.size, to - start),
                         f, nodeStart + start);
    }
    pos = end;
  }
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. The callback
// may return `false` to prevent traversal of a given node's children.
Fragment.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.size, f);
};

// : (number, number, ?string, ?string) → string
Fragment.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  var text = "", separated = true;
  this.nodesBetween(from, to, function (node, pos) {
    if (node.isText) {
      text += node.text.slice(Math.max(from, pos) - pos, to - pos);
      separated = !blockSeparator;
    } else if (node.isLeaf && leafText) {
      text += leafText;
      separated = !blockSeparator;
    } else if (!separated && node.isBlock) {
      text += blockSeparator;
      separated = true;
    }
  }, 0);
  return text
};

// :: (Fragment) → Fragment
// Create a new fragment containing the combined content of this
// fragment and the other.
Fragment.prototype.append = function append (other) {
  if (!other.size) { return this }
  if (!this.size) { return other }
  var last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
  if (last.isText && last.sameMarkup(first)) {
    content[content.length - 1] = last.withText(last.text + first.text);
    i = 1;
  }
  for (; i < other.content.length; i++) { content.push(other.content[i]); }
  return new Fragment(content, this.size + other.size)
};

// :: (number, ?number) → Fragment
// Cut out the sub-fragment between the two given positions.
Fragment.prototype.cut = function cut (from, to) {
    var this$1 = this;

  if (to == null) { to = this.size; }
  if (from == 0 && to == this.size) { return this }
  var result = [], size = 0;
  if (to > from) { for (var i = 0, pos = 0; pos < to; i++) {
    var child = this$1.content[i], end = pos + child.nodeSize;
    if (end > from) {
      if (pos < from || end > to) {
        if (child.isText)
          { child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos)); }
        else
          { child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1)); }
      }
      result.push(child);
      size += child.nodeSize;
    }
    pos = end;
  } }
  return new Fragment(result, size)
};

Fragment.prototype.cutByIndex = function cutByIndex (from, to) {
  if (from == to) { return Fragment.empty }
  if (from == 0 && to == this.content.length) { return this }
  return new Fragment(this.content.slice(from, to))
};

// :: (number, Node) → Fragment
// Create a new fragment in which the node at the given index is
// replaced by the given node.
Fragment.prototype.replaceChild = function replaceChild (index, node) {
  var current = this.content[index];
  if (current == node) { return this }
  var copy = this.content.slice();
  var size = this.size + node.nodeSize - current.nodeSize;
  copy[index] = node;
  return new Fragment(copy, size)
};

// : (Node) → Fragment
// Create a new fragment by prepending the given node to this
// fragment.
Fragment.prototype.addToStart = function addToStart (node) {
  return new Fragment([node].concat(this.content), this.size + node.nodeSize)
};

// : (Node) → Fragment
// Create a new fragment by appending the given node to this
// fragment.
Fragment.prototype.addToEnd = function addToEnd (node) {
  return new Fragment(this.content.concat(node), this.size + node.nodeSize)
};

// :: (Fragment) → bool
// Compare this fragment to another one.
Fragment.prototype.eq = function eq (other) {
    var this$1 = this;

  if (this.content.length != other.content.length) { return false }
  for (var i = 0; i < this.content.length; i++)
    { if (!this$1.content[i].eq(other.content[i])) { return false } }
  return true
};

// :: ?Node
// The first child of the fragment, or `null` if it is empty.
prototypeAccessors$1.firstChild.get = function () { return this.content.length ? this.content[0] : null };

// :: ?Node
// The last child of the fragment, or `null` if it is empty.
prototypeAccessors$1.lastChild.get = function () { return this.content.length ? this.content[this.content.length - 1] : null };

// :: number
// The number of child nodes in this fragment.
prototypeAccessors$1.childCount.get = function () { return this.content.length };

// :: (number) → Node
// Get the child node at the given index. Raise an error when the
// index is out of range.
Fragment.prototype.child = function child (index) {
  var found = this.content[index];
  if (!found) { throw new RangeError("Index " + index + " out of range for " + this) }
  return found
};

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Fragment.prototype.maybeChild = function maybeChild (index) {
  return this.content[index]
};

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Fragment.prototype.forEach = function forEach (f) {
    var this$1 = this;

  for (var i = 0, p = 0; i < this.content.length; i++) {
    var child = this$1.content[i];
    f(child, p, i);
    p += child.nodeSize;
  }
};

// :: (Fragment) → ?number
// Find the first position at which this fragment and another
// fragment differ, or `null` if they are the same.
Fragment.prototype.findDiffStart = function findDiffStart$1 (other, pos) {
    if ( pos === void 0 ) pos = 0;

  return findDiffStart(this, other, pos)
};

// :: (Fragment) → ?{a: number, b: number}
// Find the first position, searching from the end, at which this
// fragment and the given fragment differ, or `null` if they are the
// same. Since this position will not be the same in both nodes, an
// object with two separate positions is returned.
Fragment.prototype.findDiffEnd = function findDiffEnd$1 (other, pos, otherPos) {
    if ( pos === void 0 ) pos = this.size;
    if ( otherPos === void 0 ) otherPos = other.size;

  return findDiffEnd(this, other, pos, otherPos)
};

// : (number, ?number) → {index: number, offset: number}
// Find the index and inner offset corresponding to a given relative
// position in this fragment. The result object will be reused
// (overwritten) the next time the function is called. (Not public.)
Fragment.prototype.findIndex = function findIndex (pos, round) {
    var this$1 = this;
    if ( round === void 0 ) round = -1;

  if (pos == 0) { return retIndex(0, pos) }
  if (pos == this.size) { return retIndex(this.content.length, pos) }
  if (pos > this.size || pos < 0) { throw new RangeError(("Position " + pos + " outside of fragment (" + (this) + ")")) }
  for (var i = 0, curPos = 0;; i++) {
    var cur = this$1.child(i), end = curPos + cur.nodeSize;
    if (end >= pos) {
      if (end == pos || round > 0) { return retIndex(i + 1, end) }
      return retIndex(i, curPos)
    }
    curPos = end;
  }
};

// :: () → string
// Return a debugging string that describes this fragment.
Fragment.prototype.toString = function toString () { return "<" + this.toStringInner() + ">" };

Fragment.prototype.toStringInner = function toStringInner () { return this.content.join(", ") };

// :: () → ?Object
// Create a JSON-serializeable representation of this fragment.
Fragment.prototype.toJSON = function toJSON () {
  return this.content.length ? this.content.map(function (n) { return n.toJSON(); }) : null
};

// :: (Schema, ?Object) → Fragment
// Deserialize a fragment from its JSON representation.
Fragment.fromJSON = function fromJSON (schema, value) {
  if (!value) { return Fragment.empty }
  if (!Array.isArray(value)) { throw new RangeError("Invalid input for Fragment.fromJSON") }
  return new Fragment(value.map(schema.nodeFromJSON))
};

// :: ([Node]) → Fragment
// Build a fragment from an array of nodes. Ensures that adjacent
// text nodes with the same marks are joined together.
Fragment.fromArray = function fromArray (array) {
  if (!array.length) { return Fragment.empty }
  var joined, size = 0;
  for (var i = 0; i < array.length; i++) {
    var node = array[i];
    size += node.nodeSize;
    if (i && node.isText && array[i - 1].sameMarkup(node)) {
      if (!joined) { joined = array.slice(0, i); }
      joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
    } else if (joined) {
      joined.push(node);
    }
  }
  return new Fragment(joined || array, size)
};

// :: (?union<Fragment, Node, [Node]>) → Fragment
// Create a fragment from something that can be interpreted as a set
// of nodes. For `null`, it returns the empty fragment. For a
// fragment, the fragment itself. For a node or array of nodes, a
// fragment containing those nodes.
Fragment.from = function from (nodes) {
  if (!nodes) { return Fragment.empty }
  if (nodes instanceof Fragment) { return nodes }
  if (Array.isArray(nodes)) { return this.fromArray(nodes) }
  return new Fragment([nodes], nodes.nodeSize)
};

Object.defineProperties( Fragment.prototype, prototypeAccessors$1 );

var found = {index: 0, offset: 0};
function retIndex(index, offset) {
  found.index = index;
  found.offset = offset;
  return found
}

// :: Fragment
// An empty fragment. Intended to be reused whenever a node doesn't
// contain anything (rather than allocating a new empty fragment for
// each leaf node).
Fragment.empty = new Fragment([], 0);

function compareDeep(a, b) {
  if (a === b) { return true }
  if (!(a && typeof a == "object") ||
      !(b && typeof b == "object")) { return false }
  var array = Array.isArray(a);
  if (Array.isArray(b) != array) { return false }
  if (array) {
    if (a.length != b.length) { return false }
    for (var i = 0; i < a.length; i++) { if (!compareDeep(a[i], b[i])) { return false } }
  } else {
    for (var p in a) { if (!(p in b) || !compareDeep(a[p], b[p])) { return false } }
    for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  }
  return true
}

// ::- A mark is a piece of information that can be attached to a node,
// such as it being emphasized, in code font, or a link. It has a type
// and optionally a set of attributes that provide further information
// (such as the target of the link). Marks are created through a
// `Schema`, which controls which types exist and which
// attributes they have.
var Mark = function Mark(type, attrs) {
  // :: MarkType
  // The type of this mark.
  this.type = type;
  // :: Object
  // The attributes associated with this mark.
  this.attrs = attrs;
};

// :: ([Mark]) → [Mark]
// Given a set of marks, create a new set which contains this one as
// well, in the right position. If this mark is already in the set,
// the set itself is returned. If any marks that are set to be
// [exclusive](#model.MarkSpec.excludes) with this mark are present,
// those are replaced by this one.
Mark.prototype.addToSet = function addToSet (set) {
    var this$1 = this;

  var copy, placed = false;
  for (var i = 0; i < set.length; i++) {
    var other = set[i];
    if (this$1.eq(other)) { return set }
    if (this$1.type.excludes(other.type)) {
      if (!copy) { copy = set.slice(0, i); }
    } else if (other.type.excludes(this$1.type)) {
      return set
    } else {
      if (!placed && other.type.rank > this$1.type.rank) {
        if (!copy) { copy = set.slice(0, i); }
        copy.push(this$1);
        placed = true;
      }
      if (copy) { copy.push(other); }
    }
  }
  if (!copy) { copy = set.slice(); }
  if (!placed) { copy.push(this); }
  return copy
};

// :: ([Mark]) → [Mark]
// Remove this mark from the given set, returning a new set. If this
// mark is not in the set, the set itself is returned.
Mark.prototype.removeFromSet = function removeFromSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (this$1.eq(set[i]))
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → bool
// Test whether this mark is in the given set of marks.
Mark.prototype.isInSet = function isInSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (this$1.eq(set[i])) { return true } }
  return false
};

// :: (Mark) → bool
// Test whether this mark has the same type and attributes as
// another mark.
Mark.prototype.eq = function eq (other) {
  return this == other ||
    (this.type == other.type && compareDeep(this.attrs, other.attrs))
};

// :: () → Object
// Convert this mark to a JSON-serializeable representation.
Mark.prototype.toJSON = function toJSON () {
    var this$1 = this;

  var obj = {type: this.type.name};
  for (var _ in this$1.attrs) {
    obj.attrs = this$1.attrs;
    break
  }
  return obj
};

// :: (Schema, Object) → Mark
Mark.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Mark.fromJSON") }
  var type = schema.marks[json.type];
  if (!type) { throw new RangeError(("There is no mark type " + (json.type) + " in this schema")) }
  return type.create(json.attrs)
};

// :: ([Mark], [Mark]) → bool
// Test whether two sets of marks are identical.
Mark.sameSet = function sameSet (a, b) {
  if (a == b) { return true }
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++)
    { if (!a[i].eq(b[i])) { return false } }
  return true
};

// :: (?union<Mark, [Mark]>) → [Mark]
// Create a properly sorted mark set from null, a single mark, or an
// unsorted array of marks.
Mark.setFrom = function setFrom (marks) {
  if (!marks || marks.length == 0) { return Mark.none }
  if (marks instanceof Mark) { return [marks] }
  var copy = marks.slice();
  copy.sort(function (a, b) { return a.type.rank - b.type.rank; });
  return copy
};

// :: [Mark] The empty set of marks.
Mark.none = [];

// ReplaceError:: class extends Error
// Error type raised by [`Node.replace`](#model.Node.replace) when
// given an invalid replacement.

function ReplaceError(message) {
  var err = Error.call(this, message);
  err.__proto__ = ReplaceError.prototype;
  return err
}

ReplaceError.prototype = Object.create(Error.prototype);
ReplaceError.prototype.constructor = ReplaceError;
ReplaceError.prototype.name = "ReplaceError";

// ::- A slice represents a piece cut out of a larger document. It
// stores not only a fragment, but also the depth up to which nodes on
// both side are ‘open’ (cut through).
var Slice = function Slice(content, openStart, openEnd) {
  // :: Fragment The slice's content.
  this.content = content;
  // :: number The open depth at the start.
  this.openStart = openStart;
  // :: number The open depth at the end.
  this.openEnd = openEnd;
};

var prototypeAccessors$2 = { size: {} };

// :: number
// The size this slice would add when inserted into a document.
prototypeAccessors$2.size.get = function () {
  return this.content.size - this.openStart - this.openEnd
};

Slice.prototype.insertAt = function insertAt (pos, fragment) {
  var content = insertInto(this.content, pos + this.openStart, fragment, null);
  return content && new Slice(content, this.openStart, this.openEnd)
};

Slice.prototype.removeBetween = function removeBetween (from, to) {
  return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd)
};

// :: (Slice) → bool
// Tests whether this slice is equal to another slice.
Slice.prototype.eq = function eq (other) {
  return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd
};

Slice.prototype.toString = function toString () {
  return this.content + "(" + this.openStart + "," + this.openEnd + ")"
};

// :: () → ?Object
// Convert a slice to a JSON-serializable representation.
Slice.prototype.toJSON = function toJSON () {
  if (!this.content.size) { return null }
  var json = {content: this.content.toJSON()};
  if (this.openStart > 0) { json.openStart = this.openStart; }
  if (this.openEnd > 0) { json.openEnd = this.openEnd; }
  return json
};

// :: (Schema, ?Object) → Slice
// Deserialize a slice from its JSON representation.
Slice.fromJSON = function fromJSON (schema, json) {
  if (!json) { return Slice.empty }
  var openStart = json.openStart || 0, openEnd = json.openEnd || 0;
  if (typeof openStart != "number" || typeof openEnd != "number")
    { throw new RangeError("Invalid input for Slice.fromJSON") }
  return new Slice(Fragment.fromJSON(schema, json.content), json.openStart || 0, json.openEnd || 0)
};

// :: (Fragment, ?bool) → Slice
// Create a slice from a fragment by taking the maximum possible
// open value on both side of the fragment.
Slice.maxOpen = function maxOpen (fragment, openIsolating) {
    if ( openIsolating === void 0 ) openIsolating=true;

  var openStart = 0, openEnd = 0;
  for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) { openStart++; }
  for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) { openEnd++; }
  return new Slice(fragment, openStart, openEnd)
};

Object.defineProperties( Slice.prototype, prototypeAccessors$2 );

function removeRange(content, from, to) {
  var ref = content.findIndex(from);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  var ref$1 = content.findIndex(to);
  var indexTo = ref$1.index;
  var offsetTo = ref$1.offset;
  if (offset == from || child.isText) {
    if (offsetTo != to && !content.child(indexTo).isText) { throw new RangeError("Removing non-flat range") }
    return content.cut(0, from).append(content.cut(to))
  }
  if (index != indexTo) { throw new RangeError("Removing non-flat range") }
  return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)))
}

function insertInto(content, dist, insert, parent) {
  var ref = content.findIndex(dist);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  if (offset == dist || child.isText) {
    if (parent && !parent.canReplace(index, index, insert)) { return null }
    return content.cut(0, dist).append(insert).append(content.cut(dist))
  }
  var inner = insertInto(child.content, dist - offset - 1, insert);
  return inner && content.replaceChild(index, child.copy(inner))
}

// :: Slice
// The empty slice.
Slice.empty = new Slice(Fragment.empty, 0, 0);

function replace($from, $to, slice) {
  if (slice.openStart > $from.depth)
    { throw new ReplaceError("Inserted content deeper than insertion position") }
  if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
    { throw new ReplaceError("Inconsistent open depths") }
  return replaceOuter($from, $to, slice, 0)
}

function replaceOuter($from, $to, slice, depth) {
  var index = $from.index(depth), node = $from.node(depth);
  if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
    var inner = replaceOuter($from, $to, slice, depth + 1);
    return node.copy(node.content.replaceChild(index, inner))
  } else if (!slice.content.size) {
    return close(node, replaceTwoWay($from, $to, depth))
  } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
    var parent = $from.parent, content = parent.content;
    return close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)))
  } else {
    var ref = prepareSliceForReplace(slice, $from);
    var start = ref.start;
    var end = ref.end;
    return close(node, replaceThreeWay($from, start, end, $to, depth))
  }
}

function checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type))
    { throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name) }
}

function joinable($before, $after, depth) {
  var node = $before.node(depth);
  checkJoin(node, $after.node(depth));
  return node
}

function addNode(child, target) {
  var last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
    { target[last] = child.withText(target[last].text + child.text); }
  else
    { target.push(child); }
}

function addRange($start, $end, depth, target) {
  var node = ($end || $start).node(depth);
  var startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (var i = startIndex; i < endIndex; i++) { addNode(node.child(i), target); }
  if ($end && $end.depth == depth && $end.textOffset)
    { addNode($end.nodeBefore, target); }
}

function close(node, content) {
  if (!node.type.validContent(content))
    { throw new ReplaceError("Invalid content for node " + node.type.name) }
  return node.copy(content)
}

function replaceThreeWay($from, $start, $end, $to, depth) {
  var openStart = $from.depth > depth && joinable($from, $start, depth + 1);
  var openEnd = $to.depth > depth && joinable($end, $to, depth + 1);

  var content = [];
  addRange(null, $from, depth, content);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
  } else {
    if (openStart)
      { addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content); }
    addRange($start, $end, depth, content);
    if (openEnd)
      { addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content); }
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function replaceTwoWay($from, $to, depth) {
  var content = [];
  addRange(null, $from, depth, content);
  if ($from.depth > depth) {
    var type = joinable($from, $to, depth + 1);
    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function prepareSliceForReplace(slice, $along) {
  var extra = $along.depth - slice.openStart, parent = $along.node(extra);
  var node = parent.copy(slice.content);
  for (var i = extra - 1; i >= 0; i--)
    { node = $along.node(i).copy(Fragment.from(node)); }
  return {start: node.resolveNoCache(slice.openStart + extra),
          end: node.resolveNoCache(node.content.size - slice.openEnd - extra)}
}

// ::- You can [_resolve_](#model.Node.resolve) a position to get more
// information about it. Objects of this class represent such a
// resolved position, providing various pieces of context information,
// and some helper methods.
//
// Throughout this interface, methods that take an optional `depth`
// parameter will interpret undefined as `this.depth` and negative
// numbers as `this.depth + value`.
var ResolvedPos = function ResolvedPos(pos, path, parentOffset) {
  // :: number The position that was resolved.
  this.pos = pos;
  this.path = path;
  // :: number
  // The number of levels the parent node is from the root. If this
  // position points directly into the root node, it is 0. If it
  // points into a top-level paragraph, 1, and so on.
  this.depth = path.length / 3 - 1;
  // :: number The offset this position has into its parent node.
  this.parentOffset = parentOffset;
};

var prototypeAccessors$3 = { parent: {},doc: {},textOffset: {},nodeAfter: {},nodeBefore: {} };

ResolvedPos.prototype.resolveDepth = function resolveDepth (val) {
  if (val == null) { return this.depth }
  if (val < 0) { return this.depth + val }
  return val
};

// :: Node
// The parent node that the position points into. Note that even if
// a position points into a text node, that node is not considered
// the parent—text nodes are ‘flat’ in this model, and have no content.
prototypeAccessors$3.parent.get = function () { return this.node(this.depth) };

// :: Node
// The root node in which the position was resolved.
prototypeAccessors$3.doc.get = function () { return this.node(0) };

// :: (?number) → Node
// The ancestor node at the given level. `p.node(p.depth)` is the
// same as `p.parent`.
ResolvedPos.prototype.node = function node (depth) { return this.path[this.resolveDepth(depth) * 3] };

// :: (?number) → number
// The index into the ancestor at the given level. If this points at
// the 3rd node in the 2nd paragraph on the top level, for example,
// `p.index(0)` is 2 and `p.index(1)` is 3.
ResolvedPos.prototype.index = function index (depth) { return this.path[this.resolveDepth(depth) * 3 + 1] };

// :: (?number) → number
// The index pointing after this position into the ancestor at the
// given level.
ResolvedPos.prototype.indexAfter = function indexAfter (depth) {
  depth = this.resolveDepth(depth);
  return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1)
};

// :: (?number) → number
// The (absolute) position at the start of the node at the given
// level.
ResolvedPos.prototype.start = function start (depth) {
  depth = this.resolveDepth(depth);
  return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1
};

// :: (?number) → number
// The (absolute) position at the end of the node at the given
// level.
ResolvedPos.prototype.end = function end (depth) {
  depth = this.resolveDepth(depth);
  return this.start(depth) + this.node(depth).content.size
};

// :: (?number) → number
// The (absolute) position directly before the wrapping node at the
// given level, or, when `level` is `this.depth + 1`, the original
// position.
ResolvedPos.prototype.before = function before (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position before the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1]
};

// :: (?number) → number
// The (absolute) position directly after the wrapping node at the
// given level, or the original position when `level` is `this.depth + 1`.
ResolvedPos.prototype.after = function after (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position after the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize
};

// :: number
// When this position points into a text node, this returns the
// distance between the position and the start of the text node.
// Will be zero for positions that point between nodes.
prototypeAccessors$3.textOffset.get = function () { return this.pos - this.path[this.path.length - 1] };

// :: ?Node
// Get the node directly after the position, if any. If the position
// points into a text node, only the part of that node after the
// position is returned.
prototypeAccessors$3.nodeAfter.get = function () {
  var parent = this.parent, index = this.index(this.depth);
  if (index == parent.childCount) { return null }
  var dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
  return dOff ? parent.child(index).cut(dOff) : child
};

// :: ?Node
// Get the node directly before the position, if any. If the
// position points into a text node, only the part of that node
// before the position is returned.
prototypeAccessors$3.nodeBefore.get = function () {
  var index = this.index(this.depth);
  var dOff = this.pos - this.path[this.path.length - 1];
  if (dOff) { return this.parent.child(index).cut(0, dOff) }
  return index == 0 ? null : this.parent.child(index - 1)
};

// :: () → [Mark]
// Get the marks at this position, factoring in the surrounding
// marks' [`inclusive`](#model.MarkSpec.inclusive) property. If the
// position is at the start of a non-empty node, the marks of the
// node after it (if any) are returned.
ResolvedPos.prototype.marks = function marks () {
  var parent = this.parent, index = this.index();

  // In an empty parent, return the empty array
  if (parent.content.size == 0) { return Mark.none }

  // When inside a text node, just return the text node's marks
  if (this.textOffset) { return parent.child(index).marks }

  var main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
  // If the `after` flag is true of there is no node before, make
  // the node after this position the main reference.
  if (!main) { var tmp = main; main = other; other = tmp; }

  // Use all marks in the main node, except those that have
  // `inclusive` set to false and are not present in the other node.
  var marks = main.marks;
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
      { marks = marks[i--].removeFromSet(marks); } }

  return marks
};

// :: (ResolvedPos) → ?[Mark]
// Get the marks after the current position, if any, except those
// that are non-inclusive and not present at position `$end`. This
// is mostly useful for getting the set of marks to preserve after a
// deletion. Will return `null` if this position is at the end of
// its parent node or its parent node isn't a textblock (in which
// case no marks should be preserved).
ResolvedPos.prototype.marksAcross = function marksAcross ($end) {
  var after = this.parent.maybeChild(this.index());
  if (!after || !after.isInline) { return null }

  var marks = after.marks, next = $end.parent.maybeChild($end.index());
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
      { marks = marks[i--].removeFromSet(marks); } }
  return marks
};

// :: (number) → number
// The depth up to which this position and the given (non-resolved)
// position share the same parent nodes.
ResolvedPos.prototype.sharedDepth = function sharedDepth (pos) {
    var this$1 = this;

  for (var depth = this.depth; depth > 0; depth--)
    { if (this$1.start(depth) <= pos && this$1.end(depth) >= pos) { return depth } }
  return 0
};

// :: (?ResolvedPos, ?(Node) → bool) → ?NodeRange
// Returns a range based on the place where this position and the
// given position diverge around block content. If both point into
// the same textblock, for example, a range around that textblock
// will be returned. If they point into different blocks, the range
// around those blocks in their shared ancestor is returned. You can
// pass in an optional predicate that will be called with a parent
// node to see if a range into that parent is acceptable.
ResolvedPos.prototype.blockRange = function blockRange (other, pred) {
    var this$1 = this;
    if ( other === void 0 ) other = this;

  if (other.pos < this.pos) { return other.blockRange(this) }
  for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
    { if (other.pos <= this$1.end(d) && (!pred || pred(this$1.node(d))))
      { return new NodeRange(this$1, other, d) } }
};

// :: (ResolvedPos) → bool
// Query whether the given position shares the same parent node.
ResolvedPos.prototype.sameParent = function sameParent (other) {
  return this.pos - this.parentOffset == other.pos - other.parentOffset
};

// :: (ResolvedPos) → ResolvedPos
// Return the greater of this and the given position.
ResolvedPos.prototype.max = function max (other) {
  return other.pos > this.pos ? other : this
};

// :: (ResolvedPos) → ResolvedPos
// Return the smaller of this and the given position.
ResolvedPos.prototype.min = function min (other) {
  return other.pos < this.pos ? other : this
};

ResolvedPos.prototype.toString = function toString () {
    var this$1 = this;

  var str = "";
  for (var i = 1; i <= this.depth; i++)
    { str += (str ? "/" : "") + this$1.node(i).type.name + "_" + this$1.index(i - 1); }
  return str + ":" + this.parentOffset
};

ResolvedPos.resolve = function resolve (doc, pos) {
  if (!(pos >= 0 && pos <= doc.content.size)) { throw new RangeError("Position " + pos + " out of range") }
  var path = [];
  var start = 0, parentOffset = pos;
  for (var node = doc;;) {
    var ref = node.content.findIndex(parentOffset);
      var index = ref.index;
      var offset = ref.offset;
    var rem = parentOffset - offset;
    path.push(node, index, start + offset);
    if (!rem) { break }
    node = node.child(index);
    if (node.isText) { break }
    parentOffset = rem - 1;
    start += offset + 1;
  }
  return new ResolvedPos(pos, path, parentOffset)
};

ResolvedPos.resolveCached = function resolveCached (doc, pos) {
  for (var i = 0; i < resolveCache.length; i++) {
    var cached = resolveCache[i];
    if (cached.pos == pos && cached.doc == doc) { return cached }
  }
  var result = resolveCache[resolveCachePos] = ResolvedPos.resolve(doc, pos);
  resolveCachePos = (resolveCachePos + 1) % resolveCacheSize;
  return result
};

Object.defineProperties( ResolvedPos.prototype, prototypeAccessors$3 );

var resolveCache = [];
var resolveCachePos = 0;
var resolveCacheSize = 12;

// ::- Represents a flat range of content, i.e. one that starts and
// ends in the same node.
var NodeRange = function NodeRange($from, $to, depth) {
  // :: ResolvedPos A resolved position along the start of the
  // content. May have a `depth` greater than this object's `depth`
  // property, since these are the positions that were used to
  // compute the range, not re-resolved positions directly at its
  // boundaries.
  this.$from = $from;
  // :: ResolvedPos A position along the end of the content. See
  // caveat for [`$from`](#model.NodeRange.$from).
  this.$to = $to;
  // :: number The depth of the node that this range points into.
  this.depth = depth;
};

var prototypeAccessors$1$1 = { start: {},end: {},parent: {},startIndex: {},endIndex: {} };

// :: number The position at the start of the range.
prototypeAccessors$1$1.start.get = function () { return this.$from.before(this.depth + 1) };
// :: number The position at the end of the range.
prototypeAccessors$1$1.end.get = function () { return this.$to.after(this.depth + 1) };

// :: Node The parent node that the range points into.
prototypeAccessors$1$1.parent.get = function () { return this.$from.node(this.depth) };
// :: number The start index of the range in the parent node.
prototypeAccessors$1$1.startIndex.get = function () { return this.$from.index(this.depth) };
// :: number The end index of the range in the parent node.
prototypeAccessors$1$1.endIndex.get = function () { return this.$to.indexAfter(this.depth) };

Object.defineProperties( NodeRange.prototype, prototypeAccessors$1$1 );

var emptyAttrs = Object.create(null);

// ::- This class represents a node in the tree that makes up a
// ProseMirror document. So a document is an instance of `Node`, with
// children that are also instances of `Node`.
//
// Nodes are persistent data structures. Instead of changing them, you
// create new ones with the content you want. Old ones keep pointing
// at the old document shape. This is made cheaper by sharing
// structure between the old and new data as much as possible, which a
// tree shape like this (without back pointers) makes easy.
//
// **Do not** directly mutate the properties of a `Node` object. See
// [the guide](/docs/guide/#doc) for more information.
var Node = function Node(type, attrs, content, marks) {
  // :: NodeType
  // The type of node that this is.
  this.type = type;

  // :: Object
  // An object mapping attribute names to values. The kind of
  // attributes allowed and required are
  // [determined](#model.NodeSpec.attrs) by the node type.
  this.attrs = attrs;

  // :: Fragment
  // A container holding the node's children.
  this.content = content || Fragment.empty;

  // :: [Mark]
  // The marks (things like whether it is emphasized or part of a
  // link) applied to this node.
  this.marks = marks || Mark.none;
};

var prototypeAccessors = { nodeSize: {},childCount: {},textContent: {},firstChild: {},lastChild: {},isBlock: {},isTextblock: {},inlineContent: {},isInline: {},isText: {},isLeaf: {},isAtom: {} };

// text:: ?string
// For text nodes, this contains the node's text content.

// :: number
// The size of this node, as defined by the integer-based [indexing
// scheme](/docs/guide/#doc.indexing). For text nodes, this is the
// amount of characters. For other leaf nodes, it is one. For
// non-leaf nodes, it is the size of the content plus two (the start
// and end token).
prototypeAccessors.nodeSize.get = function () { return this.isLeaf ? 1 : 2 + this.content.size };

// :: number
// The number of children that the node has.
prototypeAccessors.childCount.get = function () { return this.content.childCount };

// :: (number) → Node
// Get the child node at the given index. Raises an error when the
// index is out of range.
Node.prototype.child = function child (index) { return this.content.child(index) };

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Node.prototype.maybeChild = function maybeChild (index) { return this.content.maybeChild(index) };

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Node.prototype.forEach = function forEach (f) { this.content.forEach(f); };

// :: (number, number, (node: Node, pos: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes recursively between
// the given two positions that are relative to start of this node's
// content. The callback is invoked with the node, its
// parent-relative position, its parent node, and its child index.
// When the callback returns false for a given node, that node's
// children will not be recursed over. The last parameter can be
// used to specify a starting position to count from.
Node.prototype.nodesBetween = function nodesBetween (from, to, f, startPos) {
    if ( startPos === void 0 ) startPos = 0;

  this.content.nodesBetween(from, to, f, startPos, this);
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. Doesn't
// descend into a node when the callback returns `false`.
Node.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.content.size, f);
};

// :: string
// Concatenates all the text nodes found in this fragment and its
// children.
prototypeAccessors.textContent.get = function () { return this.textBetween(0, this.content.size, "") };

// :: (number, number, ?string, ?string) → string
// Get all text between positions `from` and `to`. When
// `blockSeparator` is given, it will be inserted whenever a new
// block node is started. When `leafText` is given, it'll be
// inserted for every non-text leaf node encountered.
Node.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  return this.content.textBetween(from, to, blockSeparator, leafText)
};

// :: ?Node
// Returns this node's first child, or `null` if there are no
// children.
prototypeAccessors.firstChild.get = function () { return this.content.firstChild };

// :: ?Node
// Returns this node's last child, or `null` if there are no
// children.
prototypeAccessors.lastChild.get = function () { return this.content.lastChild };

// :: (Node) → bool
// Test whether two nodes represent the same piece of document.
Node.prototype.eq = function eq (other) {
  return this == other || (this.sameMarkup(other) && this.content.eq(other.content))
};

// :: (Node) → bool
// Compare the markup (type, attributes, and marks) of this node to
// those of another. Returns `true` if both have the same markup.
Node.prototype.sameMarkup = function sameMarkup (other) {
  return this.hasMarkup(other.type, other.attrs, other.marks)
};

// :: (NodeType, ?Object, ?[Mark]) → bool
// Check whether this node's markup correspond to the given type,
// attributes, and marks.
Node.prototype.hasMarkup = function hasMarkup (type, attrs, marks) {
  return this.type == type &&
    compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) &&
    Mark.sameSet(this.marks, marks || Mark.none)
};

// :: (?Fragment) → Node
// Create a new node with the same markup as this node, containing
// the given content (or empty, if no content is given).
Node.prototype.copy = function copy (content) {
    if ( content === void 0 ) content = null;

  if (content == this.content) { return this }
  return new this.constructor(this.type, this.attrs, content, this.marks)
};

// :: ([Mark]) → Node
// Create a copy of this node, with the given set of marks instead
// of the node's own marks.
Node.prototype.mark = function mark (marks) {
  return marks == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks)
};

// :: (number, ?number) → Node
// Create a copy of this node with only the content between the
// given positions. If `to` is not given, it defaults to the end of
// the node.
Node.prototype.cut = function cut (from, to) {
  if (from == 0 && to == this.content.size) { return this }
  return this.copy(this.content.cut(from, to))
};

// :: (number, ?number) → Slice
// Cut out the part of the document between the given positions, and
// return it as a `Slice` object.
Node.prototype.slice = function slice (from, to, includeParents) {
    if ( to === void 0 ) to = this.content.size;
    if ( includeParents === void 0 ) includeParents = false;

  if (from == to) { return Slice.empty }

  var $from = this.resolve(from), $to = this.resolve(to);
  var depth = includeParents ? 0 : $from.sharedDepth(to);
  var start = $from.start(depth), node = $from.node(depth);
  var content = node.content.cut($from.pos - start, $to.pos - start);
  return new Slice(content, $from.depth - depth, $to.depth - depth)
};

// :: (number, number, Slice) → Node
// Replace the part of the document between the given positions with
// the given slice. The slice must 'fit', meaning its open sides
// must be able to connect to the surrounding content, and its
// content nodes must be valid children for the node they are placed
// into. If any of this is violated, an error of type
// [`ReplaceError`](#model.ReplaceError) is thrown.
Node.prototype.replace = function replace$1 (from, to, slice) {
  return replace(this.resolve(from), this.resolve(to), slice)
};

// :: (number) → ?Node
// Find the node directly after the given position.
Node.prototype.nodeAt = function nodeAt (pos) {
  for (var node = this;;) {
    var ref = node.content.findIndex(pos);
      var index = ref.index;
      var offset = ref.offset;
    node = node.maybeChild(index);
    if (!node) { return null }
    if (offset == pos || node.isText) { return node }
    pos -= offset + 1;
  }
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node after the given offset, if any,
// and return it along with its index and offset relative to this
// node.
Node.prototype.childAfter = function childAfter (pos) {
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  return {node: this.content.maybeChild(index), index: index, offset: offset}
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node before the given offset, if any,
// and return it along with its index and offset relative to this
// node.
Node.prototype.childBefore = function childBefore (pos) {
  if (pos == 0) { return {node: null, index: 0, offset: 0} }
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  if (offset < pos) { return {node: this.content.child(index), index: index, offset: offset} }
  var node = this.content.child(index - 1);
  return {node: node, index: index - 1, offset: offset - node.nodeSize}
};

// :: (number) → ResolvedPos
// Resolve the given position in the document, returning an
// [object](#model.ResolvedPos) with information about its context.
Node.prototype.resolve = function resolve (pos) { return ResolvedPos.resolveCached(this, pos) };

Node.prototype.resolveNoCache = function resolveNoCache (pos) { return ResolvedPos.resolve(this, pos) };

// :: (number, number, MarkType) → bool
// Test whether a mark of the given type occurs in this document
// between the two given positions.
Node.prototype.rangeHasMark = function rangeHasMark (from, to, type) {
  var found = false;
  if (to > from) { this.nodesBetween(from, to, function (node) {
    if (type.isInSet(node.marks)) { found = true; }
    return !found
  }); }
  return found
};

// :: bool
// True when this is a block (non-inline node)
prototypeAccessors.isBlock.get = function () { return this.type.isBlock };

// :: bool
// True when this is a textblock node, a block node with inline
// content.
prototypeAccessors.isTextblock.get = function () { return this.type.isTextblock };

// :: bool
// True when this node has inline content.
prototypeAccessors.inlineContent.get = function () { return this.type.inlineContent };

// :: bool
// True when this is an inline node (a text node or a node that can
// appear among text).
prototypeAccessors.isInline.get = function () { return this.type.isInline };

// :: bool
// True when this is a text node.
prototypeAccessors.isText.get = function () { return this.type.isText };

// :: bool
// True when this is a leaf node.
prototypeAccessors.isLeaf.get = function () { return this.type.isLeaf };

// :: bool
// True when this is an atom, i.e. when it does not have directly
// editable content. This is usually the same as `isLeaf`, but can
// be configured with the [`atom` property](#model.NodeSpec.atom) on
// a node's spec (typically used when the node is displayed as an
// uneditable [node view](#view.NodeView)).
prototypeAccessors.isAtom.get = function () { return this.type.isAtom };

// :: () → string
// Return a string representation of this node for debugging
// purposes.
Node.prototype.toString = function toString () {
  var name = this.type.name;
  if (this.content.size)
    { name += "(" + this.content.toStringInner() + ")"; }
  return wrapMarks(this.marks, name)
};

// :: (number) → ContentMatch
// Get the content match in this node at the given index.
Node.prototype.contentMatchAt = function contentMatchAt (index) {
  return this.type.contentMatch.matchFragment(this.content, 0, index)
};

// :: (number, number, ?Fragment, ?number, ?number) → bool
// Test whether replacing the range between `from` and `to` (by
// child index) with the given replacement fragment (which defaults
// to the empty fragment) would leave the node's content valid. You
// can optionally pass `start` and `end` indices into the
// replacement fragment.
Node.prototype.canReplace = function canReplace (from, to, replacement, start, end) {
    var this$1 = this;
    if ( replacement === void 0 ) replacement = Fragment.empty;
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = replacement.childCount;

  var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
  var two = one && one.matchFragment(this.content, to);
  if (!two || !two.validEnd) { return false }
  for (var i = start; i < end; i++) { if (!this$1.type.allowsMarks(replacement.child(i).marks)) { return false } }
  return true
};

// :: (number, number, NodeType, ?[Mark]) → bool
// Test whether replacing the range `from` to `to` (by index) with a
// node of the given type would leave the node's content valid.
Node.prototype.canReplaceWith = function canReplaceWith (from, to, type, marks) {
  if (marks && !this.type.allowsMarks(marks)) { return false }
  var start = this.contentMatchAt(from).matchType(type);
  var end = start && start.matchFragment(this.content, to);
  return end ? end.validEnd : false
};

// :: (Node) → bool
// Test whether the given node's content could be appended to this
// node. If that node is empty, this will only return true if there
// is at least one node type that can appear in both nodes (to avoid
// merging completely incompatible nodes).
Node.prototype.canAppend = function canAppend (other) {
  if (other.content.size) { return this.canReplace(this.childCount, this.childCount, other.content) }
  else { return this.type.compatibleContent(other.type) }
};

// Unused. Left for backwards compatibility.
Node.prototype.defaultContentType = function defaultContentType (at) {
  return this.contentMatchAt(at).defaultType
};

// :: ()
// Check whether this node and its descendants conform to the
// schema, and raise error when they do not.
Node.prototype.check = function check () {
  if (!this.type.validContent(this.content))
    { throw new RangeError(("Invalid content for node " + (this.type.name) + ": " + (this.content.toString().slice(0, 50)))) }
  this.content.forEach(function (node) { return node.check(); });
};

// :: () → Object
// Return a JSON-serializeable representation of this node.
Node.prototype.toJSON = function toJSON () {
    var this$1 = this;

  var obj = {type: this.type.name};
  for (var _ in this$1.attrs) {
    obj.attrs = this$1.attrs;
    break
  }
  if (this.content.size)
    { obj.content = this.content.toJSON(); }
  if (this.marks.length)
    { obj.marks = this.marks.map(function (n) { return n.toJSON(); }); }
  return obj
};

// :: (Schema, Object) → Node
// Deserialize a node from its JSON representation.
Node.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Node.fromJSON") }
  var marks = null;
  if (json.marks) {
    if (!Array.isArray(json.marks)) { throw new RangeError("Invalid mark data for Node.fromJSON") }
    marks = json.marks.map(schema.markFromJSON);
  }
  if (json.type == "text") {
    if (typeof json.text != "string") { throw new RangeError("Invalid text node in JSON") }
    return schema.text(json.text, marks)
  }
  var content = Fragment.fromJSON(schema, json.content);
  return schema.nodeType(json.type).create(json.attrs, content, marks)
};

Object.defineProperties( Node.prototype, prototypeAccessors );

var TextNode = (function (Node) {
  function TextNode(type, attrs, content, marks) {
    Node.call(this, type, attrs, null, marks);

    if (!content) { throw new RangeError("Empty text nodes are not allowed") }

    this.text = content;
  }

  if ( Node ) TextNode.__proto__ = Node;
  TextNode.prototype = Object.create( Node && Node.prototype );
  TextNode.prototype.constructor = TextNode;

  var prototypeAccessors$1 = { textContent: {},nodeSize: {} };

  TextNode.prototype.toString = function toString () { return wrapMarks(this.marks, JSON.stringify(this.text)) };

  prototypeAccessors$1.textContent.get = function () { return this.text };

  TextNode.prototype.textBetween = function textBetween (from, to) { return this.text.slice(from, to) };

  prototypeAccessors$1.nodeSize.get = function () { return this.text.length };

  TextNode.prototype.mark = function mark (marks) {
    return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks)
  };

  TextNode.prototype.withText = function withText (text) {
    if (text == this.text) { return this }
    return new TextNode(this.type, this.attrs, text, this.marks)
  };

  TextNode.prototype.cut = function cut (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.text.length;

    if (from == 0 && to == this.text.length) { return this }
    return this.withText(this.text.slice(from, to))
  };

  TextNode.prototype.eq = function eq (other) {
    return this.sameMarkup(other) && this.text == other.text
  };

  TextNode.prototype.toJSON = function toJSON () {
    var base = Node.prototype.toJSON.call(this);
    base.text = this.text;
    return base
  };

  Object.defineProperties( TextNode.prototype, prototypeAccessors$1 );

  return TextNode;
}(Node));

function wrapMarks(marks, str) {
  for (var i = marks.length - 1; i >= 0; i--)
    { str = marks[i].type.name + "(" + str + ")"; }
  return str
}

// ::- Instances of this class represent a match state of a node
// type's [content expression](#model.NodeSpec.content), and can be
// used to find out whether further content matches here, and whether
// a given position is a valid end of the node.
var ContentMatch = function ContentMatch(validEnd) {
  // :: bool
  // True when this match state represents a valid end of the node.
  this.validEnd = validEnd;
  this.next = [];
  this.wrapCache = [];
};

var prototypeAccessors$5 = { inlineContent: {},defaultType: {},edgeCount: {} };

ContentMatch.parse = function parse (string, nodeTypes) {
  var stream = new TokenStream(string, nodeTypes);
  if (stream.next == null) { return ContentMatch.empty }
  var expr = parseExpr(stream);
  if (stream.next) { stream.err("Unexpected trailing text"); }
  var match = dfa(nfa(expr));
  checkForDeadEnds(match, stream);
  return match
};

// :: (NodeType) → ?ContentMatch
// Match a node type, returning a match after that node if
// successful.
ContentMatch.prototype.matchType = function matchType (type) {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2)
    { if (this$1.next[i] == type) { return this$1.next[i + 1] } }
  return null
};

// :: (Fragment, ?number, ?number) → ?ContentMatch
// Try to match a fragment. Returns the resulting match when
// successful.
ContentMatch.prototype.matchFragment = function matchFragment (frag, start, end) {
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = frag.childCount;

  var cur = this;
  for (var i = start; cur && i < end; i++)
    { cur = cur.matchType(frag.child(i).type); }
  return cur
};

prototypeAccessors$5.inlineContent.get = function () {
  var first = this.next[0];
  return first ? first.isInline : false
};

// :: ?NodeType
// Get the first matching node type at this match position that can
// be generated.
prototypeAccessors$5.defaultType.get = function () {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2) {
    var type = this$1.next[i];
    if (!(type.isText || type.hasRequiredAttrs())) { return type }
  }
};

ContentMatch.prototype.compatible = function compatible (other) {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2)
    { for (var j = 0; j < other.next.length; j += 2)
      { if (this$1.next[i] == other.next[j]) { return true } } }
  return false
};

// :: (Fragment, bool, ?number) → ?Fragment
// Try to match the given fragment, and if that fails, see if it can
// be made to match by inserting nodes in front of it. When
// successful, return a fragment of inserted nodes (which may be
// empty if nothing had to be inserted). When `toEnd` is true, only
// return a fragment if the resulting match goes to the end of the
// content expression.
ContentMatch.prototype.fillBefore = function fillBefore (after, toEnd, startIndex) {
    if ( toEnd === void 0 ) toEnd = false;
    if ( startIndex === void 0 ) startIndex = 0;

  var seen = [this];
  function search(match, types) {
    var finished = match.matchFragment(after, startIndex);
    if (finished && (!toEnd || finished.validEnd))
      { return Fragment.from(types.map(function (tp) { return tp.createAndFill(); })) }

    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i], next = match.next[i + 1];
      if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
        seen.push(next);
        var found = search(next, types.concat(type));
        if (found) { return found }
      }
    }
  }

  return search(this, [])
};

// :: (NodeType) → ?[NodeType]
// Find a set of wrapping node types that would allow a node of the
// given type to appear at this position. The result may be empty
// (when it fits directly) and will be null when no such wrapping
// exists.
ContentMatch.prototype.findWrapping = function findWrapping (target) {
    var this$1 = this;

  for (var i = 0; i < this.wrapCache.length; i += 2)
    { if (this$1.wrapCache[i] == target) { return this$1.wrapCache[i + 1] } }
  var computed = this.computeWrapping(target);
  this.wrapCache.push(target, computed);
  return computed
};

ContentMatch.prototype.computeWrapping = function computeWrapping (target) {
  var seen = Object.create(null), active = [{match: this, type: null, via: null}];
  while (active.length) {
    var current = active.shift(), match = current.match;
    if (match.matchType(target)) {
      var result = [];
      for (var obj = current; obj.type; obj = obj.via)
        { result.push(obj.type); }
      return result.reverse()
    }
    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i];
      if (!type.isLeaf && !(type.name in seen) && (!current.type || match.next[i + 1].validEnd)) {
        active.push({match: type.contentMatch, type: type, via: current});
        seen[type.name] = true;
      }
    }
  }
};

// :: number
// The number of outgoing edges this node has in the finite
// automaton that describes the content expression.
prototypeAccessors$5.edgeCount.get = function () {
  return this.next.length >> 1
};

// :: (number) → {type: NodeType, next: ContentMatch}
// Get the _n_th outgoing edge from this node in the finite
// automaton that describes the content expression.
ContentMatch.prototype.edge = function edge (n) {
  var i = n << 1;
  if (i > this.next.length) { throw new RangeError(("There's no " + n + "th edge in this content match")) }
  return {type: this.next[i], next: this.next[i + 1]}
};

ContentMatch.prototype.toString = function toString () {
  var seen = [];
  function scan(m) {
    seen.push(m);
    for (var i = 1; i < m.next.length; i += 2)
      { if (seen.indexOf(m.next[i]) == -1) { scan(m.next[i]); } }
  }
  scan(this);
  return seen.map(function (m, i) {
    var out = i + (m.validEnd ? "*" : " ") + " ";
    for (var i$1 = 0; i$1 < m.next.length; i$1 += 2)
      { out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]); }
    return out
  }).join("\n")
};

Object.defineProperties( ContentMatch.prototype, prototypeAccessors$5 );

ContentMatch.empty = new ContentMatch(true);

var TokenStream = function TokenStream(string, nodeTypes) {
  this.string = string;
  this.nodeTypes = nodeTypes;
  this.inline = null;
  this.pos = 0;
  this.tokens = string.split(/\s*(?=\b|\W|$)/);
  if (this.tokens[this.tokens.length - 1] == "") { this.tokens.pop(); }
  if (this.tokens[0] == "") { this.tokens.unshift(); }
};

var prototypeAccessors$1$3 = { next: {} };

prototypeAccessors$1$3.next.get = function () { return this.tokens[this.pos] };

TokenStream.prototype.eat = function eat (tok) { return this.next == tok && (this.pos++ || true) };

TokenStream.prototype.err = function err (str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')") };

Object.defineProperties( TokenStream.prototype, prototypeAccessors$1$3 );

function parseExpr(stream) {
  var exprs = [];
  do { exprs.push(parseExprSeq(stream)); }
  while (stream.eat("|"))
  return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
}

function parseExprSeq(stream) {
  var exprs = [];
  do { exprs.push(parseExprSubscript(stream)); }
  while (stream.next && stream.next != ")" && stream.next != "|")
  return exprs.length == 1 ? exprs[0] : {type: "seq", exprs: exprs}
}

function parseExprSubscript(stream) {
  var expr = parseExprAtom(stream);
  for (;;) {
    if (stream.eat("+"))
      { expr = {type: "plus", expr: expr}; }
    else if (stream.eat("*"))
      { expr = {type: "star", expr: expr}; }
    else if (stream.eat("?"))
      { expr = {type: "opt", expr: expr}; }
    else if (stream.eat("{"))
      { expr = parseExprRange(stream, expr); }
    else { break }
  }
  return expr
}

function parseNum(stream) {
  if (/\D/.test(stream.next)) { stream.err("Expected number, got '" + stream.next + "'"); }
  var result = Number(stream.next);
  stream.pos++;
  return result
}

function parseExprRange(stream, expr) {
  var min = parseNum(stream), max = min;
  if (stream.eat(",")) {
    if (stream.next != "}") { max = parseNum(stream); }
    else { max = -1; }
  }
  if (!stream.eat("}")) { stream.err("Unclosed braced range"); }
  return {type: "range", min: min, max: max, expr: expr}
}

function resolveName(stream, name) {
  var types = stream.nodeTypes, type = types[name];
  if (type) { return [type] }
  var result = [];
  for (var typeName in types) {
    var type$1 = types[typeName];
    if (type$1.groups.indexOf(name) > -1) { result.push(type$1); }
  }
  if (result.length == 0) { stream.err("No node type or group '" + name + "' found"); }
  return result
}

function parseExprAtom(stream) {
  if (stream.eat("(")) {
    var expr = parseExpr(stream);
    if (!stream.eat(")")) { stream.err("Missing closing paren"); }
    return expr
  } else if (!/\W/.test(stream.next)) {
    var exprs = resolveName(stream, stream.next).map(function (type) {
      if (stream.inline == null) { stream.inline = type.isInline; }
      else if (stream.inline != type.isInline) { stream.err("Mixing inline and block content"); }
      return {type: "name", value: type}
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}

// The code below helps compile a regular-expression-like language
// into a deterministic finite automaton. For a good introduction to
// these concepts, see https://swtch.com/~rsc/regexp/regexp1.html

// : (Object) → [[{term: ?any, to: number}]]
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function nfa(expr) {
  var nfa = [[]];
  connect(compile(expr, 0), node());
  return nfa

  function node() { return nfa.push([]) - 1 }
  function edge(from, to, term) {
    var edge = {term: term, to: to};
    nfa[from].push(edge);
    return edge
  }
  function connect(edges, to) { edges.forEach(function (edge) { return edge.to = to; }); }

  function compile(expr, from) {
    if (expr.type == "choice") {
      return expr.exprs.reduce(function (out, expr) { return out.concat(compile(expr, from)); }, [])
    } else if (expr.type == "seq") {
      for (var i = 0;; i++) {
        var next = compile(expr.exprs[i], from);
        if (i == expr.exprs.length - 1) { return next }
        connect(next, from = node());
      }
    } else if (expr.type == "star") {
      var loop = node();
      edge(from, loop);
      connect(compile(expr.expr, loop), loop);
      return [edge(loop)]
    } else if (expr.type == "plus") {
      var loop$1 = node();
      connect(compile(expr.expr, from), loop$1);
      connect(compile(expr.expr, loop$1), loop$1);
      return [edge(loop$1)]
    } else if (expr.type == "opt") {
      return [edge(from)].concat(compile(expr.expr, from))
    } else if (expr.type == "range") {
      var cur = from;
      for (var i$1 = 0; i$1 < expr.min; i$1++) {
        var next$1 = node();
        connect(compile(expr.expr, cur), next$1);
        cur = next$1;
      }
      if (expr.max == -1) {
        connect(compile(expr.expr, cur), cur);
      } else {
        for (var i$2 = expr.min; i$2 < expr.max; i$2++) {
          var next$2 = node();
          edge(cur, next$2);
          connect(compile(expr.expr, cur), next$2);
          cur = next$2;
        }
      }
      return [edge(cur)]
    } else if (expr.type == "name") {
      return [edge(from, null, expr.value)]
    }
  }
}

function cmp(a, b) { return a - b }

// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function nullFrom(nfa, node) {
  var result = [];
  scan(node);
  return result.sort(cmp)

  function scan(node) {
    var edges = nfa[node];
    if (edges.length == 1 && !edges[0].term) { return scan(edges[0].to) }
    result.push(node);
    for (var i = 0; i < edges.length; i++) {
      var ref = edges[i];
      var term = ref.term;
      var to = ref.to;
      if (!term && result.indexOf(to) == -1) { scan(to); }
    }
  }
}

// : ([[{term: ?any, to: number}]]) → ContentMatch
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function dfa(nfa) {
  var labeled = Object.create(null);
  return explore(nullFrom(nfa, 0))

  function explore(states) {
    var out = [];
    states.forEach(function (node) {
      nfa[node].forEach(function (ref) {
        var term = ref.term;
        var to = ref.to;

        if (!term) { return }
        var known = out.indexOf(term), set = known > -1 && out[known + 1];
        nullFrom(nfa, to).forEach(function (node) {
          if (!set) { out.push(term, set = []); }
          if (set.indexOf(node) == -1) { set.push(node); }
        });
      });
    });
    var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
    for (var i = 0; i < out.length; i += 2) {
      var states$1 = out[i + 1].sort(cmp);
      state.next.push(out[i], labeled[states$1.join(",")] || explore(states$1));
    }
    return state
  }
}

function checkForDeadEnds(match, stream) {
  for (var i = 0, work = [match]; i < work.length; i++) {
    var state = work[i], dead = !state.validEnd, nodes = [];
    for (var j = 0; j < state.next.length; j += 2) {
      var node = state.next[j], next = state.next[j + 1];
      nodes.push(node.name);
      if (dead && !(node.isText || node.hasRequiredAttrs())) { dead = false; }
      if (work.indexOf(next) == -1) { work.push(next); }
    }
    if (dead) { stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position"); }
  }
}

// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function defaultAttrs(attrs) {
  var defaults = Object.create(null);
  for (var attrName in attrs) {
    var attr = attrs[attrName];
    if (!attr.hasDefault) { return null }
    defaults[attrName] = attr.default;
  }
  return defaults
}

function computeAttrs(attrs, value) {
  var built = Object.create(null);
  for (var name in attrs) {
    var given = value && value[name];
    if (given === undefined) {
      var attr = attrs[name];
      if (attr.hasDefault) { given = attr.default; }
      else { throw new RangeError("No value supplied for attribute " + name) }
    }
    built[name] = given;
  }
  return built
}

function initAttrs(attrs) {
  var result = Object.create(null);
  if (attrs) { for (var name in attrs) { result[name] = new Attribute(attrs[name]); } }
  return result
}

// ::- Node types are objects allocated once per `Schema` and used to
// [tag](#model.Node.type) `Node` instances. They contain information
// about the node type, such as its name and what kind of node it
// represents.
var NodeType = function NodeType(name, schema, spec) {
  // :: string
  // The name the node type has in this schema.
  this.name = name;

  // :: Schema
  // A link back to the `Schema` the node type belongs to.
  this.schema = schema;

  // :: NodeSpec
  // The spec that this type is based on
  this.spec = spec;

  this.groups = spec.group ? spec.group.split(" ") : [];
  this.attrs = initAttrs(spec.attrs);

  this.defaultAttrs = defaultAttrs(this.attrs);

  // :: ContentMatch
  // The starting match of the node type's content expression.
  this.contentMatch = null;

  // : ?[MarkType]
  // The set of marks allowed in this node. `null` means all marks
  // are allowed.
  this.markSet = null;

  // :: bool
  // True if this node type has inline content.
  this.inlineContent = null;

  // :: bool
  // True if this is a block type
  this.isBlock = !(spec.inline || name == "text");

  // :: bool
  // True if this is the text node type.
  this.isText = name == "text";
};

var prototypeAccessors$4 = { isInline: {},isTextblock: {},isLeaf: {},isAtom: {} };

// :: bool
// True if this is an inline type.
prototypeAccessors$4.isInline.get = function () { return !this.isBlock };

// :: bool
// True if this is a textblock type, a block that contains inline
// content.
prototypeAccessors$4.isTextblock.get = function () { return this.isBlock && this.inlineContent };

// :: bool
// True for node types that allow no content.
prototypeAccessors$4.isLeaf.get = function () { return this.contentMatch == ContentMatch.empty };

// :: bool
// True when this node is an atom, i.e. when it does not have
// directly editable content.
prototypeAccessors$4.isAtom.get = function () { return this.isLeaf || this.spec.atom };

NodeType.prototype.hasRequiredAttrs = function hasRequiredAttrs (ignore) {
    var this$1 = this;

  for (var n in this$1.attrs)
    { if (this$1.attrs[n].isRequired && (!ignore || !(n in ignore))) { return true } }
  return false
};

NodeType.prototype.compatibleContent = function compatibleContent (other) {
  return this == other || this.contentMatch.compatible(other.contentMatch)
};

NodeType.prototype.computeAttrs = function computeAttrs$1 (attrs) {
  if (!attrs && this.defaultAttrs) { return this.defaultAttrs }
  else { return computeAttrs(this.attrs, attrs) }
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a `Node` of this type. The given attributes are
// checked and defaulted (you can pass `null` to use the type's
// defaults entirely, if no required attributes exist). `content`
// may be a `Fragment`, a node, an array of nodes, or
// `null`. Similarly `marks` may be `null` to default to the empty
// set of marks.
NodeType.prototype.create = function create (attrs, content, marks) {
  if (this.isText) { throw new Error("NodeType.create can't construct text nodes") }
  return new Node(this, this.computeAttrs(attrs), Fragment.from(content), Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Like [`create`](#model.NodeType.create), but check the given content
// against the node type's content restrictions, and throw an error
// if it doesn't match.
NodeType.prototype.createChecked = function createChecked (attrs, content, marks) {
  content = Fragment.from(content);
  if (!this.validContent(content))
    { throw new RangeError("Invalid content for node " + this.name) }
  return new Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → ?Node
// Like [`create`](#model.NodeType.create), but see if it is necessary to
// add nodes to the start or end of the given fragment to make it
// fit the node. If no fitting wrapping can be found, return null.
// Note that, due to the fact that required nodes can always be
// created, this will always succeed if you pass null or
// `Fragment.empty` as content.
NodeType.prototype.createAndFill = function createAndFill (attrs, content, marks) {
  attrs = this.computeAttrs(attrs);
  content = Fragment.from(content);
  if (content.size) {
    var before = this.contentMatch.fillBefore(content);
    if (!before) { return null }
    content = before.append(content);
  }
  var after = this.contentMatch.matchFragment(content).fillBefore(Fragment.empty, true);
  if (!after) { return null }
  return new Node(this, attrs, content.append(after), Mark.setFrom(marks))
};

// :: (Fragment) → bool
// Returns true if the given fragment is valid content for this node
// type with the given attributes.
NodeType.prototype.validContent = function validContent (content) {
    var this$1 = this;

  var result = this.contentMatch.matchFragment(content);
  if (!result || !result.validEnd) { return false }
  for (var i = 0; i < content.childCount; i++)
    { if (!this$1.allowsMarks(content.child(i).marks)) { return false } }
  return true
};

// :: (MarkType) → bool
// Check whether the given mark type is allowed in this node.
NodeType.prototype.allowsMarkType = function allowsMarkType (markType) {
  return this.markSet == null || this.markSet.indexOf(markType) > -1
};

// :: ([Mark]) → bool
// Test whether the given set of marks are allowed in this node.
NodeType.prototype.allowsMarks = function allowsMarks (marks) {
    var this$1 = this;

  if (this.markSet == null) { return true }
  for (var i = 0; i < marks.length; i++) { if (!this$1.allowsMarkType(marks[i].type)) { return false } }
  return true
};

// :: ([Mark]) → [Mark]
// Removes the marks that are not allowed in this node from the given set.
NodeType.prototype.allowedMarks = function allowedMarks (marks) {
    var this$1 = this;

  if (this.markSet == null) { return marks }
  var copy;
  for (var i = 0; i < marks.length; i++) {
    if (!this$1.allowsMarkType(marks[i].type)) {
      if (!copy) { copy = marks.slice(0, i); }
    } else if (copy) {
      copy.push(marks[i]);
    }
  }
  return !copy ? marks : copy.length ? copy : Mark.empty
};

NodeType.compile = function compile (nodes, schema) {
  var result = Object.create(null);
  nodes.forEach(function (name, spec) { return result[name] = new NodeType(name, schema, spec); });

  var topType = schema.spec.topNode || "doc";
  if (!result[topType]) { throw new RangeError("Schema is missing its top node type ('" + topType + "')") }
  if (!result.text) { throw new RangeError("Every schema needs a 'text' type") }
  for (var _ in result.text.attrs) { throw new RangeError("The text node type should not have attributes") }

  return result
};

Object.defineProperties( NodeType.prototype, prototypeAccessors$4 );

// Attribute descriptors

var Attribute = function Attribute(options) {
  this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
  this.default = options.default;
};

var prototypeAccessors$1$2 = { isRequired: {} };

prototypeAccessors$1$2.isRequired.get = function () {
  return !this.hasDefault
};

Object.defineProperties( Attribute.prototype, prototypeAccessors$1$2 );

// Marks

// ::- Like nodes, marks (which are associated with nodes to signify
// things like emphasis or being part of a link) are
// [tagged](#model.Mark.type) with type objects, which are
// instantiated once per `Schema`.
var MarkType = function MarkType(name, rank, schema, spec) {
  // :: string
  // The name of the mark type.
  this.name = name;

  // :: Schema
  // The schema that this mark type instance is part of.
  this.schema = schema;

  // :: MarkSpec
  // The spec on which the type is based.
  this.spec = spec;

  this.attrs = initAttrs(spec.attrs);

  this.rank = rank;
  this.excluded = null;
  var defaults = defaultAttrs(this.attrs);
  this.instance = defaults && new Mark(this, defaults);
};

// :: (?Object) → Mark
// Create a mark of this type. `attrs` may be `null` or an object
// containing only some of the mark's attributes. The others, if
// they have defaults, will be added.
MarkType.prototype.create = function create (attrs) {
  if (!attrs && this.instance) { return this.instance }
  return new Mark(this, computeAttrs(this.attrs, attrs))
};

MarkType.compile = function compile (marks, schema) {
  var result = Object.create(null), rank = 0;
  marks.forEach(function (name, spec) { return result[name] = new MarkType(name, rank++, schema, spec); });
  return result
};

// :: ([Mark]) → [Mark]
// When there is a mark of this type in the given set, a new set
// without it is returned. Otherwise, the input set is returned.
MarkType.prototype.removeFromSet = function removeFromSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this$1)
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → ?Mark
// Tests whether there is a mark of this type in the given set.
MarkType.prototype.isInSet = function isInSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this$1) { return set[i] } }
};

// :: (MarkType) → bool
// Queries whether a given mark type is
// [excluded](#model.MarkSpec.excludes) by this one.
MarkType.prototype.excludes = function excludes (other) {
  return this.excluded.indexOf(other) > -1
};

// SchemaSpec:: interface
// An object describing a schema, as passed to the [`Schema`](#model.Schema)
// constructor.
//
//   nodes:: union<Object<NodeSpec>, OrderedMap<NodeSpec>>
//   The node types in this schema. Maps names to
//   [`NodeSpec`](#model.NodeSpec) objects that describe the node type
//   associated with that name. Their order is significant—it
//   determines which [parse rules](#model.NodeSpec.parseDOM) take
//   precedence by default, and which nodes come first in a given
//   [group](#model.NodeSpec.group).
//
//   marks:: ?union<Object<MarkSpec>, OrderedMap<MarkSpec>>
//   The mark types that exist in this schema. The order in which they
//   are provided determines the order in which [mark
//   sets](#model.Mark.addToSet) are sorted and in which [parse
//   rules](#model.MarkSpec.parseDOM) are tried.
//
//   topNode:: ?string
//   The name of the default top-level node for the schema. Defaults
//   to `"doc"`.

// NodeSpec:: interface
//
//   content:: ?string
//   The content expression for this node, as described in the [schema
//   guide](/docs/guide/#schema.content_expressions). When not given,
//   the node does not allow any content.
//
//   marks:: ?string
//   The marks that are allowed inside of this node. May be a
//   space-separated string referring to mark names or groups, `"_"`
//   to explicitly allow all marks, or `""` to disallow marks. When
//   not given, nodes with inline content default to allowing all
//   marks, other nodes default to not allowing marks.
//
//   group:: ?string
//   The group or space-separated groups to which this node belongs,
//   which can be referred to in the content expressions for the
//   schema.
//
//   inline:: ?bool
//   Should be set to true for inline nodes. (Implied for text nodes.)
//
//   atom:: ?bool
//   Can be set to true to indicate that, though this isn't a [leaf
//   node](#model.NodeType.isLeaf), it doesn't have directly editable
//   content and should be treated as a single unit in the view.
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that nodes of this type get.
//
//   selectable:: ?bool
//   Controls whether nodes of this type can be selected as a [node
//   selection](#state.NodeSelection). Defaults to true for non-text
//   nodes.
//
//   draggable:: ?bool
//   Determines whether nodes of this type can be dragged without
//   being selected. Defaults to false.
//
//   code:: ?bool
//   Can be used to indicate that this node contains code, which
//   causes some commands to behave differently.
//
//   defining:: ?bool
//   Determines whether this node is considered an important parent
//   node during replace operations (such as paste). Non-defining (the
//   default) nodes get dropped when their entire content is replaced,
//   whereas defining nodes persist and wrap the inserted content.
//   Likewise, in _inserted_ content the defining parents of the
//   content are preserved when possible. Typically,
//   non-default-paragraph textblock types, and possibly list items,
//   are marked as defining.
//
//   isolating:: ?bool
//   When enabled (default is false), the sides of nodes of this type
//   count as boundaries that regular editing operations, like
//   backspacing or lifting, won't cross. An example of a node that
//   should probably have this enabled is a table cell.
//
//   toDOM:: ?(node: Node) → DOMOutputSpec
//   Defines the default way a node of this type should be serialized
//   to DOM/HTML (as used by
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)).
//   Should return a DOM node or an [array
//   structure](#model.DOMOutputSpec) that describes one, with an
//   optional number zero (“hole”) in it to indicate where the node's
//   content should be inserted.
//
//   For text nodes, the default is to create a text DOM node. Though
//   it is possible to create a serializer where text is rendered
//   differently, this is not supported inside the editor, so you
//   shouldn't override that in your text node spec.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this node, which can be
//   used by [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) to
//   automatically derive a parser. The `node` field in the rules is
//   implied (the name of this node will be filled in automatically).
//   If you supply your own parser, you do not need to also specify
//   parsing rules in your schema.

// MarkSpec:: interface
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that marks of this type get.
//
//   inclusive:: ?bool
//   Whether this mark should be active when the cursor is positioned
//   at its end (or at its start when that is also the start of the
//   parent node). Defaults to true.
//
//   excludes:: ?string
//   Determines which other marks this mark can coexist with. Should
//   be a space-separated strings naming other marks or groups of marks.
//   When a mark is [added](#model.Mark.addToSet) to a set, all marks
//   that it excludes are removed in the process. If the set contains
//   any mark that excludes the new mark but is not, itself, excluded
//   by the new mark, the mark can not be added an the set. You can
//   use the value `"_"` to indicate that the mark excludes all
//   marks in the schema.
//
//   Defaults to only being exclusive with marks of the same type. You
//   can set it to an empty string (or any string not containing the
//   mark's own name) to allow multiple marks of a given type to
//   coexist (as long as they have different attributes).
//
//   group:: ?string
//   The group or space-separated groups to which this mark belongs.
//
//   toDOM:: ?(mark: Mark, inline: bool) → DOMOutputSpec
//   Defines the default way marks of this type should be serialized
//   to DOM/HTML. When the resulting spec contains a hole, that is
//   where the marked content is placed. Otherwise, it is appended to
//   the top node.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this mark (see the
//   corresponding [node spec field](#model.NodeSpec.parseDOM)). The
//   `mark` field in the rules is implied.

// AttributeSpec:: interface
//
// Used to [define](#model.NodeSpec.attrs) attributes on nodes or
// marks.
//
//   default:: ?any
//   The default value for this attribute, to use when no explicit
//   value is provided. Attributes that have no default must be
//   provided whenever a node or mark of a type that has them is
//   created.

// ::- A document schema. Holds [node](#model.NodeType) and [mark
// type](#model.MarkType) objects for the nodes and marks that may
// occur in conforming documents, and provides functionality for
// creating and deserializing such documents.
var Schema = function Schema(spec) {
  var this$1 = this;

  // :: SchemaSpec
  // The [spec](#model.SchemaSpec) on which the schema is based,
  // with the added guarantee that its `nodes` and `marks`
  // properties are
  // [`OrderedMap`](https://github.com/marijnh/orderedmap) instances
  // (not raw objects).
  this.spec = {};
  for (var prop in spec) { this$1.spec[prop] = spec[prop]; }
  this.spec.nodes = OrderedMap.from(spec.nodes);
  this.spec.marks = OrderedMap.from(spec.marks);

  // :: Object<NodeType>
  // An object mapping the schema's node names to node type objects.
  this.nodes = NodeType.compile(this.spec.nodes, this);

  // :: Object<MarkType>
  // A map from mark names to mark type objects.
  this.marks = MarkType.compile(this.spec.marks, this);

  var contentExprCache = Object.create(null);
  for (var prop$1 in this$1.nodes) {
    if (prop$1 in this$1.marks)
      { throw new RangeError(prop$1 + " can not be both a node and a mark") }
    var type = this$1.nodes[prop$1], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
    type.contentMatch = contentExprCache[contentExpr] ||
      (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this$1.nodes));
    type.inlineContent = type.contentMatch.inlineContent;
    type.markSet = markExpr == "_" ? null :
      markExpr ? gatherMarks(this$1, markExpr.split(" ")) :
      markExpr == "" || !type.inlineContent ? [] : null;
  }
  for (var prop$2 in this$1.marks) {
    var type$1 = this$1.marks[prop$2], excl = type$1.spec.excludes;
    type$1.excluded = excl == null ? [type$1] : excl == "" ? [] : gatherMarks(this$1, excl.split(" "));
  }

  this.nodeFromJSON = this.nodeFromJSON.bind(this);
  this.markFromJSON = this.markFromJSON.bind(this);

  // :: NodeType
  // The type of the [default top node](#model.SchemaSpec.topNode)
  // for this schema.
  this.topNodeType = this.nodes[this.spec.topNode || "doc"];

  // :: Object
  // An object for storing whatever values modules may want to
  // compute and cache per schema. (If you want to store something
  // in it, try to use property names unlikely to clash.)
  this.cached = Object.create(null);
  this.cached.wrappings = Object.create(null);
};

// :: (union<string, NodeType>, ?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a node in this schema. The `type` may be a string or a
// `NodeType` instance. Attributes will be extended
// with defaults, `content` may be a `Fragment`,
// `null`, a `Node`, or an array of nodes.
Schema.prototype.node = function node (type, attrs, content, marks) {
  if (typeof type == "string")
    { type = this.nodeType(type); }
  else if (!(type instanceof NodeType))
    { throw new RangeError("Invalid node type: " + type) }
  else if (type.schema != this)
    { throw new RangeError("Node type from different schema used (" + type.name + ")") }

  return type.createChecked(attrs, content, marks)
};

// :: (string, ?[Mark]) → Node
// Create a text node in the schema. Empty text nodes are not
// allowed.
Schema.prototype.text = function text (text$1, marks) {
  var type = this.nodes.text;
  return new TextNode(type, type.defaultAttrs, text$1, Mark.setFrom(marks))
};

// :: (union<string, MarkType>, ?Object) → Mark
// Create a mark with the given type and attributes.
Schema.prototype.mark = function mark (type, attrs) {
  if (typeof type == "string") { type = this.marks[type]; }
  return type.create(attrs)
};

// :: (Object) → Node
// Deserialize a node from its JSON representation. This method is
// bound.
Schema.prototype.nodeFromJSON = function nodeFromJSON (json) {
  return Node.fromJSON(this, json)
};

// :: (Object) → Mark
// Deserialize a mark from its JSON representation. This method is
// bound.
Schema.prototype.markFromJSON = function markFromJSON (json) {
  return Mark.fromJSON(this, json)
};

Schema.prototype.nodeType = function nodeType (name) {
  var found = this.nodes[name];
  if (!found) { throw new RangeError("Unknown node type: " + name) }
  return found
};

function gatherMarks(schema, marks) {
  var found = [];
  for (var i = 0; i < marks.length; i++) {
    var name = marks[i], mark = schema.marks[name], ok = mark;
    if (mark) {
      found.push(mark);
    } else {
      for (var prop in schema.marks) {
        var mark$1 = schema.marks[prop];
        if (name == "_" || (mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1))
          { found.push(ok = mark$1); }
      }
    }
    if (!ok) { throw new SyntaxError("Unknown mark type: '" + marks[i] + "'") }
  }
  return found
}

// ParseOptions:: interface
// These are the options recognized by the
// [`parse`](#model.DOMParser.parse) and
// [`parseSlice`](#model.DOMParser.parseSlice) methods.
//
//   preserveWhitespace:: ?union<bool, "full">
//   By default, whitespace is collapsed as per HTML's rules. Pass
//   `true` to preserve whitespace, but normalize newlines to
//   spaces, and `"full"` to preserve whitespace entirely.
//
//   findPositions:: ?[{node: dom.Node, offset: number}]
//   When given, the parser will, beside parsing the content,
//   record the document positions of the given DOM positions. It
//   will do so by writing to the objects, adding a `pos` property
//   that holds the document position. DOM positions that are not
//   in the parsed content will not be written to.
//
//   from:: ?number
//   The child node index to start parsing from.
//
//   to:: ?number
//   The child node index to stop parsing at.
//
//   topNode:: ?Node
//   By default, the content is parsed into the schema's default
//   [top node type](#model.Schema.topNodeType). You can pass this
//   option to use the type and attributes from a different node
//   as the top container.
//
//   topMatch:: ?ContentMatch
//   Provide the starting content match that content parsed into the
//   top node is matched against.
//
//   context:: ?ResolvedPos
//   A set of additional nodes to count as
//   [context](#model.ParseRule.context) when parsing, above the
//   given [top node](#model.ParseOptions.topNode).

// ParseRule:: interface
// A value that describes how to parse a given DOM node or inline
// style as a ProseMirror node or mark.
//
//   tag:: ?string
//   A CSS selector describing the kind of DOM elements to match. A
//   single rule should have _either_ a `tag` or a `style` property.
//
//   namespace:: ?string
//   The namespace to match. This should be used with `tag`.
//   Nodes are only matched when the namespace matches or this property
//   is null.
//
//   style:: ?string
//   A CSS property name to match. When given, this rule matches
//   inline styles that list that property. May also have the form
//   `"property=value"`, in which case the rule only matches if the
//   propery's value exactly matches the given value. (For more
//   complicated filters, use [`getAttrs`](#model.ParseRule.getAttrs)
//   and return undefined to indicate that the match failed.)
//
//   priority:: ?number
//   Can be used to change the order in which the parse rules in a
//   schema are tried. Those with higher priority come first. Rules
//   without a priority are counted as having priority 50. This
//   property is only meaningful in a schema—when directly
//   constructing a parser, the order of the rule array is used.
//
//   context:: ?string
//   When given, restricts this rule to only match when the current
//   context—the parent nodes into which the content is being
//   parsed—matches this expression. Should contain one or more node
//   names or node group names followed by single or double slashes.
//   For example `"paragraph/"` means the rule only matches when the
//   parent node is a paragraph, `"blockquote/paragraph/"` restricts
//   it to be in a paragraph that is inside a blockquote, and
//   `"section//"` matches any position inside a section—a double
//   slash matches any sequence of ancestor nodes. To allow multiple
//   different contexts, they can be separated by a pipe (`|`)
//   character, as in `"blockquote/|list_item/"`.
//
//   node:: ?string
//   The name of the node type to create when this rule matches. Only
//   valid for rules with a `tag` property, not for style rules. Each
//   rule should have one of a `node`, `mark`, or `ignore` property
//   (except when it appears in a [node](#model.NodeSpec.parseDOM) or
//   [mark spec](#model.MarkSpec.parseDOM), in which case the `node`
//   or `mark` property will be derived from its position).
//
//   mark:: ?string
//   The name of the mark type to wrap the matched content in.
//
//   ignore:: ?bool
//   When true, ignore content that matches this rule.
//
//   skip:: ?bool
//   When true, ignore the node that matches this rule, but do parse
//   its content.
//
//   attrs:: ?Object
//   Attributes for the node or mark created by this rule. When
//   `getAttrs` is provided, it takes precedence.
//
//   getAttrs:: ?(union<dom.Node, string>) → ?union<Object, false>
//   A function used to compute the attributes for the node or mark
//   created by this rule. Can also be used to describe further
//   conditions the DOM element or style must match. When it returns
//   `false`, the rule won't match. When it returns null or undefined,
//   that is interpreted as an empty/default set of attributes.
//
//   Called with a DOM Element for `tag` rules, and with a string (the
//   style's value) for `style` rules.
//
//   contentElement:: ?union<string, (dom.Node) → dom.Node>
//   For `tag` rules that produce non-leaf nodes or marks, by default
//   the content of the DOM element is parsed as content of the mark
//   or node. If the child nodes are in a descendent node, this may be
//   a CSS selector string that the parser must use to find the actual
//   content element, or a function that returns the actual content
//   element to the parser.
//
//   getContent:: ?(dom.Node, schema: Schema) → Fragment
//   Can be used to override the content of a matched node. When
//   present, instead of parsing the node's child nodes, the result of
//   this function is used.
//
//   preserveWhitespace:: ?union<bool, "full">
//   Controls whether whitespace should be preserved when parsing the
//   content inside the matched element. `false` means whitespace may
//   be collapsed, `true` means that whitespace should be preserved
//   but newlines normalized to spaces, and `"full"` means that
//   newlines should also be preserved.

// ::- A DOM parser represents a strategy for parsing DOM content into
// a ProseMirror document conforming to a given schema. Its behavior
// is defined by an array of [rules](#model.ParseRule).
var DOMParser = function DOMParser(schema, rules) {
  var this$1 = this;

  // :: Schema
  // The schema into which the parser parses.
  this.schema = schema;
  // :: [ParseRule]
  // The set of [parse rules](#model.ParseRule) that the parser
  // uses, in order of precedence.
  this.rules = rules;
  this.tags = [];
  this.styles = [];

  rules.forEach(function (rule) {
    if (rule.tag) { this$1.tags.push(rule); }
    else if (rule.style) { this$1.styles.push(rule); }
  });
};

// :: (dom.Node, ?ParseOptions) → Node
// Parse a document from the content of a DOM node.
DOMParser.prototype.parse = function parse (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, false);
  context.addAll(dom, null, options.from, options.to);
  return context.finish()
};

// :: (dom.Node, ?ParseOptions) → Slice
// Parses the content of the given DOM node, like
// [`parse`](#model.DOMParser.parse), and takes the same set of
// options. But unlike that method, which produces a whole node,
// this one returns a slice that is open at the sides, meaning that
// the schema constraints aren't applied to the start of nodes to
// the left of the input and the end of nodes at the end.
DOMParser.prototype.parseSlice = function parseSlice (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, true);
  context.addAll(dom, null, options.from, options.to);
  return Slice.maxOpen(context.finish())
};

DOMParser.prototype.matchTag = function matchTag (dom, context) {
    var this$1 = this;

  for (var i = 0; i < this.tags.length; i++) {
    var rule = this$1.tags[i];
    if (matches(dom, rule.tag) &&
        (rule.namespace === undefined || dom.namespaceURI == rule.namespace) &&
        (!rule.context || context.matchesContext(rule.context))) {
      if (rule.getAttrs) {
        var result = rule.getAttrs(dom);
        if (result === false) { continue }
        rule.attrs = result;
      }
      return rule
    }
  }
};

DOMParser.prototype.matchStyle = function matchStyle (prop, value, context) {
    var this$1 = this;

  for (var i = 0; i < this.styles.length; i++) {
    var rule = this$1.styles[i];
    if (rule.style.indexOf(prop) != 0 ||
        rule.context && !context.matchesContext(rule.context) ||
        // Test that the style string either precisely matches the prop,
        // or has an '=' sign after the prop, followed by the given
        // value.
        rule.style.length > prop.length &&
        (rule.style.charCodeAt(prop.length) != 61 || rule.style.slice(prop.length + 1) != value))
      { continue }
    if (rule.getAttrs) {
      var result = rule.getAttrs(value);
      if (result === false) { continue }
      rule.attrs = result;
    }
    return rule
  }
};

// : (Schema) → [ParseRule]
DOMParser.schemaRules = function schemaRules (schema) {
  var result = [];
  function insert(rule) {
    var priority = rule.priority == null ? 50 : rule.priority, i = 0;
    for (; i < result.length; i++) {
      var next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
      if (nextPriority < priority) { break }
    }
    result.splice(i, 0, rule);
  }

  var loop = function ( name ) {
    var rules = schema.marks[name].spec.parseDOM;
    if (rules) { rules.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.mark = name;
    }); }
  };

    for (var name in schema.marks) loop( name );
  var loop$1 = function ( name ) {
    var rules$1 = schema.nodes[name$1].spec.parseDOM;
    if (rules$1) { rules$1.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.node = name$1;
    }); }
  };

    for (var name$1 in schema.nodes) loop$1( name );
  return result
};

// :: (Schema) → DOMParser
// Construct a DOM parser using the parsing rules listed in a
// schema's [node specs](#model.NodeSpec.parseDOM), reordered by
// [priority](#model.ParseRule.priority).
DOMParser.fromSchema = function fromSchema (schema) {
  return schema.cached.domParser ||
    (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)))
};

// : Object<bool> The block-level tags in HTML5
var blockTags = {
  address: true, article: true, aside: true, blockquote: true, canvas: true,
  dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
  footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
  h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
  output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
};

// : Object<bool> The tags that we normally ignore.
var ignoreTags = {
  head: true, noscript: true, object: true, script: true, style: true, title: true
};

// : Object<bool> List tags.
var listTags = {ol: true, ul: true};

// Using a bitfield for node context options
var OPT_PRESERVE_WS = 1;
var OPT_PRESERVE_WS_FULL = 2;
var OPT_OPEN_LEFT = 4;

function wsOptionsFor(preserveWhitespace) {
  return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0)
}

var NodeContext = function NodeContext(type, attrs, marks, solid, match, options) {
  this.type = type;
  this.attrs = attrs;
  this.solid = solid;
  this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  this.options = options;
  this.content = [];
  this.marks = marks;
  this.activeMarks = Mark.none;
};

NodeContext.prototype.findWrapping = function findWrapping (node) {
  if (!this.match) {
    if (!this.type) { return [] }
    var fill = this.type.contentMatch.fillBefore(Fragment.from(node));
    if (fill) {
      this.match = this.type.contentMatch.matchFragment(fill);
    } else {
      var start = this.type.contentMatch, wrap;
      if (wrap = start.findWrapping(node.type)) {
        this.match = start;
        return wrap
      } else {
        return null
      }
    }
  }
  return this.match.findWrapping(node.type)
};

NodeContext.prototype.finish = function finish (openEnd) {
  if (!(this.options & OPT_PRESERVE_WS)) { // Strip trailing whitespace
    var last = this.content[this.content.length - 1], m;
    if (last && last.isText && (m = /\s+$/.exec(last.text))) {
      if (last.text.length == m[0].length) { this.content.pop(); }
      else { this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length)); }
    }
  }
  var content = Fragment.from(this.content);
  if (!openEnd && this.match)
    { content = content.append(this.match.fillBefore(Fragment.empty, true)); }
  return this.type ? this.type.create(this.attrs, content, this.marks) : content
};

var ParseContext = function ParseContext(parser, options, open) {
  // : DOMParser The parser we are using.
  this.parser = parser;
  // : Object The options passed to this parse.
  this.options = options;
  this.isOpen = open;
  this.pendingMarks = [];
  var topNode = options.topNode, topContext;
  var topOptions = wsOptionsFor(options.preserveWhitespace) | (open ? OPT_OPEN_LEFT : 0);
  if (topNode)
    { topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true,
                                 options.topMatch || topNode.type.contentMatch, topOptions); }
  else if (open)
    { topContext = new NodeContext(null, null, Mark.none, true, null, topOptions); }
  else
    { topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions); }
  this.nodes = [topContext];
  // : [Mark] The current set of marks
  this.open = 0;
  this.find = options.findPositions;
  this.needsBlock = false;
};

var prototypeAccessors$6 = { top: {},currentPos: {} };

prototypeAccessors$6.top.get = function () {
  return this.nodes[this.open]
};

// : (dom.Node)
// Add a DOM node to the content. Text is inserted as text node,
// otherwise, the node is passed to `addElement` or, if it has a
// `style` attribute, `addElementWithStyles`.
ParseContext.prototype.addDOM = function addDOM (dom) {
    var this$1 = this;

  if (dom.nodeType == 3) {
    this.addTextNode(dom);
  } else if (dom.nodeType == 1) {
    var style = dom.getAttribute("style");
    if (!style) {
      this.addElement(dom);
    } else {
      var marks = this.readStyles(parseStyles(style));
      if (marks != null) {
        for (var i = 0; i < marks.length; i++) { this$1.addPendingMark(marks[i]); }
        this.addElement(dom);
        for (var i$1 = 0; i$1 < marks.length; i$1++) { this$1.removePendingMark(marks[i$1]); }
      }
    }
  }
};

ParseContext.prototype.addTextNode = function addTextNode (dom) {
  var value = dom.nodeValue;
  var top = this.top;
  if ((top.type ? top.type.inlineContent : top.content.length && top.content[0].isInline) || /\S/.test(value)) {
    if (!(top.options & OPT_PRESERVE_WS)) {
      value = value.replace(/\s+/g, " ");
      // If this starts with whitespace, and there is either no node
      // before it or a node that ends with whitespace, strip the
      // leading space.
      if (/^\s/.test(value) && this.open == this.nodes.length - 1) {
        var nodeBefore = top.content[top.content.length - 1];
        if (!nodeBefore || nodeBefore.isText && /\s$/.test(nodeBefore.text))
          { value = value.slice(1); }
      }
    } else if (!(top.options & OPT_PRESERVE_WS_FULL)) {
      value = value.replace(/\r?\n|\r/g, " ");
    }
    if (value) { this.insertNode(this.parser.schema.text(value)); }
    this.findInText(dom);
  } else {
    this.findInside(dom);
  }
};

// : (dom.Element)
// Try to find a handler for the given tag and use that to parse. If
// none is found, the element's content nodes are added directly.
ParseContext.prototype.addElement = function addElement (dom) {
  var name = dom.nodeName.toLowerCase();
  if (listTags.hasOwnProperty(name)) { normalizeList(dom); }
  var rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) || this.parser.matchTag(dom, this);
  if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
    this.findInside(dom);
  } else if (!rule || rule.skip) {
    if (rule && rule.skip.nodeType) { dom = rule.skip; }
    var sync, top = this.top, oldMarks = top.activeMarks, oldNeedsBlock = this.needsBlock;
    if (blockTags.hasOwnProperty(name)) {
      sync = true;
      if (!top.type) { this.needsBlock = true; }
    }
    this.addAll(dom);
    if (sync) { this.sync(top); }
    top.activeMarks = oldMarks;
    this.needsBlock = oldNeedsBlock;
  } else {
    this.addElementByRule(dom, rule);
  }
};

// Run any style parser associated with the node's styles. Either
// return an array of marks, or null to indicate some of the styles
// had a rule with `ignore` set.
ParseContext.prototype.readStyles = function readStyles (styles) {
    var this$1 = this;

  var marks = Mark.none;
  for (var i = 0; i < styles.length; i += 2) {
    var rule = this$1.parser.matchStyle(styles[i], styles[i + 1], this$1);
    if (!rule) { continue }
    if (rule.ignore) { return null }
    marks = this$1.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks);
  }
  return marks
};

// : (dom.Element, ParseRule) → bool
// Look up a handler for the given node. If none are found, return
// false. Otherwise, apply it, use its return value to drive the way
// the node's content is wrapped, and return true.
ParseContext.prototype.addElementByRule = function addElementByRule (dom, rule) {
    var this$1 = this;

  var sync, nodeType, markType, mark;
  if (rule.node) {
    nodeType = this.parser.schema.nodes[rule.node];
    if (nodeType.isLeaf) { this.insertNode(nodeType.create(rule.attrs)); }
    else { sync = this.enter(nodeType, rule.attrs, rule.preserveWhitespace); }
  } else {
    markType = this.parser.schema.marks[rule.mark];
    mark = markType.create(rule.attrs);
    this.addPendingMark(mark);
  }
  var startIn = this.top;

  if (nodeType && nodeType.isLeaf) {
    this.findInside(dom);
  } else if (rule.getContent) {
    this.findInside(dom);
    rule.getContent(dom, this.parser.schema).forEach(function (node) { return this$1.insertNode(node); });
  } else {
    var contentDOM = rule.contentElement;
    if (typeof contentDOM == "string") { contentDOM = dom.querySelector(contentDOM); }
    else if (typeof contentDOM == "function") { contentDOM = contentDOM(dom); }
    if (!contentDOM) { contentDOM = dom; }
    this.findAround(dom, contentDOM, true);
    this.addAll(contentDOM, sync);
  }
  if (sync) { this.sync(startIn); this.open--; }
  if (mark) { this.removePendingMark(mark); }
  return true
};

// : (dom.Node, ?NodeBuilder, ?number, ?number)
// Add all child nodes between `startIndex` and `endIndex` (or the
// whole node, if not given). If `sync` is passed, use it to
// synchronize after every block element.
ParseContext.prototype.addAll = function addAll (parent, sync, startIndex, endIndex) {
    var this$1 = this;

  var index = startIndex || 0;
  for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild,
           end = endIndex == null ? null : parent.childNodes[endIndex];
       dom != end; dom = dom.nextSibling, ++index) {
    this$1.findAtPoint(parent, index);
    this$1.addDOM(dom);
    if (sync && blockTags.hasOwnProperty(dom.nodeName.toLowerCase()))
      { this$1.sync(sync); }
  }
  this.findAtPoint(parent, index);
};

// Try to find a way to fit the given node type into the current
// context. May add intermediate wrappers and/or leave non-solid
// nodes that we're in.
ParseContext.prototype.findPlace = function findPlace (node) {
    var this$1 = this;

  var route, sync;
  for (var depth = this.open; depth >= 0; depth--) {
    var cx = this$1.nodes[depth];
    var found = cx.findWrapping(node);
    if (found && (!route || route.length > found.length)) {
      route = found;
      sync = cx;
      if (!found.length) { break }
    }
    if (cx.solid) { break }
  }
  if (!route) { return false }
  this.sync(sync);
  for (var i = 0; i < route.length; i++)
    { this$1.enterInner(route[i], null, false); }
  return true
};

// : (Node) → ?Node
// Try to insert the given node, adjusting the context when needed.
ParseContext.prototype.insertNode = function insertNode (node) {
  if (node.isInline && this.needsBlock && !this.top.type) {
    var block = this.textblockFromContext();
    if (block) { this.enter(block); }
  }
  if (this.findPlace(node)) {
    this.closeExtra();
    var top = this.top;
    this.applyPendingMarks(top);
    if (top.match) { top.match = top.match.matchType(node.type); }
    var marks = top.activeMarks;
    for (var i = 0; i < node.marks.length; i++)
      { if (!top.type || top.type.allowsMarkType(node.marks[i].type))
        { marks = node.marks[i].addToSet(marks); } }
    top.content.push(node.mark(marks));
  }
};

ParseContext.prototype.applyPendingMarks = function applyPendingMarks (top) {
    var this$1 = this;

  for (var i = 0; i < this.pendingMarks.length; i++) {
    var mark = this$1.pendingMarks[i];
    if ((!top.type || top.type.allowsMarkType(mark.type)) && !mark.type.isInSet(top.activeMarks)) {
      top.activeMarks = mark.addToSet(top.activeMarks);
      this$1.pendingMarks.splice(i--, 1);
    }
  }
};

// : (NodeType, ?Object) → bool
// Try to start a node of the given type, adjusting the context when
// necessary.
ParseContext.prototype.enter = function enter (type, attrs, preserveWS) {
  var ok = this.findPlace(type.create(attrs));
  if (ok) {
    this.applyPendingMarks(this.top);
    this.enterInner(type, attrs, true, preserveWS);
  }
  return ok
};

// Open a node of the given type
ParseContext.prototype.enterInner = function enterInner (type, attrs, solid, preserveWS) {
  this.closeExtra();
  var top = this.top;
  top.match = top.match && top.match.matchType(type, attrs);
  var options = preserveWS == null ? top.options & ~OPT_OPEN_LEFT : wsOptionsFor(preserveWS);
  if ((top.options & OPT_OPEN_LEFT) && top.content.length == 0) { options |= OPT_OPEN_LEFT; }
  this.nodes.push(new NodeContext(type, attrs, top.activeMarks, solid, null, options));
  this.open++;
};

// Make sure all nodes above this.open are finished and added to
// their parents
ParseContext.prototype.closeExtra = function closeExtra (openEnd) {
    var this$1 = this;

  var i = this.nodes.length - 1;
  if (i > this.open) {
    for (; i > this.open; i--) { this$1.nodes[i - 1].content.push(this$1.nodes[i].finish(openEnd)); }
    this.nodes.length = this.open + 1;
  }
};

ParseContext.prototype.finish = function finish () {
  this.open = 0;
  this.closeExtra(this.isOpen);
  return this.nodes[0].finish(this.isOpen || this.options.topOpen)
};

ParseContext.prototype.sync = function sync (to) {
    var this$1 = this;

  for (var i = this.open; i >= 0; i--) { if (this$1.nodes[i] == to) {
    this$1.open = i;
    return
  } }
};

ParseContext.prototype.addPendingMark = function addPendingMark (mark) {
  this.pendingMarks.push(mark);
};

ParseContext.prototype.removePendingMark = function removePendingMark (mark) {
  var found = this.pendingMarks.lastIndexOf(mark);
  if (found > -1) {
    this.pendingMarks.splice(mark, 1);
  } else {
    var top = this.top;
    top.activeMarks = mark.removeFromSet(top.activeMarks);
  }
};

prototypeAccessors$6.currentPos.get = function () {
    var this$1 = this;

  this.closeExtra();
  var pos = 0;
  for (var i = this.open; i >= 0; i--) {
    var content = this$1.nodes[i].content;
    for (var j = content.length - 1; j >= 0; j--)
      { pos += content[j].nodeSize; }
    if (i) { pos++; }
  }
  return pos
};

ParseContext.prototype.findAtPoint = function findAtPoint (parent, offset) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].node == parent && this$1.find[i].offset == offset)
      { this$1.find[i].pos = this$1.currentPos; }
  } }
};

ParseContext.prototype.findInside = function findInside (parent) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].pos == null && parent.nodeType == 1 && parent.contains(this$1.find[i].node))
      { this$1.find[i].pos = this$1.currentPos; }
  } }
};

ParseContext.prototype.findAround = function findAround (parent, content, before) {
    var this$1 = this;

  if (parent != content && this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].pos == null && parent.nodeType == 1 && parent.contains(this$1.find[i].node)) {
      var pos = content.compareDocumentPosition(this$1.find[i].node);
      if (pos & (before ? 2 : 4))
        { this$1.find[i].pos = this$1.currentPos; }
    }
  } }
};

ParseContext.prototype.findInText = function findInText (textNode) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].node == textNode)
      { this$1.find[i].pos = this$1.currentPos - (textNode.nodeValue.length - this$1.find[i].offset); }
  } }
};

// : (string) → bool
// Determines whether the given [context
// string](#ParseRule.context) matches this context.
ParseContext.prototype.matchesContext = function matchesContext (context) {
    var this$1 = this;

  if (context.indexOf("|") > -1)
    { return context.split(/\s*\|\s*/).some(this.matchesContext, this) }

  var parts = context.split("/");
  var option = this.options.context;
  var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
  var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
  var match = function (i, depth) {
    for (; i >= 0; i--) {
      var part = parts[i];
      if (part == "") {
        if (i == parts.length - 1 || i == 0) { continue }
        for (; depth >= minDepth; depth--)
          { if (match(i - 1, depth)) { return true } }
        return false
      } else {
        var next = depth > 0 || (depth == 0 && useRoot) ? this$1.nodes[depth].type
            : option && depth >= minDepth ? option.node(depth - minDepth).type
            : null;
        if (!next || (next.name != part && next.groups.indexOf(part) == -1))
          { return false }
        depth--;
      }
    }
    return true
  };
  return match(parts.length - 1, this.open)
};

ParseContext.prototype.textblockFromContext = function textblockFromContext () {
    var this$1 = this;

  var $context = this.options.context;
  if ($context) { for (var d = $context.depth; d >= 0; d--) {
    var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
    if (deflt && deflt.isTextblock && deflt.defaultAttrs) { return deflt }
  } }
  for (var name in this$1.parser.schema.nodes) {
    var type = this$1.parser.schema.nodes[name];
    if (type.isTextblock && type.defaultAttrs) { return type }
  }
};

Object.defineProperties( ParseContext.prototype, prototypeAccessors$6 );

// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function normalizeList(dom) {
  for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name && listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name == "li") {
      prevItem = child;
    } else if (name) {
      prevItem = null;
    }
  }
}

// Apply a CSS selector.
function matches(dom, selector) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector)
}

// : (string) → [string]
// Tokenize a style attribute into property/value pairs.
function parseStyles(style) {
  var re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
  while (m = re.exec(style)) { result.push(m[1], m[2].trim()); }
  return result
}

function copy(obj) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  return copy
}

// DOMOutputSpec:: interface
// A description of a DOM structure. Can be either a string, which is
// interpreted as a text node, a DOM node, which is interpreted as
// itself, or an array.
//
// An array describes a DOM element. The first value in the array
// should be a string—the name of the DOM element. If the second
// element is plain object, it is interpreted as a set of attributes
// for the element. Any elements after that (including the 2nd if it's
// not an attribute object) are interpreted as children of the DOM
// elements, and must either be valid `DOMOutputSpec` values, or the
// number zero.
//
// The number zero (pronounced “hole”) is used to indicate the place
// where a node's child nodes should be inserted. It it occurs in an
// output spec, it should be the only child element in its parent
// node.

// ::- A DOM serializer knows how to convert ProseMirror nodes and
// marks of various types to DOM nodes.
var DOMSerializer = function DOMSerializer(nodes, marks) {
  // :: Object<(node: Node) → DOMOutputSpec>
  // The node serialization functions.
  this.nodes = nodes || {};
  // :: Object<?(mark: Mark, inline: bool) → DOMOutputSpec>
  // The mark serialization functions.
  this.marks = marks || {};
};

// :: (Fragment, ?Object) → dom.DocumentFragment
// Serialize the content of this fragment to a DOM fragment. When
// not in the browser, the `document` option, containing a DOM
// document, should be passed so that the serializer can create
// nodes.
DOMSerializer.prototype.serializeFragment = function serializeFragment (fragment, options, target) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

  if (!target) { target = doc(options).createDocumentFragment(); }

  var top = target, active = null;
  fragment.forEach(function (node) {
    if (active || node.marks.length) {
      if (!active) { active = []; }
      var keep = 0, rendered = 0;
      while (keep < active.length && rendered < node.marks.length) {
        var next = node.marks[rendered];
        if (!this$1.marks[next.type.name]) { rendered++; continue }
        if (!next.eq(active[keep])) { break }
        keep += 2; rendered++;
      }
      while (keep < active.length) {
        top = active.pop();
        active.pop();
      }
      while (rendered < node.marks.length) {
        var add = node.marks[rendered++];
        var markDOM = this$1.serializeMark(add, node.isInline, options);
        if (markDOM) {
          active.push(add, top);
          top.appendChild(markDOM.dom);
          top = markDOM.contentDOM || markDOM.dom;
        }
      }
    }
    top.appendChild(this$1.serializeNode(node, options));
  });

  return target
};

// :: (Node, ?Object) → dom.Node
// Serialize this node to a DOM node. This can be useful when you
// need to serialize a part of a document, as opposed to the whole
// document. To serialize a whole document, use
// [`serializeFragment`](#model.DOMSerializer.serializeFragment) on
// its [content](#model.Node.content).
DOMSerializer.prototype.serializeNode = function serializeNode (node, options) {
    if ( options === void 0 ) options = {};

  var ref =
      DOMSerializer.renderSpec(doc(options), this.nodes[node.type.name](node));
    var dom = ref.dom;
    var contentDOM = ref.contentDOM;
  if (contentDOM) {
    if (node.isLeaf)
      { throw new RangeError("Content hole not allowed in a leaf node spec") }
    if (options.onContent)
      { options.onContent(node, contentDOM, options); }
    else
      { this.serializeFragment(node.content, options, contentDOM); }
  }
  return dom
};

DOMSerializer.prototype.serializeNodeAndMarks = function serializeNodeAndMarks (node, options) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

  var dom = this.serializeNode(node, options);
  for (var i = node.marks.length - 1; i >= 0; i--) {
    var wrap = this$1.serializeMark(node.marks[i], node.isInline, options);
    if (wrap) {
      (wrap.contentDOM || wrap.dom).appendChild(dom);
      dom = wrap.dom;
    }
  }
  return dom
};

DOMSerializer.prototype.serializeMark = function serializeMark (mark, inline, options) {
    if ( options === void 0 ) options = {};

  var toDOM = this.marks[mark.type.name];
  return toDOM && DOMSerializer.renderSpec(doc(options), toDOM(mark, inline))
};

// :: (dom.Document, DOMOutputSpec) → {dom: dom.Node, contentDOM: ?dom.Node}
// Render an [output spec](#model.DOMOutputSpec) to a DOM node. If
// the spec has a hole (zero) in it, `contentDOM` will point at the
// node with the hole.
DOMSerializer.renderSpec = function renderSpec (doc, structure) {
  if (typeof structure == "string")
    { return {dom: doc.createTextNode(structure)} }
  if (structure.nodeType != null)
    { return {dom: structure} }
  var dom = doc.createElement(structure[0]), contentDOM = null;
  var attrs = structure[1], start = 1;
  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start = 2;
    for (var name in attrs) {
      if (name == "style") { dom.style.cssText = attrs[name]; }
      else if (attrs[name] != null) { dom.setAttribute(name, attrs[name]); }
    }
  }
  for (var i = start; i < structure.length; i++) {
    var child = structure[i];
    if (child === 0) {
      if (i < structure.length - 1 || i > start)
        { throw new RangeError("Content hole must be the only child of its parent node") }
      return {dom: dom, contentDOM: dom}
    } else {
      var ref = DOMSerializer.renderSpec(doc, child);
        var inner = ref.dom;
        var innerContent = ref.contentDOM;
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM) { throw new RangeError("Multiple content holes") }
        contentDOM = innerContent;
      }
    }
  }
  return {dom: dom, contentDOM: contentDOM}
};

// :: (Schema) → DOMSerializer
// Build a serializer using the [`toDOM`](#model.NodeSpec.toDOM)
// properties in a schema's node and mark specs.
DOMSerializer.fromSchema = function fromSchema (schema) {
  return schema.cached.domSerializer ||
    (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)))
};

// : (Schema) → Object<(node: Node) → DOMOutputSpec>
// Gather the serializers in a schema's node specs into an object.
// This can be useful as a base to build a custom serializer from.
DOMSerializer.nodesFromSchema = function nodesFromSchema (schema) {
  var result = gatherToDOM(schema.nodes);
  if (!result.text) { result.text = function (node) { return node.text; }; }
  return result
};

// : (Schema) → Object<(mark: Mark) → DOMOutputSpec>
// Gather the serializers in a schema's mark specs into an object.
DOMSerializer.marksFromSchema = function marksFromSchema (schema) {
  return gatherToDOM(schema.marks)
};

function gatherToDOM(obj) {
  var result = {};
  for (var name in obj) {
    var toDOM = obj[name].spec.toDOM;
    if (toDOM) { result[name] = toDOM; }
  }
  return result
}

function doc(options) {
  // declare global: window
  return options.document || window.document
}

exports.Node = Node;
exports.ResolvedPos = ResolvedPos;
exports.NodeRange = NodeRange;
exports.Fragment = Fragment;
exports.Slice = Slice;
exports.ReplaceError = ReplaceError;
exports.Mark = Mark;
exports.Schema = Schema;
exports.NodeType = NodeType;
exports.MarkType = MarkType;
exports.ContentMatch = ContentMatch;
exports.DOMParser = DOMParser;
exports.DOMSerializer = DOMSerializer;
//# sourceMappingURL=index.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__(6);

// Mappable:: interface
// There are several things that positions can be mapped through.
// Such objects conform to this interface.
//
//   map:: (pos: number, assoc: ?number) → number
//   Map a position through this object. When given, `assoc` (should
//   be -1 or 1, defaults to 1) determines with which side the
//   position is associated, which determines in which direction to
//   move when a chunk of content is inserted at the mapped position.
//
//   mapResult:: (pos: number, assoc: ?number) → MapResult
//   Map a position, and return an object containing additional
//   information about the mapping. The result's `deleted` field tells
//   you whether the position was deleted (completely enclosed in a
//   replaced range) during the mapping. When content on only one side
//   is deleted, the position itself is only considered deleted when
//   `assoc` points in the direction of the deleted content.

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.

var lower16 = 0xffff;
var factor16 = Math.pow(2, 16);

function makeRecover(index, offset) { return index + offset * factor16 }
function recoverIndex(value) { return value & lower16 }
function recoverOffset(value) { return (value - (value & lower16)) / factor16 }

// ::- An object representing a mapped position with extra
// information.
var MapResult = function MapResult(pos, deleted, recover) {
  if ( deleted === void 0 ) deleted = false;
  if ( recover === void 0 ) recover = null;

  // :: number The mapped version of the position.
  this.pos = pos;
  // :: bool Tells you whether the position was deleted, that is,
  // whether the step removed its surroundings from the document.
  this.deleted = deleted;
  this.recover = recover;
};

// :: class extends Mappable
// A map describing the deletions and insertions made by a step, which
// can be used to find the correspondence between positions in the
// pre-step version of a document and the same position in the
// post-step version.
var StepMap = function StepMap(ranges, inverted) {
  if ( inverted === void 0 ) inverted = false;

  this.ranges = ranges;
  this.inverted = inverted;
};

StepMap.prototype.recover = function recover (value) {
    var this$1 = this;

  var diff = 0, index = recoverIndex(value);
  if (!this.inverted) { for (var i = 0; i < index; i++)
    { diff += this$1.ranges[i * 3 + 2] - this$1.ranges[i * 3 + 1]; } }
  return this.ranges[index * 3] + diff + recoverOffset(value)
};

// : (number, ?number) → MapResult
StepMap.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

// : (number, ?number) → number
StepMap.prototype.map = function map (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, true) };

StepMap.prototype._map = function _map (pos, assoc, simple) {
    var this$1 = this;

  var diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i] - (this$1.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this$1.ranges[i + oldIndex], newSize = this$1.ranges[i + newIndex], end = start + oldSize;
    if (pos <= end) {
      var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
      var result = start + diff + (side < 0 ? 0 : newSize);
      if (simple) { return result }
      var recover = makeRecover(i / 3, pos - start);
      return new MapResult(result, assoc < 0 ? pos != start : pos != end, recover)
    }
    diff += newSize - oldSize;
  }
  return simple ? pos + diff : new MapResult(pos + diff)
};

StepMap.prototype.touches = function touches (pos, recover) {
    var this$1 = this;

  var diff = 0, index = recoverIndex(recover);
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i] - (this$1.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this$1.ranges[i + oldIndex], end = start + oldSize;
    if (pos <= end && i == index * 3) { return true }
    diff += this$1.ranges[i + newIndex] - oldSize;
  }
  return false
};

// :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
// Calls the given function on each of the changed ranges included in
// this map.
StepMap.prototype.forEach = function forEach (f) {
    var this$1 = this;

  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i], oldStart = start - (this$1.inverted ? diff : 0), newStart = start + (this$1.inverted ? 0 : diff);
    var oldSize = this$1.ranges[i + oldIndex], newSize = this$1.ranges[i + newIndex];
    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
    diff += newSize - oldSize;
  }
};

// :: () → StepMap
// Create an inverted version of this map. The result can be used to
// map positions in the post-step document to the pre-step document.
StepMap.prototype.invert = function invert () {
  return new StepMap(this.ranges, !this.inverted)
};

StepMap.prototype.toString = function toString () {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges)
};

// :: (n: number) → StepMap
// Create a map that moves all positions by offset `n` (which may be
// negative). This can be useful when applying steps meant for a
// sub-document to a larger document, or vice-versa.
StepMap.offset = function offset (n) {
  return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n])
};

StepMap.empty = new StepMap([]);

// :: class extends Mappable
// A mapping represents a pipeline of zero or more [step
// maps](#transform.StepMap). It has special provisions for losslessly
// handling mapping positions through a series of steps in which some
// steps are inverted versions of earlier steps. (This comes up when
// ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
// collaboration or history management.)
var Mapping = function Mapping(maps, mirror, from, to) {
  // :: [StepMap]
  // The step maps in this mapping.
  this.maps = maps || [];
  // :: number
  // The starting position in the `maps` array, used when `map` or
  // `mapResult` is called.
  this.from = from || 0;
  // :: number
  // The end position in the `maps` array.
  this.to = to == null ? this.maps.length : to;
  this.mirror = mirror;
};

// :: (?number, ?number) → Mapping
// Create a mapping that maps only through a part of this one.
Mapping.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.maps.length;

  return new Mapping(this.maps, this.mirror, from, to)
};

Mapping.prototype.copy = function copy () {
  return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to)
};

// :: (StepMap, ?number)
// Add a step map to the end of this mapping. If `mirrors` is
// given, it should be the index of the step map that is the mirror
// image of this one.
Mapping.prototype.appendMap = function appendMap (map, mirrors) {
  this.to = this.maps.push(map);
  if (mirrors != null) { this.setMirror(this.maps.length - 1, mirrors); }
};

// :: (Mapping)
// Add all the step maps in a given mapping to this one (preserving
// mirroring information).
Mapping.prototype.appendMapping = function appendMapping (mapping) {
    var this$1 = this;

  for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
    var mirr = mapping.getMirror(i);
    this$1.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
  }
};

// :: (number) → ?number
// Finds the offset of the step map that mirrors the map at the
// given offset, in this mapping (as per the second argument to
// `appendMap`).
Mapping.prototype.getMirror = function getMirror (n) {
    var this$1 = this;

  if (this.mirror) { for (var i = 0; i < this.mirror.length; i++)
    { if (this$1.mirror[i] == n) { return this$1.mirror[i + (i % 2 ? -1 : 1)] } } }
};

Mapping.prototype.setMirror = function setMirror (n, m) {
  if (!this.mirror) { this.mirror = []; }
  this.mirror.push(n, m);
};

// :: (Mapping)
// Append the inverse of the given mapping to this one.
Mapping.prototype.appendMappingInverted = function appendMappingInverted (mapping) {
    var this$1 = this;

  for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
    var mirr = mapping.getMirror(i);
    this$1.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
  }
};

// () → Mapping
// Create an inverted version of this mapping.
Mapping.prototype.invert = function invert () {
  var inverse = new Mapping;
  inverse.appendMappingInverted(this);
  return inverse
};

// : (number, ?number) → number
// Map a position through this mapping.
Mapping.prototype.map = function map (pos, assoc) {
    var this$1 = this;
    if ( assoc === void 0 ) assoc = 1;

  if (this.mirror) { return this._map(pos, assoc, true) }
  for (var i = this.from; i < this.to; i++)
    { pos = this$1.maps[i].map(pos, assoc); }
  return pos
};

// : (number, ?number) → MapResult
// Map a position through this mapping, returning a mapping
// result.
Mapping.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

Mapping.prototype._map = function _map (pos, assoc, simple) {
    var this$1 = this;

  var deleted = false, recoverables = null;

  for (var i = this.from; i < this.to; i++) {
    var map = this$1.maps[i], rec = recoverables && recoverables[i];
    if (rec != null && map.touches(pos, rec)) {
      pos = map.recover(rec);
      continue
    }

    var result = map.mapResult(pos, assoc);
    if (result.recover != null) {
      var corr = this$1.getMirror(i);
      if (corr != null && corr > i && corr < this$1.to) {
        if (result.deleted) {
          i = corr;
          pos = this$1.maps[corr].recover(result.recover);
          continue
        } else {
          (recoverables || (recoverables = Object.create(null)))[corr] = result.recover;
        }
      }
    }

    if (result.deleted) { deleted = true; }
    pos = result.pos;
  }

  return simple ? pos : new MapResult(pos, deleted)
};

function TransformError(message) {
  var err = Error.call(this, message);
  err.__proto__ = TransformError.prototype;
  return err
}

TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";

// ::- Abstraction to build up and track an array of
// [steps](#transform.Step) representing a document transformation.
//
// Most transforming methods return the `Transform` object itself, so
// that they can be chained.
var Transform = function Transform(doc) {
  // :: Node
  // The current document (the result of applying the steps in the
  // transform).
  this.doc = doc;
  // :: [Step]
  // The steps in this transform.
  this.steps = [];
  // :: [Node]
  // The documents before each of the steps.
  this.docs = [];
  // :: Mapping
  // A mapping with the maps for each of the steps in this transform.
  this.mapping = new Mapping;
};

var prototypeAccessors = { before: {},docChanged: {} };

// :: Node The starting document.
prototypeAccessors.before.get = function () { return this.docs.length ? this.docs[0] : this.doc };

// :: (step: Step) → this
// Apply a new step in this transform, saving the result. Throws an
// error when the step fails.
Transform.prototype.step = function step (object) {
  var result = this.maybeStep(object);
  if (result.failed) { throw new TransformError(result.failed) }
  return this
};

// :: (Step) → StepResult
// Try to apply a step in this transformation, ignoring it if it
// fails. Returns the step result.
Transform.prototype.maybeStep = function maybeStep (step) {
  var result = step.apply(this.doc);
  if (!result.failed) { this.addStep(step, result.doc); }
  return result
};

// :: bool
// True when the document has been changed (when there are any
// steps).
prototypeAccessors.docChanged.get = function () {
  return this.steps.length > 0
};

Transform.prototype.addStep = function addStep (step, doc) {
  this.docs.push(this.doc);
  this.steps.push(step);
  this.mapping.appendMap(step.getMap());
  this.doc = doc;
};

Object.defineProperties( Transform.prototype, prototypeAccessors );

function mustOverride() { throw new Error("Override me") }

var stepsByID = Object.create(null);

// ::- A step object represents an atomic change. It generally applies
// only to the document it was created for, since the positions
// stored in it will only make sense for that document.
//
// New steps are defined by creating classes that extend `Step`,
// overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
// methods, and registering your class with a unique
// JSON-serialization identifier using
// [`Step.jsonID`](#transform.Step^jsonID).
var Step = function Step () {};

Step.prototype.apply = function apply (_doc) { return mustOverride() };

// :: () → StepMap
// Get the step map that represents the changes made by this step,
// and which can be used to transform between positions in the old
// and the new document.
Step.prototype.getMap = function getMap () { return StepMap.empty };

// :: (doc: Node) → Step
// Create an inverted version of this step. Needs the document as it
// was before the step as argument.
Step.prototype.invert = function invert (_doc) { return mustOverride() };

// :: (mapping: Mappable) → ?Step
// Map this step through a mappable thing, returning either a
// version of that step with its positions adjusted, or `null` if
// the step was entirely deleted by the mapping.
Step.prototype.map = function map (_mapping) { return mustOverride() };

// :: (other: Step) → ?Step
// Try to merge this step with another one, to be applied directly
// after it. Returns the merged step when possible, null if the
// steps can't be merged.
Step.prototype.merge = function merge (_other) { return null };

// :: () → Object
// Create a JSON-serializeable representation of this step. When
// defining this for a custom subclass, make sure the result object
// includes the step type's [JSON id](#transform.Step^jsonID) under
// the `stepType` property.
Step.prototype.toJSON = function toJSON () { return mustOverride() };

// :: (Schema, Object) → Step
// Deserialize a step from its JSON representation. Will call
// through to the step class' own implementation of this method.
Step.fromJSON = function fromJSON (schema, json) {
  if (!json || !json.stepType) { throw new RangeError("Invalid input for Step.fromJSON") }
  var type = stepsByID[json.stepType];
  if (!type) { throw new RangeError(("No step type " + (json.stepType) + " defined")) }
  return type.fromJSON(schema, json)
};

// :: (string, constructor<Step>)
// To be able to serialize steps to JSON, each step needs a string
// ID to attach to its JSON representation. Use this method to
// register an ID for your step classes. Try to pick something
// that's unlikely to clash with steps from other modules.
Step.jsonID = function jsonID (id, stepClass) {
  if (id in stepsByID) { throw new RangeError("Duplicate use of step JSON ID " + id) }
  stepsByID[id] = stepClass;
  stepClass.prototype.jsonID = id;
  return stepClass
};

// ::- The result of [applying](#transform.Step.apply) a step. Contains either a
// new document or a failure value.
var StepResult = function StepResult(doc, failed) {
  // :: ?Node The transformed document.
  this.doc = doc;
  // :: ?string Text providing information about a failed step.
  this.failed = failed;
};

// :: (Node) → StepResult
// Create a successful step result.
StepResult.ok = function ok (doc) { return new StepResult(doc, null) };

// :: (string) → StepResult
// Create a failed step result.
StepResult.fail = function fail (message) { return new StepResult(null, message) };

// :: (Node, number, number, Slice) → StepResult
// Call [`Node.replace`](#model.Node.replace) with the given
// arguments. Create a successful result if it succeeds, and a
// failed one if it throws a `ReplaceError`.
StepResult.fromReplace = function fromReplace (doc, from, to, slice) {
  try {
    return StepResult.ok(doc.replace(from, to, slice))
  } catch (e) {
    if (e instanceof prosemirrorModel.ReplaceError) { return StepResult.fail(e.message) }
    throw e
  }
};

// ::- Replace a part of the document with a slice of new content.
var ReplaceStep = (function (Step$$1) {
  function ReplaceStep(from, to, slice, structure) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.slice = slice;
    this.structure = !!structure;
  }

  if ( Step$$1 ) ReplaceStep.__proto__ = Step$$1;
  ReplaceStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  ReplaceStep.prototype.constructor = ReplaceStep;

  ReplaceStep.prototype.apply = function apply (doc) {
    if (this.structure && contentBetween(doc, this.from, this.to))
      { return StepResult.fail("Structure replace would overwrite content") }
    return StepResult.fromReplace(doc, this.from, this.to, this.slice)
  };

  ReplaceStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.to - this.from, this.slice.size])
  };

  ReplaceStep.prototype.invert = function invert (doc) {
    return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to))
  };

  ReplaceStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted) { return null }
    return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice)
  };

  ReplaceStep.prototype.merge = function merge (other) {
    if (!(other instanceof ReplaceStep) || other.structure != this.structure) { return null }

    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      var slice = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty
          : new prosemirrorModel.Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure)
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      var slice$1 = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty
          : new prosemirrorModel.Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new ReplaceStep(other.from, this.to, slice$1, this.structure)
    } else {
      return null
    }
  };

  ReplaceStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replace", from: this.from, to: this.to};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for ReplaceStep.fromJSON") }
    return new ReplaceStep(json.from, json.to, prosemirrorModel.Slice.fromJSON(schema, json.slice), !!json.structure)
  };

  return ReplaceStep;
}(Step));

Step.jsonID("replace", ReplaceStep);

// ::- Replace a part of the document with a slice of content, but
// preserve a range of the replaced content by moving it into the
// slice.
var ReplaceAroundStep = (function (Step$$1) {
  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.gapFrom = gapFrom;
    this.gapTo = gapTo;
    this.slice = slice;
    this.insert = insert;
    this.structure = !!structure;
  }

  if ( Step$$1 ) ReplaceAroundStep.__proto__ = Step$$1;
  ReplaceAroundStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;

  ReplaceAroundStep.prototype.apply = function apply (doc) {
    if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
                           contentBetween(doc, this.gapTo, this.to)))
      { return StepResult.fail("Structure gap-replace would overwrite content") }

    var gap = doc.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      { return StepResult.fail("Gap is not a flat range") }
    var inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted) { return StepResult.fail("Content does not fit in gap") }
    return StepResult.fromReplace(doc, this.from, this.to, inserted)
  };

  ReplaceAroundStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.gapFrom - this.from, this.insert,
                        this.gapTo, this.to - this.gapTo, this.slice.size - this.insert])
  };

  ReplaceAroundStep.prototype.invert = function invert (doc) {
    var gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap,
                                 this.from + this.insert, this.from + this.insert + gap,
                                 doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
                                 this.gapFrom - this.from, this.structure)
  };

  ReplaceAroundStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
    if ((from.deleted && to.deleted) || gapFrom < from.pos || gapTo > to.pos) { return null }
    return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure)
  };

  ReplaceAroundStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replaceAround", from: this.from, to: this.to,
                gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceAroundStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" ||
        typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      { throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON") }
    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo,
                                 prosemirrorModel.Slice.fromJSON(schema, json.slice), json.insert, !!json.structure)
  };

  return ReplaceAroundStep;
}(Step));

Step.jsonID("replaceAround", ReplaceAroundStep);

function contentBetween(doc, from, to) {
  var $from = doc.resolve(from), dist = to - from, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) { return true }
      next = next.firstChild;
      dist--;
    }
  }
  return false
}

function canCut(node, start, end) {
  return (start == 0 || node.canReplace(start, node.childCount)) &&
    (end == node.childCount || node.canReplace(0, end))
}

// :: (NodeRange) → ?number
// Try to find a target depth to which the content in the given range
// can be lifted. Will not go across
// [isolating](#model.NodeSpec.isolating) parent nodes.
function liftTarget(range) {
  var parent = range.parent;
  var content = parent.content.cutByIndex(range.startIndex, range.endIndex);
  for (var depth = range.depth;; --depth) {
    var node = range.$from.node(depth);
    var index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
    if (depth < range.depth && node.canReplace(index, endIndex, content))
      { return depth }
    if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) { break }
  }
}

// :: (NodeRange, number) → this
// Split the content in the given range off from its parent, if there
// is sibling content before or after it, and move it up the tree to
// the depth specified by `target`. You'll probably want to use
// [`liftTarget`](#transform.liftTarget) to compute `target`, to make
// sure the lift is valid.
Transform.prototype.lift = function(range, target) {
  var $from = range.$from;
  var $to = range.$to;
  var depth = range.depth;

  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  var start = gapStart, end = gapEnd;

  var before = prosemirrorModel.Fragment.empty, openStart = 0;
  for (var d = depth, splitting = false; d > target; d--)
    { if (splitting || $from.index(d) > 0) {
      splitting = true;
      before = prosemirrorModel.Fragment.from($from.node(d).copy(before));
      openStart++;
    } else {
      start--;
    } }
  var after = prosemirrorModel.Fragment.empty, openEnd = 0;
  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--)
    { if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
      splitting$1 = true;
      after = prosemirrorModel.Fragment.from($to.node(d$1).copy(after));
      openEnd++;
    } else {
      end++;
    } }

  return this.step(new ReplaceAroundStep(start, end, gapStart, gapEnd,
                                         new prosemirrorModel.Slice(before.append(after), openStart, openEnd),
                                         before.size - openStart, true))
};

// :: (NodeRange, NodeType, ?Object, ?NodeRange) → ?[{type: NodeType, attrs: ?Object}]
// Try to find a valid way to wrap the content in the given range in a
// node of the given type. May introduce extra nodes around and inside
// the wrapper node, if necessary. Returns null if no valid wrapping
// could be found. When `innerRange` is given, that range's content is
// used as the content to fit into the wrapping, instead of the
// content of `range`.
function findWrapping(range, nodeType, attrs, innerRange) {
  if ( innerRange === void 0 ) innerRange = range;

  var around = findWrappingOutside(range, nodeType);
  var inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner) { return null }
  return around.map(withAttrs).concat({type: nodeType, attrs: attrs}).concat(inner.map(withAttrs))
}

function withAttrs(type) { return {type: type, attrs: null} }

function findWrappingOutside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around) { return null }
  var outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null
}

function findWrappingInside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var inner = parent.child(startIndex);
  var inside = type.contentMatch.findWrapping(inner.type);
  if (!inside) { return null }
  var lastType = inside.length ? inside[inside.length - 1] : type;
  var innerMatch = lastType.contentMatch;
  for (var i = startIndex; innerMatch && i < endIndex; i++)
    { innerMatch = innerMatch.matchType(parent.child(i).type); }
  if (!innerMatch || !innerMatch.validEnd) { return null }
  return inside
}

// :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
// Wrap the given [range](#model.NodeRange) in the given set of wrappers.
// The wrappers are assumed to be valid in this position, and should
// probably be computed with [`findWrapping`](#transform.findWrapping).
Transform.prototype.wrap = function(range, wrappers) {
  var content = prosemirrorModel.Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = prosemirrorModel.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  var start = range.start, end = range.end;
  return this.step(new ReplaceAroundStep(start, end, start, end, new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true))
};

// :: (number, ?number, NodeType, ?Object) → this
// Set the type of all textblocks (partly) between `from` and `to` to
// the given node type with the given attributes.
Transform.prototype.setBlockType = function(from, to, type, attrs) {
  var this$1 = this;
  if ( to === void 0 ) to = from;

  if (!type.isTextblock) { throw new RangeError("Type given to setBlockType should be a textblock") }
  var mapFrom = this.steps.length;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isTextblock && !node.hasMarkup(type, attrs) && canChangeType(this$1.doc, this$1.mapping.slice(mapFrom).map(pos), type)) {
      // Ensure all markup that isn't allowed in the new node type is cleared
      this$1.clearIncompatible(this$1.mapping.slice(mapFrom).map(pos, 1), type);
      var mapping = this$1.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
      this$1.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1,
                                      new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
      return false
    }
  });
  return this
};

function canChangeType(doc, pos, type) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return $pos.parent.canReplaceWith(index, index + 1, type)
}

// :: (number, ?NodeType, ?Object, ?[Mark]) → this
// Change the type, attributes, and/or marks of the node at `pos`.
// When `type` isn't given, the existing node type is preserved,
Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks) {
  var node = this.doc.nodeAt(pos);
  if (!node) { throw new RangeError("No node at given position") }
  if (!type) { type = node.type; }
  var newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf)
    { return this.replaceWith(pos, pos + node.nodeSize, newNode) }

  if (!type.validContent(node.content))
    { throw new RangeError("Invalid content for node type " + type.name) }

  return this.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1,
                                         new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(newNode), 0, 0), 1, true))
};

// :: (Node, number, number, ?[?{type: NodeType, attrs: ?Object}]) → bool
// Check whether splitting at the given position is allowed.
function canSplit(doc, pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = doc.resolve(pos), base = $pos.depth - depth;
  var innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
  if (base < 0 || $pos.parent.type.spec.isolating ||
      !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
      !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
    { return false }
  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
    var node = $pos.node(d), index$1 = $pos.index(d);
    if (node.type.spec.isolating) { return false }
    var rest = node.content.cutByIndex(index$1, node.childCount);
    var after = (typesAfter && typesAfter[i]) || node;
    if (after != node) { rest = rest.replaceChild(0, after.type.create(after.attrs)); }
    if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest))
      { return false }
  }
  var index = $pos.indexAfter(base);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type)
}

// :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
// Split the node at the given position, and optionally, if `depth` is
// greater than one, any number of nodes above that. By default, the
// parts split off will inherit the node type of the original node.
// This can be changed by passing an array of types and attributes to
// use after the split.
Transform.prototype.split = function(pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = this.doc.resolve(pos), before = prosemirrorModel.Fragment.empty, after = prosemirrorModel.Fragment.empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = prosemirrorModel.Fragment.from($pos.node(d).copy(before));
    var typeAfter = typesAfter && typesAfter[i];
    after = prosemirrorModel.Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  return this.step(new ReplaceStep(pos, pos, new prosemirrorModel.Slice(before.append(after), depth, depth, true)))
};

// :: (Node, number) → bool
// Test whether the blocks before and after a given position can be
// joined.
function canJoin(doc, pos) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return joinable($pos.nodeBefore, $pos.nodeAfter) &&
    $pos.parent.canReplace(index, index + 1)
}

function joinable(a, b) {
  return a && b && !a.isLeaf && a.canAppend(b)
}

// :: (Node, number, ?number) → ?number
// Find an ancestor of the given position that can be joined to the
// block before (or after if `dir` is positive). Returns the joinable
// point, if any.
function joinPoint(doc, pos, dir) {
  if ( dir === void 0 ) dir = -1;

  var $pos = doc.resolve(pos);
  for (var d = $pos.depth;; d--) {
    var before = (void 0), after = (void 0);
    if (d == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d + 1);
      after = $pos.node(d).maybeChild($pos.index(d) + 1);
    } else {
      before = $pos.node(d).maybeChild($pos.index(d) - 1);
      after = $pos.node(d + 1);
    }
    if (before && !before.isTextblock && joinable(before, after)) { return pos }
    if (d == 0) { break }
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}

// :: (number, ?number) → this
// Join the blocks around the given position. If depth is 2, their
// last and first siblings are also joined, and so on.
Transform.prototype.join = function(pos, depth) {
  if ( depth === void 0 ) depth = 1;

  var step = new ReplaceStep(pos - depth, pos + depth, prosemirrorModel.Slice.empty, true);
  return this.step(step)
};

// :: (Node, number, NodeType) → ?number
// Try to find a point where a node of the given type can be inserted
// near `pos`, by searching up the node hierarchy when `pos` itself
// isn't a valid place but is at the start or end of a node. Return
// null if no position was found.
function insertPoint(doc, pos, nodeType) {
  var $pos = doc.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) { return pos }

  if ($pos.parentOffset == 0)
    { for (var d = $pos.depth - 1; d >= 0; d--) {
      var index = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index, index, nodeType)) { return $pos.before(d + 1) }
      if (index > 0) { return null }
    } }
  if ($pos.parentOffset == $pos.parent.content.size)
    { for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
      var index$1 = $pos.indexAfter(d$1);
      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) { return $pos.after(d$1 + 1) }
      if (index$1 < $pos.node(d$1).childCount) { return null }
    } }
}

// :: (Node, number, Slice) → ?number
// Finds a position at or around the given position where the given
// slice can be inserted. Will look at parent nodes' nearest boundary
// and try there, even if the original position wasn't directly at the
// start or end of that node. Returns null when no position was found.
function dropPoint(doc, pos, slice) {
  var $pos = doc.resolve(pos);
  if (!slice.content.size) { return pos }
  var content = slice.content;
  for (var i = 0; i < slice.openStart; i++) { content = content.firstChild.content; }
  for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
    for (var d = $pos.depth; d >= 0; d--) {
      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      if (pass == 1
          ? $pos.node(d).canReplace(insertPos, insertPos, content)
          : $pos.node(d).contentMatchAt(insertPos).findWrapping(content.firstChild.type))
        { return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1) }
    }
  }
  return null
}

function mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i = 0; i < fragment.childCount; i++) {
    var child = fragment.child(i);
    if (child.content.size) { child = child.copy(mapFragment(child.content, f, child)); }
    if (child.isInline) { child = f(child, parent, i); }
    mapped.push(child);
  }
  return prosemirrorModel.Fragment.fromArray(mapped)
}

// ::- Add a mark to all inline content between two positions.
var AddMarkStep = (function (Step$$1) {
  function AddMarkStep(from, to, mark) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step$$1 ) AddMarkStep.__proto__ = Step$$1;
  AddMarkStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  AddMarkStep.prototype.constructor = AddMarkStep;

  AddMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
    var parent = $from.node($from.sharedDepth(this.to));
    var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node, parent) {
      if (!parent.type.allowsMarkType(this$1.mark.type)) { return node }
      return node.mark(this$1.mark.addToSet(node.marks))
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  AddMarkStep.prototype.invert = function invert () {
    return new RemoveMarkStep(this.from, this.to, this.mark)
  };

  AddMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new AddMarkStep(from.pos, to.pos, this.mark)
  };

  AddMarkStep.prototype.merge = function merge (other) {
    if (other instanceof AddMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new AddMarkStep(Math.min(this.from, other.from),
                             Math.max(this.to, other.to), this.mark) }
  };

  AddMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  AddMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for AddMarkStep.fromJSON") }
    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return AddMarkStep;
}(Step));

Step.jsonID("addMark", AddMarkStep);

// ::- Remove a mark from all inline content between two positions.
var RemoveMarkStep = (function (Step$$1) {
  function RemoveMarkStep(from, to, mark) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step$$1 ) RemoveMarkStep.__proto__ = Step$$1;
  RemoveMarkStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  RemoveMarkStep.prototype.constructor = RemoveMarkStep;

  RemoveMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to);
    var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node) {
      return node.mark(this$1.mark.removeFromSet(node.marks))
    }), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  RemoveMarkStep.prototype.invert = function invert () {
    return new AddMarkStep(this.from, this.to, this.mark)
  };

  RemoveMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new RemoveMarkStep(from.pos, to.pos, this.mark)
  };

  RemoveMarkStep.prototype.merge = function merge (other) {
    if (other instanceof RemoveMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new RemoveMarkStep(Math.min(this.from, other.from),
                                Math.max(this.to, other.to), this.mark) }
  };

  RemoveMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  RemoveMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for RemoveMarkStep.fromJSON") }
    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return RemoveMarkStep;
}(Step));

Step.jsonID("removeMark", RemoveMarkStep);

// :: (number, number, Mark) → this
// Add the given mark to the inline content between `from` and `to`.
Transform.prototype.addMark = function(from, to, mark) {
  var this$1 = this;

  var removed = [], added = [], removing = null, adding = null;
  this.doc.nodesBetween(from, to, function (node, pos, parent) {
    if (!node.isInline) { return }
    var marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      var start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
      var newSet = mark.addToSet(marks);

      for (var i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start && removing.mark.eq(marks[i]))
            { removing.to = end; }
          else
            { removed.push(removing = new RemoveMarkStep(start, end, marks[i])); }
        }
      }

      if (adding && adding.to == start)
        { adding.to = end; }
      else
        { added.push(adding = new AddMarkStep(start, end, mark)); }
    }
  });

  removed.forEach(function (s) { return this$1.step(s); });
  added.forEach(function (s) { return this$1.step(s); });
  return this
};

// :: (number, number, ?union<Mark, MarkType>) → this
// Remove marks from inline nodes between `from` and `to`. When `mark`
// is a single mark, remove precisely that mark. When it is a mark type,
// remove all marks of that type. When it is null, remove all marks of
// any type.
Transform.prototype.removeMark = function(from, to, mark) {
  var this$1 = this;
  if ( mark === void 0 ) mark = null;

  var matched = [], step = 0;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline) { return }
    step++;
    var toRemove = null;
    if (mark instanceof prosemirrorModel.MarkType) {
      var found = mark.isInSet(node.marks);
      if (found) { toRemove = [found]; }
    } else if (mark) {
      if (mark.isInSet(node.marks)) { toRemove = [mark]; }
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      var end = Math.min(pos + node.nodeSize, to);
      for (var i = 0; i < toRemove.length; i++) {
        var style = toRemove[i], found$1 = (void 0);
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step - 1 && style.eq(matched[j].style)) { found$1 = m; }
        }
        if (found$1) {
          found$1.to = end;
          found$1.step = step;
        } else {
          matched.push({style: style, from: Math.max(pos, from), to: end, step: step});
        }
      }
    }
  });
  matched.forEach(function (m) { return this$1.step(new RemoveMarkStep(m.from, m.to, m.style)); });
  return this
};

// :: (number, NodeType, ?ContentMatch) → this
// Removes all marks and nodes from the content of the node at `pos`
// that don't match the given new parent node type. Accepts an
// optional starting [content match](#model.ContentMatch) as third
// argument.
Transform.prototype.clearIncompatible = function(pos, parentType, match) {
  var this$1 = this;
  if ( match === void 0 ) match = parentType.contentMatch;

  var node = this.doc.nodeAt(pos);
  var delSteps = [], cur = pos + 1;
  for (var i = 0; i < node.childCount; i++) {
    var child = node.child(i), end = cur + child.nodeSize;
    var allowed = match.matchType(child.type, child.attrs);
    if (!allowed) {
      delSteps.push(new ReplaceStep(cur, end, prosemirrorModel.Slice.empty));
    } else {
      match = allowed;
      for (var j = 0; j < child.marks.length; j++) { if (!parentType.allowsMarkType(child.marks[j].type))
        { this$1.step(new RemoveMarkStep(cur, end, child.marks[j])); } }
    }
    cur = end;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(prosemirrorModel.Fragment.empty, true);
    this.replace(cur, cur, new prosemirrorModel.Slice(fill, 0, 0));
  }
  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) { this$1.step(delSteps[i$1]); }
  return this
};

// :: (Node, number, ?number, ?Slice) → ?Step
// ‘Fit’ a slice into a given position in the document, producing a
// [step](#transform.Step) that inserts it. Will return null if
// there's no meaningful way to insert the slice here, or inserting it
// would be a no-op (an empty slice over an empty range).
function replaceStep(doc, from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = prosemirrorModel.Slice.empty;

  if (from == to && !slice.size) { return null }

  var $from = doc.resolve(from), $to = doc.resolve(to);
  // Optimization -- avoid work if it's obvious that it's not needed.
  if (fitsTrivially($from, $to, slice)) { return new ReplaceStep(from, to, slice) }
  var placed = placeSlice($from, slice);

  var fittedLeft = fitLeft($from, placed);
  var fitted = fitRight($from, $to, fittedLeft);
  if (!fitted) { return null }
  if (fittedLeft.size != fitted.size && canMoveText($from, $to, fittedLeft)) {
    var d = $to.depth, after = $to.after(d);
    while (d > 1 && after == $to.end(--d)) { ++after; }
    var fittedAfter = fitRight($from, doc.resolve(after), fittedLeft);
    if (fittedAfter)
      { return new ReplaceAroundStep(from, after, to, $to.end(), fittedAfter, fittedLeft.size) }
  }
  return fitted.size || from != to ? new ReplaceStep(from, to, fitted) : null
}

// :: (number, ?number, ?Slice) → this
// Replace the part of the document between `from` and `to` with the
// given `slice`.
Transform.prototype.replace = function(from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = prosemirrorModel.Slice.empty;

  var step = replaceStep(this.doc, from, to, slice);
  if (step) { this.step(step); }
  return this
};

// :: (number, number, union<Fragment, Node, [Node]>) → this
// Replace the given range with the given content, which may be a
// fragment, node, or array of nodes.
Transform.prototype.replaceWith = function(from, to, content) {
  return this.replace(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(content), 0, 0))
};

// :: (number, number) → this
// Delete the content between the given positions.
Transform.prototype.delete = function(from, to) {
  return this.replace(from, to, prosemirrorModel.Slice.empty)
};

// :: (number, union<Fragment, Node, [Node]>) → this
// Insert the given content at the given position.
Transform.prototype.insert = function(pos, content) {
  return this.replaceWith(pos, pos, content)
};



function fitLeftInner($from, depth, placed, placedBelow) {
  var content = prosemirrorModel.Fragment.empty, openEnd = 0, placedHere = placed[depth];
  if ($from.depth > depth) {
    var inner = fitLeftInner($from, depth + 1, placed, placedBelow || placedHere);
    openEnd = inner.openEnd + 1;
    content = prosemirrorModel.Fragment.from($from.node(depth + 1).copy(inner.content));
  }

  if (placedHere) {
    content = content.append(placedHere.content);
    openEnd = placedHere.openEnd;
  }
  if (placedBelow) {
    content = content.append($from.node(depth).contentMatchAt($from.indexAfter(depth)).fillBefore(prosemirrorModel.Fragment.empty, true));
    openEnd = 0;
  }

  return {content: content, openEnd: openEnd}
}

function fitLeft($from, placed) {
  var ref = fitLeftInner($from, 0, placed, false);
  var content = ref.content;
  var openEnd = ref.openEnd;
  return new prosemirrorModel.Slice(content, $from.depth, openEnd || 0)
}

function fitRightJoin(content, parent, $from, $to, depth, openStart, openEnd) {
  var match, count = content.childCount, matchCount = count - (openEnd > 0 ? 1 : 0);
  var parentNode = openStart < 0 ? parent : $from.node(depth);
  if (openStart < 0)
    { match = parentNode.contentMatchAt(matchCount); }
  else if (count == 1 && openEnd > 0)
    { match = parentNode.contentMatchAt(openStart ? $from.index(depth) : $from.indexAfter(depth)); }
  else
    { match = parentNode.contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, count > 0 && openStart ? 1 : 0, matchCount); }

  var toNode = $to.node(depth);
  if (openEnd > 0 && depth < $to.depth) {
    var after = toNode.content.cutByIndex($to.indexAfter(depth)).addToStart(content.lastChild);
    var joinable$1 = match.fillBefore(after, true);
    // Can't insert content if there's a single node stretched across this gap
    if (joinable$1 && joinable$1.size && openStart > 0 && count == 1) { joinable$1 = null; }

    if (joinable$1) {
      var inner = fitRightJoin(content.lastChild.content, content.lastChild, $from, $to,
                               depth + 1, count == 1 ? openStart - 1 : -1, openEnd - 1);
      if (inner) {
        var last = content.lastChild.copy(inner);
        if (joinable$1.size)
          { return content.cutByIndex(0, count - 1).append(joinable$1).addToEnd(last) }
        else
          { return content.replaceChild(count - 1, last) }
      }
    }
  }
  if (openEnd > 0)
    { match = match.matchType((count == 1 && openStart > 0 ? $from.node(depth + 1) : content.lastChild).type); }

  // If we're here, the next level can't be joined, so we see what
  // happens if we leave it open.
  var toIndex = $to.index(depth);
  if (toIndex == toNode.childCount && !toNode.type.compatibleContent(parent.type)) { return null }
  var joinable = match.fillBefore(toNode.content, true, toIndex);
  for (var i = toIndex; joinable && i < toNode.content.childCount; i++)
    { if (!parentNode.type.allowsMarks(toNode.content.child(i).marks)) { joinable = null; } }
  if (!joinable) { return null }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }
  content = content.append(joinable);
  if ($to.depth > depth)
    { content = content.addToEnd(fitRightSeparate($to, depth + 1)); }
  return content
}

function fitRightClosed(node, openEnd, $from, depth, openStart) {
  var match, content = node.content, count = content.childCount;
  if (openStart >= 0)
    { match = $from.node(depth).contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, openStart > 0 ? 1 : 0, count); }
  else
    { match = node.contentMatchAt(count); }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }

  return node.copy(content.append(match.fillBefore(prosemirrorModel.Fragment.empty, true)))
}

function fitRightSeparate($to, depth) {
  var node = $to.node(depth);
  var fill = node.contentMatchAt(0).fillBefore(node.content, true, $to.index(depth));
  if ($to.depth > depth) { fill = fill.addToEnd(fitRightSeparate($to, depth + 1)); }
  return node.copy(fill)
}

function normalizeSlice(content, openStart, openEnd) {
  while (openStart > 0 && openEnd > 0 && content.childCount == 1) {
    content = content.firstChild.content;
    openStart--;
    openEnd--;
  }
  return new prosemirrorModel.Slice(content, openStart, openEnd)
}

// : (ResolvedPos, ResolvedPos, number, Slice) → Slice
function fitRight($from, $to, slice) {
  var fitted = fitRightJoin(slice.content, $from.node(0), $from, $to, 0, slice.openStart, slice.openEnd);
  if (!fitted) { return null }
  return normalizeSlice(fitted, slice.openStart, $to.depth)
}

function fitsTrivially($from, $to, slice) {
  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
    $from.parent.canReplace($from.index(), $to.index(), slice.content)
}

function canMoveText($from, $to, slice) {
  if (!$to.parent.isTextblock) { return false }

  var parent = slice.openEnd ? nodeRight(slice.content, slice.openEnd)
      : $from.node($from.depth - (slice.openStart - slice.openEnd));
  if (!parent.isTextblock) { return false }
  for (var i = $to.index(); i < $to.parent.childCount; i++)
    { if (!parent.type.allowsMarks($to.parent.child(i).marks)) { return false } }
  var match;
  if (slice.openEnd) {
    match = parent.contentMatchAt(parent.childCount);
  } else {
    match = parent.contentMatchAt(parent.childCount);
    if (slice.size) { match = match.matchFragment(slice.content, slice.openStart ? 1 : 0); }
  }
  match = match.matchFragment($to.parent.content, $to.index());
  return match && match.validEnd
}

function nodeRight(content, depth) {
  for (var i = 1; i < depth; i++) { content = content.lastChild.content; }
  return content.lastChild
}

// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// So placeSlice splits up a slice into a number of sub-slices,
// along with information on where they can be placed on the given
// left-side edge. It works by walking the open side of the slice,
// from the inside out, and trying to find a landing spot for each
// element, by simultaneously scanning over the gap side. When no
// place is found for an open node's content, it is left in that node.

// : (ResolvedPos, Slice) → [{content: Fragment, openEnd: number, depth: number}]
function placeSlice($from, slice) {
  var frontier = new Frontier($from);
  for (var pass = 1; slice.size && pass <= 3; pass++)
    { slice = frontier.placeSlice(slice.content, slice.openStart, slice.openEnd, pass); }
  while (frontier.open.length) { frontier.closeNode(); }
  return frontier.placed
}

// Helper class that models the open side of the insert position,
// keeping track of the content match and already inserted content
// at each depth.
var Frontier = function Frontier($pos) {
  var this$1 = this;

  // : [{parent: Node, match: ContentMatch, content: Fragment, wrapper: bool, openEnd: number, depth: number}]
  this.open = [];
  for (var d = 0; d <= $pos.depth; d++) {
    var parent = $pos.node(d), match = parent.contentMatchAt($pos.indexAfter(d));
    this$1.open.push({parent: parent, match: match, content: prosemirrorModel.Fragment.empty, wrapper: false, openEnd: 0, depth: d});
  }
  this.placed = [];
};

// : (Fragment, number, number, number, ?Node) → Slice
// Tries to place the content of the given slice, and returns a
// slice containing unplaced content.
//
// pass 1: try to fit directly
// pass 2: allow wrapper nodes to be introduced
// pass 3: allow unwrapping of nodes that aren't open
Frontier.prototype.placeSlice = function placeSlice (fragment, openStart, openEnd, pass, parent) {
    var this$1 = this;

  if (openStart > 0) {
    var first = fragment.firstChild;
    var inner = this.placeSlice(first.content, Math.max(0, openStart - 1),
                                openEnd && fragment.childCount == 1 ? openEnd - 1 : 0,
                                pass, first);
    if (inner.content != first.content) {
      if (inner.content.size) {
        fragment = fragment.replaceChild(0, first.copy(inner.content));
        openStart = inner.openStart + 1;
      } else {
        if (fragment.childCount == 1) { openEnd = 0; }
        fragment = fragment.cutByIndex(1);
        openStart = 0;
      }
    }
  }
  var result = this.placeContent(fragment, openStart, openEnd, pass, parent);
  if (pass > 2 && result.size && openStart == 0) {
    for (var i = 0; i < result.content.childCount; i++) {
      var child = result.content.child(i);
      this$1.placeContent(child.content, 0,
                        openEnd && i == result.content.childCount.length - 1 ? openEnd - 1 : 0,
                        pass, child);
    }
    result = prosemirrorModel.Fragment.empty;
  }
  return result
};

Frontier.prototype.placeContent = function placeContent (fragment, openStart, openEnd, pass, parent) {
    var this$1 = this;

  var i = 0;
  // Go over the fragment's children
  for (; i < fragment.childCount; i++) {
    var child = fragment.child(i), placed = false, last = i == fragment.childCount - 1;
    // Try each open node in turn, starting from the innermost
    for (var d = this.open.length - 1; d >= 0; d--) {
      var open = this$1.open[d], wrap = (void 0);

      // If pass > 1, it is allowed to wrap the node to help find a
      // fit, so if findWrappeing returns something, we add open
      // nodes to the frontier for that wrapping.
      if (pass > 1 && (wrap = open.match.findWrapping(child.type)) &&
          !(parent && wrap.length && wrap[wrap.length - 1] == parent.type)) {
        while (this.open.length - 1 > d) { this$1.closeNode(); }
        for (var w = 0; w < wrap.length; w++) {
          open.match = open.match.matchType(wrap[w]);
          d++;
          open = {parent: wrap[w].create(),
                  match: wrap[w].contentMatch,
                  content: prosemirrorModel.Fragment.empty, wrapper: true, openEnd: 0, depth: d + w};
          this$1.open.push(open);
        }
      }

      // See if the child fits here
      var match = open.match.matchType(child.type);
      if (!match) {
        var fill = open.match.fillBefore(prosemirrorModel.Fragment.from(child));
        if (fill) {
          for (var j = 0; j < fill.childCount; j++) {
            var ch = fill.child(j);
            this$1.addNode(open, ch, 0);
            match = open.match.matchFragment(ch);
          }
        } else if (parent && open.match.matchType(parent.type)) {
          // Don't continue looking further up if the parent node
          // would fit here.
          break
        } else {
          continue
        }
      }

      // Close open nodes above this one, since we're starting to
      // add to this.
      while (this.open.length - 1 > d) { this$1.closeNode(); }
      // Strip marks from the child or close its start when necessary
      child = child.mark(open.parent.type.allowedMarks(child.marks));
      if (openStart) {
        child = closeNodeStart(child, openStart, last ? openEnd : 0);
        openStart = 0;
      }
      // Add the child to this open node and adjust its metadata
      this$1.addNode(open, child, last ? openEnd : 0);
      open.match = match;
      if (last) { openEnd = 0; }
      placed = true;
      break
    }
    // As soon as we've failed to place a node we stop looking at
    // later nodes
    if (!placed) { break }
  }
  // Close the current open node if it's not the the root and we
  // either placed up to the end of the node or the the current
  // slice depth's node type matches the open node's type
  if (this.open.length > 1 &&
      (i > 0 && i == fragment.childCount ||
       parent && this.open[this.open.length - 1].parent.type == parent.type))
    { this.closeNode(); }

  return new prosemirrorModel.Slice(fragment.cutByIndex(i), openStart, openEnd)
};

Frontier.prototype.addNode = function addNode (open, node, openEnd) {
  open.content = closeFragmentEnd(open.content, open.openEnd).addToEnd(node);
  open.openEnd = openEnd;
};

Frontier.prototype.closeNode = function closeNode () {
  var open = this.open.pop();
  if (open.content.size == 0) {
    // Nothing here
  } else if (open.wrapper) {
    this.addNode(this.open[this.open.length - 1], open.parent.copy(open.content), open.openEnd + 1);
  } else {
    this.placed[open.depth] = {depth: open.depth, content: open.content, openEnd: open.openEnd};
  }
};

function closeNodeStart(node, openStart, openEnd) {
  var content = node.content;
  if (openStart > 1) {
    var first = closeNodeStart(node.firstChild, openStart - 1, node.childCount == 1 ? openEnd - 1 : 0);
    content = node.content.replaceChild(0, first);
  }
  var fill = node.type.contentMatch.fillBefore(content, openEnd == 0);
  return node.copy(fill.append(content))
}

function closeNodeEnd(node, depth) {
  var content = node.content;
  if (depth > 1) {
    var last = closeNodeEnd(node.lastChild, depth - 1);
    content = node.content.replaceChild(node.childCount - 1, last);
  }
  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true);
  return node.copy(content.append(fill))
}

function closeFragmentEnd(fragment, depth) {
  return depth ? fragment.replaceChild(fragment.childCount - 1, closeNodeEnd(fragment.lastChild, depth)) : fragment
}

// :: (number, number, Slice) → this
// Replace a range of the document with a given slice, using `from`,
// `to`, and the slice's [`openStart`](#model.Slice.openStart) property
// as hints, rather than fixed start and end points. This method may
// grow the replaced area or close open nodes in the slice in order to
// get a fit that is more in line with WYSIWYG expectations, by
// dropping fully covered parent nodes of the replaced region when
// they are marked [non-defining](#model.NodeSpec.defining), or
// including an open parent node from the slice that _is_ marked as
// [defining](#model.NodeSpec.defining).
//
// This is the method, for example, to handle paste. The similar
// [`replace`](#transform.Transform.replace) method is a more
// primitive tool which will _not_ move the start and end of its given
// range, and is useful in situations where you need more precise
// control over what happens.
Transform.prototype.replaceRange = function(from, to, slice) {
  var this$1 = this;

  if (!slice.size) { return this.deleteRange(from, to) }

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  if (fitsTrivially($from, $to, slice))
    { return this.step(new ReplaceStep(from, to, slice)) }

  var targetDepths = coveredDepths($from, this.doc.resolve(to));
  // Can't replace the whole document, so remove 0 if it's present
  if (targetDepths[targetDepths.length - 1] == 0) { targetDepths.pop(); }
  // Negative numbers represent not expansion over the whole node at
  // that depth, but replacing from $from.before(-D) to $to.pos.
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  // This loop picks a preferred target depth, if one of the covering
  // depths is not outside of a defining node, and adds negative
  // depths for any depth that has $from at its start and does not
  // cross a defining node.
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.isolating) { break }
    if (targetDepths.indexOf(d) > -1) { preferredTarget = d; }
    else if ($from.before(d) == pos) { targetDepths.splice(1, 0, -d); }
  }
  // Try to fit each possible depth of the slice into each possible
  // target depth, starting with the preferred depths.
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);

  var leftNodes = [], preferredDepth = slice.openStart;
  for (var content = slice.content, i = 0;; i++) {
    var node = content.firstChild;
    leftNodes.push(node);
    if (i == slice.openStart) { break }
    content = node.content;
  }
  // Back up if the node directly above openStart, or the node above
  // that separated only by a non-defining textblock node, is defining.
  if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining &&
      $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type)
    { preferredDepth -= 1; }
  else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining &&
           $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type)
    { preferredDepth -= 2; }

  for (var j = slice.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) { continue }
    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
      // Loop over possible expansion levels, starting with the
      // preferred one
      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) { expand = false; targetDepth = -targetDepth; }
      var parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index, index, insert.type, insert.marks))
        { return this$1.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to,
                            new prosemirrorModel.Slice(closeFragment(slice.content, 0, slice.openStart, openDepth),
                                      openDepth, slice.openEnd)) }
    }
  }

  return this.replace(from, to, slice)
};

function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen)
    { fragment = parent.contentMatchAt(0).fillBefore(fragment, true).append(fragment); }
  return fragment
}

// :: (number, number, Node) → this
// Replace the given range with a node, but use `from` and `to` as
// hints, rather than precise positions. When from and to are the same
// and are at the start or end of a parent node in which the given
// node doesn't fit, this method may _move_ them out towards a parent
// that does allow the given node to be placed. When the given range
// completely covers a parent node, this method may completely replace
// that parent node.
Transform.prototype.replaceRangeWith = function(from, to, node) {
  if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
    var point = insertPoint(this.doc, from, node.type);
    if (point != null) { from = to = point; }
  }
  return this.replaceRange(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(node), 0, 0))
};

// :: (number, number) → this
// Delete the given range, expanding it to cover fully covered
// parent nodes until a valid replace is found.
Transform.prototype.deleteRange = function(from, to) {
  var this$1 = this;

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  var covered = coveredDepths($from, $to);
  for (var i = 0; i < covered.length; i++) {
    var depth = covered[i], last = i == covered.length - 1;
    if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
      { return this$1.delete($from.start(depth), $to.end(depth)) }
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      { return this$1.delete($from.before(depth), $to.after(depth)) }
  }
  for (var d = 1; d <= $from.depth; d++) {
    if (from - $from.start(d) == $from.depth - d && to > $from.end(d))
      { return this$1.delete($from.before(d), to) }
  }
  return this.delete(from, to)
};

// : (ResolvedPos, ResolvedPos) → [number]
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function coveredDepths($from, $to) {
  var result = [], minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start = $from.start(d);
    if (start < $from.pos - ($from.depth - d) ||
        $to.end(d) > $to.pos + ($to.depth - d) ||
        $from.node(d).type.spec.isolating ||
        $to.node(d).type.spec.isolating) { break }
    if (start == $to.start(d)) { result.push(d); }
  }
  return result
}

exports.Transform = Transform;
exports.TransformError = TransformError;
exports.Step = Step;
exports.StepResult = StepResult;
exports.joinPoint = joinPoint;
exports.canJoin = canJoin;
exports.canSplit = canSplit;
exports.insertPoint = insertPoint;
exports.dropPoint = dropPoint;
exports.liftTarget = liftTarget;
exports.findWrapping = findWrapping;
exports.StepMap = StepMap;
exports.MapResult = MapResult;
exports.Mapping = Mapping;
exports.AddMarkStep = AddMarkStep;
exports.RemoveMarkStep = RemoveMarkStep;
exports.ReplaceStep = ReplaceStep;
exports.ReplaceAroundStep = ReplaceAroundStep;
exports.replaceStep = replaceStep;
//# sourceMappingURL=index.js.map


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(2);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(5);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* unused harmony export HTTP */
/* harmony export (immutable) */ __webpack_exports__["b"] = get;
/* unused harmony export getAsDataURL */
/* harmony export (immutable) */ __webpack_exports__["c"] = post;
/* unused harmony export del */
/* harmony export (immutable) */ __webpack_exports__["a"] = checkResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_urijs__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_urijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_urijs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var HTTP = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    paramsSerializer: function (params) {
        var search = [];
        var _loop_1 = function (k) {
            var v = params[k];
            if (v && Array.isArray(v)) {
                search.push.apply(search, v.map(function (x) { return k + "=" + encodeURIComponent(x); }));
            }
            else {
                search.push(k + "=" + encodeURIComponent(v));
            }
        };
        for (var k in params) {
            _loop_1(k);
        }
        return search.join('&');
    }
});
function buildRequest(url, volatile, parameters) {
    var uri = url[0] == '/' ? new __WEBPACK_IMPORTED_MODULE_0_urijs___default.a(window.location.toString()).pathname(url).search("") : new __WEBPACK_IMPORTED_MODULE_0_urijs___default.a(url);
    var params = {};
    if (parameters) {
        for (var k in parameters) {
            if (k == '__volatile') {
                volatile = true;
            }
            else {
                params[k] = parameters[k];
            }
        }
    }
    if (volatile) {
        params['__t'] = new Date().getTime();
    }
    // Return ready to go Axios options.
    return { url: uri.toString(), params: params };
}
var discardableRequests = {};
function get(url, parameters, isDiscardable) {
    if (isDiscardable === void 0) { isDiscardable = false; }
    var cts;
    if (parameters === true || isDiscardable) {
        cts = discardableRequests[url];
        if (cts) {
            cts.cancel();
        }
        cts = discardableRequests[url] = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken.source();
    }
    return HTTP
        .request(__assign({ method: 'GET', cancelToken: cts && cts.token || null }, buildRequest(url, true, parameters)))
        .catch(function (error) {
        if (error.response.status == 401) {
            window.location.href = "/";
            return error.response;
        }
        throw error;
    });
}
function getAsDataURL(url, parameters) {
    return HTTP
        .request(__assign({ method: 'GET', responseType: 'blob' }, buildRequest(url, true, parameters)))
        .then(function (res) { return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () { return resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(res.data);
    }); })
        .catch(function (error) {
        if (error.response.status == 401) {
            window.location.href = "/";
            return error.response;
        }
        throw error;
    });
}
function post(url, data) {
    return HTTP
        .request(__assign({ method: 'POST', data: data }, buildRequest(url, false)))
        .catch(function (error) {
        if (error.response.status == 401) {
            window.location.href = "/";
            return error.response;
        }
        throw error;
    });
}
function del(url, parameters) {
    return HTTP
        .request(__assign({ method: 'DELETE' }, buildRequest(url, false, parameters)))
        .catch(function (error) {
        if (error.response.status == 401) {
            window.location.href = "/";
            return error.response;
        }
        throw error;
    });
}
function checkResult(ctx, result) {
    if (result) {
        if (result.result == "OK") {
            return result.data || true;
        }
        else {
            if (result.result == "ERROR") {
                //ctx.dispatch('showError', result);
            }
        }
    }
    return false;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorTransform = __webpack_require__(7);
var prosemirrorModel = __webpack_require__(6);
var prosemirrorState = __webpack_require__(5);

// :: (EditorState, ?(tr: Transaction)) → bool
// Delete the selection, if there is one.
function deleteSelection(state, dispatch) {
  if (state.selection.empty) { return false }
  if (dispatch) { dispatch(state.tr.deleteSelection().scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and at the start of a textblock, try to
// reduce the distance between that block and the one before it—if
// there's a block directly before it that can be joined, join them.
// If not, try to move the selected block closer to the next one in
// the document structure by lifting it out of its parent or moving it
// into a parent of the previous block. Will use the view for accurate
// (bidi-aware) start-of-textblock detection if given.
function joinBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor);

  // If there is no node before this, try to lift
  if (!$cut) {
    var range = $cursor.blockRange(), target = range && prosemirrorTransform.liftTarget(range);
    if (target == null) { return false }
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  var before = $cut.nodeBefore;
  // Apply the joining algorithm
  if (!before.type.spec.isolating && deleteBarrier(state, $cut, dispatch))
    { return true }

  // If the node below has no content and the node above is
  // selectable, delete the node below and select the one above.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(before, "end") || prosemirrorState.NodeSelection.isSelectable(before))) {
    if (dispatch) {
      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
      tr.setSelection(textblockAt(before, "end") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1)
                      : prosemirrorState.NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  // If the node before is an atom, delete it
  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView()); }
    return true
  }

  return false
}

function textblockAt(node, side) {
  for (; node; node = (side == "start" ? node.firstChild : node.lastChild))
    { if (node.isTextblock) { return true } }
  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the start of a textblock, select
// the node before that textblock, if possible. This is intended to be
// bound to keys like backspace, after
// [`joinBackward`](#commands.joinBackward) or other deleting
// commands, as a fall-back behavior when the schema doesn't allow
// deletion at the selected point.
function selectNodeBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor), node = $cut && $cut.nodeBefore;
  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView()); }
  return true
}

function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    if ($pos.index(i) > 0) { return $pos.doc.resolve($pos.before(i + 1)) }
    if ($pos.node(i).type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and the cursor is at the end of a
// textblock, try to reduce or remove the boundary between that block
// and the one after it, either by joining them or by moving the other
// block closer to this one in the tree structure. Will use the view
// for accurate start-of-textblock detection if given.
function joinForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor);

  // If there is no node after this, there's nothing to do
  if (!$cut) { return false }

  var after = $cut.nodeAfter;
  // Try the joining algorithm
  if (deleteBarrier(state, $cut, dispatch)) { return true }

  // If the node above has no content and the node below is
  // selectable, delete the node above and select the one below.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(after, "start") || prosemirrorState.NodeSelection.isSelectable(after))) {
    if (dispatch) {
      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
      tr.setSelection(textblockAt(after, "start") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1)
                      : prosemirrorState.NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  // If the next node is an atom, delete it
  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView()); }
    return true
  }

  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the end of a textblock, select
// the node coming after that textblock, if possible. This is intended
// to be bound to keys like delete, after
// [`joinForward`](#commands.joinForward) and similar deleting
// commands, to provide a fall-back behavior when the schema doesn't
// allow deletion at the selected point.
function selectNodeForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor), node = $cut && $cut.nodeAfter;
  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos)).scrollIntoView()); }
  return true
}

function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    var parent = $pos.node(i);
    if ($pos.index(i) + 1 < parent.childCount) { return $pos.doc.resolve($pos.after(i + 1)) }
    if (parent.type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block or, if there is a text selection, the
// closest ancestor block of the selection that can be joined, with
// the sibling above it.
function joinUp(state, dispatch) {
  var sel = state.selection, nodeSel = sel instanceof prosemirrorState.NodeSelection, point;
  if (nodeSel) {
    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.from)) { return false }
    point = sel.from;
  } else {
    point = prosemirrorTransform.joinPoint(state.doc, sel.from, -1);
    if (point == null) { return false }
  }
  if (dispatch) {
    var tr = state.tr.join(point);
    if (nodeSel) { tr.setSelection(prosemirrorState.NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize)); }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block, or the closest ancestor of the selection
// that can be joined, with the sibling after it.
function joinDown(state, dispatch) {
  var sel = state.selection, point;
  if (sel instanceof prosemirrorState.NodeSelection) {
    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.to)) { return false }
    point = sel.to;
  } else {
    point = prosemirrorTransform.joinPoint(state.doc, sel.to, 1);
    if (point == null) { return false }
  }
  if (dispatch)
    { dispatch(state.tr.join(point).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Lift the selected block, or the closest ancestor block of the
// selection that can be lifted, out of its parent node.
function lift(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  var range = $from.blockRange($to), target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the selection is in a node whose type has a truthy
// [`code`](#model.NodeSpec.code) property in its spec, replace the
// selection with a newline character.
function newlineInCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  if (dispatch) { dispatch(state.tr.insertText("\n").scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// When the selection is in a node with a truthy
// [`code`](#model.NodeSpec.code) property in its spec, create a
// default block after the code block, and move the cursor there.
function exitCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  var above = $head.node(-1), after = $head.indexAfter(-1), type = above.contentMatchAt(after).defaultType;
  if (!above.canReplaceWith(after, after, type)) { return false }
  if (dispatch) {
    var pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(prosemirrorState.Selection.near(tr.doc.resolve(pos), 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If a block node is selected, create an empty paragraph before (if
// it is its parent's first child) or after it.
function createParagraphNear(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if ($from.parent.inlineContent || $to.parent.inlineContent) { return false }
  var type = $from.parent.contentMatchAt($to.indexAfter()).defaultType;
  if (!type || !type.isTextblock) { return false }
  if (dispatch) {
    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    var tr = state.tr.insert(side, type.createAndFill());
    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, side + 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the cursor is in an empty textblock that can be lifted, lift the
// block.
function liftEmptyBlock(state, dispatch) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || $cursor.parent.content.size) { return false }
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    var before = $cursor.before();
    if (prosemirrorTransform.canSplit(state.doc, before)) {
      if (dispatch) { dispatch(state.tr.split(before).scrollIntoView()); }
      return true
    }
  }
  var range = $cursor.blockRange(), target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Split the parent block of the selection. If the selection is a text
// selection, also delete its content.
function splitBlock(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if (state.selection instanceof prosemirrorState.NodeSelection && state.selection.node.isBlock) {
    if (!$from.parentOffset || !prosemirrorTransform.canSplit(state.doc, $from.pos)) { return false }
    if (dispatch) { dispatch(state.tr.split($from.pos).scrollIntoView()); }
    return true
  }

  if (!$from.parent.isBlock) { return false }

  if (dispatch) {
    var atEnd = $to.parentOffset == $to.parent.content.size;
    var tr = state.tr;
    if (state.selection instanceof prosemirrorState.TextSelection) { tr.deleteSelection(); }
    var deflt = $from.depth == 0 ? null : $from.node(-1).contentMatchAt($from.indexAfter(-1)).defaultType;
    var types = atEnd && deflt ? [{type: deflt}] : null;
    var can = prosemirrorTransform.canSplit(tr.doc, $from.pos, 1, types);
    if (!types && !can && prosemirrorTransform.canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt && [{type: deflt}])) {
      types = [{type: deflt}];
      can = true;
    }
    if (can) {
      tr.split(tr.mapping.map($from.pos), 1, types);
      if (!atEnd && !$from.parentOffset && $from.parent.type != deflt &&
          $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), prosemirrorModel.Fragment.from(deflt.create(), $from.parent)))
        { tr.setNodeMarkup(tr.mapping.map($from.before()), deflt); }
    }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Acts like [`splitBlock`](#commands.splitBlock), but without
// resetting the set of active marks at the cursor.
function splitBlockKeepMarks(state, dispatch) {
  return splitBlock(state, dispatch && (function (tr) {
    var marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) { tr.ensureMarks(marks); }
    dispatch(tr);
  }))
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Move the selection to the node wrapping the current selection, if
// any. (Will not select the document node.)
function selectParentNode(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var to = ref.to;
  var pos;
  var same = $from.sharedDepth(to);
  if (same == 0) { return false }
  pos = $from.before(same);
  if (dispatch) { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, pos))); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Select the whole document.
function selectAll(state, dispatch) {
  if (dispatch) { dispatch(state.tr.setSelection(new prosemirrorState.AllSelection(state.doc))); }
  return true
}

function joinMaybeClear(state, $pos, dispatch) {
  var before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
  if (!before || !after || !before.type.compatibleContent(after.type)) { return false }
  if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
    if (dispatch) { dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView()); }
    return true
  }
  if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || prosemirrorTransform.canJoin(state.doc, $pos.pos)))
    { return false }
  if (dispatch)
    { dispatch(state.tr
             .clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount))
             .join($pos.pos)
             .scrollIntoView()); }
  return true
}

function deleteBarrier(state, $cut, dispatch) {
  var before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
  if (before.type.spec.isolating || after.type.spec.isolating) { return false }
  if (joinMaybeClear(state, $cut, dispatch)) { return true }

  if ($cut.parent.canReplace($cut.index(), $cut.index() + 1) &&
      (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) &&
      match.matchType(conn[0] || after.type).validEnd) {
    if (dispatch) {
      var end = $cut.pos + after.nodeSize, wrap = prosemirrorModel.Fragment.empty;
      for (var i = conn.length - 1; i >= 0; i--)
        { wrap = prosemirrorModel.Fragment.from(conn[i].create(null, wrap)); }
      wrap = prosemirrorModel.Fragment.from(before.copy(wrap));
      var tr = state.tr.step(new prosemirrorTransform.ReplaceAroundStep($cut.pos - 1, end, $cut.pos, end, new prosemirrorModel.Slice(wrap, 1, 0), conn.length, true));
      var joinAt = end + 2 * conn.length;
      if (prosemirrorTransform.canJoin(tr.doc, joinAt)) { tr.join(joinAt); }
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  var selAfter = prosemirrorState.Selection.findFrom($cut, 1);
  var range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && prosemirrorTransform.liftTarget(range);
  if (target != null && target >= $cut.depth) {
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  return false
}

// Parameterized commands

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Wrap the selection in a node of the given type with the given
// attributes.
function wrapIn(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), wrapping = range && prosemirrorTransform.findWrapping(range, nodeType, attrs);
    if (!wrapping) { return false }
    if (dispatch) { dispatch(state.tr.wrap(range, wrapping).scrollIntoView()); }
    return true
  }
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command that tries to set the selected textblocks to the
// given node type with the given attributes.
function setBlockType(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var from = ref.from;
    var to = ref.to;
    var applicable = false;
    state.doc.nodesBetween(from, to, function (node, pos) {
      if (applicable) { return false }
      if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) { return }
      if (node.type == nodeType) {
        applicable = true;
      } else {
        var $pos = state.doc.resolve(pos), index = $pos.index();
        applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
      }
    });
    if (!applicable) { return false }
    if (dispatch) { dispatch(state.tr.setBlockType(from, to, nodeType, attrs).scrollIntoView()); }
    return true
  }
}

function markApplies(doc, ranges, type) {
  var loop = function ( i ) {
    var ref = ranges[i];
    var $from = ref.$from;
    var $to = ref.$to;
    var can = $from.depth == 0 ? doc.type.allowsMarkType(type) : false;
    doc.nodesBetween($from.pos, $to.pos, function (node) {
      if (can) { return false }
      can = node.inlineContent && node.type.allowsMarkType(type);
    });
    if (can) { return { v: true } }
  };

  for (var i = 0; i < ranges.length; i++) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

// :: (MarkType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command function that toggles the given mark with the
// given attributes. Will return `false` when the current selection
// doesn't support that mark. This will remove the mark if any marks
// of that type exist in the selection, or add it otherwise. If the
// selection is empty, this applies to the [stored
// marks](#state.EditorState.storedMarks) instead of a range of the
// document.
function toggleMark(markType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var empty = ref.empty;
    var $cursor = ref.$cursor;
    var ranges = ref.ranges;
    if ((empty && !$cursor) || !markApplies(state.doc, ranges, markType)) { return false }
    if (dispatch) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks()))
          { dispatch(state.tr.removeStoredMark(markType)); }
        else
          { dispatch(state.tr.addStoredMark(markType.create(attrs))); }
      } else {
        var has = false, tr = state.tr;
        for (var i = 0; !has && i < ranges.length; i++) {
          var ref$1 = ranges[i];
          var $from = ref$1.$from;
          var $to = ref$1.$to;
          has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
        }
        for (var i$1 = 0; i$1 < ranges.length; i$1++) {
          var ref$2 = ranges[i$1];
          var $from$1 = ref$2.$from;
          var $to$1 = ref$2.$to;
          if (has) { tr.removeMark($from$1.pos, $to$1.pos, markType); }
          else { tr.addMark($from$1.pos, $to$1.pos, markType.create(attrs)); }
        }
        dispatch(tr.scrollIntoView());
      }
    }
    return true
  }
}

function wrapDispatchForJoin(dispatch, isJoinable) {
  return function (tr) {
    if (!tr.isGeneric) { return dispatch(tr) }

    var ranges = [];
    for (var i = 0; i < tr.mapping.maps.length; i++) {
      var map = tr.mapping.maps[i];
      for (var j = 0; j < ranges.length; j++)
        { ranges[j] = map.map(ranges[j]); }
      map.forEach(function (_s, _e, from, to) { return ranges.push(from, to); });
    }

    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    var joinable = [];
    for (var i$1 = 0; i$1 < ranges.length; i$1 += 2) {
      var from = ranges[i$1], to = ranges[i$1 + 1];
      var $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
      for (var index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index) {
        var after = parent.maybeChild(index);
        if (!after) { break }
        if (index && joinable.indexOf(pos) == -1) {
          var before = parent.child(index - 1);
          if (before.type == after.type && isJoinable(before, after))
            { joinable.push(pos); }
        }
        pos += after.nodeSize;
      }
    }
    // Join the joinable points
    joinable.sort(function (a, b) { return a - b; });
    for (var i$2 = joinable.length - 1; i$2 >= 0; i$2--) {
      if (prosemirrorTransform.canJoin(tr.doc, joinable[i$2])) { tr.join(joinable[i$2]); }
    }
    dispatch(tr);
  }
}

// :: ((state: EditorState, ?(tr: Transaction)) → bool, union<(before: Node, after: Node) → bool, [string]>) → (state: EditorState, ?(tr: Transaction)) → bool
// Wrap a command so that, when it produces a transform that causes
// two joinable nodes to end up next to each other, those are joined.
// Nodes are considered joinable when they are of the same type and
// when the `isJoinable` predicate returns true for them or, if an
// array of strings was passed, if their node type name is in that
// array.
function autoJoin(command, isJoinable) {
  if (Array.isArray(isJoinable)) {
    var types = isJoinable;
    isJoinable = function (node) { return types.indexOf(node.type.name) > -1; };
  }
  return function (state, dispatch) { return command(state, dispatch && wrapDispatchForJoin(dispatch, isJoinable)); }
}

// :: (...[(EditorState, ?(tr: Transaction), ?EditorView) → bool]) → (EditorState, ?(tr: Transaction), ?EditorView) → bool
// Combine a number of command functions into a single function (which
// calls them one by one until one returns true).
function chainCommands() {
  var commands = [], len = arguments.length;
  while ( len-- ) commands[ len ] = arguments[ len ];

  return function(state, dispatch, view) {
    for (var i = 0; i < commands.length; i++)
      { if (commands[i](state, dispatch, view)) { return true } }
    return false
  }
}

var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
var del = chainCommands(deleteSelection, joinForward, selectNodeForward);

// :: Object
// A basic keymap containing bindings not specific to any schema.
// Binds the following keys (when multiple commands are listed, they
// are chained with [`chainCommands`](#commands.chainCommands)):
//
// * **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
// * **Mod-Enter** to `exitCode`
// * **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
// * **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-a** to `selectAll`
var pcBaseKeymap = {
  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
  "Mod-Enter": exitCode,
  "Backspace": backspace,
  "Mod-Backspace": backspace,
  "Delete": del,
  "Mod-Delete": del,
  "Mod-a": selectAll
};

// :: Object
// A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
// **Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
// **Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
// Ctrl-Delete.
var macBaseKeymap = {
  "Ctrl-h": pcBaseKeymap["Backspace"],
  "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
  "Ctrl-d": pcBaseKeymap["Delete"],
  "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
  "Alt-Delete": pcBaseKeymap["Mod-Delete"],
  "Alt-d": pcBaseKeymap["Mod-Delete"]
};
for (var key in pcBaseKeymap) { macBaseKeymap[key] = pcBaseKeymap[key]; }

// declare global: os, navigator
var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform)
          : typeof os != "undefined" ? os.platform() == "darwin" : false;

// :: Object
// Depending on the detected platform, this will hold
// [`pcBasekeymap`](#commands.pcBaseKeymap) or
// [`macBaseKeymap`](#commands.macBaseKeymap).
var baseKeymap = mac ? macBaseKeymap : pcBaseKeymap;

exports.deleteSelection = deleteSelection;
exports.joinBackward = joinBackward;
exports.selectNodeBackward = selectNodeBackward;
exports.joinForward = joinForward;
exports.selectNodeForward = selectNodeForward;
exports.joinUp = joinUp;
exports.joinDown = joinDown;
exports.lift = lift;
exports.newlineInCode = newlineInCode;
exports.exitCode = exitCode;
exports.createParagraphNear = createParagraphNear;
exports.liftEmptyBlock = liftEmptyBlock;
exports.splitBlock = splitBlock;
exports.splitBlockKeepMarks = splitBlockKeepMarks;
exports.selectParentNode = selectParentNode;
exports.selectAll = selectAll;
exports.wrapIn = wrapIn;
exports.setBlockType = setBlockType;
exports.toggleMark = toggleMark;
exports.autoJoin = autoJoin;
exports.chainCommands = chainCommands;
exports.pcBaseKeymap = pcBaseKeymap;
exports.macBaseKeymap = macBaseKeymap;
exports.baseKeymap = baseKeymap;
//# sourceMappingURL=commands.js.map


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var RopeSequence = _interopDefault(__webpack_require__(57));
var prosemirrorTransform = __webpack_require__(7);
var prosemirrorState = __webpack_require__(5);

// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)

// Used to schedule history compression
var max_empty_items = 500;

var Branch = function Branch(items, eventCount) {
  this.items = items;
  this.eventCount = eventCount;
};

// : (Node, bool, ?Item) → ?{transform: Transform, selection: Object}
// Pop the latest event off the branch's history and apply it
// to a document transform.
Branch.prototype.popEvent = function popEvent (state, preserveItems) {
    var this$1 = this;

  if (this.eventCount == 0) { return null }

  var end = this.items.length;
  for (;; end--) {
    var next = this$1.items.get(end - 1);
    if (next.selection) { --end; break }
  }

  var remap, mapFrom;
  if (preserveItems) {
    remap = this.remapping(end, this.items.length);
    mapFrom = remap.maps.length;
  }
  var transform = state.tr;
  var selection, remaining;
  var addAfter = [], addBefore = [];

  this.items.forEach(function (item, i) {
    if (!item.step) {
      if (!remap) {
        remap = this$1.remapping(end, i + 1);
        mapFrom = remap.maps.length;
      }
      mapFrom--;
      addBefore.push(item);
      return
    }

    if (remap) {
      addBefore.push(new Item(item.map));
      var step = item.step.map(remap.slice(mapFrom)), map;

      if (step && transform.maybeStep(step).doc) {
        map = transform.mapping.maps[transform.mapping.maps.length - 1];
        addAfter.push(new Item(map, null, null, addAfter.length + addBefore.length));
      }
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
    } else {
      transform.maybeStep(item.step);
    }

    if (item.selection) {
      selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
      remaining = new Branch(this$1.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this$1.eventCount - 1);
      return false
    }
  }, this.items.length, 0);

  return {remaining: remaining, transform: transform, selection: selection}
};

// : (Transform, Selection, Object)
// Create a new branch with the given transform added.
Branch.prototype.addTransform = function addTransform (transform, selection, histOptions, preserveItems) {
  var newItems = [], eventCount = this.eventCount;
  var oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;

  for (var i = 0; i < transform.steps.length; i++) {
    var step = transform.steps[i].invert(transform.docs[i]);
    var item = new Item(transform.mapping.maps[i], step, selection), merged = (void 0);
    if (merged = lastItem && lastItem.merge(item)) {
      item = merged;
      if (i) { newItems.pop(); }
      else { oldItems = oldItems.slice(0, oldItems.length - 1); }
    }
    newItems.push(item);
    if (selection) {
      eventCount++;
      selection = null;
    }
    if (!preserveItems) { lastItem = item; }
  }
  var overflow = eventCount - histOptions.depth;
  if (overflow > DEPTH_OVERFLOW) {
    oldItems = cutOffEvents(oldItems, overflow);
    eventCount -= overflow;
  }
  return new Branch(oldItems.append(newItems), eventCount)
};

Branch.prototype.remapping = function remapping (from, to) {
  var maps = [], mirrors = [];
  this.items.forEach(function (item, i) {
    if (item.mirrorOffset != null) {
      var mirrorPos = i - item.mirrorOffset;
      if (mirrorPos >= from) { mirrors.push(maps.length - item.mirrorOffset, maps.length); }
    }
    maps.push(item.map);
  }, from, to);
  return new prosemirrorTransform.Mapping(maps, mirrors)
};

Branch.prototype.addMaps = function addMaps (array) {
  if (this.eventCount == 0) { return this }
  return new Branch(this.items.append(array.map(function (map) { return new Item(map); })), this.eventCount)
};

// : ([StepMap], Transform, [number])
// When the collab module receives remote changes, the history has
// to know about those, so that it can adjust the steps that were
// rebased on top of the remote changes, and include the position
// maps for the remote changes in its array of items.
Branch.prototype.rebased = function rebased (rebasedTransform, rebasedCount) {
  if (!this.eventCount) { return this }

  var rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);

  var mapping = rebasedTransform.mapping;
  var newUntil = rebasedTransform.steps.length;
  var eventCount = this.eventCount;
  this.items.forEach(function (item) { if (item.selection) { eventCount--; } }, this.items.length - rebasedCount);

  var iRebased = rebasedCount;
  this.items.forEach(function (item) {
    var pos = mapping.getMirror(--iRebased);
    if (pos == null) { return }
    newUntil = Math.min(newUntil, pos);
    var map = mapping.maps[pos];
    if (item.step) {
      var step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
      var selection = item.selection && item.selection.map(mapping.slice(iRebased, pos));
      if (selection) { eventCount++; }
      rebasedItems.push(new Item(map, step, selection));
    } else {
      rebasedItems.push(new Item(map));
    }
  }, start);

  var newMaps = [];
  for (var i = rebasedCount; i < newUntil; i++)
    { newMaps.push(new Item(mapping.maps[i])); }
  var items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
  var branch = new Branch(items, eventCount);

  if (branch.emptyItemCount() > max_empty_items)
    { branch = branch.compress(this.items.length - rebasedItems.length); }
  return branch
};

Branch.prototype.emptyItemCount = function emptyItemCount () {
  var count = 0;
  this.items.forEach(function (item) { if (!item.step) { count++; } });
  return count
};

// Compressing a branch means rewriting it to push the air (map-only
// items) out. During collaboration, these naturally accumulate
// because each remote change adds one. The `upto` argument is used
// to ensure that only the items below a given level are compressed,
// because `rebased` relies on a clean, untouched set of items in
// order to associate old items with rebased steps.
Branch.prototype.compress = function compress (upto) {
    if ( upto === void 0 ) upto = this.items.length;

  var remap = this.remapping(0, upto), mapFrom = remap.maps.length;
  var items = [], events = 0;
  this.items.forEach(function (item, i) {
    if (i >= upto) {
      items.push(item);
      if (item.selection) { events++; }
    } else if (item.step) {
      var step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
      if (step) {
        var selection = item.selection && item.selection.map(remap.slice(mapFrom));
        if (selection) { events++; }
        var newItem = new Item(map.invert(), step, selection), merged, last = items.length - 1;
        if (merged = items.length && items[last].merge(newItem))
          { items[last] = merged; }
        else
          { items.push(newItem); }
      }
    } else if (item.map) {
      mapFrom--;
    }
  }, this.items.length, 0);
  return new Branch(RopeSequence.from(items.reverse()), events)
};

Branch.empty = new Branch(RopeSequence.empty, 0);

function cutOffEvents(items, n) {
  var cutPoint;
  items.forEach(function (item, i) {
    if (item.selection && (n-- == 0)) {
      cutPoint = i;
      return false
    }
  });
  return items.slice(cutPoint)
}

var Item = function Item(map, step, selection, mirrorOffset) {
  this.map = map;
  this.step = step;
  this.selection = selection;
  this.mirrorOffset = mirrorOffset;
};

Item.prototype.merge = function merge (other) {
  if (this.step && other.step && !other.selection) {
    var step = other.step.merge(this.step);
    if (step) { return new Item(step.getMap().invert(), step, this.selection) }
  }
};

// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
var HistoryState = function HistoryState(done, undone, prevMap, prevTime) {
  this.done = done;
  this.undone = undone;
  this.prevMap = prevMap;
  this.prevTime = prevTime;
};

var DEPTH_OVERFLOW = 20;

// : (EditorState, EditorState, Selection, Object)
// Record a transformation in undo history.
function applyTransaction(history, state, tr, options) {
  var newState = tr.getMeta(historyKey), rebased;
  if (newState) { return newState }

  if (tr.getMeta(closeHistoryKey)) { history = new HistoryState(history.done, history.undone, null, 0); }

  var appended = tr.getMeta("appendedTransaction");
  if (tr.steps.length == 0) {
    return history
  } else if ((appended || tr).getMeta("addToHistory") !== false) {
    // Group transforms that occur in quick succession into one event.
    var newGroup = history.prevTime < (tr.time || 0) - options.newGroupDelay ||
        !appended && !isAdjacentToLastStep(tr, history.prevMap, history.done);
    return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : null,
                                                      options, mustPreserveItems(state)),
                            Branch.empty, tr.mapping.maps[tr.steps.length - 1], tr.time)
  } else if (rebased = tr.getMeta("rebased")) {
    // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new HistoryState(history.done.rebased(tr, rebased),
                            history.undone.rebased(tr, rebased),
                            history.prevMap && tr.mapping.maps[tr.steps.length - 1], history.prevTime)
  } else {
    return new HistoryState(history.done.addMaps(tr.mapping.maps),
                            history.undone.addMaps(tr.mapping.maps),
                            history.prevMap, history.prevTime)
  }
}

function isAdjacentToLastStep(transform, prevMap, done) {
  if (!prevMap) { return false }
  var firstMap = transform.mapping.maps[0], adjacent = false;
  if (!firstMap) { return true }
  firstMap.forEach(function (start, end) {
    done.items.forEach(function (item) {
      if (item.step) {
        prevMap.forEach(function (_start, _end, rStart, rEnd) {
          if (start <= rEnd && end >= rStart) { adjacent = true; }
        });
        return false
      } else {
        start = item.map.invert().map(start, -1);
        end = item.map.invert().map(end, 1);
      }
    }, done.items.length, 0);
  });
  return adjacent
}

// : (HistoryState, EditorState, (tr: Transaction), bool)
// Apply the latest event from one branch to the document and optionally
// shift the event onto the other branch. Returns true when an event could
// be shifted.
function histTransaction(history, state, dispatch, redo) {
  var preserveItems = mustPreserveItems(state), histOptions = historyKey.get(state).spec.config;
  var pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
  if (!pop) { return }

  var selection = pop.selection.resolve(pop.transform.doc);
  var added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(),
                                                                  histOptions, preserveItems);

  var newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0);
  dispatch(pop.transform.setSelection(selection).setMeta(historyKey, newHist).scrollIntoView());
}

var cachedPreserveItems = false;
var cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function mustPreserveItems(state) {
  var plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (var i = 0; i < plugins.length; i++) { if (plugins[i].spec.historyPreserveItems) {
      cachedPreserveItems = true;
      break
    } }
  }
  return cachedPreserveItems
}

// :: (Transaction) → Transaction
// Set a flag on the given transaction that will prevent further steps
// from being appended to an existing history event (so that they
// require a separate undo command to undo).
function closeHistory(tr) {
  return tr.setMeta(closeHistoryKey, true)
}

var historyKey = new prosemirrorState.PluginKey("history");
var closeHistoryKey = new prosemirrorState.PluginKey("closeHistory");

// :: (?Object) → Plugin
// Returns a plugin that enables the undo history for an editor. The
// plugin will track undo and redo stacks, which can be used with the
// [`undo`](#history.undo) and [`redo`](#history.redo) commands.
//
// You can set an `"addToHistory"` [metadata
// property](#state.Transaction.setMeta) of `false` on a transaction
// to prevent it from being rolled back by undo.
//
//   config::-
//   Supports the following configuration options:
//
//     depth:: ?number
//     The amount of history events that are collected before the
//     oldest events are discarded. Defaults to 100.
//
//     newGroupDelay:: ?number
//     The delay between changes after which a new group should be
//     started. Defaults to 500 (milliseconds). Note that when changes
//     aren't adjacent, a new group is always started.
function history(config) {
  config = {depth: config && config.depth || 100,
            newGroupDelay: config && config.newGroupDelay || 500};
  return new prosemirrorState.Plugin({
    key: historyKey,

    state: {
      init: function init() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0)
      },
      apply: function apply(tr, hist, state) {
        return applyTransaction(hist, state, tr, config)
      }
    },

    config: config
  })
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that undoes the last change, if any.
function undo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.done.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, false); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that redoes the last undone change, if any.
function redo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.undone.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, true); }
  return true
}

// :: (EditorState) → number
// The amount of undoable events available in a given state.
function undoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.done.eventCount : 0
}

// :: (EditorState) → number
// The amount of redoable events available in a given editor state.
function redoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.undone.eventCount : 0
}

exports.HistoryState = HistoryState;
exports.closeHistory = closeHistory;
exports.history = history;
exports.undo = undo;
exports.redo = redo;
exports.undoDepth = undoDepth;
exports.redoDepth = redoDepth;
//# sourceMappingURL=history.js.map


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var keyName = _interopDefault(__webpack_require__(61));
var prosemirrorState = __webpack_require__(5);

// declare global: navigator

var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : false;

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
  if (result == "Space") { result = " "; }
  var alt, ctrl, shift, meta;
  for (var i = 0; i < parts.length - 1; i++) {
    var mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) { meta = true; }
    else if (/^a(lt)?$/i.test(mod)) { alt = true; }
    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
    else if (/^s(hift)?$/i.test(mod)) { shift = true; }
    else if (/^mod$/i.test(mod)) { if (mac) { meta = true; } else { ctrl = true; } }
    else { throw new Error("Unrecognized modifier name: " + mod) }
  }
  if (alt) { result = "Alt-" + result; }
  if (ctrl) { result = "Ctrl-" + result; }
  if (meta) { result = "Meta-" + result; }
  if (shift) { result = "Shift-" + result; }
  return result
}

function normalize(map) {
  var copy = Object.create(null);
  for (var prop in map) { copy[normalizeKeyName(prop)] = map[prop]; }
  return copy
}

function modifiers(name, event, shift) {
  if (event.altKey) { name = "Alt-" + name; }
  if (event.ctrlKey) { name = "Ctrl-" + name; }
  if (event.metaKey) { name = "Meta-" + name; }
  if (shift !== false && event.shiftKey) { name = "Shift-" + name; }
  return name
}

// :: (Object) → Plugin
// Create a keymap plugin for the given set of bindings.
//
// Bindings should map key names to [command](#commands)-style
// functions, which will be called with `(EditorState, dispatch,
// EditorView)` arguments, and should return true when they've handled
// the key. Note that the view argument isn't part of the command
// protocol, but can be used as an escape hatch if a binding needs to
// directly interact with the UI.
//
// Key names may be strings like `"Shift-Ctrl-Enter"`—a key
// identifier prefixed with zero or more modifiers. Key identifiers
// are based on the strings that can appear in
// [`KeyEvent.key`](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
// Use lowercase letters to refer to letter keys (or uppercase letters
// if you want shift to be held). You may use `"Space"` as an alias
// for the `" "` name.
//
// Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
// `a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
// `Meta-`) are recognized. For characters that are created by holding
// shift, the `Shift-` prefix is implied, and should not be added
// explicitly.
//
// You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
// other platforms.
//
// You can add multiple keymap plugins to an editor. The order in
// which they appear determines their precedence (the ones early in
// the array get to dispatch first).
function keymap(bindings) {
  return new prosemirrorState.Plugin({props: {handleKeyDown: keydownHandler(bindings)}})
}

// :: (Object) → (view: EditorView, event: dom.Event) → bool
// Given a set of bindings (using the same format as
// [`keymap`](#keymap.keymap), return a [keydown
// handler](#view.EditorProps.handleKeyDown) handles them.
function keydownHandler(bindings) {
  var map = normalize(bindings);
  return function(view, event) {
    var name = keyName(event), isChar = name.length == 1 && name != " ", baseName;
    var direct = map[modifiers(name, event, !isChar)];
    if (direct && direct(view.state, view.dispatch, view)) { return true }
    if (isChar && (event.shiftKey || event.altKey || event.metaKey) &&
        (baseName = keyName.base[event.keyCode]) && baseName != name) {
      var fromCode = map[modifiers(baseName, event, true)];
      if (fromCode && fromCode(view.state, view.dispatch, view)) { return true }
    }
    return false
  }
}

exports.keymap = keymap;
exports.keydownHandler = keydownHandler;
//# sourceMappingURL=keymap.js.map


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__(6);
var prosemirrorState = __webpack_require__(5);
var prosemirrorTransform = __webpack_require__(7);

var result = {};
if (typeof navigator != "undefined" && typeof document != "undefined") {
  var ie_edge = /Edge\/(\d+)/.exec(navigator.userAgent);
  var ie_upto10 = /MSIE \d/.test(navigator.userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);

  result.mac = /Mac/.test(navigator.platform);
  var ie = result.ie = !!(ie_upto10 || ie_11up || ie_edge);
  result.ie_version = ie_upto10 ? document.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : null;
  result.gecko = !ie && /gecko\/(\d+)/i.test(navigator.userAgent);
  result.gecko_version = result.gecko && +(/Firefox\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
  var chrome = !ie && /Chrome\/(\d+)/.exec(navigator.userAgent);
  result.chrome = !!chrome;
  result.chrome_version = chrome && +chrome[1];
  result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
  result.webkit = !ie && 'WebkitAppearance' in document.documentElement.style;
  result.safari = /Apple Computer/.test(navigator.vendor);
  result.webkit_version = result.webkit && +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
}

var domIndex = function(node) {
  for (var index = 0;; index++) {
    node = node.previousSibling;
    if (!node) { return index }
  }
};

var parentNode = function(node) {
  var parent = node.parentNode;
  return parent && parent.nodeType == 11 ? parent.host : parent
};

var textRange = function(node, from, to) {
  var range = document.createRange();
  range.setEnd(node, to == null ? node.nodeValue.length : to);
  range.setStart(node, from || 0);
  return range
};

// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
var isEquivalentPosition = function(node, off, targetNode, targetOff) {
  return targetNode && (scanFor(node, off, targetNode, targetOff, -1) ||
                        scanFor(node, off, targetNode, targetOff, 1))
};

var atomElements = /^(img|br|input|textarea|hr)$/i;

function scanFor(node, off, targetNode, targetOff, dir) {
  for (;;) {
    if (node == targetNode && off == targetOff) { return true }
    if (off == (dir < 0 ? 0 : nodeSize(node)) || node.nodeType == 3 && node.nodeValue == "\ufeff") {
      var parent = node.parentNode;
      if (parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName)) { return false }
      off = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      node = node.childNodes[off + (dir < 0 ? -1 : 0)];
      off = dir < 0 ? nodeSize(node) : 0;
    } else {
      return false
    }
  }
}

function nodeSize(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function hasBlockDesc(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock
}

// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
var selectionCollapsed = function(domSel) {
  var collapsed = domSel.isCollapsed;
  if (collapsed && result.chrome && domSel.rangeCount && !domSel.getRangeAt(0).collapsed)
    { collapsed = false; }
  return collapsed
};

function windowRect(win) {
  return {left: 0, right: win.innerWidth,
          top: 0, bottom: win.innerHeight}
}

function scrollRectIntoView(view, rect) {
  var scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin");
  var doc = view.dom.ownerDocument, win = doc.defaultView;
  if (scrollMargin == null) { scrollMargin = 5; }
  for (var parent = view.dom;; parent = parentNode(parent)) {
    if (!parent) { break }
    var atTop = parent == doc.body || parent.nodeType != 1;
    var bounding = atTop ? windowRect(win) : parent.getBoundingClientRect();
    var moveX = 0, moveY = 0;
    if (rect.top < bounding.top + scrollThreshold)
      { moveY = -(bounding.top - rect.top + scrollMargin); }
    else if (rect.bottom > bounding.bottom - scrollThreshold)
      { moveY = rect.bottom - bounding.bottom + scrollMargin; }
    if (rect.left < bounding.left + scrollThreshold)
      { moveX = -(bounding.left - rect.left + scrollMargin); }
    else if (rect.right > bounding.right - scrollThreshold)
      { moveX = rect.right - bounding.right + scrollMargin; }
    if (moveX || moveY) {
      if (atTop) {
        win.scrollBy(moveX, moveY);
      } else {
        if (moveY) { parent.scrollTop += moveY; }
        if (moveX) { parent.scrollLeft += moveX; }
      }
    }
    if (atTop) { break }
  }
}

// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function storeScrollPos(view) {
  var rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
  var doc = view.dom.ownerDocument;
  var refDOM, refTop;
  for (var x = (rect.left + rect.right) / 2, y = startY + 1;
       y < Math.min(innerHeight, rect.bottom); y += 5) {
    var dom = view.root.elementFromPoint(x, y);
    if (dom == view.dom || !view.dom.contains(dom)) { continue }
    var localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break
    }
  }
  var stack = [];
  for (var dom$1 = view.dom; dom$1; dom$1 = parentNode(dom$1)) {
    stack.push({dom: dom$1, top: dom$1.scrollTop, left: dom$1.scrollLeft});
    if (dom$1 == doc.body) { break }
  }
  return {refDOM: refDOM, refTop: refTop, stack: stack}
}

// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function resetScrollPos(ref) {
  var refDOM = ref.refDOM;
  var refTop = ref.refTop;
  var stack = ref.stack;

  var newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  var dTop = newRefTop == 0 ? 0 : newRefTop - refTop;
  for (var i = 0; i < stack.length; i++) {
    var ref$1 = stack[i];
    var dom = ref$1.dom;
    var top = ref$1.top;
    var left = ref$1.left;
    if (dom.scrollTop != top + dTop) { dom.scrollTop = top + dTop; }
    if (dom.scrollLeft != left) { dom.scrollLeft = left; }
  }
}

function findOffsetInNode(node, coords) {
  var closest, dxClosest = 2e8, coordsClosest, offset = 0;
  var rowBot = coords.top, rowTop = coords.top;
  for (var child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
    var rects = (void 0);
    if (child.nodeType == 1) { rects = child.getClientRects(); }
    else if (child.nodeType == 3) { rects = textRange(child).getClientRects(); }
    else { continue }

    for (var i = 0; i < rects.length; i++) {
      var rect = rects[i];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        var dx = rect.left > coords.left ? rect.left - coords.left
            : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest = child;
          dxClosest = dx;
          coordsClosest = dx && closest.nodeType == 3 ? {left: rect.right < coords.left ? rect.right : rect.left, top: coords.top} : coords;
          if (child.nodeType == 1 && dx)
            { offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0); }
          continue
        }
      }
      if (!closest && (coords.left >= rect.right && coords.top >= rect.top ||
                       coords.left >= rect.left && coords.top >= rect.bottom))
        { offset = childIndex + 1; }
    }
  }
  if (closest && closest.nodeType == 3) { return findOffsetInText(closest, coordsClosest) }
  if (!closest || (dxClosest && closest.nodeType == 1)) { return {node: node, offset: offset} }
  return findOffsetInNode(closest, coordsClosest)
}

function findOffsetInText(node, coords) {
  var len = node.nodeValue.length;
  var range = document.createRange();
  for (var i = 0; i < len; i++) {
    range.setEnd(node, i + 1);
    range.setStart(node, i);
    var rect = singleRect(range, 1);
    if (rect.top == rect.bottom) { continue }
    if (rect.left - 1 <= coords.left && rect.right + 1 >= coords.left &&
        rect.top - 1 <= coords.top && rect.bottom + 1 >= coords.top)
      { return {node: node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)} }
  }
  return {node: node, offset: 0}
}

function targetKludge(dom, coords) {
  var parent = dom.parentNode;
  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
    { return parent }
  return dom
}

function posFromElement(view, elt, coords) {
  if (!view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) { return null }

  var ref = findOffsetInNode(elt, coords);
  var node = ref.node;
  var offset = ref.offset;
  var bias = -1;
  if (node.nodeType == 1 && !node.firstChild) {
    var rect = node.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node, offset, bias)
}

function posFromCaret(view, node, offset, coords) {
  // Browser (in caretPosition/RangeFromPoint) will agressively
  // normalize towards nearby inline nodes. Since we are interested in
  // positions between block nodes too, we first walk up the hierarchy
  // of nodes to see if there are block nodes that the coordinates
  // fall outside of. If so, we take the position before/after that
  // block. If not, we call `posFromDOM` on the raw node/offset.
  var outside = -1;
  for (var cur = node;;) {
    if (cur == view.dom) { break }
    var desc = view.docView.nearestDesc(cur, true);
    if (!desc) { return null }
    if (desc.node.isBlock && desc.parent) {
      var rect = desc.dom.getBoundingClientRect();
      if (rect.left > coords.left || rect.top > coords.top) { outside = desc.posBefore; }
      else if (rect.right < coords.left || rect.bottom < coords.top) { outside = desc.posAfter; }
      else { break }
    }
    cur = desc.dom.parentNode;
  }
  return outside > -1 ? outside : view.docView.posFromDOM(node, offset)
}

// Given an x,y position on the editor, get the position in the document.
function posAtCoords(view, coords) {
  var root = view.root, node, offset;
  if (root.caretPositionFromPoint) {
    var pos$1 = root.caretPositionFromPoint(coords.left, coords.top);
    if (pos$1) { var assign;
      ((assign = pos$1, node = assign.offsetNode, offset = assign.offset)); }
  }
  if (!node && root.caretRangeFromPoint) {
    var range = root.caretRangeFromPoint(coords.left, coords.top);
    if (range) { var assign$1;
      ((assign$1 = range, node = assign$1.startContainer, offset = assign$1.startOffset)); }
  }

  var elt = root.elementFromPoint(coords.left, coords.top + 1), pos;
  if (!elt) { return null }
  elt = targetKludge(elt, coords);
  if (node) {
    // Suspiciously specific kludge to work around caret*FromPoint
    // never returning a position at the end of the document
    if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 &&
        coords.top > node.lastChild.getBoundingClientRect().bottom)
      { pos = view.state.doc.content.size; }
    // Ignore positions directly after a BR, since caret*FromPoint
    // 'round up' positions that would be more accurately places
    // before the BR node.
    else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR")
      { pos = posFromCaret(view, node, offset, coords); }
  }
  if (pos == null) {
    pos = posFromElement(view, elt, coords);
    if (pos == null) { return null }
  }

  var desc = view.docView.nearestDesc(elt, true);
  return {pos: pos, inside: desc ? desc.posAtStart - desc.border : -1}
}

function singleRect(object, bias) {
  var rects = object.getClientRects();
  return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1]
}

// : (EditorView, number) → {left: number, top: number, right: number, bottom: number}
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function coordsAtPos(view, pos) {
  var ref = view.docView.domFromPos(pos);
  var node = ref.node;
  var offset = ref.offset;
  var side, rect;
  if (node.nodeType == 3) {
    if (offset < node.nodeValue.length) {
      rect = singleRect(textRange(node, offset, offset + 1), -1);
      side = "left";
    }
    if ((!rect || rect.left == rect.right) && offset) {
      rect = singleRect(textRange(node, offset - 1, offset), 1);
      side = "right";
    }
  } else if (node.firstChild) {
    if (offset < node.childNodes.length) {
      var child = node.childNodes[offset];
      rect = singleRect(child.nodeType == 3 ? textRange(child) : child, -1);
      side = "left";
    }
    if ((!rect || rect.top == rect.bottom) && offset) {
      var child$1 = node.childNodes[offset - 1];
      rect = singleRect(child$1.nodeType == 3 ? textRange(child$1) : child$1, 1);
      side = "right";
    }
  } else {
    rect = node.getBoundingClientRect();
    side = "left";
  }
  var x = rect[side];
  return {top: rect.top, bottom: rect.bottom, left: x, right: x}
}

function withFlushedState(view, state, f) {
  var viewState = view.state, active = view.root.activeElement;
  if (viewState != state || !view.inDOMChange) { view.updateState(state); }
  if (active != view.dom) { view.focus(); }
  try {
    return f()
  } finally {
    if (viewState != state) { view.updateState(viewState); }
    if (active != view.dom) { active.focus(); }
  }
}

// : (EditorView, number, number)
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function endOfTextblockVertical(view, state, dir) {
  var sel = state.selection;
  var $pos = dir == "up" ? sel.$anchor.min(sel.$head) : sel.$anchor.max(sel.$head);
  if (!$pos.depth) { return false }
  return withFlushedState(view, state, function () {
    var dom = view.docView.domAfterPos($pos.before());
    var coords = coordsAtPos(view, $pos.pos);
    for (var child = dom.firstChild; child; child = child.nextSibling) {
      var boxes = (void 0);
      if (child.nodeType == 1) { boxes = child.getClientRects(); }
      else if (child.nodeType == 3) { boxes = textRange(child, 0, child.nodeValue.length).getClientRects(); }
      else { continue }
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        if (box.bottom > box.top && (dir == "up" ? box.bottom < coords.top + 1 : box.top > coords.bottom - 1))
          { return false }
      }
    }
    return true
  })
}

var maybeRTL = /[\u0590-\u08ac]/;

function endOfTextblockHorizontal(view, state, dir) {
  var ref = state.selection;
  var $head = ref.$head;
  if (!$head.parent.isTextblock || !$head.depth) { return false }
  var offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
  var sel = getSelection();
  // If the textblock is all LTR, or the browser doesn't support
  // Selection.modify (Edge), fall back to a primitive approach
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
    { return dir == "left" || dir == "backward" ? atStart : atEnd }

  return withFlushedState(view, state, function () {
    // This is a huge hack, but appears to be the best we can
    // currently do: use `Selection.modify` to move the selection by
    // one character, and see if that moves the cursor out of the
    // textblock (or doesn't move it at all, when at the start/end of
    // the document).
    var oldRange = sel.getRangeAt(0), oldNode = sel.focusNode, oldOff = sel.focusOffset;
    sel.modify("move", dir, "character");
    var parentDOM = view.docView.domAfterPos($head.before());
    var result = !parentDOM.contains(sel.focusNode.nodeType == 1 ? sel.focusNode : sel.focusNode.parentNode) ||
        (oldNode == sel.focusNode && oldOff == sel.focusOffset);
    // Restore the previous selection
    sel.removeAllRanges();
    sel.addRange(oldRange);
    return result
  })
}

var cachedState = null;
var cachedDir = null;
var cachedResult = false;
function endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir) { return cachedResult }
  cachedState = state; cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down"
    ? endOfTextblockVertical(view, state, dir)
    : endOfTextblockHorizontal(view, state, dir)
}

// NodeView:: interface
//
// By default, document nodes are rendered using the result of the
// [`toDOM`](#model.NodeSpec.toDOM) method of their spec, and managed
// entirely by the editor. For some use cases, such as embedded
// node-specific editing interfaces, you want more control over
// the behavior of a node's in-editor representation, and need to
// [define](#view.EditorProps.nodeViews) a custom node view.
//
// Objects returned as node views must conform to this interface.
//
//   dom:: ?dom.Node
//   The outer DOM node that represents the document node. When not
//   given, the default strategy is used to create a DOM node.
//
//   contentDOM:: ?dom.Node
//   The DOM node that should hold the node's content. Only meaningful
//   if the node view also defines a `dom` property and if its node
//   type is not a leaf node type. When this is present, ProseMirror
//   will take care of rendering the node's children into it. When it
//   is not present, the node view itself is responsible for rendering
//   (or deciding not to render) its child nodes.
//
//   update:: ?(node: Node, decorations: [Decoration]) → bool
//   When given, this will be called when the view is updating itself.
//   It will be given a node (possibly of a different type), and an
//   array of active decorations (which are automatically drawn, and
//   the node view may ignore if it isn't interested in them), and
//   should return true if it was able to update to that node, and
//   false otherwise. If the node view has a `contentDOM` property (or
//   no `dom` property), updating its child nodes will be handled by
//   ProseMirror.
//
//   selectNode:: ?()
//   Can be used to override the way the node's selected status (as a
//   node selection) is displayed.
//
//   deselectNode:: ?()
//   When defining a `selectNode` method, you should also provide a
//   `deselectNode` method to remove the effect again.
//
//   setSelection:: ?(anchor: number, head: number, root: dom.Document)
//   This will be called to handle setting the selection inside the
//   node. The `anchor` and `head` positions are relative to the start
//   of the node. By default, a DOM selection will be created between
//   the DOM positions corresponding to those positions, but if you
//   override it you can do something else.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to prevent the editor view from trying to handle some
//   or all DOM events that bubble up from the node view. Events for
//   which this returns true are not handled by the editor.
//
//   ignoreMutation:: ?(dom.MutationRecord) → bool
//   Called when a DOM
//   [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver)
//   happens within the view. Return false if the editor should
//   re-parse the range around the mutation, true if it can safely be
//   ignored.
//
//   destroy:: ?()
//   Called when the node view is removed from the editor or the whole
//   editor is destroyed.

// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.

var NOT_DIRTY = 0;
var CHILD_DIRTY = 1;
var CONTENT_DIRTY = 2;
var NODE_DIRTY = 3;

// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
var ViewDesc = function ViewDesc(parent, children, dom, contentDOM) {
  this.parent = parent;
  this.children = children;
  this.dom = dom;
  // An expando property on the DOM node provides a link back to its
  // description.
  dom.pmViewDesc = this;
  // This is the node that holds the child views. It may be null for
  // descs that don't have children.
  this.contentDOM = contentDOM;
  this.dirty = NOT_DIRTY;
};

var prototypeAccessors$1 = { beforePosition: {},size: {},border: {},posBefore: {},posAtStart: {},posAfter: {},posAtEnd: {},contentLost: {} };

// Used to check whether a given description corresponds to a
// widget/mark/node.
ViewDesc.prototype.matchesWidget = function matchesWidget () { return false };
ViewDesc.prototype.matchesMark = function matchesMark () { return false };
ViewDesc.prototype.matchesNode = function matchesNode () { return false };
ViewDesc.prototype.matchesHack = function matchesHack () { return false };

prototypeAccessors$1.beforePosition.get = function () { return false };

// : () → ?ParseRule
// When parsing in-editor content (in domchange.js), we allow
// descriptions to determine the parse rules that should be used to
// parse them.
ViewDesc.prototype.parseRule = function parseRule () { return null };

// : (dom.Event) → bool
// Used by the editor's event handler to ignore events that come
// from certain descs.
ViewDesc.prototype.stopEvent = function stopEvent () { return false };

// The size of the content represented by this desc.
prototypeAccessors$1.size.get = function () {
    var this$1 = this;

  var size = 0;
  for (var i = 0; i < this.children.length; i++) { size += this$1.children[i].size; }
  return size
};

// For block nodes, this represents the space taken up by their
// start/end tokens.
prototypeAccessors$1.border.get = function () { return 0 };

ViewDesc.prototype.destroy = function destroy () {
    var this$1 = this;

  this.parent = null;
  if (this.dom.pmViewDesc == this) { this.dom.pmViewDesc = null; }
  for (var i = 0; i < this.children.length; i++)
    { this$1.children[i].destroy(); }
};

ViewDesc.prototype.posBeforeChild = function posBeforeChild (child) {
    var this$1 = this;

  for (var i = 0, pos = this.posAtStart; i < this.children.length; i++) {
    var cur = this$1.children[i];
    if (cur == child) { return pos }
    pos += cur.size;
  }
};

prototypeAccessors$1.posBefore.get = function () {
  return this.parent.posBeforeChild(this)
};

prototypeAccessors$1.posAtStart.get = function () {
  return this.parent ? this.parent.posBeforeChild(this) + this.border : 0
};

prototypeAccessors$1.posAfter.get = function () {
  return this.posBefore + this.size
};

prototypeAccessors$1.posAtEnd.get = function () {
  return this.posAtStart + this.size - 2 * this.border
};

// : (dom.Node, number, ?number) → number
ViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
    var this$1 = this;

  // If the DOM position is in the content, use the child desc after
  // it to figure out a position.
  if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
    if (bias < 0) {
      var domBefore, desc;
      if (dom == this.contentDOM) {
        domBefore = dom.childNodes[offset - 1];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domBefore = dom.previousSibling;
      }
      while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) { domBefore = domBefore.previousSibling; }
      return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart
    } else {
      var domAfter, desc$1;
      if (dom == this.contentDOM) {
        domAfter = dom.childNodes[offset];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domAfter = dom.nextSibling;
      }
      while (domAfter && !((desc$1 = domAfter.pmViewDesc) && desc$1.parent == this)) { domAfter = domAfter.nextSibling; }
      return domAfter ? this.posBeforeChild(desc$1) : this.posAtEnd
    }
  }
  // Otherwise, use various heuristics, falling back on the bias
  // parameter, to determine whether to return the position at the
  // start or at the end of this view desc.
  var atEnd;
  if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
    atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
  } else if (this.dom.firstChild) {
    if (offset == 0) { for (var search = dom;; search = search.parentNode) {
      if (search == this$1.dom) { atEnd = false; break }
      if (search.parentNode.firstChild != search) { break }
    } }
    if (atEnd == null && offset == dom.childNodes.length) { for (var search$1 = dom;; search$1 = search$1.parentNode) {
      if (search$1 == this$1.dom) { atEnd = true; break }
      if (search$1.parentNode.lastChild != search$1) { break }
    } }
  }
  return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart
};

// Scan up the dom finding the first desc that is a descendant of
// this one.
ViewDesc.prototype.nearestDesc = function nearestDesc (dom, onlyNodes) {
    var this$1 = this;

  for (var first = true, cur = dom; cur; cur = cur.parentNode) {
    var desc = this$1.getDesc(cur);
    if (desc && (!onlyNodes || desc.node)) {
      // If dom is outside of this desc's nodeDOM, don't count it.
      if (first && desc.nodeDOM && !(desc.nodeDOM.nodeType == 1 ? desc.nodeDOM.contains(dom) : desc.nodeDOM == dom)) { first = false; }
      else { return desc }
    }
  }
};

ViewDesc.prototype.getDesc = function getDesc (dom) {
    var this$1 = this;

  var desc = dom.pmViewDesc;
  for (var cur = desc; cur; cur = cur.parent) { if (cur == this$1) { return desc } }
};

ViewDesc.prototype.posFromDOM = function posFromDOM (dom, offset, bias) {
    var this$1 = this;

  for (var scan = dom;; scan = scan.parentNode) {
    var desc = this$1.getDesc(scan);
    if (desc) { return desc.localPosFromDOM(dom, offset, bias) }
  }
};

// : (number) → ?NodeViewDesc
// Find the desc for the node after the given pos, if any. (When a
// parent node overrode rendering, there might not be one.)
ViewDesc.prototype.descAt = function descAt (pos) {
    var this$1 = this;

  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this$1.children[i], end = offset + child.size;
    if (offset == pos && end != offset) {
      while (!child.border && child.children.length) { child = child.children[0]; }
      return child
    }
    if (pos < end) { return child.descAt(pos - offset - child.border) }
    offset = end;
  }
};

// : (number) → {node: dom.Node, offset: number}
ViewDesc.prototype.domFromPos = function domFromPos (pos) {
    var this$1 = this;

  if (!this.contentDOM) { return {node: this.dom, offset: 0} }
  for (var offset = 0, i = 0;; i++) {
    if (offset == pos) {
      while (i < this.children.length && this.children[i].beforePosition) { i++; }
      return {node: this$1.contentDOM, offset: i}
    }
    if (i == this$1.children.length) { throw new Error("Invalid position " + pos) }
    var child = this$1.children[i], end = offset + child.size;
    if (pos < end) { return child.domFromPos(pos - offset - child.border) }
    offset = end;
  }
};

// Used to find a DOM range in a single parent for a given changed
// range.
ViewDesc.prototype.parseRange = function parseRange (from, to, base) {
    var this$1 = this;
    if ( base === void 0 ) base = 0;

  if (this.children.length == 0)
    { return {node: this.contentDOM, from: from, to: to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length} }

  var fromOffset = -1, toOffset = -1;
  for (var offset = 0, i = 0;; i++) {
    var child = this$1.children[i], end = offset + child.size;
    if (fromOffset == -1 && from <= end) {
      var childBase = offset + child.border;
      // FIXME maybe descend mark views to parse a narrower range?
      if (from >= childBase && to <= end - child.border && child.node &&
          child.contentDOM && this$1.contentDOM.contains(child.contentDOM))
        { return child.parseRange(from - childBase, to - childBase, base + childBase) }

      from = base + offset;
      for (var j = i; j > 0; j--) {
        var prev = this$1.children[j - 1];
        if (prev.size && prev.dom.parentNode == this$1.contentDOM && !prev.emptyChildAt(1)) {
          fromOffset = domIndex(prev.dom) + 1;
          break
        }
        from -= prev.size;
      }
      if (fromOffset == -1) { fromOffset = 0; }
    }
    if (fromOffset > -1 && to <= end) {
      to = base + end;
      for (var j$1 = i + 1; j$1 < this.children.length; j$1++) {
        var next = this$1.children[j$1];
        if (next.size && next.dom.parentNode == this$1.contentDOM && !next.emptyChildAt(-1)) {
          toOffset = domIndex(next.dom);
          break
        }
        to += next.size;
      }
      if (toOffset == -1) { toOffset = this$1.contentDOM.childNodes.length; }
      break
    }
    offset = end;
  }
  return {node: this.contentDOM, from: from, to: to, fromOffset: fromOffset, toOffset: toOffset}
};

ViewDesc.prototype.emptyChildAt = function emptyChildAt (side) {
  if (this.border || !this.contentDOM || !this.children.length) { return false }
  var child = this.children[side < 0 ? 0 : this.children.length - 1];
  return child.size == 0 || child.emptyChildAt(side)
};

// : (number) → dom.Node
ViewDesc.prototype.domAfterPos = function domAfterPos (pos) {
  var ref = this.domFromPos(pos);
    var node = ref.node;
    var offset = ref.offset;
  if (node.nodeType != 1 || offset == node.childNodes.length)
    { throw new RangeError("No node after pos " + pos) }
  return node.childNodes[offset]
};

// : (number, number, dom.Document)
// View descs are responsible for setting any selection that falls
// entirely inside of them, so that custom implementations can do
// custom things with the selection. Note that this falls apart when
// a selection starts in such a node and ends in another, in which
// case we just use whatever domFromPos produces as a best effort.
ViewDesc.prototype.setSelection = function setSelection (anchor, head, root) {
    var this$1 = this;

  // If the selection falls entirely in a child, give it to that child
  var from = Math.min(anchor, head), to = Math.max(anchor, head);
  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this$1.children[i], end = offset + child.size;
    if (from > offset && to < end)
      { return child.setSelection(anchor - offset - child.border, head - offset - child.border, root) }
    offset = end;
  }

  var anchorDOM = this.domFromPos(anchor), headDOM = this.domFromPos(head);
  var domSel = root.getSelection(), range = document.createRange();
  if (isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) &&
      isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset))
    { return }

  // Selection.extend can be used to create an 'inverted' selection
  // (one where the focus is before the anchor), but not all
  // browsers support it yet.
  if (domSel.extend) {
    range.setEnd(anchorDOM.node, anchorDOM.offset);
    range.collapse(false);
  } else {
    if (anchor > head) { var tmp = anchorDOM; anchorDOM = headDOM; headDOM = tmp; }
    range.setEnd(headDOM.node, headDOM.offset);
    range.setStart(anchorDOM.node, anchorDOM.offset);
  }
  domSel.removeAllRanges();
  domSel.addRange(range);
  if (domSel.extend)
    { domSel.extend(headDOM.node, headDOM.offset); }
};

// : (dom.MutationRecord) → bool
ViewDesc.prototype.ignoreMutation = function ignoreMutation (_mutation) {
  return !this.contentDOM
};

prototypeAccessors$1.contentLost.get = function () {
  return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM)
};

// Remove a subtree of the element tree that has been touched
// by a DOM change, so that the next update will redraw it.
ViewDesc.prototype.markDirty = function markDirty (from, to) {
    var this$1 = this;

  for (var offset = 0, i = 0; i < this.children.length; i++) {
    var child = this$1.children[i], end = offset + child.size;
    if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
      var startInside = offset + child.border, endInside = end - child.border;
      if (from >= startInside && to <= endInside) {
        this$1.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
        if (from == startInside && to == endInside && child.contentLost) { child.dirty = NODE_DIRTY; }
        else { child.markDirty(from - startInside, to - startInside); }
        return
      } else {
        child.dirty = NODE_DIRTY;
      }
    }
    offset = end;
  }
  this.dirty = CONTENT_DIRTY;
};

Object.defineProperties( ViewDesc.prototype, prototypeAccessors$1 );

// Reused array to avoid allocating fresh arrays for things that will
// stay empty anyway.
var nothing = [];

// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
var WidgetViewDesc = (function (ViewDesc) {
  function WidgetViewDesc(parent, widget, view, pos) {
    var self, dom = widget.type.toDOM;
    if (typeof dom == "function") { dom = dom(view, function () {
      if (!self) { return pos }
      if (self.parent) { return self.parent.posBeforeChild(self) }
    }); }
    if (!widget.type.spec.raw) {
      if (dom.nodeType != 1) {
        var wrap = document.createElement("span");
        wrap.appendChild(dom);
        dom = wrap;
      }
      dom.contentEditable = false;
      dom.classList.add("ProseMirror-widget");
    }
    ViewDesc.call(this, parent, nothing, dom, null);
    this.widget = widget;
    self = this;
  }

  if ( ViewDesc ) WidgetViewDesc.__proto__ = ViewDesc;
  WidgetViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  WidgetViewDesc.prototype.constructor = WidgetViewDesc;

  var prototypeAccessors$1 = { beforePosition: {} };

  prototypeAccessors$1.beforePosition.get = function () {
    return this.widget.type.side < 0
  };

  WidgetViewDesc.prototype.matchesWidget = function matchesWidget (widget) {
    return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type)
  };

  WidgetViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };

  WidgetViewDesc.prototype.stopEvent = function stopEvent (event) {
    var stop = this.widget.spec.stopEvent;
    return stop ? stop(event) : false
  };

  Object.defineProperties( WidgetViewDesc.prototype, prototypeAccessors$1 );

  return WidgetViewDesc;
}(ViewDesc));

// A cursor wrapper is used to put the cursor in when newly typed text
// needs to be styled differently from its surrounding text (for
// example through storedMarks), so that the style of the text doesn't
// visually 'pop' between typing it and actually updating the view.
var CursorWrapperDesc = (function (WidgetViewDesc) {
  function CursorWrapperDesc () {
    WidgetViewDesc.apply(this, arguments);
  }

  if ( WidgetViewDesc ) CursorWrapperDesc.__proto__ = WidgetViewDesc;
  CursorWrapperDesc.prototype = Object.create( WidgetViewDesc && WidgetViewDesc.prototype );
  CursorWrapperDesc.prototype.constructor = CursorWrapperDesc;

  CursorWrapperDesc.prototype.parseRule = function parseRule () {
    var content;
    for (var child = this.dom.firstChild; child; child = child.nextSibling) {
      var add = (void 0);
      if (child.nodeType == 3) {
        var text = child.nodeValue.replace(/\ufeff/g, "");
        if (!text) { continue }
        add = document.createTextNode(text);
      } else if (child.textContent == "\ufeff") {
        continue
      } else {
        add = child.cloneNode(true);
      }
      if (!content) { content = document.createDocumentFragment(); }
      content.appendChild(add);
    }
    if (content) { return {skip: content} }
    else { return WidgetViewDesc.prototype.parseRule.call(this) }
  };

  CursorWrapperDesc.prototype.ignoreMutation = function ignoreMutation () { return false };

  return CursorWrapperDesc;
}(WidgetViewDesc));

// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
var MarkViewDesc = (function (ViewDesc) {
  function MarkViewDesc(parent, mark, dom, contentDOM) {
    ViewDesc.call(this, parent, [], dom, contentDOM);
    this.mark = mark;
  }

  if ( ViewDesc ) MarkViewDesc.__proto__ = ViewDesc;
  MarkViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  MarkViewDesc.prototype.constructor = MarkViewDesc;

  MarkViewDesc.create = function create (parent, mark, inline, view) {
    var custom = customNodeViews(view)[mark.type.name];
    var spec = custom && custom(mark, view);
    if (!spec || !spec.dom)
      { spec = prosemirrorModel.DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline)); }
    return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom)
  };

  MarkViewDesc.prototype.parseRule = function parseRule () { return {mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM} };

  MarkViewDesc.prototype.matchesMark = function matchesMark (mark) { return this.dirty != NODE_DIRTY && this.mark.eq(mark) };

  MarkViewDesc.prototype.markDirty = function markDirty (from, to) {
    ViewDesc.prototype.markDirty.call(this, from, to);
    // Move dirty info to nearest node view
    if (this.dirty != NOT_DIRTY) {
      var parent = this.parent;
      while (!parent.node) { parent = parent.parent; }
      if (parent.dirty < this.dirty) { parent.dirty = this.dirty; }
      this.dirty = NOT_DIRTY;
    }
  };

  return MarkViewDesc;
}(ViewDesc));

// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
var NodeViewDesc = (function (ViewDesc) {
  function NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
    ViewDesc.call(this, parent, node.isLeaf ? nothing : [], dom, contentDOM);
    this.nodeDOM = nodeDOM;
    this.node = node;
    this.outerDeco = outerDeco;
    this.innerDeco = innerDeco;
    if (contentDOM) { this.updateChildren(view, pos); }
  }

  if ( ViewDesc ) NodeViewDesc.__proto__ = ViewDesc;
  NodeViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  NodeViewDesc.prototype.constructor = NodeViewDesc;

  var prototypeAccessors$2 = { size: {},border: {} };

  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finnicky
  // implementation details to the user code that they probably will
  // never need.)
  NodeViewDesc.create = function create (parent, node, outerDeco, innerDeco, view, pos) {
    var custom = customNodeViews(view)[node.type.name], descObj;
    var spec = custom && custom(node, view, function () {
      // (This is a function that allows the custom view to find its
      // own position)
      if (!descObj) { return pos }
      if (descObj.parent) { return descObj.parent.posBeforeChild(descObj) }
    }, outerDeco);

    var dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
    if (node.isText) {
      if (!dom) { dom = document.createTextNode(node.text); }
      else if (dom.nodeType != 3) { throw new RangeError("Text must be rendered as a DOM text node") }
    } else if (!dom) {
      var assign;
      ((assign = prosemirrorModel.DOMSerializer.renderSpec(document, node.type.spec.toDOM(node)), dom = assign.dom, contentDOM = assign.contentDOM));
    }
    if (!contentDOM && !node.isText && dom.nodeName != "BR") { // Chrome gets confused by <br contenteditable=false>
      dom.contentEditable = false;
      if (node.type.spec.draggable) { dom.draggable = true; }
    }

    var nodeDOM = dom;
    dom = applyOuterDeco(dom, outerDeco, node);

    if (spec)
      { return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view) }
    else if (node.isText)
      { return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) }
    else
      { return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos + 1) }
  };

  NodeViewDesc.prototype.parseRule = function parseRule () {
    var this$1 = this;

    // FIXME the assumption that this can always return the current
    // attrs means that if the user somehow manages to change the
    // attrs in the dom, that won't be picked up. Not entirely sure
    // whether this is a problem
    var rule = {node: this.node.type.name, attrs: this.node.attrs};
    if (this.node.type.spec.code) { rule.preserveWhitespace = "full"; }
    if (this.contentDOM && !this.contentLost) { rule.contentElement = this.contentDOM; }
    else { rule.getContent = function () { return this$1.contentDOM ? prosemirrorModel.Fragment.empty : this$1.node.content; }; }
    return rule
  };

  NodeViewDesc.prototype.matchesNode = function matchesNode (node, outerDeco, innerDeco) {
    return this.dirty == NOT_DIRTY && node.eq(this.node) &&
      sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco)
  };

  prototypeAccessors$2.size.get = function () { return this.node.nodeSize };

  prototypeAccessors$2.border.get = function () { return this.node.isLeaf ? 0 : 1 };

  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  NodeViewDesc.prototype.updateChildren = function updateChildren (view, pos) {
    var this$1 = this;

    var updater = new ViewTreeUpdater(this), inline = this.node.inlineContent;
    iterDeco(this.node, this.innerDeco, function (widget, i) {
      if (widget.spec.marks)
        { updater.syncToMarks(widget.spec.marks, inline, view); }
      else if (widget.type.side >= 0)
        { updater.syncToMarks(i == this$1.node.childCount ? prosemirrorModel.Mark.none : this$1.node.child(i).marks, inline, view); }
      // If the next node is a desc matching this widget, reuse it,
      // otherwise insert the widget as a new view desc.
      updater.placeWidget(widget, view, pos);
    }, function (child, outerDeco, innerDeco, i) {
      // Make sure the wrapping mark descs match the node's marks.
      updater.syncToMarks(child.marks, inline, view);
      // Either find an existing desc that exactly matches this node,
      // and drop the descs before it.
      updater.findNodeMatch(child, outerDeco, innerDeco, i) ||
        // Or try updating the next desc to reflect this node.
        updater.updateNextNode(child, outerDeco, innerDeco, view, i) ||
        // Or just add it as a new desc.
        updater.addNode(child, outerDeco, innerDeco, view, pos);
      pos += child.nodeSize;
    });
    // Drop all remaining descs after the current position.
    updater.syncToMarks(nothing, inline, view);
    if (this.node.isTextblock) { updater.addTextblockHacks(); }
    updater.destroyRest();

    // Sync the DOM if anything changed
    if (updater.changed || this.dirty == CONTENT_DIRTY) { this.renderChildren(); }
  };

  NodeViewDesc.prototype.renderChildren = function renderChildren () {
    renderDescs(this.contentDOM, this.children, NodeViewDesc.is);
    if (result.ios) { iosHacks(this.dom); }
  };

  // : (Node, [Decoration], DecorationSet, EditorView) → bool
  // If this desc be updated to match the given node decoration,
  // do so and return true.
  NodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY ||
        !node.sameMarkup(this.node)) { return false }
    this.updateInner(node, outerDeco, innerDeco, view);
    return true
  };

  NodeViewDesc.prototype.updateInner = function updateInner (node, outerDeco, innerDeco, view) {
    this.updateOuterDeco(outerDeco);
    this.node = node;
    this.innerDeco = innerDeco;
    if (this.contentDOM) { this.updateChildren(view, this.posAtStart); }
    this.dirty = NOT_DIRTY;
  };

  NodeViewDesc.prototype.updateOuterDeco = function updateOuterDeco (outerDeco) {
    if (sameOuterDeco(outerDeco, this.outerDeco)) { return }
    var needsWrap = this.nodeDOM.nodeType != 1;
    var oldDOM = this.dom;
    this.dom = patchOuterDeco(this.dom, this.nodeDOM,
                              computeOuterDeco(this.outerDeco, this.node, needsWrap),
                              computeOuterDeco(outerDeco, this.node, needsWrap));
    if (this.dom != oldDOM) {
      oldDOM.pmViewDesc = null;
      this.dom.pmViewDesc = this;
    }
    this.outerDeco = outerDeco;
  };

  // Mark this node as being the selected node.
  NodeViewDesc.prototype.selectNode = function selectNode () {
    this.nodeDOM.classList.add("ProseMirror-selectednode");
  };

  // Remove selected node marking from this node.
  NodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.nodeDOM.classList.remove("ProseMirror-selectednode");
  };

  Object.defineProperties( NodeViewDesc.prototype, prototypeAccessors$2 );

  return NodeViewDesc;
}(ViewDesc));

// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc, true);
  return new NodeViewDesc(null, doc, outerDeco, innerDeco, dom, dom, dom, view, 0)
}

var TextViewDesc = (function (NodeViewDesc) {
  function TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view);
  }

  if ( NodeViewDesc ) TextViewDesc.__proto__ = NodeViewDesc;
  TextViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  TextViewDesc.prototype.constructor = TextViewDesc;

  TextViewDesc.prototype.parseRule = function parseRule () {
    var parent = this.nodeDOM.parentNode;
    return parent ? {skip: parent} : {ignore: true}
  };

  TextViewDesc.prototype.update = function update (node, outerDeco) {
    if (this.dirty == NODE_DIRTY || (this.dirty != NOT_DIRTY && !this.inParent()) ||
        !node.sameMarkup(this.node)) { return false }
    this.updateOuterDeco(outerDeco);
    if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue)
      { this.nodeDOM.nodeValue = node.text; }
    this.node = node;
    this.dirty = NOT_DIRTY;
    return true
  };

  TextViewDesc.prototype.inParent = function inParent () {
    var parentDOM = this.parent.contentDOM;
    for (var n = this.nodeDOM; n; n = n.parentNode) { if (n == parentDOM) { return true } }
    return false
  };

  TextViewDesc.prototype.domFromPos = function domFromPos (pos) {
    return {node: this.nodeDOM, offset: pos}
  };

  TextViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
    if (dom == this.nodeDOM) { return this.posAtStart + Math.min(offset, this.node.text.length) }
    return NodeViewDesc.prototype.localPosFromDOM.call(this, dom, offset, bias)
  };

  TextViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return mutation.type != "characterData"
  };

  return TextViewDesc;
}(NodeViewDesc));

// A dummy desc used to tag trailing BR or span nodes created to work
// around contentEditable terribleness.
var BRHackViewDesc = (function (ViewDesc) {
  function BRHackViewDesc () {
    ViewDesc.apply(this, arguments);
  }

  if ( ViewDesc ) BRHackViewDesc.__proto__ = ViewDesc;
  BRHackViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  BRHackViewDesc.prototype.constructor = BRHackViewDesc;

  BRHackViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };
  BRHackViewDesc.prototype.matchesHack = function matchesHack () { return this.dirty == NOT_DIRTY };

  return BRHackViewDesc;
}(ViewDesc));

// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
var CustomNodeViewDesc = (function (NodeViewDesc) {
  function CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view);
    this.spec = spec;
  }

  if ( NodeViewDesc ) CustomNodeViewDesc.__proto__ = NodeViewDesc;
  CustomNodeViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  CustomNodeViewDesc.prototype.constructor = CustomNodeViewDesc;

  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  CustomNodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY) { return false }
    if (this.spec.update) {
      var result$$1 = this.spec.update(node, outerDeco);
      if (result$$1) { this.updateInner(node, outerDeco, innerDeco, view); }
      return result$$1
    } else if (!this.contentDOM && !node.isLeaf) {
      return false
    } else {
      return NodeViewDesc.prototype.update.call(this, node, outerDeco, innerDeco, view)
    }
  };

  CustomNodeViewDesc.prototype.selectNode = function selectNode () {
    this.spec.selectNode ? this.spec.selectNode() : NodeViewDesc.prototype.selectNode.call(this);
  };

  CustomNodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.spec.deselectNode ? this.spec.deselectNode() : NodeViewDesc.prototype.deselectNode.call(this);
  };

  CustomNodeViewDesc.prototype.setSelection = function setSelection (anchor, head, root) {
    this.spec.setSelection ? this.spec.setSelection(anchor, head, root) : NodeViewDesc.prototype.setSelection.call(this, anchor, head, root);
  };

  CustomNodeViewDesc.prototype.destroy = function destroy () {
    if (this.spec.destroy) { this.spec.destroy(); }
    NodeViewDesc.prototype.destroy.call(this);
  };

  CustomNodeViewDesc.prototype.stopEvent = function stopEvent (event) {
    return this.spec.stopEvent ? this.spec.stopEvent(event) : false
  };

  CustomNodeViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : NodeViewDesc.prototype.ignoreMutation.call(this, mutation)
  };

  return CustomNodeViewDesc;
}(NodeViewDesc));

// : (dom.Node, [ViewDesc])
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function renderDescs(parentDOM, descs) {
  var dom = parentDOM.firstChild;
  for (var i = 0; i < descs.length; i++) {
    var desc = descs[i], childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) { dom = rm(dom); }
      dom = dom.nextSibling;
    } else {
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof MarkViewDesc) {
      var pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) { dom = rm(dom); }
}

function OuterDecoLevel(nodeName) {
  if (nodeName) { this.nodeName = nodeName; }
}
OuterDecoLevel.prototype = Object.create(null);

var noDeco = [new OuterDecoLevel];

function computeOuterDeco(outerDeco, node, needsWrap) {
  if (outerDeco.length == 0) { return noDeco }

  var top = needsWrap ? noDeco[0] : new OuterDecoLevel, result$$1 = [top];

  for (var i = 0; i < outerDeco.length; i++) {
    var attrs = outerDeco[i].type.attrs, cur = top;
    if (!attrs) { continue }
    if (attrs.nodeName)
      { result$$1.push(cur = new OuterDecoLevel(attrs.nodeName)); }

    for (var name in attrs) {
      var val = attrs[name];
      if (val == null) { continue }
      if (needsWrap && result$$1.length == 1)
        { result$$1.push(cur = top = new OuterDecoLevel(node.isInline ? "span" : "div")); }
      if (name == "class") { cur.class = (cur.class ? cur.class + " " : "") + val; }
      else if (name == "style") { cur.style = (cur.style ? cur.style + ";" : "") + val; }
      else if (name != "nodeName") { cur[name] = val; }
    }
  }

  return result$$1
}

function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
  // Shortcut for trivial case
  if (prevComputed == noDeco && curComputed == noDeco) { return nodeDOM }

  var curDOM = nodeDOM;
  for (var i = 0; i < curComputed.length; i++) {
    var deco = curComputed[i], prev = prevComputed[i];
    if (i) {
      var parent = (void 0);
      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM &&
          (parent = nodeDOM.parentNode) && parent.tagName.toLowerCase() == deco.nodeName) {
        curDOM = parent;
      } else {
        parent = document.createElement(deco.nodeName);
        parent.appendChild(curDOM);
        curDOM = parent;
      }
    }
    patchAttributes(curDOM, prev || noDeco[0], deco);
  }
  return curDOM
}

function patchAttributes(dom, prev, cur) {
  for (var name in prev)
    { if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
      { dom.removeAttribute(name); } }
  for (var name$1 in cur)
    { if (name$1 != "class" && name$1 != "style" && name$1 != "nodeName" && cur[name$1] != prev[name$1])
      { dom.setAttribute(name$1, cur[name$1]); } }
  if (prev.class != cur.class) {
    var prevList = prev.class ? prev.class.split(" ") : nothing;
    var curList = cur.class ? cur.class.split(" ") : nothing;
    for (var i = 0; i < prevList.length; i++) { if (curList.indexOf(prevList[i]) == -1)
      { dom.classList.remove(prevList[i]); } }
    for (var i$1 = 0; i$1 < curList.length; i$1++) { if (prevList.indexOf(curList[i$1]) == -1)
      { dom.classList.add(curList[i$1]); } }
  }
  if (prev.style != cur.style) {
    if (prev.style) {
      var prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
      while (m = prop.exec(prev.style))
        { dom.style[m[1].toLowerCase()] = ""; }
    }
    if (cur.style)
      { dom.style.cssText += cur.style; }
  }
}

function applyOuterDeco(dom, deco, node) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1))
}

// : ([Decoration], [Decoration]) → bool
function sameOuterDeco(a, b) {
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++) { if (!a[i].type.eq(b[i].type)) { return false } }
  return true
}

// Remove a DOM node and return its next sibling.
function rm(dom) {
  var next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next
}

// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
var ViewTreeUpdater = function ViewTreeUpdater(top) {
  this.top = top;
  // Index into `this.top`'s child array, represents the current
  // update position.
  this.index = 0;
  // When entering a mark, the current top and index are pushed
  // onto this.
  this.stack = [];
  // Tracks whether anything was changed
  this.changed = false;

  this.preMatched = preMatch(top.node.content, top.children);
};

// Destroy and remove the children between the given indices in
// `this.top`.
ViewTreeUpdater.prototype.destroyBetween = function destroyBetween (start, end) {
    var this$1 = this;

  if (start == end) { return }
  for (var i = start; i < end; i++) { this$1.top.children[i].destroy(); }
  this.top.children.splice(start, end - start);
  this.changed = true;
};

// Destroy all remaining children in `this.top`.
ViewTreeUpdater.prototype.destroyRest = function destroyRest () {
  this.destroyBetween(this.index, this.top.children.length);
};

// : ([Mark], EditorView)
// Sync the current stack of mark descs with the given array of
// marks, reusing existing mark descs when possible.
ViewTreeUpdater.prototype.syncToMarks = function syncToMarks (marks, inline, view) {
    var this$1 = this;

  var keep = 0, depth = this.stack.length >> 1;
  var maxKeep = Math.min(depth, marks.length), next;
  while (keep < maxKeep &&
         (keep == depth - 1 ? this.top : this.stack[(keep + 1) << 1]).matchesMark(marks[keep]))
    { keep++; }

  while (keep < depth) {
    this$1.destroyRest();
    this$1.top.dirty = NOT_DIRTY;
    this$1.index = this$1.stack.pop();
    this$1.top = this$1.stack.pop();
    depth--;
  }
  while (depth < marks.length) {
    this$1.stack.push(this$1.top, this$1.index + 1);
    if (this$1.index < this$1.top.children.length &&
        (next = this$1.top.children[this$1.index]).matchesMark(marks[depth])) {
      this$1.top = next;
    } else {
      var markDesc = MarkViewDesc.create(this$1.top, marks[depth], inline, view);
      this$1.top.children.splice(this$1.index, 0, markDesc);
      this$1.top = markDesc;
      this$1.changed = true;
    }
    this$1.index = 0;
    depth++;
  }
};

// : (Node, [Decoration], DecorationSet) → bool
// Try to find a node desc matching the given data. Skip over it and
// return true when successful.
ViewTreeUpdater.prototype.findNodeMatch = function findNodeMatch (node, outerDeco, innerDeco, index) {
    var this$1 = this;

  for (var i = this.index, children = this.top.children, e = Math.min(children.length, i + 5); i < e; i++) {
    var child = children[i], preMatched = (void 0);
    if (child.matchesNode(node, outerDeco, innerDeco) &&
        ((preMatched = this$1.preMatched.indexOf(child)) == -1 || preMatched == index)) {
      this$1.destroyBetween(this$1.index, i);
      this$1.index++;
      return true
    }
  }
  return false
};

// : (Node, [Decoration], DecorationSet, EditorView, Fragment, number) → bool
// Try to update the next node, if any, to the given data. Checks
// pre-matches to avoid overwriting nodes that could still be used.
ViewTreeUpdater.prototype.updateNextNode = function updateNextNode (node, outerDeco, innerDeco, view, index) {
  if (this.index == this.top.children.length) { return false }
  var next = this.top.children[this.index];
  if (next instanceof NodeViewDesc) {
    var preMatch = this.preMatched.indexOf(next);
    if (preMatch > -1 && preMatch != index) { return false }
    var nextDOM = next.dom;
    if (next.update(node, outerDeco, innerDeco, view)) {
      if (next.dom != nextDOM) { this.changed = true; }
      this.index++;
      return true
    }
  }
  return false
};

// : (Node, [Decoration], DecorationSet, EditorView)
// Insert the node as a newly created node desc.
ViewTreeUpdater.prototype.addNode = function addNode (node, outerDeco, innerDeco, view, pos) {
  this.top.children.splice(this.index++, 0, NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos));
  this.changed = true;
};

ViewTreeUpdater.prototype.placeWidget = function placeWidget (widget, view, pos) {
  if (this.index < this.top.children.length && this.top.children[this.index].matchesWidget(widget)) {
    this.index++;
  } else {
    var desc = new (widget.spec.isCursorWrapper ? CursorWrapperDesc : WidgetViewDesc)(this.top, widget, view, pos);
    this.top.children.splice(this.index++, 0, desc);
    this.changed = true;
  }
};

// Make sure a textblock looks and behaves correctly in
// contentEditable.
ViewTreeUpdater.prototype.addTextblockHacks = function addTextblockHacks () {
  var lastChild = this.top.children[this.index - 1];
  while (lastChild instanceof MarkViewDesc) { lastChild = lastChild.children[lastChild.children.length - 1]; }

  if (!lastChild || // Empty textblock
      !(lastChild instanceof TextViewDesc) ||
      /\n$/.test(lastChild.node.text)) {
    if (this.index < this.top.children.length && this.top.children[this.index].matchesHack()) {
      this.index++;
    } else {
      var dom = document.createElement("br");
      this.top.children.splice(this.index++, 0, new BRHackViewDesc(this.top, nothing, dom, null));
      this.changed = true;
    }
  }
};

// : (Fragment, [ViewDesc]) → [ViewDesc]
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing
// those for other nodes. Returns an array whose positions correspond
// to node positions in the fragment, and whose elements are either
// descs matched to the child at that index, or empty.
function preMatch(frag, descs) {
  var result$$1 = [], end = frag.childCount;
  for (var i = descs.length - 1; end > 0 && i >= 0; i--) {
    var desc = descs[i], node = desc.node;
    if (!node) { continue }
    if (node != frag.child(end - 1)) { break }
    result$$1[--end] = desc;
  }
  return result$$1
}

function compareSide(a, b) { return a.type.side - b.type.side }

// : (ViewDesc, DecorationSet, (Decoration), (Node, [Decoration], DecorationSet, number))
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function iterDeco(parent, deco, onWidget, onNode) {
  var locals = deco.locals(parent), offset = 0;
  // Simple, cheap variant for when there are no local decorations
  if (locals.length == 0) {
    for (var i = 0; i < parent.childCount; i++) {
      var child = parent.child(i);
      onNode(child, locals, deco.forChild(offset, child), i);
      offset += child.nodeSize;
    }
    return
  }

  var decoIndex = 0, active = [], restNode = null;
  for (var parentIndex = 0;;) {
    if (decoIndex < locals.length && locals[decoIndex].to == offset) {
      var widget = locals[decoIndex++], widgets = (void 0);
      while (decoIndex < locals.length && locals[decoIndex].to == offset)
        { (widgets || (widgets = [widget])).push(locals[decoIndex++]); }
      if (widgets) {
        widgets.sort(compareSide);
        for (var i$1 = 0; i$1 < widgets.length; i$1++) { onWidget(widgets[i$1], parentIndex); }
      } else {
        onWidget(widget, parentIndex);
      }
    }

    var child$1 = (void 0);
    if (restNode) {
      child$1 = restNode;
      restNode = null;
    } else if (parentIndex < parent.childCount) {
      child$1 = parent.child(parentIndex++);
    } else {
      break
    }

    for (var i$2 = 0; i$2 < active.length; i$2++) { if (active[i$2].to <= offset) { active.splice(i$2--, 1); } }
    while (decoIndex < locals.length && locals[decoIndex].from == offset) { active.push(locals[decoIndex++]); }

    var end = offset + child$1.nodeSize;
    if (child$1.isText) {
      var cutAt = end;
      if (decoIndex < locals.length && locals[decoIndex].from < cutAt) { cutAt = locals[decoIndex].from; }
      for (var i$3 = 0; i$3 < active.length; i$3++) { if (active[i$3].to < cutAt) { cutAt = active[i$3].to; } }
      if (cutAt < end) {
        restNode = child$1.cut(cutAt - offset);
        child$1 = child$1.cut(0, cutAt - offset);
        end = cutAt;
      }
    }

    onNode(child$1, active.length ? active.slice() : nothing, deco.forChild(offset, child$1), parentIndex - 1);
    offset = end;
  }
}

// Pre-calculate and cache the set of custom view specs for a given
// prop object.
var cachedCustomViews;
var cachedCustomFor;
function customNodeViews(view) {
  if (cachedCustomFor == view._props) { return cachedCustomViews }
  cachedCustomFor = view._props;
  return cachedCustomViews = buildCustomViews(view)
}
function buildCustomViews(view) {
  var result$$1 = {};
  view.someProp("nodeViews", function (obj) {
    for (var prop in obj) { if (!Object.prototype.hasOwnProperty.call(result$$1, prop))
      { result$$1[prop] = obj[prop]; } }
  });
  return result$$1
}

// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    var oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}

function moveSelectionBlock(state, dir) {
  var ref = state.selection;
  var $anchor = ref.$anchor;
  var $head = ref.$head;
  var $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  var $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && prosemirrorState.Selection.findFrom($start, dir)
}

function apply(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true
}

function selectHorizontally(view, dir) {
  var sel = view.state.selection;
  if (sel instanceof prosemirrorState.TextSelection) {
    if (!sel.empty) {
      return false
    } else if (view.endOfTextblock(dir > 0 ? "right" : "left")) {
      var next = moveSelectionBlock(view.state, dir);
      if (next && (next instanceof prosemirrorState.NodeSelection)) { return apply(view, next) }
      return false
    } else {
      var $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
      if (node && prosemirrorState.NodeSelection.isSelectable(node)) {
        var nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
        if (node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)
          { return apply(view, new prosemirrorState.NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head)) }
      }
      return false
    }
  } else if (sel instanceof prosemirrorState.NodeSelection && sel.node.isInline) {
    return apply(view, new prosemirrorState.TextSelection(dir > 0 ? sel.$to : sel.$from))
  } else {
    var next$1 = moveSelectionBlock(view.state, dir);
    if (next$1) { return apply(view, next$1) }
    return false
  }
}

function nodeLen(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function isIgnorable(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dom.nextSibling || dom.nodeName != "BR")
}

// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function skipIgnoredNodesLeft(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var moveNode, moveOffset, force = false;
  for (;;) {
    if (offset > 0) {
      if (node.nodeType != 1) {
        if (node.nodeType == 3 && node.nodeValue.charAt(offset - 1) == "\ufeff") {
          // IE11's cursor will still be stuck when placed at the
          // beginning of the cursor wrapper text node (#807)
          if (result.ie && result.ie_version <= 11) { force = true; }
          moveNode = node;
          moveOffset = --offset;
        } else { break }
      } else {
        var before = node.childNodes[offset - 1];
        if (isIgnorable(before)) {
          moveNode = node;
          moveOffset = --offset;
        } else if (before.nodeType == 3) {
          node = before;
          offset = node.nodeValue.length;
        } else { break }
      }
    } else if (isBlockNode(node)) {
      break
    } else {
      var prev = node.previousSibling;
      while (prev && isIgnorable(prev)) {
        moveNode = node.parentNode;
        moveOffset = domIndex(prev);
        prev = prev.previousSibling;
      }
      if (!prev) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = 0;
      } else {
        node = prev;
        offset = nodeLen(node);
      }
    }
  }
  if (force) { setSelFocus(view, sel, node, offset); }
  else if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

// Make sure the cursor isn't directly before one or more ignored
// nodes.
function skipIgnoredNodesRight(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var len = nodeLen(node);
  var moveNode, moveOffset;
  for (;;) {
    if (offset < len) {
      if (node.nodeType != 1) { break }
      var after = node.childNodes[offset];
      if (isIgnorable(after)) {
        moveNode = node;
        moveOffset = ++offset;
      }
      else { break }
    } else if (isBlockNode(node)) {
      break
    } else {
      var next = node.nextSibling;
      while (next && isIgnorable(next)) {
        moveNode = next.parentNode;
        moveOffset = domIndex(next) + 1;
        next = next.nextSibling;
      }
      if (!next) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = len = 0;
      } else {
        node = next;
        offset = 0;
        len = nodeLen(node);
      }
    }
  }
  if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

function isBlockNode(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock
}

function setSelFocus(view, sel, node, offset) {
  if (selectionCollapsed(sel)) {
    var range = document.createRange();
    range.setEnd(node, offset);
    range.setStart(node, offset);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (sel.extend) {
    sel.extend(node, offset);
  }
  view.selectionReader.storeDOMState(view.selection);
}

// : (EditorState, number)
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function selectVertically(view, dir) {
  var sel = view.state.selection;
  if (sel instanceof prosemirrorState.TextSelection && !sel.empty) { return false }
  var $from = sel.$from;
  var $to = sel.$to;

  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    var next = moveSelectionBlock(view.state, dir);
    if (next && (next instanceof prosemirrorState.NodeSelection))
      { return apply(view, next) }
  }
  if (!$from.parent.inlineContent) {
    var beyond = prosemirrorState.Selection.findFrom(dir < 0 ? $from : $to, dir);
    return beyond ? apply(view, beyond) : true
  }
  return false
}

function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof prosemirrorState.TextSelection)) { return true }
  var ref = view.state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  var empty = ref.empty;
  if (!$head.sameParent($anchor)) { return true }
  if (!empty) { return false }
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) { return true }
  var nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    var tr = view.state.tr;
    if (dir < 0) { tr.delete($head.pos - nextNode.nodeSize, $head.pos); }
    else { tr.delete($head.pos, $head.pos + nextNode.nodeSize); }
    view.dispatch(tr);
    return true
  }
  return false
}

// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.

function getMods(event) {
  var result$$1 = "";
  if (event.ctrlKey) { result$$1 += "c"; }
  if (event.metaKey) { result$$1 += "m"; }
  if (event.altKey) { result$$1 += "a"; }
  if (event.shiftKey) { result$$1 += "s"; }
  return result$$1
}

function captureKeyDown(view, event) {
  var code = event.keyCode, mods = getMods(event);
  if (code == 8 || (result.mac && code == 72 && mods == "c")) { // Backspace, Ctrl-h on Mac
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 46 || (result.mac && code == 68 && mods == "c")) { // Delete, Ctrl-d on Mac
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodesRight(view)
  } else if (code == 13 || code == 27) { // Enter, Esc
    return true
  } else if (code == 37) { // Left arrow
    return selectHorizontally(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 39) { // Right arrow
    return selectHorizontally(view, 1) || skipIgnoredNodesRight(view)
  } else if (code == 38) { // Up arrow
    return selectVertically(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 40) { // Down arrow
    return selectVertically(view, 1) || skipIgnoredNodesRight(view)
  } else if (mods == (result.mac ? "m" : "c") &&
             (code == 66 || code == 73 || code == 89 || code == 90)) { // Mod-[biyz]
    return true
  }
  return false
}

var TrackedRecord = function TrackedRecord(prev, mapping, state) {
  this.prev = prev;
  this.mapping = mapping;
  this.state = state;
};

var TrackMappings = function TrackMappings(state) {
  this.seen = [new TrackedRecord(null, null, state)];
  // Kludge to listen to state changes globally in order to be able
  // to find mappings from a given state to another.
  prosemirrorState.EditorState.addApplyListener(this.track = this.track.bind(this));
};

TrackMappings.prototype.destroy = function destroy () {
  prosemirrorState.EditorState.removeApplyListener(this.track);
};

TrackMappings.prototype.find = function find (state) {
    var this$1 = this;

  for (var i = this.seen.length - 1; i >= 0; i--) {
    var record = this$1.seen[i];
    if (record.state == state) { return record }
  }
};

TrackMappings.prototype.track = function track (old, tr, state) {
  var found = this.seen.length < 200 ? this.find(old) : null;
  if (found)
    { this.seen.push(new TrackedRecord(found, tr.docChanged ? tr.mapping : null, state)); }
};

TrackMappings.prototype.getMapping = function getMapping (state, appendTo) {
  var found = this.find(state);
  if (!found) { return null }
  var mappings = [];
  for (var rec = found; rec; rec = rec.prev)
    { if (rec.mapping) { mappings.push(rec.mapping); } }
  var result = appendTo || new prosemirrorTransform.Mapping;
  for (var i = mappings.length - 1; i >= 0; i--)
    { result.appendMapping(mappings[i]); }
  return result
};

// Track the state of the DOM selection, creating transactions to
// update the selection state when necessary.
var SelectionReader = function SelectionReader(view) {
  var this$1 = this;

  this.view = view;

  // Track the state of the DOM selection.
  this.lastAnchorNode = this.lastHeadNode = this.lastAnchorOffset = this.lastHeadOffset = null;
  this.lastSelection = view.state.selection;
  this.ignoreUpdates = false;
  this.poller = poller(this);

  view.dom.addEventListener("focus", function () { return this$1.poller.start(hasFocusAndSelection(this$1.view)); });
  view.dom.addEventListener("blur", function () { return this$1.poller.stop(); });

  if (!view.editable) { this.poller.start(false); }
};

SelectionReader.prototype.destroy = function destroy () { this.poller.stop(); };

SelectionReader.prototype.poll = function poll (origin) { this.poller.poll(origin); };

SelectionReader.prototype.editableChanged = function editableChanged () {
  if (!this.view.editable) { this.poller.start(); }
  else if (!hasFocusAndSelection(this.view)) { this.poller.stop(); }
};

// : () → bool
// Whether the DOM selection has changed from the last known state.
SelectionReader.prototype.domChanged = function domChanged () {
  var sel = this.view.root.getSelection();
  return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
    sel.focusNode != this.lastHeadNode || sel.focusOffset != this.lastHeadOffset
};

// Store the current state of the DOM selection.
SelectionReader.prototype.storeDOMState = function storeDOMState (selection) {
  var sel = this.view.root.getSelection();
  this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
  this.lastHeadNode = sel.focusNode; this.lastHeadOffset = sel.focusOffset;
  this.lastSelection = selection;
};

SelectionReader.prototype.clearDOMState = function clearDOMState () {
  this.lastAnchorNode = this.lastSelection = null;
};

// : (?string) → bool
// When the DOM selection changes in a notable manner, modify the
// current selection state to match.
SelectionReader.prototype.readFromDOM = function readFromDOM (origin) {
  if (this.ignoreUpdates || !this.domChanged() || !hasFocusAndSelection(this.view)) { return }
  if (!this.view.inDOMChange) { this.view.domObserver.flush(); }
  if (this.view.inDOMChange) { return }

  var domSel = this.view.root.getSelection(), doc = this.view.state.doc;
  var nearestDesc = this.view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc.size == 0;
  var head = this.view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
  var $head = doc.resolve(head), $anchor, selection;
  if (selectionCollapsed(domSel)) {
    $anchor = $head;
    while (nearestDesc && !nearestDesc.node) { nearestDesc = nearestDesc.parent; }
    if (nearestDesc && nearestDesc.node.isAtom && prosemirrorState.NodeSelection.isSelectable(nearestDesc.node) && nearestDesc.parent) {
      var pos = nearestDesc.posBefore;
      selection = new prosemirrorState.NodeSelection(head == pos ? $head : doc.resolve(pos));
    }
  } else {
    $anchor = doc.resolve(this.view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset));
  }

  if (!selection) {
    var bias = origin == "pointer" || (this.view.state.selection.head < $head.pos && !inWidget) ? 1 : -1;
    selection = selectionBetween(this.view, $anchor, $head, bias);
  }
  var preserve = !inWidget && head == selection.head && $anchor.pos == selection.anchor &&
      (!this.view.cursorWrapper || domSel.isCollapsed && origin != "pointer");
  if (preserve) { this.storeDOMState(selection); }
  if (!this.view.state.selection.eq(selection)) {
    var tr = this.view.state.tr.setSelection(selection);
    if (origin == "pointer") { tr.setMeta("pointer", true); }
    this.view.dispatch(tr);
  } else if (!preserve) {
    selectionToDOM(this.view);
  }
};

// There's two polling models. On browsers that support the
// selectionchange event (everything except Firefox < 52, basically), we
// register a listener for that whenever the editor is focused.
var SelectionChangePoller = function SelectionChangePoller(reader) {
  var this$1 = this;

  this.listening = false;
  this.curOrigin = null;
  this.originTime = 0;
  this.reader = reader;

  this.readFunc = function () { return reader.readFromDOM(this$1.originTime > Date.now() - 50 ? this$1.curOrigin : null); };
};

SelectionChangePoller.prototype.poll = function poll (origin) {
  this.curOrigin = origin;
  this.originTime = Date.now();
};

SelectionChangePoller.prototype.start = function start (andRead) {
  if (!this.listening) {
    var doc = this.reader.view.dom.ownerDocument;
    doc.addEventListener("selectionchange", this.readFunc);
    this.listening = true;
    if (andRead) { this.readFunc(); }
  }
};

SelectionChangePoller.prototype.stop = function stop () {
  if (this.listening) {
    var doc = this.reader.view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", this.readFunc);
    this.listening = false;
  }
};

// On Browsers that don't support the selectionchange event,
// we use timeout-based polling.
var TimeoutPoller = function TimeoutPoller(reader) {
  // The timeout ID for the poller when active.
  this.polling = null;
  this.reader = reader;
  this.pollFunc = this.doPoll.bind(this, null);
};

TimeoutPoller.prototype.doPoll = function doPoll (origin) {
  var view = this.reader.view;
  if (view.focused || !view.editable) {
    this.reader.readFromDOM(origin);
    this.polling = setTimeout(this.pollFunc, 100);
  } else {
    this.polling = null;
  }
};

TimeoutPoller.prototype.poll = function poll (origin) {
  clearTimeout(this.polling);
  this.polling = setTimeout(origin ? this.doPoll.bind(this, origin) : this.pollFunc, 0);
};

TimeoutPoller.prototype.start = function start () {
  if (this.polling == null) { this.poll(); }
};

TimeoutPoller.prototype.stop = function stop () {
  clearTimeout(this.polling);
  this.polling = null;
};

function poller(reader) {
  return new ("onselectionchange" in document ? SelectionChangePoller : TimeoutPoller)(reader)
}

function selectionToDOM(view, takeFocus) {
  var sel = view.state.selection;
  syncNodeSelection(view, sel);

  if (view.editable && !view.hasFocus()) {
    if (!takeFocus) { return }
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444
    if (result.gecko && result.gecko_version <= 55) {
      view.selectionReader.ignoreUpdates = true;
      view.dom.focus();
      view.selectionReader.ignoreUpdates = false;
    }
  } else if (!view.editable && !hasSelection(view) && !takeFocus) {
    return
  }

  var reader = view.selectionReader;
  if (reader.lastSelection && reader.lastSelection.eq(sel) && !reader.domChanged()) { return }

  reader.ignoreUpdates = true;

  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    var anchor = sel.anchor;
    var head = sel.head;
    var resetEditableFrom, resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof prosemirrorState.TextSelection)) {
      if (!sel.$from.parent.inlineContent)
        { resetEditableFrom = temporarilyEditableNear(view, sel.from); }
      if (!sel.empty && !sel.$from.parent.inlineContent)
        { resetEditableTo = temporarilyEditableNear(view, sel.to); }
    }
    view.docView.setSelection(anchor, head, view.root);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom) { resetEditableFrom.contentEditable = "false"; }
      if (resetEditableTo) { resetEditableTo.contentEditable = "false"; }
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else if (anchor != head) {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document) { removeClassOnSelectionChange(view); }
    }
  }

  reader.storeDOMState(sel);
  reader.ignoreUpdates = false;
}

// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.

var brokenSelectBetweenUneditable = result.safari || result.chrome && result.chrome_version < 63;

function temporarilyEditableNear(view, pos) {
  var ref = view.docView.domFromPos(pos);
  var node = ref.node;
  var offset = ref.offset;
  var after = offset < node.childNodes.length ? node.childNodes[offset] : null;
  var before = offset ? node.childNodes[offset - 1] : null;
  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
    if (after) {
      after.contentEditable = "true";
      return after
    } else if (before) {
      before.contentEditable = "true";
      return before
    }
  }
}

function removeClassOnSelectionChange(view) {
  var doc = view.dom.ownerDocument;
  doc.removeEventListener("selectionchange", view.hideSelectionGuard);
  var domSel = view.root.getSelection();
  var node = domSel.anchorNode, offset = domSel.anchorOffset;
  doc.addEventListener("selectionchange", view.hideSelectionGuard = function () {
    if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
      doc.removeEventListener("selectionchange", view.hideSelectionGuard);
      view.dom.classList.remove("ProseMirror-hideselection");
    }
  });
}

function selectCursorWrapper(view) {
  var domSel = view.root.getSelection(), range = document.createRange();
  var node = view.cursorWrapper.dom;
  range.setEnd(node, node.childNodes.length);
  range.collapse(false);
  domSel.removeAllRanges();
  domSel.addRange(range);
  // Kludge to kill 'control selection' in IE11 when selecting an
  // invisible cursor wrapper, since that would result in those weird
  // resize handles and a selection that considers the absolutely
  // positioned wrapper, rather than the root editable node, the
  // focused element.
  if (!view.state.selection.visible && result.ie && result.ie_version <= 11) {
    node.disabled = true;
    node.disabled = false;
  }
}

function syncNodeSelection(view, sel) {
  if (sel instanceof prosemirrorState.NodeSelection) {
    var desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc) { desc.selectNode(); }
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}

// Clear all DOM statefulness of the last node selection.
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    view.lastSelectedViewDesc.deselectNode();
    view.lastSelectedViewDesc = null;
  }
}

function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", function (f) { return f(view, $anchor, $head); })
    || prosemirrorState.TextSelection.between($anchor, $head, bias)
}

function hasFocusAndSelection(view) {
  if (view.editable && view.root.activeElement != view.dom) { return false }
  return hasSelection(view)
}

function hasSelection(view) {
  var sel = view.root.getSelection();
  if (!sel.anchorNode) { return false }
  try {
    // Firefox will raise 'permission denied' errors when accessing
    // properties of `sel.anchorNode` when it's in a generated CSS
    // element.
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode)
  } catch(_) {
    return false
  }
}

function nonInclusiveMark(mark) {
  return mark.type.spec.inclusive === false
}

function needsCursorWrapper(state) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  var visible = ref.visible;
  var $pos = $head.pos == $anchor.pos && (!visible || $head.parent.inlineContent) ? $head : null;
  if ($pos && (!visible || state.storedMarks || $pos.parent.content.length == 0 ||
               $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.some(nonInclusiveMark)))
    { return $pos }
  else
    { return null }
}

var DOMChange = function DOMChange(view, composing) {
  var this$1 = this;

  this.view = view;
  this.state = view.state;
  this.composing = composing;
  this.from = this.to = null;
  this.typeOver = false;
  this.timeout = composing ? null : setTimeout(function () { return this$1.finish(); }, DOMChange.commitTimeout);
  this.trackMappings = new TrackMappings(view.state);

  // If there have been changes since this DOM update started, we must
  // map our start and end positions, as well as the new selection
  // positions, through them. This tracks that mapping.
  this.mapping = new prosemirrorTransform.Mapping;
  this.mappingTo = view.state;
};

DOMChange.prototype.addRange = function addRange (from, to) {
  if (this.from == null) {
    this.from = from;
    this.to = to;
  } else {
    this.from = Math.min(from, this.from);
    this.to = Math.max(to, this.to);
  }
};

DOMChange.prototype.changedRange = function changedRange () {
  if (this.from == null) { return rangeAroundSelection(this.state.selection) }
  var $from = this.state.doc.resolve(Math.min(this.from, this.state.selection.from)), $to = this.state.doc.resolve(this.to);
  var shared = $from.sharedDepth(this.to);
  return {from: $from.before(shared + 1), to: $to.after(shared + 1)}
};

DOMChange.prototype.markDirty = function markDirty (range) {
  if (this.from == null) { this.view.docView.markDirty((range = range || this.changedRange()).from, range.to); }
  else { this.view.docView.markDirty(this.from, this.to); }
};

DOMChange.prototype.stateUpdated = function stateUpdated (state) {
  if (this.trackMappings.getMapping(state, this.mapping)) {
    this.trackMappings.destroy();
    this.trackMappings = new TrackMappings(state);
    this.mappingTo = state;
    return true
  } else {
    this.markDirty();
    this.destroy();
    return false
  }
};

DOMChange.prototype.finish = function finish (force) {
  clearTimeout(this.timeout);
  if (this.composing && !force) { return }
  this.view.domObserver.flush();
  var range = this.changedRange();
  this.markDirty(range);

  this.destroy();
  var sel = this.state.selection, allowTypeOver = this.typeOver && sel instanceof prosemirrorState.TextSelection &&
      !sel.empty && sel.$head.sameParent(sel.$anchor);
  readDOMChange(this.view, this.mapping, this.state, range, allowTypeOver);

  // If the reading didn't result in a view update, force one by
  // resetting the view to its current state.
  if (this.view.docView.dirty) { this.view.updateState(this.view.state); }
};

DOMChange.prototype.destroy = function destroy () {
  clearTimeout(this.timeout);
  this.trackMappings.destroy();
  this.view.inDOMChange = null;
};

DOMChange.prototype.compositionEnd = function compositionEnd () {
    var this$1 = this;

  if (this.composing) {
    this.composing = false;
    this.timeout = setTimeout(function () { return this$1.finish(); }, 50);
  }
};

DOMChange.start = function start (view, composing) {
  if (view.inDOMChange) {
    if (composing) {
      clearTimeout(view.inDOMChange.timeout);
      view.inDOMChange.composing = true;
    }
  } else {
    view.inDOMChange = new DOMChange(view, composing);
  }
  return view.inDOMChange
};
DOMChange.commitTimeout = 20;

// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.

function parseBetween(view, oldState, range) {
  var ref = view.docView.parseRange(range.from, range.to);
  var parent = ref.node;
  var fromOffset = ref.fromOffset;
  var toOffset = ref.toOffset;
  var from = ref.from;
  var to = ref.to;

  var domSel = view.root.getSelection(), find = null, anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find = [{node: anchor, offset: domSel.anchorOffset}];
    if (!selectionCollapsed(domSel))
      { find.push({node: domSel.focusNode, offset: domSel.focusOffset}); }
  }
  var startDoc = oldState.doc;
  var parser = view.someProp("domParser") || prosemirrorModel.DOMParser.fromSchema(view.state.schema);
  var $from = startDoc.resolve(from);
  var sel = null, doc = parser.parse(parent, {
    topNode: $from.parent,
    topMatch: $from.parent.contentMatchAt($from.index()),
    topOpen: true,
    from: fromOffset,
    to: toOffset,
    preserveWhitespace: $from.parent.type.spec.code ? "full" : true,
    editableContent: true,
    findPositions: find,
    ruleFromNode: ruleFromNode(parser, $from),
    context: $from
  });
  if (find && find[0].pos != null) {
    var anchor$1 = find[0].pos, head = find[1] && find[1].pos;
    if (head == null) { head = anchor$1; }
    sel = {anchor: anchor$1 + from, head: head + from};
  }
  return {doc: doc, sel: sel, from: from, to: to}
}

function ruleFromNode(parser, context) {
  return function (dom) {
    var desc = dom.pmViewDesc;
    if (desc) {
      return desc.parseRule()
    } else if (dom.nodeName == "BR" && dom.parentNode) {
      // Safari replaces the list item with a BR directly in the list node (?!) if you delete the last character in a list item (#708)
      if (result.safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName))
        { return parser.matchTag(document.createElement("li"), context) }
      else if (dom.parentNode.lastChild == dom)
        { return {ignore: true} }
    }
  }
}

function isAtEnd($pos, depth) {
  for (var i = depth || 0; i < $pos.depth; i++)
    { if ($pos.index(i) + 1 < $pos.node(i).childCount) { return false } }
  return $pos.parentOffset == $pos.parent.content.size
}
function isAtStart($pos, depth) {
  for (var i = depth || 0; i < $pos.depth; i++)
    { if ($pos.index(0) > 0) { return false } }
  return $pos.parentOffset == 0
}

function rangeAroundSelection(selection) {
  // Intentionally uses $head/$anchor because those will correspond to the DOM selection
  var $from = selection.$anchor.min(selection.$head), $to = selection.$anchor.max(selection.$head);

  if ($from.sameParent($to) && $from.parent.inlineContent && $from.parentOffset && $to.parentOffset < $to.parent.content.size) {
    var startOff = Math.max(0, $from.parentOffset);
    var size = $from.parent.content.size;
    var endOff = Math.min(size, $to.parentOffset);

    if (startOff > 0)
      { startOff = $from.parent.childBefore(startOff).offset; }
    if (endOff < size) {
      var after = $from.parent.childAfter(endOff);
      endOff = after.offset + after.node.nodeSize;
    }
    var nodeStart = $from.start();
    return {from: nodeStart + startOff, to: nodeStart + endOff}
  } else {
    for (var depth = 0;; depth++) {
      var fromStart = isAtStart($from, depth + 1), toEnd = isAtEnd($to, depth + 1);
      if (fromStart || toEnd || $from.index(depth) != $to.index(depth) || $to.node(depth).isTextblock) {
        var from = $from.before(depth + 1), to = $to.after(depth + 1);
        if (fromStart && $from.index(depth) > 0)
          { from -= $from.node(depth).child($from.index(depth) - 1).nodeSize; }
        if (toEnd && $to.index(depth) + 1 < $to.node(depth).childCount)
          { to += $to.node(depth).child($to.index(depth) + 1).nodeSize; }
        return {from: from, to: to}
      }
    }
  }
}

function keyEvent(keyCode, key) {
  var event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key;
  return event
}

function readDOMChange(view, mapping, oldState, range, allowTypeOver) {
  var parse = parseBetween(view, oldState, range);

  var doc = oldState.doc, compare = doc.slice(parse.from, parse.to);
  var preferredPos, preferredSide;
  // Prefer anchoring to end when Backspace is pressed
  if (view.lastKeyCode === 8 && Date.now() - 100 < view.lastKeyCodeTime) {
    preferredPos = oldState.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = oldState.selection.from;
    preferredSide = "start";
  }
  view.lastKeyCode = null;

  var change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
  if (!change) {
    if (allowTypeOver) {
      var state = view.state, sel = state.selection;
      view.dispatch(state.tr.replaceSelectionWith(state.schema.text(state.doc.textBetween(sel.from, sel.to)), true).scrollIntoView());
    } else if (parse.sel) {
      var sel$1 = resolveSelection(view, view.state.doc, mapping, parse.sel);
      if (sel$1 && !sel$1.eq(view.state.selection)) { view.dispatch(view.state.tr.setSelection(sel$1)); }
    }
    return
  }

  var $from = parse.doc.resolveNoCache(change.start - parse.from);
  var $to = parse.doc.resolveNoCache(change.endB - parse.from);
  var nextSel;
  // If this looks like the effect of pressing Enter, just dispatch an
  // Enter key instead.
  if (!$from.sameParent($to) && $from.pos < parse.doc.content.size &&
      (nextSel = prosemirrorState.Selection.findFrom(parse.doc.resolve($from.pos + 1), 1, true)) &&
      nextSel.head == $to.pos &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); }))
    { return }
  // Same for backspace
  if (oldState.selection.anchor > change.start &&
      looksLikeJoin(doc, change.start, change.endA, $from, $to) &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); }))
    { return }

  var from = mapping.map(change.start), to = mapping.map(change.endA, -1);

  var tr, storedMarks, markChange, $from1;
  if ($from.sameParent($to) && $from.parent.inlineContent) {
    if ($from.pos == $to.pos) { // Deletion
      tr = view.state.tr.delete(from, to);
      storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
    } else if ( // Adding or removing a mark
      change.endA == change.endB && ($from1 = doc.resolve(change.start)) &&
      (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset),
                                 $from1.parent.content.cut($from1.parentOffset, change.endA - $from1.start())))
    ) {
      tr = view.state.tr;
      if (markChange.type == "add") { tr.addMark(from, to, markChange.mark); }
      else { tr.removeMark(from, to, markChange.mark); }
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      // Both positions in the same text node -- simply insert text
      var text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      if (view.someProp("handleTextInput", function (f) { return f(view, from, to, text); })) { return }
      tr = view.state.tr.insertText(text, from, to);
    }
  }

  if (!tr)
    { tr = view.state.tr.replace(from, to, parse.doc.slice(change.start - parse.from, change.endB - parse.from)); }
  if (parse.sel) {
    var sel$2 = resolveSelection(view, tr.doc, mapping, parse.sel);
    if (sel$2) { tr.setSelection(sel$2); }
  }
  if (storedMarks) { tr.ensureMarks(storedMarks); }
  view.dispatch(tr.scrollIntoView());
}

function resolveSelection(view, doc, mapping, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) { return null }
  return selectionBetween(view, doc.resolve(mapping.map(parsedSel.anchor)),
                          doc.resolve(mapping.map(parsedSel.head)))
}

// : (Fragment, Fragment) → ?{mark: Mark, type: string}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function isMarkChange(cur, prev) {
  var curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
  var added = curMarks, removed = prevMarks, type, mark, update;
  for (var i = 0; i < prevMarks.length; i++) { added = prevMarks[i].removeFromSet(added); }
  for (var i$1 = 0; i$1 < curMarks.length; i$1++) { removed = curMarks[i$1].removeFromSet(removed); }
  if (added.length == 1 && removed.length == 0) {
    mark = added[0];
    type = "add";
    update = function (node) { return node.mark(mark.addToSet(node.marks)); };
  } else if (added.length == 0 && removed.length == 1) {
    mark = removed[0];
    type = "remove";
    update = function (node) { return node.mark(mark.removeFromSet(node.marks)); };
  } else {
    return null
  }
  var updated = [];
  for (var i$2 = 0; i$2 < prev.childCount; i$2++) { updated.push(update(prev.child(i$2))); }
  if (prosemirrorModel.Fragment.from(updated).eq(cur)) { return {mark: mark, type: type} }
}

function looksLikeJoin(old, start, end, $newStart, $newEnd) {
  if (!$newStart.parent.isTextblock ||
      // The content must have shrunk
      end - start <= $newEnd.pos - $newStart.pos ||
      // newEnd must point directly at or after the end of the block that newStart points into
      skipClosingAndOpening($newStart, true, false) < $newEnd.pos)
    { return false }

  var $start = old.resolve(start);
  // Start must be at the end of a block
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
    { return false }
  var $next = old.resolve(skipClosingAndOpening($start, true, true));
  // The next textblock must start before end and end near it
  if (!$next.parent.isTextblock || $next.pos > end ||
      skipClosingAndOpening($next, true, false) < end)
    { return false }

  // The fragments after the join point must match
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content)
}

function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  var depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end++;
    fromEnd = false;
  }
  if (mayOpen) {
    var next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next && !next.isLeaf) {
      next = next.firstChild;
      end++;
    }
  }
  return end
}

function findDiff(a, b, pos, preferredPos, preferredSide) {
  var start = a.findDiffStart(b, pos);
  if (start == null) { return null }
  var ref = a.findDiffEnd(b, pos + a.size, pos + b.size);
  var endA = ref.a;
  var endB = ref.b;
  if (preferredSide == "end") {
    var adjust = Math.max(0, start - Math.min(endA, endB));
    preferredPos -= endA + adjust - start;
  }
  if (endA < start && a.size < b.size) {
    var move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
    start -= move;
    endB = start + (endB - endA);
    endA = start;
  } else if (endB < start) {
    var move$1 = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
    start -= move$1;
    endA = start + (endA - endB);
    endB = start;
  }
  return {start: start, endA: endA, endB: endB}
}

function serializeForClipboard(view, slice) {
  var context = [];
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    var node = content.firstChild;
    context.push(node.type.name, node.type.hasRequiredAttrs() ? node.attrs : null);
    content = node.content;
  }

  var serializer = view.someProp("clipboardSerializer") || prosemirrorModel.DOMSerializer.fromSchema(view.state.schema);
  var wrap = document.createElement("div");
  wrap.appendChild(serializer.serializeFragment(content));

  var firstChild = wrap.firstChild, needsWrap;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (var i = needsWrap.length - 1; i >= 0; i--) {
      var wrapper = document.createElement(needsWrap[i]);
      while (wrap.firstChild) { wrapper.appendChild(wrap.firstChild); }
      wrap.appendChild(wrapper);
    }
    firstChild = wrap.firstChild;
  }

  if (firstChild && firstChild.nodeType == 1)
    { firstChild.setAttribute("data-pm-slice", (openStart + " " + openEnd + " " + (JSON.stringify(context)))); }

  var text = view.someProp("clipboardTextSerializer", function (f) { return f(slice); }) ||
      slice.content.textBetween(0, slice.content.size, "\n\n");

  return {dom: wrap, text: text}
}

// : (EditorView, string, string, ?bool, ResolvedPos) → ?Slice
// Read a slice of content from the clipboard (or drop data).
function parseFromClipboard(view, text, html, plainText, $context) {
  var dom, inCode = $context.parent.type.spec.code, slice;
  if (!html && !text) { return null }
  if ((plainText || inCode || !html) && text) {
    view.someProp("transformPastedText", function (f) { text = f(text); });
    if (inCode) { return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(view.state.schema.text(text)), 0, 0) }
    var parsed = view.someProp("clipboardTextParser", function (f) { return f(text, $context); });
    if (parsed) {
      slice = parsed;
    } else {
      dom = document.createElement("div");
      text.trim().split(/(?:\r\n?|\n)+/).forEach(function (block) {
        dom.appendChild(document.createElement("p")).textContent = block;
      });
    }
  } else {
    view.someProp("transformPastedHTML", function (f) { return html = f(html); });
    dom = readHTML(html);
  }

  if (!slice) {
    var parser = view.someProp("clipboardParser") || view.someProp("domParser") || prosemirrorModel.DOMParser.fromSchema(view.state.schema);
    slice = parser.parseSlice(dom, {preserveWhitespace: true, context: $context});
  }
  var contextNode = dom && dom.querySelector("[data-pm-slice]");
  var sliceData = contextNode && /^(\d+) (\d+) (.*)/.exec(contextNode.getAttribute("data-pm-slice"));
  if (sliceData)
    { slice = addContext(new prosemirrorModel.Slice(slice.content, Math.min(slice.openStart, +sliceData[1]),
                                 Math.min(slice.openEnd, +sliceData[2])), sliceData[3]); }
  else // HTML wasn't created by ProseMirror. Make sure top-level siblings are coherent
    { slice = prosemirrorModel.Slice.maxOpen(normalizeSiblings(slice.content, $context), false); }
  view.someProp("transformPasted", function (f) { slice = f(slice); });
  return slice
}

// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2) { return fragment }
  var loop = function ( d ) {
    var parent = $context.node(d);
    var match = parent.contentMatchAt($context.index(d));
    var lastWrap = (void 0), result = [];
    fragment.forEach(function (node) {
      if (!result) { return }
      var wrap = match.findWrapping(node.type), inLast;
      if (!wrap) { return result = null }
      if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
        result[result.length - 1] = inLast;
      } else {
        if (result.length) { result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length); }
        var wrapped = withWrappers(node, wrap);
        result.push(wrapped);
        match = match.matchType(wrapped.type, wrapped.attrs);
        lastWrap = wrap;
      }
    });
    if (result) { return { v: prosemirrorModel.Fragment.from(result) } }
  };

  for (var d = $context.depth; d >= 0; d--) {
    var returned = loop( d );

    if ( returned ) return returned.v;
  }
  return fragment
}

function withWrappers(node, wrap, from) {
  if ( from === void 0 ) from = 0;

  for (var i = wrap.length - 1; i >= from; i--)
    { node = wrap[i].create(null, prosemirrorModel.Fragment.from(node)); }
  return node
}

// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function addToSibling(wrap, lastWrap, node, sibling, depth) {
  if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
    var inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
    if (inner) { return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner)) }
    var match = sibling.contentMatchAt(sibling.childCount);
    if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1]))
      { return sibling.copy(sibling.content.append(prosemirrorModel.Fragment.from(withWrappers(node, wrap, depth + 1)))) }
  }
}

function closeRight(node, depth) {
  if (depth == 0) { return node }
  var fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true);
  return node.copy(fragment.append(fill))
}

// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
var wrapMap = {thead: ["table"], colgroup: ["table"], col: ["table", "colgroup"],
                 tr: ["table", "tbody"], td: ["table", "tbody", "tr"], th: ["table", "tbody", "tr"]};
var detachedDoc = null;
function readHTML(html) {
  var metas = /(\s*<meta [^>]*>)*/.exec(html);
  if (metas) { html = html.slice(metas[0].length); }
  var doc = detachedDoc || (detachedDoc = document.implementation.createHTMLDocument("title"));
  var elt = doc.createElement("div");
  var firstTag = /(?:<meta [^>]*>)*<([a-z][^>\s]+)/i.exec(html), wrap, depth = 0;
  if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()]) {
    html = wrap.map(function (n) { return "<" + n + ">"; }).join("") + html + wrap.map(function (n) { return "</" + n + ">"; }).reverse().join("");
    depth = wrap.length;
  }
  elt.innerHTML = html;
  for (var i = 0; i < depth; i++) { elt = elt.firstChild; }
  return elt
}

function addContext(slice, context) {
  if (!slice.size) { return slice }
  var schema = slice.content.firstChild.type.schema, array;
  try { array = JSON.parse(context); }
  catch(e) { return slice }
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  for (var i = array.length - 2; i >= 0; i -= 2) {
    var type = schema.nodes[array[i]];
    if (!type || type.hasRequiredAttrs()) { break }
    content = prosemirrorModel.Fragment.from(type.create(array[i + 1], content));
    openStart++; openEnd++;
  }
  return new prosemirrorModel.Slice(content, openStart, openEnd)
}

var observeOptions = {childList: true, characterData: true, attributes: true, subtree: true, characterDataOldValue: true};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
var useCharData = result.ie && result.ie_version <= 11;

var DOMObserver = function DOMObserver(view) {
  var this$1 = this;

  this.view = view;
  this.observer = window.MutationObserver &&
    new window.MutationObserver(function (mutations) { return this$1.registerMutations(mutations); });
  if (useCharData)
    { this.onCharData = function (e) { return this$1.registerMutation({target: e.target, type: "characterData", oldValue: e.prevValue}); }; }
};

DOMObserver.prototype.start = function start () {
  if (this.observer)
    { this.observer.observe(this.view.dom, observeOptions); }
  if (useCharData)
    { this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData); }
};

DOMObserver.prototype.stop = function stop () {
  if (this.observer) {
    this.flush();
    this.observer.disconnect();
  }
  if (useCharData)
    { this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData); }
};

DOMObserver.prototype.flush = function flush () {
  if (this.observer)
    { this.registerMutations(this.observer.takeRecords()); }
};

DOMObserver.prototype.registerMutations = function registerMutations (mutations) {
    var this$1 = this;

  for (var i = 0; i < mutations.length; i++)
    { this$1.registerMutation(mutations[i]); }
};

DOMObserver.prototype.registerMutation = function registerMutation (mut) {
  if (!this.view.editable) { return }
  var desc = this.view.docView.nearestDesc(mut.target);
  if (mut.type == "attributes" &&
      (desc == this.view.docView || mut.attributeName == "contenteditable")) { return }
  if (!desc || desc.ignoreMutation(mut)) { return }

  var from, to;
  if (mut.type == "childList") {
    var fromOffset = mut.previousSibling && mut.previousSibling.parentNode == mut.target
        ? domIndex(mut.previousSibling) + 1 : 0;
    if (fromOffset == -1) { return }
    from = desc.localPosFromDOM(mut.target, fromOffset, -1);
    var toOffset = mut.nextSibling && mut.nextSibling.parentNode == mut.target
        ? domIndex(mut.nextSibling) : mut.target.childNodes.length;
    if (toOffset == -1) { return }
    to = desc.localPosFromDOM(mut.target, toOffset, 1);
  } else if (mut.type == "attributes") {
    from = desc.posAtStart - desc.border;
    to = desc.posAtEnd + desc.border;
  } else { // "characterData"
    from = desc.posAtStart;
    to = desc.posAtEnd;
    // An event was generated for a text change that didn't change
    // any text. Mark the dom change to fall back to assuming the
    // selection was typed over with an identical value if it can't
    // find another change.
    if (mut.target.nodeValue == mut.oldValue) { DOMChange.start(this.view).typeOver = true; }
  }

  DOMChange.start(this.view).addRange(from, to);
};

// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
var handlers = {};
var editHandlers = {};

function initInput(view) {
  view.shiftKey = false;
  view.mouseDown = null;
  view.inDOMChange = null;
  view.lastKeyCode = null;
  view.lastKeyCodeTime = 0;
  view.domObserver = new DOMObserver(view);
  view.domObserver.start();

  view.eventHandlers = Object.create(null);
  var loop = function ( event ) {
    var handler = handlers[event];
    view.dom.addEventListener(event, view.eventHandlers[event] = function (event) {
      if (eventBelongsToView(view, event) && !runCustomHandler(view, event) &&
          (view.editable || !(event.type in editHandlers)))
        { handler(view, event); }
    });
  };

  for (var event in handlers) loop( event );
  ensureListeners(view);
}

function destroyInput(view) {
  view.domObserver.stop();
  if (view.inDOMChange) { view.inDOMChange.destroy(); }
  for (var type in view.eventHandlers)
    { view.dom.removeEventListener(type, view.eventHandlers[type]); }
}

function ensureListeners(view) {
  view.someProp("handleDOMEvents", function (currentHandlers) {
    for (var type in currentHandlers) { if (!view.eventHandlers[type])
      { view.dom.addEventListener(type, view.eventHandlers[type] = function (event) { return runCustomHandler(view, event); }); } }
  });
}

function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", function (handlers) {
    var handler = handlers[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false
  })
}

function eventBelongsToView(view, event) {
  if (!event.bubbles) { return true }
  if (event.defaultPrevented) { return false }
  for (var node = event.target; node != view.dom; node = node.parentNode)
    { if (!node || node.nodeType == 11 ||
        (node.pmViewDesc && node.pmViewDesc.stopEvent(event)))
      { return false } }
  return true
}

function dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] &&
      (view.editable || !(event.type in editHandlers)))
    { handlers[event.type](view, event); }
}

editHandlers.keydown = function (view, event) {
  if (event.keyCode == 16) { view.shiftKey = true; }
  if (view.inDOMChange) {
    if (view.inDOMChange.composing) { return }
    view.inDOMChange.finish();
  }
  view.lastKeyCode = event.keyCode;
  view.lastKeyCodeTime = Date.now();
  if (view.someProp("handleKeyDown", function (f) { return f(view, event); }) || captureKeyDown(view, event))
    { event.preventDefault(); }
  else
    { view.selectionReader.poll(); }
};

editHandlers.keyup = function (view, e) {
  if (e.keyCode == 16) { view.shiftKey = false; }
};

editHandlers.keypress = function (view, event) {
  if (view.inDOMChange || !event.charCode ||
      event.ctrlKey && !event.altKey || result.mac && event.metaKey) { return }

  if (view.someProp("handleKeyPress", function (f) { return f(view, event); })) {
    event.preventDefault();
    return
  }

  var sel = view.state.selection;
  if (!(sel instanceof prosemirrorState.TextSelection) || !sel.$from.sameParent(sel.$to)) {
    var text = String.fromCharCode(event.charCode);
    if (!view.someProp("handleTextInput", function (f) { return f(view, sel.$from.pos, sel.$to.pos, text); }))
      { view.dispatch(view.state.tr.insertText(text).scrollIntoView()); }
    event.preventDefault();
  }
};

function eventCoords(event) { return {left: event.clientX, top: event.clientY} }

var lastClick = {time: 0, x: 0, y: 0};
var oneButLastClick = lastClick;

function isNear(event, click) {
  var dx = click.x - event.clientX, dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100
}

function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside);
  var loop = function ( i ) {
    if (view.someProp(propName, function (f) { return i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true)
                                                    : f(view, pos, $pos.node(i), $pos.before(i), event, false); }))
      { return { v: true } }
  };

  for (var i = $pos.depth + 1; i > 0; i--) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

function updateSelection(view, selection, origin) {
  if (!view.focused) { view.focus(); }
  var tr = view.state.tr.setSelection(selection);
  if (origin == "pointer") { tr.setMeta("pointer", true); }
  view.dispatch(tr);
}

function selectClickedLeaf(view, inside) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
  if (node && node.isAtom && prosemirrorState.NodeSelection.isSelectable(node)) {
    updateSelection(view, new prosemirrorState.NodeSelection($pos), "pointer");
    return true
  }
  return false
}

function selectClickedNode(view, inside) {
  if (inside == -1) { return false }
  var sel = view.state.selection, selectedNode, selectAt;
  if (sel instanceof prosemirrorState.NodeSelection) { selectedNode = sel.node; }

  var $pos = view.state.doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    if (prosemirrorState.NodeSelection.isSelectable(node)) {
      if (selectedNode && sel.$from.depth > 0 &&
          i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
        { selectAt = $pos.before(sel.$from.depth); }
      else
        { selectAt = $pos.before(i); }
      break
    }
  }

  if (selectAt != null) {
    updateSelection(view, prosemirrorState.NodeSelection.create(view.state.doc, selectAt), "pointer");
    return true
  } else {
    return false
  }
}

function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) ||
    view.someProp("handleClick", function (f) { return f(view, pos, event); }) ||
    (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside))
}

function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) ||
    view.someProp("handleDoubleClick", function (f) { return f(view, pos, event); })
}

function handleTripleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) ||
    view.someProp("handleTripleClick", function (f) { return f(view, pos, event); }) ||
    defaultTripleClick(view, inside)
}

function defaultTripleClick(view, inside) {
  var doc = view.state.doc;
  if (inside == -1) {
    if (doc.inlineContent) {
      updateSelection(view, prosemirrorState.TextSelection.create(doc, 0, doc.content.size), "pointer");
      return true
    }
    return false
  }

  var $pos = doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    var nodePos = $pos.before(i);
    if (node.inlineContent)
      { updateSelection(view, prosemirrorState.TextSelection.create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer"); }
    else if (prosemirrorState.NodeSelection.isSelectable(node))
      { updateSelection(view, prosemirrorState.NodeSelection.create(doc, nodePos), "pointer"); }
    else
      { continue }
    return true
  }
}

function forceDOMFlush(view) {
  if (!view.inDOMChange) { return false }
  view.inDOMChange.finish(true);
  return true
}

var selectNodeModifier = result.mac ? "metaKey" : "ctrlKey";

handlers.mousedown = function (view, event) {
  var flushed = forceDOMFlush(view);
  var now = Date.now(), type;
  if (now - lastClick.time >= 500 || !isNear(event, lastClick) || event[selectNodeModifier]) { type = "singleClick"; }
  else if (now - oneButLastClick.time >= 600 || !isNear(event, oneButLastClick)) { type = "doubleClick"; }
  else { type = "tripleClick"; }
  oneButLastClick = lastClick;
  lastClick = {time: now, x: event.clientX, y: event.clientY};

  var pos = view.posAtCoords(eventCoords(event));
  if (!pos) { return }

  if (type == "singleClick")
    { view.mouseDown = new MouseDown(view, pos, event, flushed); }
  else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event))
    { event.preventDefault(); }
  else
    { view.selectionReader.poll("pointer"); }
};

var MouseDown = function MouseDown(view, pos, event, flushed) {
  var this$1 = this;

  this.view = view;
  this.pos = pos;
  this.event = event;
  this.flushed = flushed;
  this.selectNode = event[selectNodeModifier];
  this.allowDefault = event.shiftKey;

  var targetNode, targetPos;
  if (pos.inside > -1) {
    targetNode = view.state.doc.nodeAt(pos.inside);
    targetPos = pos.inside;
  } else {
    var $pos = view.state.doc.resolve(pos.pos);
    targetNode = $pos.parent;
    targetPos = $pos.depth ? $pos.before() : 0;
  }

  this.mightDrag = null;
  this.target = flushed ? null : event.target;
  if (targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false ||
      view.state.selection instanceof prosemirrorState.NodeSelection && targetPos == view.state.selection.from)
    { this.mightDrag = {node: targetNode,
                      pos: targetPos,
                      addAttr: this.target && !this.target.draggable,
                      setUneditable: this.target && result.gecko && !this.target.hasAttribute("contentEditable")}; }

  if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.draggable = true; }
    if (this.mightDrag.setUneditable)
      { setTimeout(function () { return this$1.target.setAttribute("contentEditable", "false"); }, 20); }
    this.view.domObserver.start();
  }

  view.root.addEventListener("mouseup", this.up = this.up.bind(this));
  view.root.addEventListener("mousemove", this.move = this.move.bind(this));
  view.selectionReader.poll("pointer");
};

MouseDown.prototype.done = function done () {
  this.view.root.removeEventListener("mouseup", this.up);
  this.view.root.removeEventListener("mousemove", this.move);
  if (this.mightDrag && this.target) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.draggable = false; }
    if (this.mightDrag.setUneditable) { this.target.removeAttribute("contentEditable"); }
    this.view.domObserver.start();
  }
  this.view.mouseDown = null;
};

MouseDown.prototype.up = function up (event) {
  this.done();

  if (!this.view.dom.contains(event.target.nodeType == 3 ? event.target.parentNode : event.target))
    { return }

  if (this.allowDefault) {
    // Force a cursor wrapper redraw if this was suppressed (to avoid an issue with IE drag-selection)
    if (result.ie && needsCursorWrapper(this.view.state)) { this.view.updateState(this.view.state); }
    this.view.selectionReader.poll("pointer");
  } else if (handleSingleClick(this.view, this.pos.pos, this.pos.inside, event, this.selectNode)) {
    event.preventDefault();
  } else if (this.flushed) {
    updateSelection(this.view, prosemirrorState.Selection.near(this.view.state.doc.resolve(this.pos.pos)), "pointer");
    event.preventDefault();
  } else {
    this.view.selectionReader.poll("pointer");
  }
};

MouseDown.prototype.move = function move (event) {
  if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 ||
                             Math.abs(this.event.y - event.clientY) > 4))
    { this.allowDefault = true; }
  this.view.selectionReader.poll("pointer");
};

handlers.touchdown = function (view) {
  forceDOMFlush(view);
  view.selectionReader.poll("pointer");
};

handlers.contextmenu = function (view) { return forceDOMFlush(view); };

// Input compositions are hard. Mostly because the events fired by
// browsers are A) very unpredictable and inconsistent, and B) not
// cancelable.
//
// ProseMirror has the problem that it must not update the DOM during
// a composition, or the browser will cancel it. What it does is keep
// long-running operations (delayed DOM updates) when a composition is
// active.
//
// We _do not_ trust the information in the composition events which,
// apart from being very uninformative to begin with, is often just
// plain wrong. Instead, when a composition ends, we parse the dom
// around the original selection, and derive an update from that.

editHandlers.compositionstart = editHandlers.compositionupdate = function (view) {
  DOMChange.start(view, true);
};

editHandlers.compositionend = function (view, e) {
  if (!view.inDOMChange) {
    // We received a compositionend without having seen any previous
    // events for the composition. If there's data in the event
    // object, we assume that it's a real change, and start a
    // composition. Otherwise, we just ignore it.
    if (e.data) { DOMChange.start(view, true); }
    else { return }
  }

  view.inDOMChange.compositionEnd();
};

editHandlers.input = function (view) {
  var change = DOMChange.start(view);
  if (!change.composing) { change.finish(); }
};

function captureCopy(view, dom) {
  // The extra wrapper is somehow necessary on IE/Edge to prevent the
  // content from being mangled when it is put onto the clipboard
  var doc = dom.ownerDocument;
  var wrap = doc.body.appendChild(doc.createElement("div"));
  wrap.appendChild(dom);
  wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
  var sel = getSelection(), range = doc.createRange();
  range.selectNodeContents(dom);
  // Done because IE will fire a selectionchange moving the selection
  // to its start when removeAllRanges is called and the editor still
  // has focus (which will mess up the editor's selection state).
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range);
  setTimeout(function () {
    doc.body.removeChild(wrap);
    view.focus();
  }, 50);
}

// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
var brokenClipboardAPI = (result.ie && result.ie_version < 15) ||
      (result.ios && result.webkit_version < 604);

handlers.copy = editHandlers.cut = function (view, e) {
  var sel = view.state.selection, cut = e.type == "cut";
  if (sel.empty) { return }

  // IE and Edge's clipboard interface is completely broken
  var data = brokenClipboardAPI ? null : e.clipboardData;
  var slice = sel.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  if (data) {
    e.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text);
  } else {
    captureCopy(view, dom);
  }
  if (cut) { view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut")); }
};

function sliceSingleNode(slice) {
  return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null
}

function capturePaste(view, e) {
  var doc = view.dom.ownerDocument;
  var plainText = view.shiftKey || view.state.selection.$from.parent.type.spec.code;
  var target = doc.body.appendChild(doc.createElement(plainText ? "textarea" : "div"));
  if (!plainText) { target.contentEditable = "true"; }
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(function () {
    view.focus();
    doc.body.removeChild(target);
    if (plainText) { doPaste(view, target.value, null, e); }
    else { doPaste(view, target.textContent, target.innerHTML, e); }
  }, 50);
}

function doPaste(view, text, html, e) {
  var slice = parseFromClipboard(view, text, html, view.shiftKey, view.state.selection.$from);
  if (!slice) { return false }

  if (view.someProp("handlePaste", function (f) { return f(view, e, slice); })) { return true }

  var singleNode = sliceSingleNode(slice);
  var tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, view.shiftKey) : view.state.tr.replaceSelection(slice);
  view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
  return true
}

editHandlers.paste = function (view, e) {
  var data = brokenClipboardAPI ? null : e.clipboardData;
  if (data && doPaste(view, data.getData("text/plain"), data.getData("text/html"), e))
    { e.preventDefault(); }
  else
    { capturePaste(view, e); }
};

var Dragging = function Dragging(slice, move) {
  this.slice = slice;
  this.move = move;
};

var dragCopyModifier = result.mac ? "altKey" : "ctrlKey";

handlers.dragstart = function (view, e) {
  var mouseDown = view.mouseDown;
  if (mouseDown) { mouseDown.done(); }
  if (!e.dataTransfer) { return }

  var sel = view.state.selection;
  var pos = sel.empty ? null : view.posAtCoords(eventCoords(e));
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof prosemirrorState.NodeSelection ? sel.to - 1: sel.to)) {
    // In selection
  } else if (mouseDown && mouseDown.mightDrag) {
    view.dispatch(view.state.tr.setSelection(prosemirrorState.NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos)));
  } else if (e.target && e.target.nodeType == 1) {
    var desc = view.docView.nearestDesc(e.target, true);
    if (!desc || !desc.node.type.spec.draggable || desc == view.docView) { return }
    view.dispatch(view.state.tr.setSelection(prosemirrorState.NodeSelection.create(view.state.doc, desc.posBefore)));
  }
  var slice = view.state.selection.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  e.dataTransfer.clearData();
  e.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  if (!brokenClipboardAPI) { e.dataTransfer.setData("text/plain", text); }
  view.dragging = new Dragging(slice, !e[dragCopyModifier]);
};

handlers.dragend = function (view) {
  window.setTimeout(function () { return view.dragging = null; }, 50);
};

editHandlers.dragover = editHandlers.dragenter = function (_, e) { return e.preventDefault(); };

editHandlers.drop = function (view, e) {
  var dragging = view.dragging;
  view.dragging = null;

  if (!e.dataTransfer) { return }

  var eventPos = view.posAtCoords(eventCoords(e));
  if (!eventPos) { return }
  var $mouse = view.state.doc.resolve(eventPos.pos);
  if (!$mouse) { return }
  var slice = dragging && dragging.slice ||
      parseFromClipboard(view, e.dataTransfer.getData(brokenClipboardAPI ? "Text" : "text/plain"),
                         brokenClipboardAPI ? null : e.dataTransfer.getData("text/html"), false, $mouse);
  if (!slice) { return }

  e.preventDefault();
  if (view.someProp("handleDrop", function (f) { return f(view, e, slice, dragging && dragging.move); })) { return }
  var insertPos = slice ? prosemirrorTransform.dropPoint(view.state.doc, $mouse.pos, slice) : $mouse.pos;
  if (insertPos == null) { insertPos = $mouse.pos; }

  var tr = view.state.tr;
  if (dragging && dragging.move) { tr.deleteSelection(); }

  var pos = tr.mapping.map(insertPos);
  var isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
  var beforeInsert = tr.doc;
  if (isNode)
    { tr.replaceRangeWith(pos, pos, slice.content.firstChild); }
  else
    { tr.replaceRange(pos, pos, slice); }
  if (tr.doc.eq(beforeInsert)) { return }

  var $pos = tr.doc.resolve(pos);
  if (isNode && prosemirrorState.NodeSelection.isSelectable(slice.content.firstChild) &&
      $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild))
    { tr.setSelection(new prosemirrorState.NodeSelection($pos)); }
  else
    { tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(tr.mapping.map(insertPos)))); }
  view.focus();
  view.dispatch(tr.setMeta("uiEvent", "drop"));
};

handlers.focus = function (view) {
  if (!view.focused) {
    view.dom.classList.add("ProseMirror-focused");
    view.focused = true;
  }
};

handlers.blur = function (view) {
  if (view.focused) {
    view.dom.classList.remove("ProseMirror-focused");
    view.focused = false;
  }
};

// Make sure all handlers get registered
for (var prop in editHandlers) { handlers[prop] = editHandlers[prop]; }

function compareObjs(a, b) {
  if (a == b) { return true }
  for (var p in a) { if (a[p] !== b[p]) { return false } }
  for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  return true
}

var WidgetType = function WidgetType(toDOM, spec) {
  this.spec = spec || noSpec;
  this.side = this.spec.side || 0;
  this.toDOM = toDOM;
};

WidgetType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var ref = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
    var pos = ref.pos;
    var deleted = ref.deleted;
  return deleted ? null : new Decoration(pos - offset, pos - offset, this)
};

WidgetType.prototype.valid = function valid () { return true };

WidgetType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof WidgetType &&
     (this.spec.key && this.spec.key == other.spec.key ||
      this.toDOM == other.toDOM && compareObjs(this.spec, other.spec)))
};

var InlineType = function InlineType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

InlineType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
  var to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
  return from >= to ? null : new Decoration(from, to, this)
};

InlineType.prototype.valid = function valid (_, span) { return span.from < span.to };

InlineType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof InlineType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

InlineType.is = function is (span) { return span.type instanceof InlineType };

var NodeType = function NodeType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

NodeType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.mapResult(span.from + oldOffset, 1);
  if (from.deleted) { return null }
  var to = mapping.mapResult(span.to + oldOffset, -1);
  if (to.deleted || to.pos <= from.pos) { return null }
  return new Decoration(from.pos - offset, to.pos - offset, this)
};

NodeType.prototype.valid = function valid (node, span) {
  var ref = node.content.findIndex(span.from);
    var index = ref.index;
    var offset = ref.offset;
  return offset == span.from && offset + node.child(index).nodeSize == span.to
};

NodeType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof NodeType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

// ::- Decoration objects can be provided to the view through the
// [`decorations` prop](#view.EditorProps.decorations). They come in
// several variants—see the static members of this class for details.
var Decoration = function Decoration(from, to, type) {
  // :: number
  // The start position of the decoration.
  this.from = from;
  // :: number
  // The end position. Will be the same as `from` for [widget
  // decorations](#view.Decoration^widget).
  this.to = to;
  this.type = type;
};

var prototypeAccessors$2 = { spec: {} };

Decoration.prototype.copy = function copy (from, to) {
  return new Decoration(from, to, this.type)
};

Decoration.prototype.eq = function eq (other) {
  return this.type.eq(other.type) && this.from == other.from && this.to == other.to
};

Decoration.prototype.map = function map (mapping, offset, oldOffset) {
  return this.type.map(mapping, this, offset, oldOffset)
};

// :: (number, union<(view: EditorView, getPos: () → number) → dom.Node, dom.Node>, ?Object) → Decoration
// Creates a widget decoration, which is a DOM node that's shown in
// the document at the given position. It is recommended that you
// delay rendering the widget by passing a function that will be
// called when the widget is actually drawn in a view, but you can
// also directly pass a DOM node. `getPos` can be used to find the
// widget's current document position.
//
// spec::- These options are supported:
//
//   side:: ?number
//   Controls which side of the document position this widget is
//   associated with. When negative, it is drawn before a cursor
//   at its position, and content inserted at that position ends
//   up after the widget. When zero (the default) or positive, the
//   widget is drawn after the cursor and content inserted there
//   ends up before the widget.
//
//   When there are multiple widgets at a given position, their
//   `side` values determine the order in which they appear. Those
//   with lower values appear first. The ordering of widgets with
//   the same `side` value is unspecified.
//
//   When `marks` is null, `side` also determines the marks that
//   the widget is wrapped in—those of the node before when
//   negative, those of the node after when positive.
//
//   marks:: ?[Mark]
//   The precise set of marks to draw around the widget.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to control which DOM events, when they bubble out
//   of this widget, the editor view should ignore.
//
//   key:: ?string
//   When comparing decorations of this type (in order to decide
//   whether it needs to be redrawn), ProseMirror will by default
//   compare the widget DOM node by identity. If you pass a key,
//   that key will be compared instead, which can be useful when
//   you generate decorations on the fly and don't want to store
//   and reuse DOM nodes. Make sure that any widgets with the same
//   key are interchangeable—if widgets differ in, for example,
//   the behavior of some event handler, they should get
//   different keys.
Decoration.widget = function widget (pos, toDOM, spec) {
  return new Decoration(pos, pos, new WidgetType(toDOM, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates an inline decoration, which adds the given attributes to
// each inline node between `from` and `to`.
//
// spec::- These options are recognized:
//
//   inclusiveStart:: ?bool
//   Determines how the left side of the decoration is
//   [mapped](#transform.Position_Mapping) when content is
//   inserted directly at that positon. By default, the decoration
//   won't include the new content, but you can set this to `true`
//   to make it inclusive.
//
//   inclusiveEnd:: ?bool
//   Determines how the right side of the decoration is mapped.
//   See
//   [`inclusiveStart`](#view.Decoration^inline^spec.inclusiveStart).
Decoration.inline = function inline (from, to, attrs, spec) {
  return new Decoration(from, to, new InlineType(attrs, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates a node decoration. `from` and `to` should point precisely
// before and after a node in the document. That node, and only that
// node, will receive the given attributes.
Decoration.node = function node (from, to, attrs, spec) {
  return new Decoration(from, to, new NodeType(attrs, spec))
};

// :: Object
// The spec provided when creating this decoration. Can be useful
// if you've stored extra information in that object.
prototypeAccessors$2.spec.get = function () { return this.type.spec };

Object.defineProperties( Decoration.prototype, prototypeAccessors$2 );

// DecorationAttrs:: interface
// A set of attributes to add to a decorated node. Most properties
// simply directly correspond to DOM attributes of the same name,
// which will be set to the property's value. These are exceptions:
//
//   class:: ?string
//   A CSS class name or a space-separated set of class names to be
//   _added_ to the classes that the node already had.
//
//   style:: ?string
//   A string of CSS to be _added_ to the node's existing `style` property.
//
//   nodeName:: ?string
//   When non-null, the target node is wrapped in a DOM element of
//   this type (and the other attributes are applied to this element).

var none = [];
var noSpec = {};

// ::- A collection of [decorations](#view.Decoration), organized in
// such a way that the drawing algorithm can efficiently use and
// compare them. This is a persistent data structure—it is not
// modified, updates create a new value.
var DecorationSet = function DecorationSet(local, children) {
  this.local = local && local.length ? local : none;
  this.children = children && children.length ? children : none;
};

// :: (Node, [Decoration]) → DecorationSet
// Create a set of decorations, using the structure of the given
// document.
DecorationSet.create = function create (doc, decorations) {
  return decorations.length ? buildTree(decorations, doc, 0, noSpec) : empty
};

// :: (?number, ?number, ?(spec: Object) → bool) → [Decoration]
// Find all decorations in this set which touch the given range
// (including decorations that start or end directly at the
// boundaries) and match the given predicate on their spec. When
// `start` and `end` are omitted, all decorations in the set are
// considered. When `predicate` isn't given, all decorations are
// asssumed to match.
DecorationSet.prototype.find = function find (start, end, predicate) {
  var result = [];
  this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
  return result
};

DecorationSet.prototype.findInner = function findInner (start, end, result, offset, predicate) {
    var this$1 = this;

  for (var i = 0; i < this.local.length; i++) {
    var span = this$1.local[i];
    if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec)))
      { result.push(span.copy(span.from + offset, span.to + offset)); }
  }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3) {
    if (this$1.children[i$1] < end && this$1.children[i$1 + 1] > start) {
      var childOff = this$1.children[i$1] + 1;
      this$1.children[i$1 + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
    }
  }
};

// :: (Mapping, Node, ?Object) → DecorationSet
// Map the set of decorations in response to a change in the
// document.
//
// options::- An optional set of options.
//
//   onRemove:: ?(decorationSpec: Object)
//   When given, this function will be called for each decoration
//   that gets dropped as a result of the mapping, passing the
//   spec of that decoration.
DecorationSet.prototype.map = function map (mapping, doc, options) {
  if (this == empty || mapping.maps.length == 0) { return this }
  return this.mapInner(mapping, doc, 0, 0, options || noSpec)
};

DecorationSet.prototype.mapInner = function mapInner (mapping, node, offset, oldOffset, options) {
    var this$1 = this;

  var newLocal;
  for (var i = 0; i < this.local.length; i++) {
    var mapped = this$1.local[i].map(mapping, offset, oldOffset);
    if (mapped && mapped.type.valid(node, mapped)) { (newLocal || (newLocal = [])).push(mapped); }
    else if (options.onRemove) { options.onRemove(this$1.local[i].spec); }
  }

  if (this.children.length)
    { return mapChildren(this.children, newLocal, mapping, node, offset, oldOffset, options) }
  else
    { return newLocal ? new DecorationSet(newLocal.sort(byPos)) : empty }
};

// :: (Node, [Decoration]) → DecorationSet
// Add the given array of decorations to the ones in the set,
// producing a new set. Needs access to the current document to
// create the appropriate tree structure.
DecorationSet.prototype.add = function add (doc, decorations) {
  if (!decorations.length) { return this }
  if (this == empty) { return DecorationSet.create(doc, decorations) }
  return this.addInner(doc, decorations, 0)
};

DecorationSet.prototype.addInner = function addInner (doc, decorations, offset) {
    var this$1 = this;

  var children, childIndex = 0;
  doc.forEach(function (childNode, childOffset) {
    var baseOffset = childOffset + offset, found;
    if (!(found = takeSpansForNode(decorations, childNode, baseOffset))) { return }

    if (!children) { children = this$1.children.slice(); }
    while (childIndex < children.length && children[childIndex] < childOffset) { childIndex += 3; }
    if (children[childIndex] == childOffset)
      { children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1); }
    else
      { children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec)); }
    childIndex += 3;
  });

  var local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
  return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local,
                           children || this.children)
};

// :: ([Decoration]) → DecorationSet
// Create a new set that contains the decorations in this set, minus
// the ones in the given array.
DecorationSet.prototype.remove = function remove (decorations) {
  if (decorations.length == 0 || this == empty) { return this }
  return this.removeInner(decorations, 0)
};

DecorationSet.prototype.removeInner = function removeInner (decorations, offset) {
    var this$1 = this;

  var children = this.children, local = this.local;
  for (var i = 0; i < children.length; i += 3) {
    var found = (void 0), from = children[i] + offset, to = children[i + 1] + offset;
    for (var j = 0, span = (void 0); j < decorations.length; j++) { if (span = decorations[j]) {
      if (span.from > from && span.to < to) {
        decorations[j] = null
        ;(found || (found = [])).push(span);
      }
    } }
    if (!found) { continue }
    if (children == this$1.children) { children = this$1.children.slice(); }
    var removed = children[i + 2].removeInner(found, from + 1);
    if (removed != empty) {
      children[i + 2] = removed;
    } else {
      children.splice(i, 3);
      i -= 3;
    }
  }
  if (local.length) { for (var i$1 = 0, span$1 = (void 0); i$1 < decorations.length; i$1++) { if (span$1 = decorations[i$1]) {
    for (var j$1 = 0; j$1 < local.length; j$1++) { if (local[j$1].type.eq(span$1.type)) {
      if (local == this$1.local) { local = this$1.local.slice(); }
      local.splice(j$1--, 1);
    } }
  } } }
  if (children == this.children && local == this.local) { return this }
  return local.length || children.length ? new DecorationSet(local, children) : empty
};

DecorationSet.prototype.forChild = function forChild (offset, node) {
    var this$1 = this;

  if (this == empty) { return this }
  if (node.isLeaf) { return DecorationSet.empty }

  var child, local;
  for (var i = 0; i < this.children.length; i += 3) { if (this$1.children[i] >= offset) {
    if (this$1.children[i] == offset) { child = this$1.children[i + 2]; }
    break
  } }
  var start = offset + 1, end = start + node.content.size;
  for (var i$1 = 0; i$1 < this.local.length; i$1++) {
    var dec = this$1.local[i$1];
    if (dec.from < end && dec.to > start && (dec.type instanceof InlineType)) {
      var from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
      if (from < to) { (local || (local = [])).push(dec.copy(from, to)); }
    }
  }
  if (local) {
    var localSet = new DecorationSet(local.sort(byPos));
    return child ? new DecorationGroup([localSet, child]) : localSet
  }
  return child || empty
};

DecorationSet.prototype.eq = function eq (other) {
    var this$1 = this;

  if (this == other) { return true }
  if (!(other instanceof DecorationSet) ||
      this.local.length != other.local.length ||
      this.children.length != other.children.length) { return false }
  for (var i = 0; i < this.local.length; i++)
    { if (!this$1.local[i].eq(other.local[i])) { return false } }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3)
    { if (this$1.children[i$1] != other.children[i$1] ||
        this$1.children[i$1 + 1] != other.children[i$1 + 1] ||
        !this$1.children[i$1 + 2].eq(other.children[i$1 + 2])) { return false } }
  return false
};

DecorationSet.prototype.locals = function locals (node) {
  return removeOverlap(this.localsInner(node))
};

DecorationSet.prototype.localsInner = function localsInner (node) {
    var this$1 = this;

  if (this == empty) { return none }
  if (node.inlineContent || !this.local.some(InlineType.is)) { return this.local }
  var result = [];
  for (var i = 0; i < this.local.length; i++) {
    if (!(this$1.local[i].type instanceof InlineType))
      { result.push(this$1.local[i]); }
  }
  return result
};

var empty = new DecorationSet();

// :: DecorationSet
// The empty set of decorations.
DecorationSet.empty = empty;

DecorationSet.removeOverlap = removeOverlap;

// :- An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
var DecorationGroup = function DecorationGroup(members) {
  this.members = members;
};

DecorationGroup.prototype.forChild = function forChild (offset, child) {
    var this$1 = this;

  if (child.isLeaf) { return DecorationSet.empty }
  var found = [];
  for (var i = 0; i < this.members.length; i++) {
    var result = this$1.members[i].forChild(offset, child);
    if (result == empty) { continue }
    if (result instanceof DecorationGroup) { found = found.concat(result.members); }
    else { found.push(result); }
  }
  return DecorationGroup.from(found)
};

DecorationGroup.prototype.eq = function eq (other) {
    var this$1 = this;

  if (!(other instanceof DecorationGroup) ||
      other.members.length != this.members.length) { return false }
  for (var i = 0; i < this.members.length; i++)
    { if (!this$1.members[i].eq(other.members[i])) { return false } }
  return true
};

DecorationGroup.prototype.locals = function locals (node) {
    var this$1 = this;

  var result, sorted = true;
  for (var i = 0; i < this.members.length; i++) {
    var locals = this$1.members[i].localsInner(node);
    if (!locals.length) { continue }
    if (!result) {
      result = locals;
    } else {
      if (sorted) {
        result = result.slice();
        sorted = false;
      }
      for (var j = 0; j < locals.length; j++) { result.push(locals[j]); }
    }
  }
  return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none
};

// : ([DecorationSet]) → union<DecorationSet, DecorationGroup>
// Create a group for the given array of decoration sets, or return
// a single set when possible.
DecorationGroup.from = function from (members) {
  switch (members.length) {
    case 0: return empty
    case 1: return members[0]
    default: return new DecorationGroup(members)
  }
};

function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
  var children = oldChildren.slice();

  // Mark the children that are directly touched by changes, and
  // move those that are after the changes.
  var shift = function (oldStart, oldEnd, newStart, newEnd) {
    for (var i = 0; i < children.length; i += 3) {
      var end = children[i + 1], dSize = (void 0);
      if (end == -1 || oldStart > end + oldOffset) { continue }
      if (oldEnd >= children[i] + oldOffset) {
        children[i + 1] = -1;
      } else if (dSize = (newEnd - newStart) - (oldEnd - oldStart) + (oldOffset - offset)) {
        children[i] += dSize;
        children[i + 1] += dSize;
      }
    }
  };
  for (var i = 0; i < mapping.maps.length; i++) { mapping.maps[i].forEach(shift); }

  // Find the child nodes that still correspond to a single node,
  // recursively call mapInner on them and update their positions.
  var mustRebuild = false;
  for (var i$1 = 0; i$1 < children.length; i$1 += 3) { if (children[i$1 + 1] == -1) { // Touched nodes
    var from = mapping.map(children[i$1] + oldOffset), fromLocal = from - offset;
    if (fromLocal < 0 || fromLocal >= node.content.size) {
      mustRebuild = true;
      continue
    }
    // Must read oldChildren because children was tagged with -1
    var to = mapping.map(oldChildren[i$1 + 1] + oldOffset, -1), toLocal = to - offset;
    var ref = node.content.findIndex(fromLocal);
    var index = ref.index;
    var childOffset = ref.offset;
    var childNode = node.maybeChild(index);
    if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
      var mapped = children[i$1 + 2].mapInner(mapping, childNode, from + 1, children[i$1] + oldOffset + 1, options);
      if (mapped != empty) {
        children[i$1] = fromLocal;
        children[i$1 + 1] = toLocal;
        children[i$1 + 2] = mapped;
      } else {
        children.splice(i$1, 3);
        i$1 -= 3;
      }
    } else {
      mustRebuild = true;
    }
  } }

  // Remaining children must be collected and rebuilt into the appropriate structure
  if (mustRebuild) {
    var decorations = mapAndGatherRemainingDecorations(children, newLocal ? moveSpans(newLocal, offset) : [], mapping,
                                                       offset, oldOffset, options);
    var built = buildTree(decorations, node, 0, options);
    newLocal = built.local;
    for (var i$2 = 0; i$2 < children.length; i$2 += 3) { if (children[i$2 + 1] == -1) {
      children.splice(i$2, 3);
      i$2 -= 3;
    } }
    for (var i$3 = 0, j = 0; i$3 < built.children.length; i$3 += 3) {
      var from$1 = built.children[i$3];
      while (j < children.length && children[j] < from$1) { j += 3; }
      children.splice(j, 0, built.children[i$3], built.children[i$3 + 1], built.children[i$3 + 2]);
    }
  }

  return new DecorationSet(newLocal && newLocal.sort(byPos), children)
}

function moveSpans(spans, offset) {
  if (!offset || !spans.length) { return spans }
  var result = [];
  for (var i = 0; i < spans.length; i++) {
    var span = spans[i];
    result.push(new Decoration(span.from + offset, span.to + offset, span.type));
  }
  return result
}

function mapAndGatherRemainingDecorations(children, decorations, mapping, offset, oldOffset, options) {
  // Gather all decorations from the remaining marked children
  function gather(set, oldOffset) {
    for (var i = 0; i < set.local.length; i++) {
      var mapped = set.local[i].map(mapping, offset, oldOffset);
      if (mapped) { decorations.push(mapped); }
      else if (options.onRemove) { options.onRemove(set.local[i].spec); }
    }
    for (var i$1 = 0; i$1 < set.children.length; i$1 += 3)
      { gather(set.children[i$1 + 2], set.children[i$1] + oldOffset + 1); }
  }
  for (var i = 0; i < children.length; i += 3) { if (children[i + 1] == -1)
    { gather(children[i + 2], children[i] + oldOffset + 1); } }

  return decorations
}

function takeSpansForNode(spans, node, offset) {
  if (node.isLeaf) { return null }
  var end = offset + node.nodeSize, found = null;
  for (var i = 0, span = (void 0); i < spans.length; i++) {
    if ((span = spans[i]) && span.from > offset && span.to < end) {
      (found || (found = [])).push(span);
      spans[i] = null;
    }
  }
  return found
}

function withoutNulls(array) {
  var result = [];
  for (var i = 0; i < array.length; i++)
    { if (array[i] != null) { result.push(array[i]); } }
  return result
}

// : ([Decoration], Node, number) → DecorationSet
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtractet from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function buildTree(spans, node, offset, options) {
  var children = [], hasNulls = false;
  node.forEach(function (childNode, localStart) {
    var found = takeSpansForNode(spans, childNode, localStart + offset);
    if (found) {
      hasNulls = true;
      var subtree = buildTree(found, childNode, offset + localStart + 1, options);
      if (subtree != empty)
        { children.push(localStart, localStart + childNode.nodeSize, subtree); }
    }
  });
  var locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
  for (var i = 0; i < locals.length; i++) { if (!locals[i].type.valid(node, locals[i])) {
    if (options.onRemove) { options.onRemove(locals[i].spec); }
    locals.splice(i--, 1);
  } }
  return locals.length || children.length ? new DecorationSet(locals, children) : empty
}

// : (Decoration, Decoration) → number
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function byPos(a, b) {
  return a.from - b.from || a.to - b.to
}

// : ([Decoration]) → [Decoration]
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function removeOverlap(spans) {
  var working = spans;
  for (var i = 0; i < working.length - 1; i++) {
    var span = working[i];
    if (span.from != span.to) { for (var j = i + 1; j < working.length; j++) {
      var next = working[j];
      if (next.from == span.from) {
        if (next.to != span.to) {
          if (working == spans) { working = spans.slice(); }
          // Followed by a partially overlapping larger span. Split that
          // span.
          working[j] = next.copy(next.from, span.to);
          insertAhead(working, j + 1, next.copy(span.to, next.to));
        }
        continue
      } else {
        if (next.from < span.to) {
          if (working == spans) { working = spans.slice(); }
          // The end of this one overlaps with a subsequent span. Split
          // this one.
          working[i] = span.copy(span.from, next.from);
          insertAhead(working, j, span.copy(next.from, span.to));
        }
        break
      }
    } }
  }
  return working
}

function insertAhead(array, i, deco) {
  while (i < array.length && byPos(deco, array[i]) > 0) { i++; }
  array.splice(i, 0, deco);
}

// : (EditorView) → union<DecorationSet, DecorationGroup>
// Get the decorations associated with the current props of a view.
function viewDecorations(view) {
  var found = [];
  view.someProp("decorations", function (f) {
    var result = f(view.state);
    if (result && result != empty) { found.push(result); }
  });
  if (view.cursorWrapper)
    { found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco])); }
  return DecorationGroup.from(found)
}

// ::- An editor view manages the DOM structure that represents an
// editable document. Its state and behavior are determined by its
// [props](#view.DirectEditorProps).
var EditorView = function EditorView(place, props) {
  this._props = props;
  // :: EditorState
  // The view's current [state](#state.EditorState).
  this.state = props.state;

  this.dispatch = this.dispatch.bind(this);

  this._root = null;
  this.focused = false;

  // :: dom.Element
  // An editable DOM node containing the document. (You probably
  // should not directly interfere with its content.)
  this.dom = (place && place.mount) || document.createElement("div");
  if (place) {
    if (place.appendChild) { place.appendChild(this.dom); }
    else if (place.apply) { place(this.dom); }
    else if (place.mount) { this.mounted = true; }
  }

  this.editable = getEditable(this);
  this.cursorWrapper = null;
  updateCursorWrapper(this);
  this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);

  this.lastSelectedViewDesc = null;
  // :: ?{slice: Slice, move: bool}
  // When editor content is being dragged, this object contains
  // information about the dragged slice and whether it is being
  // copied or moved. At any other time, it is null.
  this.dragging = null;
  initInput(this); // Must be done before creating a SelectionReader

  this.selectionReader = new SelectionReader(this);

  this.pluginViews = [];
  this.updatePluginViews();
};

var prototypeAccessors = { props: {},root: {} };

// :: DirectEditorProps
// The view's current [props](#view.EditorProps).
prototypeAccessors.props.get = function () {
    var this$1 = this;

  if (this._props.state != this.state) {
    var prev = this._props;
    this._props = {};
    for (var name in prev) { this$1._props[name] = prev[name]; }
    this._props.state = this.state;
  }
  return this._props
};

// :: (DirectEditorProps)
// Update the view's props. Will immediately cause an update to
// the DOM.
EditorView.prototype.update = function update (props) {
  if (props.handleDOMEvents != this._props.handleDOMEvents) { ensureListeners(this); }
  this._props = props;
  this.updateState(props.state);
};

// :: (DirectEditorProps)
// Update the view by updating existing props object with the object
// given as argument. Equivalent to `view.update(Object.assign({},
// view.props, props))`.
EditorView.prototype.setProps = function setProps (props) {
    var this$1 = this;

  var updated = {};
  for (var name in this$1._props) { updated[name] = this$1._props[name]; }
  updated.state = this.state;
  for (var name$1 in props) { updated[name$1] = props[name$1]; }
  this.update(updated);
};

// :: (EditorState)
// Update the editor's `state` prop, without touching any of the
// other props.
EditorView.prototype.updateState = function updateState (state) {
    var this$1 = this;

  var prev = this.state;
  this.state = state;
  if (prev.plugins != state.plugins) { ensureListeners(this); }

  this.domObserver.flush();
  if (this.inDOMChange && this.inDOMChange.stateUpdated(state)) { return }

  var prevEditable = this.editable;
  this.editable = getEditable(this);
  updateCursorWrapper(this);
  var innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);

  var scroll = prev.config != state.config ? "reset"
      : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
  var updateDoc = !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
  var updateSel = updateDoc || !state.selection.eq(prev.selection) || this.selectionReader.domChanged();
  var oldScrollPos = scroll == "preserve" && updateSel && storeScrollPos(this);

  if (updateSel) {
    this.domObserver.stop();
    if (updateDoc) {
      if (!this.docView.update(state.doc, outerDeco, innerDeco, this)) {
        this.docView.destroy();
        this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
      }
      this.selectionReader.clearDOMState();
    }
    selectionToDOM(this);
    this.domObserver.start();
  }

  if (prevEditable != this.editable) { this.selectionReader.editableChanged(); }
  this.updatePluginViews(prev);

  if (scroll == "reset") {
    this.dom.scrollTop = 0;
  } else if (scroll == "to selection") {
    if (this.someProp("handleScrollToSelection", function (f) { return f(this$1); }))
      {} // Handled
    else if (state.selection instanceof prosemirrorState.NodeSelection)
      { scrollRectIntoView(this, this.docView.domAfterPos(state.selection.from).getBoundingClientRect()); }
    else
      { scrollRectIntoView(this, this.coordsAtPos(state.selection.head)); }
  } else if (oldScrollPos) {
    resetScrollPos(oldScrollPos);
  }
};

EditorView.prototype.destroyPluginViews = function destroyPluginViews () {
  var view;
  while (view = this.pluginViews.pop()) { if (view.destroy) { view.destroy(); } }
};

EditorView.prototype.updatePluginViews = function updatePluginViews (prevState) {
    var this$1 = this;

  var plugins = this.state.plugins;
  if (!prevState || prevState.plugins != plugins) {
    this.destroyPluginViews();
    for (var i = 0; i < plugins.length; i++) {
      var plugin = plugins[i];
      if (plugin.spec.view) { this$1.pluginViews.push(plugin.spec.view(this$1)); }
    }
  } else {
    for (var i$1 = 0; i$1 < this.pluginViews.length; i$1++) {
      var pluginView = this$1.pluginViews[i$1];
      if (pluginView.update) { pluginView.update(this$1, prevState); }
    }
  }
};

// :: (string, ?(prop: *) → *) → *
// Goes over the values of a prop, first those provided directly,
// then those from plugins (in order), and calls `f` every time a
// non-undefined value is found. When `f` returns a truthy value,
// that is immediately returned. When `f` isn't provided, it is
// treated as the identity function (the prop value is returned
// directly).
EditorView.prototype.someProp = function someProp (propName, f) {
  var prop = this._props && this._props[propName], value;
  if (prop != null && (value = f ? f(prop) : prop)) { return value }
  var plugins = this.state.plugins;
  if (plugins) { for (var i = 0; i < plugins.length; i++) {
    var prop$1 = plugins[i].props[propName];
    if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) { return value }
  } }
};

// :: () → bool
// Query whether the view has focus.
EditorView.prototype.hasFocus = function hasFocus () {
  return this.root.activeElement == this.dom
};

// :: ()
// Focus the editor.
EditorView.prototype.focus = function focus () {
  this.domObserver.stop();
  selectionToDOM(this, true);
  this.domObserver.start();
  if (this.editable) { this.dom.focus(); }
};

// :: union<dom.Document, dom.DocumentFragment>
// Get the document root in which the editor exists. This will
// usually be the top-level `document`, but might be a [shadow
// DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
// root if the editor is inside one.
prototypeAccessors.root.get = function () {
    var this$1 = this;

  var cached = this._root;
  if (cached == null) { for (var search = this.dom.parentNode; search; search = search.parentNode) {
    if (search.nodeType == 9 || (search.nodeType == 11 && search.host))
      { return this$1._root = search }
  } }
  return cached || document
};

// :: ({left: number, top: number}) → ?{pos: number, inside: number}
// Given a pair of viewport coordinates, return the document
// position that corresponds to them. May return null if the given
// coordinates aren't inside of the visible editor. When an object
// is returned, its `pos` property is the position nearest to the
// coordinates, and its `inside` property holds the position of the
// inner node that the position falls inside of, or -1 if it is at
// the top level, not in any node.
EditorView.prototype.posAtCoords = function posAtCoords$1 (coords) {
  var pos = posAtCoords(this, coords);
  if (this.inDOMChange && pos) {
    pos.pos = this.inDOMChange.mapping.map(pos.pos);
    if (pos.inside != -1) { pos.inside = this.inDOMChange.mapping.map(pos.inside); }
  }
  return pos
};

// :: (number) → {left: number, right: number, top: number, bottom: number}
// Returns the viewport rectangle at a given document position. `left`
// and `right` will be the same number, as this returns a flat
// cursor-ish rectangle.
EditorView.prototype.coordsAtPos = function coordsAtPos$1 (pos) {
  if (this.inDOMChange)
    { pos = this.inDOMChange.mapping.invert().map(pos); }
  return coordsAtPos(this, pos)
};

// :: (number) → {node: dom.Node, offset: number}
// Find the DOM position that corresponds to the given document
// position. Note that you should **not** mutate the editor's
// internal DOM, only inspect it (and even that is usually not
// necessary).
EditorView.prototype.domAtPos = function domAtPos (pos) {
  if (this.inDOMChange)
    { pos = this.inDOMChange.mapping.invert().map(pos); }
  return this.docView.domFromPos(pos)
};

// :: (number) → ?dom.Node
// Find the DOM node that represents the document node after the
// given position. May return `null` when the position doesn't point
// in front of a node or if the node is inside an opaque node view.
//
// This is intended to be able to call things like
// `getBoundingClientRect` on that DOM node. Do **not** mutate the
// editor DOM directly, or add styling this way, since that will be
// immediately overriden by the editor as it redraws the node.
EditorView.prototype.nodeDOM = function nodeDOM (pos) {
  if (this.inDOMChange)
    { pos = this.inDOMChange.mapping.invert().map(pos); }
  var desc = this.docView.descAt(pos);
  return desc ? desc.nodeDOM : null
};

// :: (dom.Node, number, ?number) → number
// Find the document position that corresponds to a given DOM
// position. (Whenever possible, it is preferable to inspect the
// document structure directly, rather than poking around in the
// DOM, but sometimes—for example when interpreting an event
// target—you don't have a choice.)
//
// The `bias` parameter can be used to influence which side of a DOM
// node to use when the position is inside a leaf node.
EditorView.prototype.posAtDOM = function posAtDOM (node, offset, bias) {
    if ( bias === void 0 ) bias = -1;

  var pos = this.docView.posFromDOM(node, offset, bias);
  if (pos == null) { throw new RangeError("DOM position not inside the editor") }
  if (this.inDOMChange)
    { pos = this.inDOMChange.mapping.map(pos); }
  return pos
};

// :: (union<"up", "down", "left", "right", "forward", "backward">, ?EditorState) → bool
// Find out whether the selection is at the end of a textblock when
// moving in a given direction. When, for example, given `"left"`,
// it will return true if moving left from the current cursor
// position would leave that position's parent textblock. Will apply
// to the view's current state by default, but it is possible to
// pass a different state.
EditorView.prototype.endOfTextblock = function endOfTextblock$1 (dir, state) {
  return endOfTextblock(this, state || this.state, dir)
};

// :: ()
// Removes the editor from the DOM and destroys all [node
// views](#view.NodeView).
EditorView.prototype.destroy = function destroy () {
  if (!this.docView) { return }
  destroyInput(this);
  this.destroyPluginViews();
  this.selectionReader.destroy();
  if (this.mounted) {
    this.docView.update(this.state.doc, [], viewDecorations(this), this);
    this.dom.textContent = "";
  } else if (this.dom.parentNode) {
    this.dom.parentNode.removeChild(this.dom);
  }
  this.docView.destroy();
  this.docView = null;
};

// Used for testing.
EditorView.prototype.dispatchEvent = function dispatchEvent$1 (event) {
  return dispatchEvent(this, event)
};

// :: (Transaction)
// Dispatch a transaction. Will call
// [`dispatchTransaction`](#view.DirectEditorProps.dispatchTransaction)
// when given, and otherwise defaults to applying the transaction to
// the current state and calling
// [`updateState`](#view.EditorView.updateState) with the result.
// This method is bound to the view instance, so that it can be
// easily passed around.
EditorView.prototype.dispatch = function dispatch (tr) {
  var dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction) { dispatchTransaction(tr); }
  else { this.updateState(this.state.apply(tr)); }
};

Object.defineProperties( EditorView.prototype, prototypeAccessors );

function computeDocDeco(view) {
  var attrs = Object.create(null);
  attrs.class = "ProseMirror" + (view.focused ? " ProseMirror-focused" : "");
  attrs.contenteditable = String(view.editable);

  view.someProp("attributes", function (value) {
    if (typeof value == "function") { value = value(view.state); }
    if (value) { for (var attr in value) {
      if (attr == "class")
        { attrs.class += " " + value[attr]; }
      else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
        { attrs[attr] = String(value[attr]); }
    } }
  });

  return [Decoration.node(0, view.state.doc.content.size, attrs)]
}

function cursorWrapperDOM(visible) {
  var span = document.createElement("span");
  span.textContent = "\ufeff"; // zero-width non-breaking space
  if (!visible) {
    span.style.position = "absolute";
    span.style.left = "-100000px";
  }
  return span
}

function updateCursorWrapper(view) {
  var $pos = needsCursorWrapper(view.state);
  // On IE/Edge, moving the DOM selection will abort a mouse drag, so
  // there we delay the creation of the wrapper when the mouse is down.
  if ($pos && !(result.ie && view.mouseDown)) {
    var visible = view.state.selection.visible;
    // Needs a cursor wrapper
    var marks = view.state.storedMarks || $pos.marks(), dom;
    if (!view.cursorWrapper || !prosemirrorModel.Mark.sameSet(view.cursorWrapper.deco.spec.marks, marks) ||
        view.cursorWrapper.dom.textContent != "\ufeff" ||
        view.cursorWrapper.deco.spec.visible != visible)
      { dom = cursorWrapperDOM(visible); }
    else if (view.cursorWrapper.deco.pos != $pos.pos)
      { dom = view.cursorWrapper.dom; }
    if (dom)
      { view.cursorWrapper = {dom: dom, deco: Decoration.widget($pos.pos, dom, {isCursorWrapper: true, marks: marks, raw: true, visible: visible})}; }
  } else {
    view.cursorWrapper = null;
  }
}

function getEditable(view) {
  return !view.someProp("editable", function (value) { return value(view.state) === false; })
}

// EditorProps:: interface
//
// Props are configuration values that can be passed to an editor view
// or included in a plugin. This interface lists the supported props.
//
// The various event-handling functions may all return `true` to
// indicate that they handled the given event. The view will then take
// care to call `preventDefault` on the event, except with
// `handleDOMEvents`, where the handler itself is responsible for that.
//
// How a prop is resolved depends on the prop. Handler functions are
// called one at a time, starting with the base props and then
// searching through the plugins (in order of appearance) until one of
// them returns true. For some props, the first plugin that yields a
// value gets precedence.
//
//   handleDOMEvents:: ?Object<(view: EditorView, event: dom.Event) → bool>
//   Can be an object mapping DOM event type names to functions that
//   handle them. Such functions will be called before any handling
//   ProseMirror does of events fired on the editable DOM element.
//   Contrary to the other event handling props, when returning true
//   from such a function, you are responsible for calling
//   `preventDefault` yourself (or not, if you want to allow the
//   default behavior).
//
//   handleKeyDown:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Called when the editor receives a `keydown` event.
//
//   handleKeyPress:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Handler for `keypress` events.
//
//   handleTextInput:: ?(view: EditorView, from: number, to: number, text: string) → bool
//   Whenever the user directly input text, this handler is called
//   before the input is applied. If it returns `true`, the default
//   behavior of actually inserting the text is suppressed.
//
//   handleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a click, from the inside out. The
//   `direct` flag will be true for the inner node.
//
//   handleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is clicked, after `handleClickOn` handlers
//   have been called.
//
//   handleDoubleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a double click.
//
//   handleDoubleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is double-clicked, after `handleDoubleClickOn`.
//
//   handleTripleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a triple click.
//
//   handleTripleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is triple-clicked, after `handleTripleClickOn`.
//
//   handlePaste:: ?(view: EditorView, event: dom.Event, slice: Slice) → bool
//   Can be used to override the behavior of pasting. `slice` is the
//   pasted content parsed by the editor, but you can directly access
//   the event to get at the raw content.
//
//   handleDrop:: ?(view: EditorView, event: dom.Event, slice: Slice, moved: bool) → bool
//   Called when something is dropped on the editor. `moved` will be
//   true if this drop moves from the current selection (which should
//   thus be deleted).
//
//   handleScrollToSelection:: ?(view: EditorView) → bool
//   Called when the view, after updating its state, tries to scroll
//   the selection into view. A handler function may return false to
//   indicate that it did not handle the scrolling and further
//   handlers or the default behavior should be tried.
//
//   createSelectionBetween:: ?(view: EditorView, anchor: ResolvedPos, head: ResolvedPos) → ?Selection
//   Can be used to override the way a selection is created when
//   reading a DOM selection between the given anchor and head.
//
//   domParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading editor changes
//   from the DOM. Defaults to calling
//   [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) on the
//   editor's schema.
//
//   transformPastedHTML:: ?(html: string) → string
//   Can be used to transform pasted HTML text, _before_ it is parsed,
//   for example to clean it up.
//
//   clipboardParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading content from
//   the clipboard. When not given, the value of the
//   [`domParser`](#view.EditorProps.domParser) prop is used.
//
//   transformPastedText:: ?(text: string) → string
//   Transform pasted plain text.
//
//   clipboardTextParser:: ?(text: string, $context: ResolvedPos) → Slice
//   A function to parse text from the clipboard into a document
//   slice. Called after
//   [`transformPastedText`](#view.EditorProps.transformPastedText).
//   The default behavior is to split the text into lines, wrap them
//   in `<p>` tags, and call
//   [`clipboardParser`](#view.EditorProps.clipboardParser) on it.
//
//   transformPasted:: ?(Slice) → Slice
//   Can be used to transform pasted content before it is applied to
//   the document.
//
//   nodeViews:: ?Object<(node: Node, view: EditorView, getPos: () → number, decorations: [Decoration]) → NodeView>
//   Allows you to pass custom rendering and behavior logic for nodes
//   and marks. Should map node and mark names to constructor
//   functions that produce a [`NodeView`](#view.NodeView) object
//   implementing the node's display behavior. `getPos` is a function
//   that can be called to get the node's current position, which can
//   be useful when creating transactions to update it.
//
//   `decorations` is an array of node or inline decorations that are
//   active around the node. They are automatically drawn in the
//   normal way, and you will usually just want to ignore this, but
//   they can also be used as a way to provide context information to
//   the node view without adding it to the document itself.
//
//   clipboardSerializer:: ?DOMSerializer
//   The DOM serializer to use when putting content onto the
//   clipboard. If not given, the result of
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)
//   will be used.
//
//   clipboardTextSerializer:: ?(Slice) → string
//   A function that will be called to get the text for the current
//   selection when copying text to the clipboard. By default, the
//   editor will use [`textBetween`](#model.Node.textBetween) on the
//   selected range.
//
//   decorations:: ?(state: EditorState) → ?DecorationSet
//   A set of [document decorations](#view.Decoration) to show in the
//   view.
//
//   editable:: ?(state: EditorState) → bool
//   When this returns false, the content of the view is not directly
//   editable.
//
//   attributes:: ?union<Object<string>, (EditorState) → ?Object<string>>
//   Control the DOM attributes of the editable element. May be either
//   an object or a function going from an editor state to an object.
//   By default, the element will get a class `"ProseMirror"`, and
//   will have its `contentEditable` attribute determined by the
//   [`editable` prop](#view.EditorProps.editable). Additional classes
//   provided here will be added to the class. For other attributes,
//   the value provided first (as in
//   [`someProp`](#view.EditorView.someProp)) will be used.
//
//   scrollThreshold:: ?number
//   Determines the distance (in pixels) between the cursor and the
//   end of the visible viewport at which point, when scrolling the
//   cursor into view, scrolling takes place. Defaults to 0.
//
//   scrollMargin:: ?number
//   Determines the extra space (in pixels) that is left above or
//   below the cursor when it is scrolled into view. Defaults to 5.

// DirectEditorProps:: interface extends EditorProps
//
// The props object given directly to the editor view supports two
// fields that can't be used in plugins:
//
//   state:: EditorState
//   The current state of the editor.
//
//   dispatchTransaction:: ?(tr: Transaction)
//   The callback over which to send transactions (state updates)
//   produced by the view. If you specify this, you probably want to
//   make sure this ends up calling the view's
//   [`updateState`](#view.EditorView.updateState) method with a new
//   state that has the transaction
//   [applied](#state.EditorState.apply).

exports.EditorView = EditorView;
exports.Decoration = Decoration;
exports.DecorationSet = DecorationSet;
exports.__serializeForClipboard = serializeForClipboard;
exports.__parseFromClipboard = parseFromClipboard;
//# sourceMappingURL=index.js.map


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var LoadingSpinner = /** @class */ (function (_super) {
    __extends(LoadingSpinner, _super);
    function LoadingSpinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingSpinner = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], LoadingSpinner);
    return LoadingSpinner;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (LoadingSpinner);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["signIn"] = signIn;
/* harmony export (immutable) */ __webpack_exports__["signOut"] = signOut;
/* harmony export (immutable) */ __webpack_exports__["authenticationCheck"] = authenticationCheck;
/* harmony export (immutable) */ __webpack_exports__["passwordSendUpdateEmail"] = passwordSendUpdateEmail;
/* harmony export (immutable) */ __webpack_exports__["passwordUpdate"] = passwordUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_api__ = __webpack_require__(10);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function signIn(ctx, data) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/auth/signin";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* post */])(endpoint, data)
                            .then(function (res) { return res.data; })];
                case 1:
                    result = _a.sent();
                    ctx.commit('updateAuthentication', { result: result.result, user: result.data });
                    return [2 /*return*/, result];
            }
        });
    });
}
function signOut(ctx) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/auth/signout";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* post */])(endpoint)
                            .then(function (res) { return res.data; })];
                case 1:
                    result = _a.sent();
                    ctx.commit('updateAuthentication', { result: result.result, user: null });
                    return [2 /*return*/, result];
            }
        });
    });
}
function authenticationCheck(ctx, data) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/auth/check";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["b" /* get */])(endpoint)
                            .then(function (res) { return res.data; })];
                case 1:
                    result = _a.sent();
                    ctx.commit('updateAuthentication', { result: result.result, user: result.data });
                    return [2 /*return*/, result];
            }
        });
    });
}
function passwordSendUpdateEmail(ctx, data) {
    var endpoint = "/_api/v1/auth/password/send-update-email";
    return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* post */])(endpoint, data).then(function (res) { return res.data; });
}
function passwordUpdate(ctx, data) {
    var endpoint = "/_api/v1/auth/password/update";
    return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_api__["c" /* post */])(endpoint, data).then(function (res) { return res.data; });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(46);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_wrapper_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570fd6c7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_wrapper_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_wrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570fd6c7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_wrapper_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570fd6c7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_wrapper_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var AppWrapper = /** @class */ (function (_super) {
    __extends(AppWrapper, _super);
    function AppWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppWrapper.prototype.created = function () {
        this.initLang();
        this.$store.commit('setDevelopment', this.isdevelopment);
    };
    AppWrapper.prototype.initLang = function () {
        var lang = (this.$route && this.$route.params.lang) || this.lang;
        if (lang && lang != this.$store.state.lang) {
            this.$store.commit('setLang', lang);
            if (this.$i18n) {
                this.$i18n.locale = lang;
            }
        }
    };
    AppWrapper.prototype.routeChanged = function (newValue, oldValue) {
        this.initLang();
    };
    Object.defineProperty(AppWrapper.prototype, "themeClasses", {
        get: function () {
            var classes = ["page"];
            var theme = this.$store.state.theme;
            if (theme) {
                for (var k in theme) {
                    classes.push(k + "-" + theme[k]);
                }
            }
            return classes;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], AppWrapper.prototype, "lang", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], AppWrapper.prototype, "isdevelopment", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('$route')
    ], AppWrapper.prototype, "routeChanged", null);
    AppWrapper = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], AppWrapper);
    return AppWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (AppWrapper);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Access = /** @class */ (function (_super) {
    __extends(Access, _super);
    function Access() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], Access.prototype, "bannerSrc", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], Access.prototype, "bannerMobileSrc", void 0);
    Access = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Access);
    return Access;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Access);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var SignIn = /** @class */ (function (_super) {
    __extends(SignIn, _super);
    function SignIn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.username = '';
        _this.usernameIsValid = false;
        _this.password = '';
        _this.accessError = false;
        _this.showPasswordUpdateMessage = false;
        return _this;
    }
    SignIn.prototype.mounted = function () {
        this.showPasswordUpdateMessage = this.$store.state.uiMessage == 'password-updated';
        this.$store.commit('clearUIMessage');
    };
    Object.defineProperty(SignIn.prototype, "isMobile", {
        get: function () {
            return this.$store.state.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SignIn.prototype, "submitEnabled", {
        get: function () {
            return !!this.username && !!this.password && this.usernameIsValid;
        },
        enumerable: true,
        configurable: true
    });
    SignIn.prototype.onUsernameValid = function (valid) {
        this.usernameIsValid = valid;
    };
    SignIn.prototype.onSubmit = function (evt) {
        return __awaiter(this, void 0, void 0, function () {
            var form, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form = this.$refs.form;
                        return [4 /*yield*/, this.$store.dispatch('signIn', { username: this.username, password: this.password })];
                    case 1:
                        response = _a.sent();
                        if (response.result == "OK") {
                            this.$router.push(this.successRoute);
                        }
                        else {
                            this.accessError = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], SignIn.prototype, "successRoute", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], SignIn.prototype, "passwordRecoveryRoute", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], SignIn.prototype, "bannerSrc", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], SignIn.prototype, "bannerMobileSrc", void 0);
    SignIn = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], SignIn);
    return SignIn;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (SignIn);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var PasswordRecovery = /** @class */ (function (_super) {
    __extends(PasswordRecovery, _super);
    function PasswordRecovery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitEnabled = false;
        _this.emailSubmitted = false;
        _this.email = "";
        return _this;
    }
    Object.defineProperty(PasswordRecovery.prototype, "isMobile", {
        get: function () {
            return this.$store.state.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    PasswordRecovery.prototype.onEmailValidChange = function (valid) {
        this.submitEnabled = valid;
    };
    PasswordRecovery.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitEnabled = false;
                        return [4 /*yield*/, this.$store.dispatch('passwordSendUpdateEmail', { username: this.email, linkPrefix: this.updateLinkPrefix })];
                    case 1:
                        _a.sent();
                        this.submitEnabled = true;
                        this.emailSubmitted = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PasswordRecovery.prototype, "signinRoute", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PasswordRecovery.prototype, "updateLinkPrefix", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PasswordRecovery.prototype, "bannerSrc", void 0);
    PasswordRecovery = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], PasswordRecovery);
    return PasswordRecovery;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (PasswordRecovery);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var PasswordUpdate = /** @class */ (function (_super) {
    __extends(PasswordUpdate, _super);
    function PasswordUpdate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.password1 = '';
        _this.password2 = '';
        _this.passwordMismatch = false;
        _this.passwordUpdateError = false;
        _this.submitEnabled = false;
        return _this;
    }
    Object.defineProperty(PasswordUpdate.prototype, "isMobile", {
        get: function () {
            return this.$store.state.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    PasswordUpdate.prototype.onPasswordChange = function () {
        this.submitEnabled = !!this.password1 && this.password1 == this.password2;
    };
    PasswordUpdate.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var code, userId, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        code = this.$route.query['c'];
                        userId = this.$route.query['u'];
                        if (!(this.password1 == this.password2)) return [3 /*break*/, 2];
                        this.submitEnabled = false;
                        return [4 /*yield*/, this.$store.dispatch('passwordUpdate', { userId: userId, code: code, password: this.password1 })];
                    case 1:
                        response = _a.sent();
                        if (response.result == "OK") {
                            this.$store.commit('setUIMessage', 'password-updated');
                            this.$router.replace(this.signinRoute);
                        }
                        else {
                            this.passwordUpdateError = true;
                        }
                        this.submitEnabled = true;
                        return [3 /*break*/, 3];
                    case 2:
                        this.passwordMismatch = true;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PasswordUpdate.prototype, "signinRoute", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PasswordUpdate.prototype, "passwordRecoveryRoute", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PasswordUpdate.prototype, "bannerSrc", void 0);
    PasswordUpdate = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], PasswordUpdate);
    return PasswordUpdate;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (PasswordUpdate);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_header_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dndg_components_policy_popup_vue__ = __webpack_require__(26);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        return _this;
    }
    Object.defineProperty(App.prototype, "privacyPopupLink", {
        get: function () {
            return { name: 'privacy-policy', query: { popup: true } };
        },
        enumerable: true,
        configurable: true
    });
    App = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ components: { AppHeader: __WEBPACK_IMPORTED_MODULE_1__common_header_vue__["a" /* default */], PolicyPopup: __WEBPACK_IMPORTED_MODULE_2__dndg_components_policy_popup_vue__["a" /* default */] } })
    ], App);
    return App;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (App);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dndg_components__ = __webpack_require__(87);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Header.prototype, "navigation", {
        get: function () {
            var _this = this;
            var menu = [{
                    title: 'About',
                    route: { name: 'about' }
                },
                {
                    title: 'Privacy Policy',
                    route: { name: 'privacy-policy' }
                },
                {
                    title: 'Logout',
                    action: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.$store.dispatch('signOut')];
                                case 1:
                                    _a.sent();
                                    this.$router.push({ name: 'signup', params: { lang: this.lang } });
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    test: function (route, store) { return store.state.isAuthenticated; }
                }];
            return menu;
        },
        enumerable: true,
        configurable: true
    });
    Header = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ components: { NavigationMenu: __WEBPACK_IMPORTED_MODULE_2__dndg_components__["a" /* NavigationMenu */] } })
    ], Header);
    return Header;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Header);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_policy_popup_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4339a76a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_policy_popup_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_policy_popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4339a76a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_policy_popup_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4339a76a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_policy_popup_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookies_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookies_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PolicyPopup = /** @class */ (function (_super) {
    __extends(PolicyPopup, _super);
    function PolicyPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.show = false;
        _this.showPopup = false;
        _this.content = '';
        return _this;
    }
    PolicyPopup.prototype.created = function () {
        var cookie = __WEBPACK_IMPORTED_MODULE_0_cookies_js___default.a.get(this.cookieName);
        if (cookie === undefined) {
            this.show = true;
        }
        else {
            if (cookie === '{"mode":"all"}' && this.gaAccount) {
                xga(this.gaAccount);
            }
        }
    };
    PolicyPopup.prototype.mounted = function () {
        // Hide no-js parts.
        var e = this.$el;
        if (e instanceof HTMLElement) {
            var h = e.querySelectorAll('.no-js');
            for (var i = 0; i < h.length; i++) {
                h[i].style.display = 'none';
            }
        }
    };
    Object.defineProperty(PolicyPopup.prototype, "showRefuseButton", {
        get: function () {
            return this.hideRefuseButton != 'true';
        },
        enumerable: true,
        configurable: true
    });
    PolicyPopup.prototype.onRefuse = function () {
        __WEBPACK_IMPORTED_MODULE_0_cookies_js___default.a.set(this.cookieName, '{"mode":"no-3rd-party"}', { expires: new Date(Date.now() + 365 * 24 * 3600 * 1000) });
        this.show = false;
    };
    PolicyPopup.prototype.onAgree = function () {
        __WEBPACK_IMPORTED_MODULE_0_cookies_js___default.a.set(this.cookieName, '{"mode":"all"}', { expires: new Date(Date.now() + 365 * 24 * 3600 * 1000) });
        if (this.gaAccount) {
            xga(this.gaAccount);
        }
        this.show = false;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], PolicyPopup.prototype, "gaAccount", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], PolicyPopup.prototype, "hideRefuseButton", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'icd' })
    ], PolicyPopup.prototype, "cookieName", void 0);
    PolicyPopup = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], PolicyPopup);
    return PolicyPopup;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (PolicyPopup);
// Fix to remove method in IE
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}
// Utility function to load Google Analytics on request.
function xga(account) {
    var w = window;
    w._gaq = w._gaq || [];
    w._gaq.push(['_setAccount', account]);
    w._gaq.push(['_trackPageview']);
    (function () {
        var ga = document.createElement('script');
        ga.type = 'text/javascript';
        ga.async = true;
        ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(ga, s);
    })();
}


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var PagePath = /** @class */ (function (_super) {
    __extends(PagePath, _super);
    function PagePath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PagePath.prototype, "showPagePath", {
        get: function () {
            return this.navigation && this.navigation.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PagePath.prototype, "navigation", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PagePath.prototype, "variant", void 0);
    PagePath = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], PagePath);
    return PagePath;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (PagePath);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showMenuPopup = false;
        return _this;
    }
    Object.defineProperty(Menu.prototype, "showMenu", {
        get: function () {
            return this.items && this.items.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Menu.prototype.onMenuItemClick = function () {
        this.showMenuPopup = false;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], Menu.prototype, "items", void 0);
    Menu = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Menu);
    return Menu;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Menu);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Signup = /** @class */ (function (_super) {
    __extends(Signup, _super);
    function Signup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLogin = false;
        return _this;
    }
    Signup.prototype.created = function () {
        this.$store.commit('setTheme', { theme: 'signup' });
    };
    Object.defineProperty(Signup.prototype, "state", {
        get: function () {
            return this.$route.query && this.$route.query.state || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Signup.prototype, "r", {
        get: function () {
            return this.$route.query && this.$route.query.r || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Signup.prototype, "fbpixelid", {
        get: function () {
            return this.$route.query && this.$route.query.fbpixelid || '';
        },
        enumerable: true,
        configurable: true
    });
    Signup.prototype.onShare = function () {
        window.FB.ui({
            method: 'share',
            href: window.location.href
        });
    };
    Signup = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Signup);
    return Signup;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Signup);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var SurveyLanding = /** @class */ (function (_super) {
    __extends(SurveyLanding, _super);
    function SurveyLanding() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLogin = false;
        _this.survey = {};
        return _this;
    }
    SurveyLanding.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$store.commit('setTheme', { theme: this.slug });
                        return [4 /*yield*/, this.$store.dispatch('loadSurveyLanding', { slug: this.slug })];
                    case 1:
                        data = _a.sent();
                        if (data) {
                            this.survey = data.survey;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SurveyLanding.prototype, "state", {
        get: function () {
            return this.$route.query && this.$route.query.state || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLanding.prototype, "r", {
        get: function () {
            return this.$route.query && this.$route.query.r || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLanding.prototype, "fbpixelid", {
        get: function () {
            return this.$route.query && this.$route.query.fbpixelid || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLanding.prototype, "coverImage", {
        get: function () {
            return '/_assets/resources/surveys/' + this.slug + '/landing.jpg?v=1';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLanding.prototype, "slug", {
        get: function () {
            return this.$route.params.slug;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SurveyLanding.prototype, "callToAction", {
        get: function () {
            var text = this.survey.texts;
            if (text) {
                return text[this.lang].Widgets.CallToAction;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    SurveyLanding.prototype.onShare = function () {
        window.FB.ui({
            method: 'share',
            href: window.location.href
        });
    };
    SurveyLanding = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], SurveyLanding);
    return SurveyLanding;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (SurveyLanding);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var RepubblicaLanding = /** @class */ (function (_super) {
    __extends(RepubblicaLanding, _super);
    function RepubblicaLanding() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLogin = false;
        return _this;
    }
    RepubblicaLanding.prototype.created = function () {
        this.$store.commit('setTheme', { theme: this.slug });
    };
    Object.defineProperty(RepubblicaLanding.prototype, "state", {
        get: function () {
            return this.$route.query && this.$route.query.state || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RepubblicaLanding.prototype, "slug", {
        get: function () {
            return this.$route.params.slug;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RepubblicaLanding.prototype, "coverImage", {
        get: function () {
            return "/_assets/resources/surveys/" + this.slug + "/landing.jpg";
        },
        enumerable: true,
        configurable: true
    });
    RepubblicaLanding = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], RepubblicaLanding);
    return RepubblicaLanding;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (RepubblicaLanding);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dndg_helpers__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var Register = /** @class */ (function (_super) {
    __extends(Register, _super);
    function Register() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {};
        _this.isSubmitEnabled = false;
        return _this;
    }
    Register.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isRegistered) return [3 /*break*/, 1];
                        this.gotoSurvey();
                        return [3 /*break*/, 3];
                    case 1:
                        this.$store.commit('setTheme', { theme: 'registration' });
                        return [4 /*yield*/, this.initModel()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.initModel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        _b = __WEBPACK_IMPORTED_MODULE_1__dndg_helpers__["a" /* copy */];
                        return [4 /*yield*/, this.$store.dispatch('loadRegistrationData')];
                    case 1:
                        _a.model = _b.apply(void 0, [_c.sent()]);
                        if (!this.model.qualification) {
                            this.model.qualification = 'other';
                        }
                        if (!this.model.gender) {
                            this.model.gender = 'M';
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.gotoSurvey = function () {
        if (this.$route.query.s) {
            // Route to correct survey.
            this.$router.replace({ name: 'survey', params: { lang: this.lang, slug: this.$route.query.s } });
        }
        else {
            // Route to survey chooser.
            this.$router.replace({ name: 'survey-chooser', params: { lang: this.lang } });
        }
    };
    Register.prototype.onValidChange = function (isValid) {
        return __awaiter(this, void 0, void 0, function () {
            var privacy;
            return __generator(this, function (_a) {
                privacy = this.$refs.privacy;
                if (privacy instanceof HTMLInputElement) {
                    this.isSubmitEnabled = isValid && privacy.checked;
                }
                return [2 /*return*/];
            });
        });
    };
    Register.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ok;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$store.dispatch('updateRegistrationData', { data: this.model })];
                    case 1:
                        ok = _a.sent();
                        if (!ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.$store.dispatch('authenticationCheck')];
                    case 2:
                        _a.sent();
                        this.gotoSurvey();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Register.prototype, "isRegistered", {
        get: function () {
            return this.$store.state.loggedUser.isRegistered;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Register.prototype, "privacyPopupLink", {
        get: function () {
            return { name: 'privacy-policy', query: { popup: true } };
        },
        enumerable: true,
        configurable: true
    });
    Register = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Register);
    return Register;
}(__WEBPACK_IMPORTED_MODULE_2__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Register);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var About = /** @class */ (function (_super) {
    __extends(About, _super);
    function About() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    About.prototype.created = function () {
        this.$store.commit('setTheme', { theme: 'signup' });
    };
    About = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], About);
    return About;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (About);


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PrivacyPolicy = /** @class */ (function (_super) {
    __extends(PrivacyPolicy, _super);
    function PrivacyPolicy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivacyPolicy.prototype.created = function () {
        this.$store.commit('setTheme', { theme: 'signup' });
    };
    PrivacyPolicy.prototype.onCloseClick = function () {
        this.$router.go(-1);
    };
    PrivacyPolicy = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], PrivacyPolicy);
    return PrivacyPolicy;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (PrivacyPolicy);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var SurveyChooser = /** @class */ (function (_super) {
    __extends(SurveyChooser, _super);
    function SurveyChooser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isNew = true;
        _this.surveys = [];
        return _this;
    }
    SurveyChooser.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.$store.commit('clearTheme');
                        this.setLoading(true);
                        _a = this.updateData;
                        return [4 /*yield*/, this.$store.dispatch('listSurveys')];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        this.setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    SurveyChooser.prototype.updateData = function (data) {
        var _this = this;
        this.surveys = data.filter(function (x) { return !!x.texts[_this.lang] && !!x.texts[_this.lang].Title; });
    };
    SurveyChooser.prototype.getSurveyTitle = function (survey) {
        return this.getText(survey.texts, 'Title');
    };
    SurveyChooser.prototype.getSurveyTagline = function (survey) {
        return this.getText(survey.texts, 'Tagline');
    };
    SurveyChooser = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], SurveyChooser);
    return SurveyChooser;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (SurveyChooser);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var Survey = /** @class */ (function (_super) {
    __extends(Survey, _super);
    function Survey() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = {};
        _this.survey = null;
        _this.itemsSections = null;
        _this.itemIndex = 0;
        _this.transitionName = 'fade';
        return _this;
    }
    Survey.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, _i, _a, section, _b, _c, item, k, _d, _e, is;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.$store.dispatch('loadSurvey', { slug: this.$route.params.slug })];
                    case 1:
                        data = _f.sent();
                        if (data) {
                            this.survey = data.survey;
                            this.itemsSections = [];
                            for (_i = 0, _a = data.sections; _i < _a.length; _i++) {
                                section = _a[_i];
                                if (section.items) {
                                    for (_b = 0, _c = section.items; _b < _c.length; _b++) {
                                        item = _c[_b];
                                        this.itemsSections.push({ item: item, section: section });
                                    }
                                }
                            }
                            if (data.results && data.results.length > 0 && data.results[0].data) {
                                for (k in data.results[0].data) {
                                    this.data[k] = data.results[0].data[k][k];
                                }
                            }
                            else {
                                for (_d = 0, _e = this.itemsSections; _d < _e.length; _d++) {
                                    is = _e[_d];
                                    this.data[is.item.key] = parseFloat(is.item.defaultValue);
                                }
                            }
                        }
                        this.updateTheme();
                        return [2 /*return*/];
                }
            });
        });
    };
    Survey.prototype.updateTheme = function () {
        var slide = this.itemsSections[this.itemIndex].item;
        var theme = {
            theme: 'survey',
            'slide-index': this.itemIndex.toString()
        };
        if (slide.themeParameters && slide.themeParameters.CssClassNames) {
            theme['slide'] = slide.themeParameters.CssClassNames;
        }
        this.$store.commit('setTheme', theme);
    };
    Object.defineProperty(Survey.prototype, "slug", {
        get: function () {
            return this.$route.params.slug;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Survey.prototype, "slideClasses", {
        get: function () {
            var classes = ['survey-item'];
            switch (this.slideLayout) {
                case 'image':
                    classes.push('image-layout');
                    break;
                default:
                    classes.push('default-layout');
                    break;
            }
            var theme = this.$store.state.theme;
            if (theme) {
                for (var k in theme) {
                    classes.push(k + "-" + theme[k]);
                }
            }
            return classes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Survey.prototype, "slideLayout", {
        get: function () {
            return this.itemsSections[this.itemIndex].item.layout || 'default';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Survey.prototype, "slideHasImage", {
        get: function () {
            var slide = this.itemsSections[this.itemIndex].item;
            return slide.themeParameters && slide.themeParameters.ImageName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Survey.prototype, "itemOptions", {
        get: function () {
            return this.itemsSections[this.itemIndex].item.options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Survey.prototype, "showPrev", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Survey.prototype, "showNext", {
        get: function () {
            if (this.itemsSections) {
                var item = this.itemsSections[this.itemIndex].item;
                var data = this.data[item.key];
                return (!data || data == item.defaultValue) && this.itemIndex < this.itemsSections.length - 1;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Survey.prototype.isItemVisible = function (item) {
        return this.itemsSections.indexOf(item) == this.itemIndex;
    };
    Survey.prototype.onOptionChange = function () {
        this.onNext();
    };
    Survey.prototype.onOptionClick = function (evt) {
        var label = evt.target;
        if (label instanceof HTMLLabelElement) {
            var input = label.parentElement.querySelector('input');
            if (input.value == this.data[input.id.split('__')[0]]) {
                this.onNext();
            }
        }
    };
    Survey.prototype.onPrev = function () {
        if (this.itemIndex == 0) {
            this.$router.push({ name: 'survey-chooser', params: { slug: this.slug } });
        }
        else {
            this.move(-1);
        }
    };
    Survey.prototype.onNext = function () {
        if (this.itemIndex == this.itemsSections.length - 1) {
            this.saveResults(true);
            this.$router.push({ name: 'results', params: { slug: this.slug } });
        }
        else {
            this.move(1);
        }
    };
    Survey.prototype.move = function (direction) {
        // Only the first transition is fade. After mount we slide left or right.
        this.transitionName = direction == -1 ? 'slide-right' : 'slide-left';
        if (this.itemsSections) {
            this.itemIndex += direction;
            this.updateTheme();
            if (direction == 1) {
                this.saveResults(false);
            }
        }
    };
    Survey.prototype.saveResults = function (isComplete) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, result, k;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        result = { isComplete: isComplete, data: {} };
                        for (k in this.data) {
                            result.data[k] = (_a = {}, _a[k] = parseFloat(this.data[k]), _a);
                        }
                        return [4 /*yield*/, this.$store.dispatch('updateSurveyResult', { slug: this.slug, result: result })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Survey = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Survey);
    return Survey;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Survey);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abacus__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_urijs__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_urijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_urijs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__podium_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var Results = /** @class */ (function (_super) {
    __extends(Results, _super);
    function Results() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.survey = {};
        _this.results = {};
        _this.itemIndex = 0;
        _this.transitionName = 'fade';
        _this.sharingCode = null;
        _this.ageRange1 = true;
        _this.ageRange2 = true;
        _this.ageRange3 = true;
        _this.gender1 = true;
        _this.gender2 = true;
        return _this;
    }
    Results.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$store.commit('setLoading', true);
                        return [4 /*yield*/, this.$store.dispatch('loadSurvey', { slug: this.routeSlug })];
                    case 1:
                        data = _a.sent();
                        if (data) {
                            this.survey = data.survey;
                            this.results = Object(__WEBPACK_IMPORTED_MODULE_1__abacus__["a" /* abacusBySurvey */])(this.lang, this.survey, data.results[0].strippedData, data.stats, data.results[0].fbId);
                            this.sharingCode = data.results[0].handle;
                        }
                        if (this.$route.query && this.$route.query.index) {
                            this.itemIndex = Number(this.$route.query.index);
                        }
                        this.$store.commit('setLoading', false);
                        this.$store.commit('setTheme', { theme: "results-" + this.survey.slug });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Results.prototype, "resultsY", {
        get: function () {
            if (this.results.y2) {
                return [this.results.y2, this.results.y1];
            }
            return [this.results.y1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "showActions", {
        get: function () {
            return this.results.plots && this.results.plots.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "disablePrev", {
        get: function () {
            return this.itemIndex == 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "disableNext", {
        get: function () {
            return this.itemIndex == this.results.plots.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "routeSlug", {
        get: function () {
            return this.$route.params.slug;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "partitometroLink", {
        get: function () {
            return { name: this.results.scatterLink };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "plotDescription", {
        get: function () {
            if (this.results.plots[this.itemIndex] == 'scatter')
                return this.results.scatterDescription;
            else if (this.results.plots[this.itemIndex] == 'rankings')
                return this.results.rankingsDescription;
            else if (this.results.plots[this.itemIndex] == 'podium')
                return this.results.podiumDescription;
            else
                return this.results.scoreDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "levelsChartHeight", {
        get: function () {
            var resultsNumber = this.results.y1.length;
            var rowHeight = this.results.levelsRowHeight;
            if (rowHeight) {
                return resultsNumber * rowHeight;
            }
            return resultsNumber * 60;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "showTexts", {
        get: function () {
            if (this.results.scoreTitle) {
                return true;
            }
            else if (this.results.scoreDescription) {
                return true;
            }
            else if (this.results.scatterDescription) {
                return true;
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Results.prototype, "fakeFilterResults", {
        get: function () {
            /* TODO */
            if (!this.gender1) {
                return [3, 2, 3, 3, 4, 3, 2, 2, 3, 2, 3, 3];
            }
            if (!this.ageRange1) {
                return [3, 3, 2, 3, 4, 3, 2, 2, 3, 2, 4, 4];
            }
            return [4, 3, 3, 4, 2, 4, 3, 2, 3, 3, 4, 3];
        },
        enumerable: true,
        configurable: true
    });
    Results.prototype.isItemVisible = function (item) {
        return this.results.plots.indexOf(item) == this.itemIndex;
    };
    Results.prototype.move = function (direction) {
        if (this.results.plots) {
            this.transitionName = direction == -1 ? 'slide-right-fade' : 'slide-left-fade';
            this.itemIndex += direction;
        }
    };
    Results.prototype.onPrev = function () {
        if (!this.disablePrev) {
            this.move(-1);
            this.$router.push({ query: { index: this.itemIndex } });
        }
    };
    Results.prototype.onNext = function () {
        if (!this.disableNext) {
            this.move(1);
            this.$router.push({ query: { index: this.itemIndex } });
        }
    };
    Results.prototype.onShare = function () {
        var _this = this;
        var slug = this.$route.params.slug;
        var route = this.$router.resolve({
            name: 'survey-landing', params: { lang: this.lang, slug: slug }, query: { r: this.sharingCode }
        });
        var href = new __WEBPACK_IMPORTED_MODULE_2_urijs___default.a(window.location.href).resource(route.href).toString();
        window.FB.ui({
            method: 'share',
            href: href
        }, function (response) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(response && !response.error_message)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$store.dispatch('updateSurveyResultShare', { slug: slug })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    Results = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ components: { Podium: __WEBPACK_IMPORTED_MODULE_3__podium_vue__["a" /* default */] } })
    ], Results);
    return Results;
}(__WEBPACK_IMPORTED_MODULE_4__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Results);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Podium = /** @class */ (function (_super) {
    __extends(Podium, _super);
    function Podium() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], Podium.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], Podium.prototype, "bgColors", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], Podium.prototype, "labelsColor", void 0);
    Podium = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Podium);
    return Podium;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Podium);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PartitometroInfo = /** @class */ (function (_super) {
    __extends(PartitometroInfo, _super);
    function PartitometroInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartitometroInfo.prototype.created = function () {
        this.$store.commit('setTheme', { theme: "results-partitometro info" });
    };
    PartitometroInfo.prototype.onCloseClick = function () {
        this.$router.go(-1);
    };
    PartitometroInfo = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], PartitometroInfo);
    return PartitometroInfo;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (PartitometroInfo);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PartitometroAffinita = /** @class */ (function (_super) {
    __extends(PartitometroAffinita, _super);
    function PartitometroAffinita() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartitometroAffinita.prototype.created = function () {
        this.$store.commit('setTheme', { theme: "results-partitometro info" });
    };
    PartitometroAffinita.prototype.onCloseClick = function () {
        this.$router.go(-1);
    };
    PartitometroAffinita = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], PartitometroAffinita);
    return PartitometroAffinita;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (PartitometroAffinita);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EuroPartitometroInfo = /** @class */ (function (_super) {
    __extends(EuroPartitometroInfo, _super);
    function EuroPartitometroInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EuroPartitometroInfo.prototype.created = function () {
        this.$store.commit('setTheme', { theme: "results-europartitometro info" });
    };
    EuroPartitometroInfo.prototype.onCloseClick = function () {
        this.$router.go(-1);
    };
    EuroPartitometroInfo = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], EuroPartitometroInfo);
    return EuroPartitometroInfo;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EuroPartitometroInfo);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_base__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Page404 = /** @class */ (function (_super) {
    __extends(Page404, _super);
    function Page404() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Page404.prototype.created = function () {
        this.$store.commit('setTheme', { theme: 'signup' });
    };
    Page404 = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], Page404);
    return Page404;
}(__WEBPACK_IMPORTED_MODULE_1__common_base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Page404);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(45);
module.exports = __webpack_require__(136);


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wok_forms__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wok_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_wok_forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wok_charts__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wok_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_wok_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_it__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dndg_components_spinner_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_filters__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dndg_components_app_wrapper_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dndg_helpers_detector__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_defaults_json__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_defaults_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__i18n_defaults_json__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






// Import moment l10n.

// Before anything else, register hooks.
__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"].registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
    'beforeRouteLeave'
]);
// Add global components.

__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"].component('loading-spinner', __WEBPACK_IMPORTED_MODULE_7__dndg_components_spinner_vue__["a" /* default */]);
// Add common filters for all Vue components. Also make some of the filters
// available as method on all Vue instances.

__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"].mixin({
    filters: __WEBPACK_IMPORTED_MODULE_8__global_filters__["a" /* default */]
});
// Setup store, routing and application.





function init(element) {
    return __awaiter(this, void 0, void 0, function () {
        var store, router, i18n;
        var _this = this;
        return __generator(this, function (_a) {
            __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);
            __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["default"]);
            __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["default"]);
            __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"].use(__WEBPACK_IMPORTED_MODULE_4_wok_forms___default.a);
            __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"].use(__WEBPACK_IMPORTED_MODULE_5_wok_charts___default.a);
            store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */]);
            router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["default"]({
                routes: Object(__WEBPACK_IMPORTED_MODULE_11__routes__["a" /* initRoutes */])(store),
                mode: 'history',
                scrollBehavior: function (to, from, savedPosition) {
                    if (to.hash) {
                        return { selector: to.hash };
                    }
                    else if (savedPosition) {
                        return savedPosition;
                    }
                    else {
                        return { x: 0, y: 0 };
                    }
                }
            });
            router.beforeEach(function (to, from, next) { return __awaiter(_this, void 0, void 0, function () {
                function check() {
                    return __awaiter(this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, store.dispatch('authenticationCheck')];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response.result == "OK"];
                            }
                        });
                    });
                }
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(!/signup/.test(to.name) && !/privacy-policy/.test(to.name) && !/about/.test(to.name) && to.name != 'repubblica-landing' && to.name != 'survey-landing')) return [3 /*break*/, 3];
                            _a = !store.state.isAuthenticated;
                            if (!_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, check()];
                        case 1:
                            _a = !(_b.sent());
                            _b.label = 2;
                        case 2:
                            if (_a) {
                                next({ name: 'signup', params: Object(__WEBPACK_IMPORTED_MODULE_11__routes__["b" /* routeParams */])(to) });
                                return [2 /*return*/];
                            }
                            _b.label = 3;
                        case 3:
                            next();
                            return [2 /*return*/];
                    }
                });
            }); });
            router.afterEach(function (to, from) {
                store.commit('resetUI');
            });
            Object(__WEBPACK_IMPORTED_MODULE_12__dndg_helpers_detector__["a" /* initDetector */])(function (level) {
                store.commit('setMobile', level >= 1);
            });
            i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["default"]({
                messages: __WEBPACK_IMPORTED_MODULE_13__i18n_defaults_json__,
                fallbackLocale: 'it'
            });
            new __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]({
                el: element,
                i18n: i18n,
                store: store,
                router: router,
                components: {
                    'dndg-app': __WEBPACK_IMPORTED_MODULE_10__dndg_components_app_wrapper_vue__["a" /* default */]
                }
            });
            return [2 /*return*/];
        });
    });
}
window.addEventListener('load', function () {
    var app = document.getElementById('application');
    if (app != null) {
        init(app);
    }
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   3.3.1
 */

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  return function () {
    vertxNext(flush);
  };
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(49);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

polyfill();
// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));
//# sourceMappingURL=es6-promise.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47), __webpack_require__(48)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(3);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(1);

/***/ }),
/* 49 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(48);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(49);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(26);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WokForms", [], factory);
	else if(typeof exports === 'object')
		exports["WokForms"] = factory();
	else
		root["WokForms"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 49);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_vue__ = __webpack_require__(13);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var FormComponent = /** @class */ (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormComponent.prototype.created = function () {
        // Look for parent form and save it in this.$form.
        var c = this.$parent;
        while (c) {
            if (c instanceof __WEBPACK_IMPORTED_MODULE_1__form_vue__["a" /* default */]) {
                this.$form = c;
                break;
            }
            c = c.$parent;
        }
    };
    return FormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (FormComponent);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = E;
/* unused harmony export EventTargetWrapper */
/* harmony export (immutable) */ __webpack_exports__["a"] = D;
/* unused harmony export DomWrapper */
function E(e) {
    return new EventTargetWrapper(e);
}
var EventTargetWrapper = /** @class */ (function () {
    function EventTargetWrapper(e) {
        this.e = e;
    }
    EventTargetWrapper.prototype.once = function (type, listener, isCapture) {
        var e = this.e;
        var l = function (evt) {
            var v = listener(evt);
            if (v !== false) {
                e.removeEventListener(type, l, isCapture);
            }
        };
        e.addEventListener(type, l, isCapture);
    };
    return EventTargetWrapper;
}());

function D(e) {
    return new DomWrapper(e);
}
var DomWrapper = /** @class */ (function () {
    function DomWrapper(e) {
        this.e = e;
    }
    DomWrapper.prototype.inside = function (container) {
        return inside(container, this.e);
    };
    DomWrapper.prototype.contains = function (element) {
        return inside(this.e, element);
    };
    DomWrapper.prototype.closest = function (selector) {
        var e = this.e;
        while (e !== null) {
            if (e.msMatchesSelector ? e.msMatchesSelector(selector) : e.matches(selector)) {
                return e;
            }
            e = e.parentElement;
        }
        return e;
    };
    return DomWrapper;
}());

// Helper functions
function isEventListenerObject(arg) {
    return arg.handleEvent !== undefined;
}
function inside(container, target) {
    if (target === null) {
        return false;
    }
    if (target === container) {
        return true;
    }
    return inside(container, target.parentElement);
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_text_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b54aec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_text_vue__ = __webpack_require__(65);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b54aec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-text.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9b54aec0", Component.options)
  } else {
    hotAPI.reload("data-v-9b54aec0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(54);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(9);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(5);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractOptions;
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
function extractOptions(nodes) {
    var options = [];
    if (nodes) {
        try {
            for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                var n = nodes_1_1.value;
                if (n.tag === "option" && n.children && n.data && (n.data.domProps || n.data.attrs)) {
                    var v = (n.data.domProps && n.data.domProps["value"]) || (n.data.attrs && n.data.attrs["value"]);
                    var a = (n.data.domProps && n.data.domProps["name"]) || (n.data.attrs && n.data.attrs["name"]);
                    var o = { label: n.children[0].text || "", value: v };
                    if (a) {
                        o.name = a;
                    }
                    options.push(o);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return options.length > 0 ? options : null;
    var e_1, _a;
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(11);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(56);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIFormEntry", function() { return isIFormEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_form_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_row_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_actions_row_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_pill_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_pill_switch_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__texts_form_title_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__texts_form_text_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__entries_entry_spacer_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__entries_entry_text_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__entries_entry_textarea_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__entries_entry_password_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__entries_entry_mail_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__entries_entry_phone_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__entries_entry_pnr_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__entries_entry_euro_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__entries_entry_color_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pickers_color_picker_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__entries_entry_select_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__entries_entry_checkbox_group_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__entries_entry_radio_group_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__entries_entry_date_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pickers_date_picker_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__entries_entry_period_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pickers_period_picker_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__entries_entry_image_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pickers_image_picker_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__entries_entry_time_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__entries_entry_upload_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pickers_file_picker_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__entries_entry_html_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__form_form_component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_dom__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_31__lib_dom__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_31__lib_dom__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_0__form_form_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRow", function() { return __WEBPACK_IMPORTED_MODULE_1__form_row_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActionsRow", function() { return __WEBPACK_IMPORTED_MODULE_2__form_actions_row_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pill", function() { return __WEBPACK_IMPORTED_MODULE_3__form_pill_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PillSwitch", function() { return __WEBPACK_IMPORTED_MODULE_4__form_pill_switch_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormTitle", function() { return __WEBPACK_IMPORTED_MODULE_5__texts_form_title_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormText", function() { return __WEBPACK_IMPORTED_MODULE_6__texts_form_text_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntrySpacer", function() { return __WEBPACK_IMPORTED_MODULE_7__entries_entry_spacer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryText", function() { return __WEBPACK_IMPORTED_MODULE_8__entries_entry_text_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryTextArea", function() { return __WEBPACK_IMPORTED_MODULE_9__entries_entry_textarea_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryPassword", function() { return __WEBPACK_IMPORTED_MODULE_10__entries_entry_password_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryMail", function() { return __WEBPACK_IMPORTED_MODULE_11__entries_entry_mail_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryPhone", function() { return __WEBPACK_IMPORTED_MODULE_12__entries_entry_phone_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryPnr", function() { return __WEBPACK_IMPORTED_MODULE_13__entries_entry_pnr_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryEuro", function() { return __WEBPACK_IMPORTED_MODULE_14__entries_entry_euro_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryColor", function() { return __WEBPACK_IMPORTED_MODULE_15__entries_entry_color_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColorPicker", function() { return __WEBPACK_IMPORTED_MODULE_16__pickers_color_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntrySelect", function() { return __WEBPACK_IMPORTED_MODULE_17__entries_entry_select_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryCheckboxGroup", function() { return __WEBPACK_IMPORTED_MODULE_18__entries_entry_checkbox_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryRadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_19__entries_entry_radio_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryDate", function() { return __WEBPACK_IMPORTED_MODULE_20__entries_entry_date_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return __WEBPACK_IMPORTED_MODULE_21__pickers_date_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryPeriod", function() { return __WEBPACK_IMPORTED_MODULE_22__entries_entry_period_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PeriodPicker", function() { return __WEBPACK_IMPORTED_MODULE_23__pickers_period_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryImage", function() { return __WEBPACK_IMPORTED_MODULE_24__entries_entry_image_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ImagePicker", function() { return __WEBPACK_IMPORTED_MODULE_25__pickers_image_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryTime", function() { return __WEBPACK_IMPORTED_MODULE_26__entries_entry_time_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryUpload", function() { return __WEBPACK_IMPORTED_MODULE_27__entries_entry_upload_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return __WEBPACK_IMPORTED_MODULE_28__pickers_file_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormComponent", function() { return __WEBPACK_IMPORTED_MODULE_30__form_form_component__["a"]; });
// Import, then re-export all default WOK Forms widgets.
































// WokForms Vue plugin, to automatically register all components.
/* harmony default export */ __webpack_exports__["default"] = ({
    install: function (V, options) {
        V.component("wok-form", __WEBPACK_IMPORTED_MODULE_0__form_form_vue__["a" /* default */]);
        V.component("form-row", __WEBPACK_IMPORTED_MODULE_1__form_row_vue__["a" /* default */]);
        V.component("actions-row", __WEBPACK_IMPORTED_MODULE_2__form_actions_row_vue__["a" /* default */]);
        V.component("wok-pill", __WEBPACK_IMPORTED_MODULE_3__form_pill_vue__["a" /* default */]);
        V.component("wok-pill-switch", __WEBPACK_IMPORTED_MODULE_4__form_pill_switch_vue__["a" /* default */]);
        V.component("form-title", __WEBPACK_IMPORTED_MODULE_5__texts_form_title_vue__["a" /* default */]);
        V.component("form-text", __WEBPACK_IMPORTED_MODULE_6__texts_form_text_vue__["a" /* default */]);
        V.component("entry-spacer", __WEBPACK_IMPORTED_MODULE_7__entries_entry_spacer_vue__["a" /* default */]);
        V.component("entry-text", __WEBPACK_IMPORTED_MODULE_8__entries_entry_text_vue__["a" /* default */]);
        V.component("entry-textarea", __WEBPACK_IMPORTED_MODULE_9__entries_entry_textarea_vue__["a" /* default */]);
        V.component("entry-password", __WEBPACK_IMPORTED_MODULE_10__entries_entry_password_vue__["a" /* default */]);
        V.component("entry-mail", __WEBPACK_IMPORTED_MODULE_11__entries_entry_mail_vue__["a" /* default */]);
        V.component("entry-phone", __WEBPACK_IMPORTED_MODULE_12__entries_entry_phone_vue__["a" /* default */]);
        V.component("entry-pnr", __WEBPACK_IMPORTED_MODULE_13__entries_entry_pnr_vue__["a" /* default */]);
        V.component("entry-euro", __WEBPACK_IMPORTED_MODULE_14__entries_entry_euro_vue__["a" /* default */]);
        V.component("entry-color", __WEBPACK_IMPORTED_MODULE_15__entries_entry_color_vue__["a" /* default */]);
        V.component("color-picker", __WEBPACK_IMPORTED_MODULE_16__pickers_color_picker_vue__["a" /* default */]);
        V.component("entry-select", __WEBPACK_IMPORTED_MODULE_17__entries_entry_select_vue__["a" /* default */]);
        V.component("entry-checkbox-group", __WEBPACK_IMPORTED_MODULE_18__entries_entry_checkbox_group_vue__["a" /* default */]);
        V.component("entry-radio-group", __WEBPACK_IMPORTED_MODULE_19__entries_entry_radio_group_vue__["a" /* default */]);
        V.component("entry-date", __WEBPACK_IMPORTED_MODULE_20__entries_entry_date_vue__["a" /* default */]);
        V.component("date-picker", __WEBPACK_IMPORTED_MODULE_21__pickers_date_picker_vue__["a" /* default */]);
        V.component("entry-period", __WEBPACK_IMPORTED_MODULE_22__entries_entry_period_vue__["a" /* default */]);
        V.component("period-picker", __WEBPACK_IMPORTED_MODULE_23__pickers_period_picker_vue__["a" /* default */]);
        V.component("entry-image", __WEBPACK_IMPORTED_MODULE_24__entries_entry_image_vue__["a" /* default */]);
        V.component("image-picker", __WEBPACK_IMPORTED_MODULE_25__pickers_image_picker_vue__["a" /* default */]);
        V.component("entry-time", __WEBPACK_IMPORTED_MODULE_26__entries_entry_time_vue__["a" /* default */]);
        V.component("entry-upload", __WEBPACK_IMPORTED_MODULE_27__entries_entry_upload_vue__["a" /* default */]);
        V.component("file-picker", __WEBPACK_IMPORTED_MODULE_28__pickers_file_picker_vue__["a" /* default */]);
        V.component("entry-html", __WEBPACK_IMPORTED_MODULE_29__entries_entry_html_vue__["a" /* default */]);
    }
});
function isIFormEntry(arg) {
    return (arg.name !== undefined || arg.names !== undefined) && arg.value !== undefined;
}
// Also export all components.



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f8f026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__ = __webpack_require__(50);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f8f026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49f8f026", Component.options)
  } else {
    hotAPI.reload("data-v-49f8f026", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Form.prototype.getEntries = function () {
        var entries = new Array();
        for (var i = 0; i < this.$children.length; i++) {
            _getEntries(this.$children[i], entries);
        }
        return entries;
    };
    Form.prototype.onSubmit = function (evt) {
        var form = this.$refs.form;
        var data = new FormData(form);
        if (this.submitButton && this.submitButton.name) {
            data.append(this.submitButton.name, this.submitButton.value || '');
        }
        this.$emit("submit", { target: this, form: form, data: data });
    };
    Form.prototype.onButtonClick = function (evt) {
        if (evt.target instanceof HTMLButtonElement) {
            this.submitButton = evt.target;
        }
    };
    Form.prototype.getEntry = function (name) {
        return this.getEntries().filter(function (x) { return x.name === name; })[0];
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Form.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Form.prototype, "method", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Form.prototype, "action", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Form.prototype, "enctype", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], Form.prototype, "readonly", void 0);
    Form = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Form);
    return Form;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (Form);
function _getEntries(component, list) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__index__["isIFormEntry"])(component)) {
        list.push(component);
    }
    for (var i = 0; i < component.$children.length; i++) {
        _getEntries(component.$children[i], list);
    }
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Row.prototype, "variant", void 0);
    Row = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Row);
    return Row;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (Row);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ActionsRow = /** @class */ (function (_super) {
    __extends(ActionsRow, _super);
    function ActionsRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionsRow.prototype.created = function () {
        // Set some defaults: left + right with a small offset.
        var c = 0, l = 5, r = 5;
        if (this.size) {
            var p = this.size.split('/');
            if (p.length === 1) {
                c = parseInt(p[0]);
                l = r = Math.floor((12 - c) / 2);
            }
            else if (p.length === 2) {
                l = parseInt(p[0]);
                r = parseInt(p[1]);
            }
            else {
                l = parseInt(p[0]);
                c = parseInt(p[1]);
                r = parseInt(p[2]);
            }
        }
        this.offset = Math.floor((12 - l - c - r) / 2).toFixed();
        this.lSize = l.toFixed();
        this.cSize = c.toFixed();
        this.rSize = r.toFixed();
    };
    ActionsRow.prototype.getClassName = function (position) {
        var offset = this.offset, size;
        switch (position) {
            case "left":
                size = this.lSize;
                break;
            case "center":
                size = this.cSize;
                break;
            case "right":
                size = this.rSize;
                break;
        }
        var names = ["c-" + position + " c-size-" + size];
        if (position === "left" && offset !== "0") {
            names.push("c-offset-" + offset);
        }
        return names;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], ActionsRow.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], ActionsRow.prototype, "size", void 0);
    ActionsRow = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], ActionsRow);
    return ActionsRow;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (ActionsRow);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Pill = /** @class */ (function (_super) {
    __extends(Pill, _super);
    function Pill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Pill.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Pill.prototype, "spacing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], Pill.prototype, "rounded", void 0);
    Pill = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Pill);
    return Pill;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (Pill);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PillSwitch = /** @class */ (function (_super) {
    __extends(PillSwitch, _super);
    function PillSwitch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue || "";
        return _this;
    }
    PillSwitch.prototype.created = function () {
        _super.prototype.created.call(this);
    };
    // Events.
    PillSwitch.prototype.onChange = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            this.$form.$emit("change", { target: this, value: this.value });
        }
    };
    Object.defineProperty(PillSwitch.prototype, "title", {
        // Generated properties.
        get: function () {
            var _this = this;
            var curr = (this.options.filter(function (x) { return x.value == _this.value; }))[0];
            return curr ? curr.title : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PillSwitch.prototype, "optionsCount", {
        get: function () {
            return this.options && this.options.length || 0;
        },
        enumerable: true,
        configurable: true
    });
    // Methods.
    PillSwitch.prototype.slotName = function (index) {
        return "option" + index;
    };
    PillSwitch.prototype.slotIsVisible = function (index) {
        if (this.options) {
            for (var i = 0; i < this.options.length; i++) {
                if (this.value === this.options[i].value) {
                    return index - 1 == i;
                }
            }
        }
        return false;
    };
    PillSwitch.prototype.getId = function (item) {
        return this.name + "_" + item.value;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "spacing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], PillSwitch.prototype, "rounded", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "options", void 0);
    PillSwitch = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], PillSwitch);
    return PillSwitch;
}(__WEBPACK_IMPORTED_MODULE_1__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (PillSwitch);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var FormTitle = /** @class */ (function (_super) {
    __extends(FormTitle, _super);
    function FormTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], FormTitle.prototype, "variant", void 0);
    FormTitle = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], FormTitle);
    return FormTitle;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (FormTitle);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var FormText = /** @class */ (function (_super) {
    __extends(FormText, _super);
    function FormText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], FormText.prototype, "variant", void 0);
    FormText = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], FormText);
    return FormText;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (FormText);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntrySpacer = /** @class */ (function (_super) {
    __extends(EntrySpacer, _super);
    function EntrySpacer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EntrySpacer.prototype, "cellClassName", {
        // Generated properties.
        get: function () {
            var c = this.size ? "c-entry-spacer-" + this.size : "c-entry-spacer";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySpacer.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-spacer": true
            };
            if (this.variant) {
                d['entry-spacer--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntrySpacer.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntrySpacer.prototype, "variant", void 0);
    EntrySpacer = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], EntrySpacer);
    return EntrySpacer;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (EntrySpacer);


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryText = /** @class */ (function (_super) {
    __extends(EntryText, _super);
    function EntryText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue != null ? _this.initialValue.toString() : '';
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryText.prototype.onInitialValueChanged = function (newValue) {
        this.value = newValue != null ? newValue.toString() : '';
        this.validate();
    };
    EntryText.prototype.fromValue = function (value) {
        switch (this.type) {
            case 'boolean':
                if (value != '') {
                    return (/true/i).test(value);
                }
                return null;
            case 'number':
                return !!value && parseInt(value) || null;
            default:
                return value || null;
        }
    };
    EntryText.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryText.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || (this.$form && this.$form.readonly);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryText.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-text-" + this.size : "c-entry-text";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryText.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-text": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-text--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryText.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryText.prototype, "hasValue", {
        get: function () {
            return !!this.value.trim();
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryText.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$emit("change", this.fromValue(this.value));
            }
        }
        this.hasFocus = isFocus;
    };
    EntryText.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            if (this.emitOnInput) {
                this.$emit("change", this.fromValue(this.value));
            }
            this.validate();
            this.showErrors = true;
        }
    };
    EntryText.prototype.onKeyEnter = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            if (evt.target.blur) {
                evt.target.blur();
            }
            if (this.submitOnEnter) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
        }
    };
    // Validation
    EntryText.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntryText.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], EntryText.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "submitOnEnter", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "emitOnInput", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryText.prototype, "onInitialValueChanged", null);
    EntryText = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryText);
    return EntryText;
}(__WEBPACK_IMPORTED_MODULE_1__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryText);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryTextArea = /** @class */ (function (_super) {
    __extends(EntryTextArea, _super);
    function EntryTextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue;
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryTextArea.prototype.onInitialValueChanged = function (newValue) {
        this.value = newValue;
        this.validate();
    };
    EntryTextArea.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryTextArea.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTextArea.prototype, "cellClassName", {
        get: function () {
            var c = "c-entry-textarea";
            if (this.variant) {
                c += " c-entry-textarea-" + this.variant;
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTextArea.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-textarea": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-textarea--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTextArea.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTextArea.prototype, "hasValue", {
        get: function () {
            return !!this.value.trim();
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryTextArea.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$emit('change', this.value);
            }
        }
        this.hasFocus = isFocus;
    };
    EntryTextArea.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLTextAreaElement) {
            this.value = evt.target.value;
            this.validate();
            this.showErrors = true;
        }
    };
    // Validation
    EntryTextArea.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntryTextArea.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryTextArea.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryTextArea.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryTextArea.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryTextArea.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], EntryTextArea.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTextArea.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTextArea.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTextArea.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryTextArea.prototype, "onInitialValueChanged", null);
    EntryTextArea = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryTextArea);
    return EntryTextArea;
}(__WEBPACK_IMPORTED_MODULE_1__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryTextArea);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_text_vue__ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryPassword = /** @class */ (function (_super) {
    __extends(EntryPassword, _super);
    function EntryPassword() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EntryPassword.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-password-" + this.size : "c-entry-password";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPassword.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-password": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-password--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    EntryPassword = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryPassword);
    return EntryPassword;
}(__WEBPACK_IMPORTED_MODULE_1__entry_text_vue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryPassword);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_text_vue__ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryMail = /** @class */ (function (_super) {
    __extends(EntryMail, _super);
    function EntryMail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EntryMail.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-mail-" + this.size : "c-entry-mail";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryMail.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-mail": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-mail--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    // Validation
    EntryMail.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.valid = !this.mandatory || (!!this.value.trim() && (re.test(this.value) || /@localhost$/.test(this.value)));
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    EntryMail = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryMail);
    return EntryMail;
}(__WEBPACK_IMPORTED_MODULE_1__entry_text_vue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryMail);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_text_vue__ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryPhone = /** @class */ (function (_super) {
    __extends(EntryPhone, _super);
    function EntryPhone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EntryPhone.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-phone-" + this.size : "c-entry-phone";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPhone.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-phone": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-phone--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    EntryPhone = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryPhone);
    return EntryPhone;
}(__WEBPACK_IMPORTED_MODULE_1__entry_text_vue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryPhone);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryPnr = /** @class */ (function (_super) {
    __extends(EntryPnr, _super);
    function EntryPnr() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value1 = "";
        _this.value2 = "";
        _this.value = _this.value1 + _this.value2;
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        _this.placeholder = 'XXXX';
        return _this;
    }
    EntryPnr.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryPnr.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPnr.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-pnr": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-pnr--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPnr.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPnr.prototype, "hasValue1", {
        get: function () {
            return !!this.value1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPnr.prototype, "hasValue2", {
        get: function () {
            return !!this.value2;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryPnr.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$form.$emit("change", { target: this, name: this.name, value: this.value });
            }
        }
        this.hasFocus = isFocus;
    };
    EntryPnr.prototype.onPaste = function (evt) {
        var clipboardData;
        var pastedData;
        evt.stopPropagation();
        evt.preventDefault();
        clipboardData = evt.clipboardData /* || window.clipboardData */;
        pastedData = clipboardData.getData('Text');
    };
    EntryPnr.prototype.onInput1 = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value1 = evt.target.value.toUpperCase();
            var inputMaxLength = evt.target.maxLength;
            var valueLength = evt.target.value.length;
            if (valueLength >= inputMaxLength) {
                var next = evt.target;
                while (next = next.nextElementSibling) {
                    if (next == null) {
                        break;
                    }
                    if (next.tagName.toLowerCase() === 'input') {
                        next.focus();
                        break;
                    }
                }
            }
            /* this.validate();
            this.showErrors = true; */
        }
    };
    EntryPnr.prototype.onInput2 = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value2 = evt.target.value.toUpperCase();
            var inputMaxLength = evt.target.maxLength;
            var valueLength = evt.target.value.length;
            if (valueLength === 0) {
                var previous = evt.target;
                while (previous = previous.previousElementSibling) {
                    if (previous == null)
                        break;
                    if (previous.tagName.toLowerCase() === "input") {
                        previous.focus();
                        break;
                    }
                }
            }
            /* this.validate();
            this.showErrors = true; */
        }
    };
    EntryPnr.prototype.onKeyEnter = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.$refs.input.blur();
            if (this.submitOnEnter) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
        }
    };
    // Validation
    EntryPnr.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryPnr.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPnr.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPnr.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPnr.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPnr.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPnr.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPnr.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPnr.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPnr.prototype, "submitOnEnter", void 0);
    EntryPnr = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryPnr);
    return EntryPnr;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryPnr);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryEuro = /** @class */ (function (_super) {
    __extends(EntryEuro, _super);
    function EntryEuro() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = (_this.initialValue || "").toString();
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryEuro.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryEuro.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryEuro.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-euro-" + this.size : "c-entry-euro";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryEuro.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-euro": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-euro--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryEuro.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryEuro.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryEuro.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$form.$emit("change", { target: this, name: this.name, value: this.value });
            }
        }
        this.hasFocus = isFocus;
    };
    EntryEuro.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            this.validate();
            this.showErrors = true;
        }
    };
    EntryEuro.prototype.onKeyEnter = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.$refs.input.blur();
            if (this.submitOnEnter) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
        }
    };
    // Validation
    EntryEuro.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryEuro.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryEuro.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryEuro.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryEuro.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryEuro.prototype, "submitOnEnter", void 0);
    EntryEuro = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryEuro);
    return EntryEuro;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryEuro);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_text_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_dom__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryColor = /** @class */ (function (_super) {
    __extends(EntryColor, _super);
    function EntryColor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.showColorPicker = false;
        return _this;
    }
    Object.defineProperty(EntryColor.prototype, "entryClassName", {
        // Generated properties
        get: function () {
            var d = {
                "entry-color": true,
                "lite": this.lite,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-color--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryColor.prototype, "selectedColor", {
        get: function () {
            return "background-color:" + this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryColor.prototype.onShowColorPicker = function () {
        var _this = this;
        if (!this.lite) {
            if (!this.showColorPicker) {
                if (!this.hasFocus) {
                    this.onFocus(true);
                }
                this.showColorPicker = true;
            }
            else {
                this.showColorPicker = false;
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["b" /* E */])(document).once('click', function (evt) {
                if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                    _this.showColorPicker = false;
                    return true;
                }
                return false;
            });
        }
    };
    // Validation
    EntryColor.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        var re = /^(#?([a-f\d]{3}|[a-f\d]{6})|rgb\((0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d)\)|rgba\((0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0?\.\d|1(\.0)?)\)|hsl\((0|360|35\d|3[0-4]\d|[12]\d\d|0?\d?\d),(0|100|\d{1,2})%,(0|100|\d{1,2})%\)|hsla\((0|360|35\d|3[0-4]\d|[12]\d\d|0?\d?\d),(0|100|\d{1,2})%,(0|100|\d{1,2})%,(0?\.\d|1(\.0)?)\))$/;
        this.valid = !!this.value.trim() && re.test(this.value);
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: true })
    ], EntryColor.prototype, "lite", void 0);
    EntryColor = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryColor);
    return EntryColor;
}(__WEBPACK_IMPORTED_MODULE_1__entry_text_vue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryColor);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorPicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], ColorPicker);
    return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (ColorPicker);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntrySelect = /** @class */ (function (_super) {
    __extends(EntrySelect, _super);
    function EntrySelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue !== null && _this.initialValue !== undefined ? _this.initialValue.toString() : '';
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntrySelect.prototype.onInitialValueChanged = function (newValue) {
        this.value = newValue !== null && newValue !== undefined ? newValue.toString() : '';
        this.validate();
    };
    EntrySelect.prototype.fromValue = function (value) {
        switch (this.type) {
            case 'boolean':
                if (value != '') {
                    return (/true/i).test(value);
                }
                return null;
            case 'number':
                return !!value && parseInt(value) || null;
            default:
                return value || null;
        }
    };
    EntrySelect.prototype.created = function () {
        _super.prototype.created.call(this);
        this.domOptions = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* extractOptions */])(this.$slots.default);
        this.validate(true);
    };
    Object.defineProperty(EntrySelect.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-select-" + this.size : "c-entry-select";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-select": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-select--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "optionItems", {
        get: function () {
            if (this.domOptions && this.options) {
                return this.domOptions.concat(this.options);
            }
            return this.options || this.domOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "displayValue", {
        get: function () {
            var _this = this;
            var option = this.optionItems.filter(function (x) { return x.value == _this.value; });
            return (option.length === 1 && option[0].label) || "";
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntrySelect.prototype.onChange = function (evt) {
        if (evt.target instanceof HTMLSelectElement) {
            this.value = evt.target.value;
            this.showErrors = true;
            this.validate();
            this.$emit("change", this.fromValue(this.value));
            if (this.submitOnChange) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
            evt.target.blur();
        }
    };
    // Validation
    EntrySelect.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntrySelect.prototype.setValue = function (value) {
        this.value = value !== null && value !== undefined ? value.toString() : '';
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "options", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], EntrySelect.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntrySelect.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntrySelect.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntrySelect.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntrySelect.prototype, "submitOnChange", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntrySelect.prototype, "onInitialValueChanged", null);
    EntrySelect = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntrySelect);
    return EntrySelect;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntrySelect);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryCheckboxGroup = /** @class */ (function (_super) {
    __extends(EntryCheckboxGroup, _super);
    function EntryCheckboxGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.toValue(_this.initialValue);
        _this.valid = false;
        return _this;
    }
    EntryCheckboxGroup.prototype.onInitialValueChanged = function (newValue) {
        this.value = this.toValue(newValue);
        this.validate();
    };
    EntryCheckboxGroup.prototype.toValue = function (initialValue) {
        if (initialValue && initialValue.map) {
            return initialValue.map(function (x) { return x.toString(); });
        }
        return [];
    };
    EntryCheckboxGroup.prototype.fromValue = function (value) {
        switch (this.type) {
            case 'boolean':
                return !!value && (/true/i).test(value) || null;
            case 'number':
                return !!value && parseInt(value) || null;
            default:
                return value;
        }
    };
    EntryCheckboxGroup.prototype.created = function () {
        _super.prototype.created.call(this);
        this.domOptions = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* extractOptions */])(this.$slots.default);
        this.validate(true);
    };
    Object.defineProperty(EntryCheckboxGroup.prototype, "cellClassName", {
        // Generated properties.
        get: function () {
            var c = "c-entry-checkbox-group";
            if (this.size && parseInt(this.size) <= 6) {
                c = "c-entry-checkbox-group-6";
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryCheckboxGroup.prototype, "entryClassName", {
        get: function () {
            var c = this.items ? "entry-checkbox-group-" + this.items : "entry-checkbox-group";
            if (this.variant) {
                c += "entry-checkbox-group--" + this.variant;
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryCheckboxGroup.prototype, "optionItems", {
        get: function () {
            return this.options || this.domOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryCheckboxGroup.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    EntryCheckboxGroup.prototype.getId = function (item) {
        return this.name + "_" + item.value;
    };
    // Events
    EntryCheckboxGroup.prototype.onChange = function (evt) {
        var _this = this;
        if (evt.target instanceof HTMLInputElement) {
            var value_1 = evt.target.value;
            if (evt.target.checked) {
                this.value.push(value_1);
            }
            else {
                this.value = this.value.filter(function (x) { return x != value_1; });
            }
            // Map current values to correct type.
            var values = this.value.filter(function (x) { return x != ''; }).map(function (x) { return _this.fromValue(x); });
            this.$emit("change", values.length > 0 ? values : null);
        }
    };
    // Validation
    EntryCheckboxGroup.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || this.value.length > 0;
        if (forceEmit || oldValid !== this.valid) {
            this.$form.$emit("valid-change", this.valid);
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "options", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: null })
    ], EntryCheckboxGroup.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryCheckboxGroup.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryCheckboxGroup.prototype, "onInitialValueChanged", null);
    EntryCheckboxGroup = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryCheckboxGroup);
    return EntryCheckboxGroup;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryCheckboxGroup);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryRadioGroup = /** @class */ (function (_super) {
    __extends(EntryRadioGroup, _super);
    function EntryRadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue != null ? _this.initialValue.toString() : '';
        _this.valid = false;
        return _this;
        // Public API
    }
    EntryRadioGroup.prototype.onInitialValueChanged = function (newValue) {
        this.value = newValue != null ? newValue.toString() : '';
        this.validate();
    };
    EntryRadioGroup.prototype.fromValue = function (value) {
        switch (this.type) {
            case 'boolean':
                if (value != '') {
                    return (/true/i).test(value);
                }
                return null;
            case 'number':
                return !!value && parseInt(value) || null;
            default:
                return value || null;
        }
    };
    EntryRadioGroup.prototype.created = function () {
        _super.prototype.created.call(this);
        this.domOptions = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* extractOptions */])(this.$slots.default);
        this.validate(true);
    };
    Object.defineProperty(EntryRadioGroup.prototype, "cellClassName", {
        // Generated properties
        get: function () {
            var c = "c-entry-radio-group";
            if (this.size && parseInt(this.size) <= 6) {
                c = "c-entry-radio-group-6";
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryRadioGroup.prototype, "entryClassName", {
        get: function () {
            var c = this.items ? "entry-radio-group-" + this.items : "entry-radio-group";
            if (this.variant) {
                c += " entry-radio-group--" + this.variant;
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryRadioGroup.prototype, "optionItems", {
        get: function () {
            return this.options || this.domOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryRadioGroup.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    EntryRadioGroup.prototype.getId = function (item) {
        return this.name + "_" + item.value;
    };
    // Events
    EntryRadioGroup.prototype.onChange = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            this.$emit("change", this.fromValue(this.value));
        }
    };
    // Validation
    EntryRadioGroup.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || (!!this.value && !!this.value.trim());
        if (forceEmit || oldValid !== this.valid) {
            this.$emit("valid-change", this.valid);
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "options", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], EntryRadioGroup.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryRadioGroup.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryRadioGroup.prototype, "onInitialValueChanged", null);
    EntryRadioGroup = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryRadioGroup);
    return EntryRadioGroup;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryRadioGroup);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EntryDate = /** @class */ (function (_super) {
    __extends(EntryDate, _super);
    function EntryDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = "";
        _this.displayValue = "";
        _this.valid = false;
        _this.hasFocus = 0;
        _this.showCalendar = false;
        _this.showErrors = false;
        return _this;
    }
    EntryDate.prototype.onInitialValueChanged = function (newValue) {
        this.setValue(this.initialValue);
        this.validate(true);
    };
    EntryDate.prototype.created = function () {
        _super.prototype.created.call(this);
        if (this.format && /L(L{0,3}|T|TS)/.test(this.format)) {
            this.parseFormat = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.localeData().longDateFormat(this.format);
        }
        this.setValue(this.initialValue);
        this.validate(true);
    };
    Object.defineProperty(EntryDate.prototype, "isReadonly", {
        // Generated properties.
        get: function () {
            return this.readonly || this.locked || (this.$form && this.$form.readonly);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-date-" + this.size : "c-entry-date";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-date": true,
                "no-label": !this.label,
                "highlight": this.hasFocus > 0,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-date--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "hasDisplayValue", {
        get: function () {
            return !!this.displayValue;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryDate.prototype.prevDay = function () {
        this.setValue(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value).subtract(1, 'day').format('YYYY-MM-DD'));
        this.$emit("change", this.value);
    };
    EntryDate.prototype.nextDay = function () {
        this.setValue(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value).add(1, 'day').format('YYYY-MM-DD'));
        this.$emit("change", this.value);
    };
    EntryDate.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.setValue(evt.target.value, true);
        }
    };
    EntryDate.prototype.onPickerChange = function (evt) {
        this.showCalendar = false;
        if (this.value !== evt.value) {
            this.setValue(evt.value);
            this.$emit("change", this.value);
        }
    };
    EntryDate.prototype.onShowCalendar = function () {
        var _this = this;
        if (!this.showCalendar) {
            this.showErrors = false;
            this.showCalendar = true;
        }
        else {
            this.showCalendar = false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["b" /* E */])(document).once('click', function (evt) {
            if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                _this.showCalendar = false;
                return true;
            }
            return false;
        });
    };
    EntryDate.prototype.onFocus = function (focus) {
        if (focus > 0) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            if (!this.showCalendar) {
                this.showErrors = true;
                if (this.value != this.focusValue) {
                    this.$emit("change", this.value);
                }
            }
        }
        this.hasFocus = focus;
    };
    // Validation
    EntryDate.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        if (this.value.trim()) {
            var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value, 'YYYY-MM-DD');
            this.valid = m.isValid() && m.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()("1200-01-01", 'YYYY-MM-DD'));
        }
        else {
            this.valid = !this.mandatory;
        }
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntryDate.prototype.parseDate = function (value) {
        var date;
        if (this.parseFormat) {
            date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, this.parseFormat);
        }
        if (!date || !date.isValid()) {
            date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, 'YYYY-MM-DD');
        }
        return date;
    };
    EntryDate.prototype.setValue = function (value, isFromInput) {
        if (isFromInput === void 0) { isFromInput = false; }
        if (isFromInput) {
            this.value = "";
            this.displayValue = value;
            if (value) {
                var m = this.parseDate(value);
                if (m.isValid()) {
                    this.value = m.format('YYYY-MM-DD');
                }
            }
        }
        else {
            this.value = value || "";
            if (value) {
                var m = this.parseDate(value);
                if (m.isValid()) {
                    this.displayValue = m.format(this.format);
                }
            }
            else {
                this.displayValue = "";
            }
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'L' })
    ], EntryDate.prototype, "format", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryDate.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryDate.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryDate.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])('initialValue')
    ], EntryDate.prototype, "onInitialValueChanged", null);
    EntryDate = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryDate);
    return EntryDate;
}(__WEBPACK_IMPORTED_MODULE_3__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryDate);


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_calendar__ = __webpack_require__(36);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.current = _this.initialValue ? __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialValue) : __WEBPACK_IMPORTED_MODULE_1_moment__();
        _this.currentYear = _this.current.get('year');
        _this.day = __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialValue);
        _this.showYears = false;
        _this.showDays = true;
        return _this;
    }
    Object.defineProperty(DatePicker.prototype, "headerYear", {
        // Generated properties
        get: function () {
            return this.current.format("YYYY");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "headerMonth", {
        get: function () {
            return this.current.format("MMM");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "headerDecade", {
        get: function () {
            return Math.floor(this.currentYear / 10) * 10 + ' - ' + (Math.floor(this.currentYear / 10) * 10 + 19);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "calendarWeeks", {
        get: function () {
            var month = this.current.clone().startOf('month');
            var start = month.clone().startOf('week');
            var end = this.current.clone().endOf('month').endOf('week');
            var d = start.clone();
            var weeks = [];
            while (d <= end) {
                var w = [];
                for (var i = 0; i < 7; i++) {
                    w.push(new __WEBPACK_IMPORTED_MODULE_3__lib_calendar__["a" /* CalendarDay */](d.clone(), month, this.day));
                    d.add(1, 'days');
                }
                weeks.push(w);
            }
            return weeks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "calendarYears", {
        get: function () {
            var years = [];
            var startYear = Math.floor(this.currentYear / 10) * 10;
            for (var i = 0; i < 20; i++) {
                years.push(startYear + i);
            }
            return years;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "daysNames", {
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3__lib_calendar__["b" /* generateDaysNames */])(this.current);
        },
        enumerable: true,
        configurable: true
    });
    // Methods and event handlers
    DatePicker.prototype.prevMonth = function () {
        this.current = this.current.clone().subtract(1, 'month');
    };
    DatePicker.prototype.nextMonth = function () {
        this.current = this.current.clone().add(1, 'month');
    };
    DatePicker.prototype.prevDecades = function () {
        this.currentYear = this.currentYear - 20;
    };
    DatePicker.prototype.nextDecades = function () {
        this.currentYear = this.currentYear + 20;
    };
    DatePicker.prototype.setCurrent = function (evt) {
        if (evt.target instanceof HTMLElement) {
            var date = evt.target.getAttribute("data-date");
            if (date && date !== this.current.format("YYYY-MM-DD")) {
                this.current = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
                this.day = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
            }
            this.$emit("change", { target: this, value: date });
        }
    };
    DatePicker.prototype.setCurrentYear = function (evt) {
        if (evt.target instanceof HTMLElement) {
            var year = Number(evt.target.getAttribute("data-year"));
            if (year && year !== this.currentYear) {
                this.currentYear = year;
                this.current = this.current.clone().year(year);
            }
            this.setShowDays();
        }
    };
    DatePicker.prototype.setShowYears = function () {
        this.showYears = true;
        this.showDays = false;
    };
    DatePicker.prototype.setShowDays = function () {
        this.showYears = false;
        this.showDays = true;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Prop"])()
    ], DatePicker.prototype, "initialValue", void 0);
    DatePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Component"]
    ], DatePicker);
    return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarDay; });
/* harmony export (immutable) */ __webpack_exports__["b"] = generateDaysNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var CalendarDay = /** @class */ (function () {
    function CalendarDay(displayDay, displayMonth, day, dayTo) {
        this.day = displayDay.clone();
        this.dayOfMonth = this.day.format('DD');
        this.isToday = this.day.format('YYYYMMDD') == __WEBPACK_IMPORTED_MODULE_0_moment__().format('YYYYMMDD');
        this.isThisYear = this.day.format('YYYY') == __WEBPACK_IMPORTED_MODULE_0_moment__().format('YYYY');
        this.isoDate = this.day.format('YYYY-MM-DD');
        if (day != null) {
            this.isCurrentDay = this.day.format('YYYYMMDD') == day.format('YYYYMMDD');
            this.isCurrentMonth = (displayMonth.format('YYYYMM') == this.day.format('YYYYMM'));
            this.isPeriodFrom = this.day.format('YYYYMMDD') == day.format('YYYYMMDD');
        }
        if (day != null && dayTo != null && dayTo >= day) {
            this.isPeriodTo = this.day.format('YYYYMMDD') == dayTo.format('YYYYMMDD');
            this.isInPeriod = (this.day >= day) && (this.day <= dayTo);
        }
    }
    return CalendarDay;
}());

function generateDaysNames(now) {
    var names = [];
    var d = now.clone().startOf('week');
    for (var i = 0; i < 7; i++) {
        names.push(d.format('dd'));
        d.add(1, 'day');
    }
    return names;
}


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EntryPeriod = /** @class */ (function (_super) {
    __extends(EntryPeriod, _super);
    function EntryPeriod() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.from = "";
        _this.to = "";
        _this.displayFrom = "";
        _this.displayTo = "";
        _this.valid = false;
        _this.hasFocus = 0;
        _this.showCalendar = false;
        _this.showErrors = false;
        return _this;
    }
    EntryPeriod.prototype.created = function () {
        _super.prototype.created.call(this);
        this.setFromValue(this.initialValue && this.initialValue.from);
        this.setToValue(this.initialValue && this.initialValue.to);
        this.validate(true);
    };
    Object.defineProperty(EntryPeriod.prototype, "value", {
        // Generated properties.
        get: function () {
            return { from: this.from, to: this.to };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "isReadonly", {
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-period-" + this.size : "c-entry-period";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-period": true,
                "no-label": !this.label,
                "highlight": this.hasFocus > 0,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-period--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "input1Name", {
        get: function () {
            return this.nameFrom || (this.name + "From");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "input2Name", {
        get: function () {
            return this.nameTo || (this.name + "To");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "entryId", {
        get: function () {
            return this.nameFrom + "__" + this.nameTo;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryPeriod.prototype.onInput1 = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.setFromValue(evt.target.value, true);
        }
    };
    EntryPeriod.prototype.onInput2 = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.setToValue(evt.target.value, true);
        }
    };
    EntryPeriod.prototype.onPickerChangeFrom = function (evt) {
        this.setFromValue(evt.value);
        this.onFocus(2);
    };
    EntryPeriod.prototype.onPickerChangeTo = function (evt) {
        this.showCalendar = false;
        this.setToValue(evt.value);
        this.onFocus(0);
        this.$emit("change", { from: this.from, to: this.to });
    };
    EntryPeriod.prototype.onShowCalendar = function () {
        var _this = this;
        if (!this.showCalendar) {
            if (this.hasFocus === 0) {
                this.onFocus(1);
            }
            this.showCalendar = true;
        }
        else {
            this.showCalendar = false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["b" /* E */])(document).once('click', function (evt) {
            if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                _this.showCalendar = false;
                return true;
            }
            return false;
        });
    };
    EntryPeriod.prototype.onFocus = function (input) {
        if (input > 0) {
            this.hasFocus = input;
            this.showErrors = false;
        }
        else {
            if (!this.showCalendar) {
                this.hasFocus = 0;
                this.showErrors = true;
            }
        }
    };
    // Validation
    EntryPeriod.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        var valid1 = true, valid2 = true;
        if (this.from.trim()) {
            var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.from, "YYYY-MM-DD");
            valid1 = m.isValid() && m.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()("1900-1-1", "YYYY-MM-DD"));
        }
        else {
            valid1 = !this.mandatory;
        }
        if (this.to.trim()) {
            var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.to, "YYYY-MM-DD");
            valid2 = m.isValid() && m.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()("1900-1-1", "YYYY-MM-DD"));
        }
        else {
            valid2 = !this.mandatory;
        }
        this.valid = valid1 && valid2;
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    EntryPeriod.prototype.setFromValue = function (value, isFromInput) {
        if (isFromInput === void 0) { isFromInput = false; }
        if (isFromInput) {
            this.displayFrom = value || "";
            if (value) {
                var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, this.format);
                if (m.isValid()) {
                    this.from = m.format("YYYY-MM-DD");
                }
                else {
                    this.from = "";
                }
            }
            else {
                this.from = "";
            }
        }
        else {
            this.from = value || "";
            if (value) {
                var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.from);
                if (m.isValid()) {
                    this.displayFrom = m.format(this.format);
                }
            }
            else {
                this.displayFrom = "";
            }
        }
        this.validate();
    };
    EntryPeriod.prototype.setToValue = function (value, isFromInput) {
        if (isFromInput === void 0) { isFromInput = false; }
        if (isFromInput) {
            this.displayTo = value || "";
            if (value) {
                var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, this.format);
                if (m.isValid()) {
                    this.to = m.format("YYYY-MM-DD");
                }
                else {
                    this.to = "";
                }
            }
            else {
                this.to = "";
            }
        }
        else {
            this.to = value || "";
            if (value) {
                var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.to);
                if (m.isValid()) {
                    this.displayTo = m.format(this.format);
                }
            }
            else {
                this.displayTo = "";
            }
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "nameFrom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "nameTo", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "labelFrom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "labelTo", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'L' })
    ], EntryPeriod.prototype, "format", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPeriod.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPeriod.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPeriod.prototype, "mandatory", void 0);
    EntryPeriod = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryPeriod);
    return EntryPeriod;
}(__WEBPACK_IMPORTED_MODULE_3__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryPeriod);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_calendar__ = __webpack_require__(36);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var PeriodPicker = /** @class */ (function (_super) {
    __extends(PeriodPicker, _super);
    function PeriodPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.current = _this.initialFromValue ? __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialFromValue) : __WEBPACK_IMPORTED_MODULE_1_moment__();
        _this.currentYear = _this.current.get('year');
        _this.day = __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialFromValue);
        _this.dayTo = __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialToValue);
        _this.showYears = false;
        _this.showDays = true;
        _this.isActivePeriodTo = false;
        return _this;
    }
    Object.defineProperty(PeriodPicker.prototype, "headerDecade", {
        // Generated properties
        get: function () {
            return Math.floor(this.currentYear / 10) * 10 + ' - ' + (Math.floor(this.currentYear / 10) * 10 + 19);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodPicker.prototype, "calendarYears", {
        get: function () {
            var years = [];
            var startYear = Math.floor(this.currentYear / 10) * 10;
            for (var i = 0; i < 20; i++) {
                years.push(startYear + i);
            }
            return years;
        },
        enumerable: true,
        configurable: true
    });
    // Methods and event handlers
    PeriodPicker.prototype.headerYear = function (monthDelta) {
        if (monthDelta === void 0) { monthDelta = 0; }
        return this.current.clone().add(monthDelta, 'months').format("YYYY");
    };
    PeriodPicker.prototype.headerMonth = function (monthDelta) {
        if (monthDelta === void 0) { monthDelta = 0; }
        return this.current.clone().add(monthDelta, 'months').format("MMM");
    };
    PeriodPicker.prototype.calendarWeeks = function (monthDelta) {
        if (monthDelta === void 0) { monthDelta = 0; }
        var month = this.current.clone().add(monthDelta, 'months').startOf('month');
        var start = month.clone().startOf('week');
        var end = month.clone().endOf('month').endOf('week');
        var d = start.clone();
        var weeks = [];
        while (d <= end) {
            var w = [];
            for (var i = 0; i < 7; i++) {
                w.push(new __WEBPACK_IMPORTED_MODULE_3__lib_calendar__["a" /* CalendarDay */](d.clone(), month.clone(), this.day, this.dayTo));
                d.add(1, 'days');
            }
            weeks.push(w);
        }
        return weeks;
    };
    Object.defineProperty(PeriodPicker.prototype, "daysNames", {
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3__lib_calendar__["b" /* generateDaysNames */])(this.current);
        },
        enumerable: true,
        configurable: true
    });
    PeriodPicker.prototype.prevMonth = function () {
        this.current = this.current.clone().subtract(1, 'month');
    };
    PeriodPicker.prototype.nextMonth = function () {
        this.current = this.current.clone().add(1, 'month');
    };
    PeriodPicker.prototype.prevDecades = function () {
        this.currentYear = this.currentYear - 20;
    };
    PeriodPicker.prototype.nextDecades = function () {
        this.currentYear = this.currentYear + 20;
    };
    PeriodPicker.prototype.setCurrent = function (evt) {
        if (evt.target instanceof HTMLElement) {
            var date = evt.target.getAttribute("data-date");
            if (date) {
                if (this.initialActivePeriodFrom && !this.isActivePeriodTo) {
                    this.current = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
                    this.day = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
                    this.$emit("change-from", { target: this, value: this.day.format("YYYY-MM-DD") });
                    this.isActivePeriodTo = true;
                }
                else {
                    this.dayTo = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
                    this.$emit("change-to", { target: this, value: this.dayTo.format("YYYY-MM-DD") });
                }
            }
        }
    };
    PeriodPicker.prototype.setCurrentYear = function (evt) {
        if (evt.target instanceof HTMLElement) {
            var year = Number(evt.target.getAttribute("data-year"));
            if (year && year !== this.currentYear) {
                this.currentYear = year;
                this.current = this.current.clone().year(year);
            }
            this.setShowDays();
        }
    };
    PeriodPicker.prototype.setShowYears = function () {
        this.showYears = true;
        this.showDays = false;
    };
    PeriodPicker.prototype.setShowDays = function () {
        this.showYears = false;
        this.showDays = true;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Prop"])()
    ], PeriodPicker.prototype, "initialFromValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Prop"])()
    ], PeriodPicker.prototype, "initialToValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Prop"])()
    ], PeriodPicker.prototype, "initialActivePeriodFrom", void 0);
    PeriodPicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Component"]
    ], PeriodPicker);
    return PeriodPicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (PeriodPicker);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_dom__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EntryImage = /** @class */ (function (_super) {
    __extends(EntryImage, _super);
    function EntryImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = (_this.initialValue || "").toString();
        _this.valid = false;
        _this.hasFocus = 0;
        _this.showErrors = false;
        _this.showImagePicker = false;
        return _this;
    }
    EntryImage.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryImage.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryImage.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-image": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-image--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryImage.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryImage.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryImage.prototype.onFocus = function (input) {
        if (input > 0) {
            this.hasFocus = input;
            this.showErrors = false;
        }
        else {
            if (!this.showImagePicker) {
                this.hasFocus = 0;
                this.showErrors = true;
            }
        }
    };
    EntryImage.prototype.onShowImagePicker = function () {
        var _this = this;
        if (!this.showImagePicker) {
            if (this.hasFocus === 0) {
                this.onFocus(1);
            }
            this.showImagePicker = true;
        }
        else {
            this.showImagePicker = false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_dom__["b" /* E */])(document).once('click', function (evt) {
            if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_3__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                _this.showImagePicker = false;
                return true;
            }
            return false;
        });
    };
    // Validation
    EntryImage.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryImage.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryImage.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryImage.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryImage.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryImage.prototype, "submitOnEnter", void 0);
    EntryImage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryImage);
    return EntryImage;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryImage);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ImagePicker = /** @class */ (function (_super) {
    __extends(ImagePicker, _super);
    function ImagePicker() {
        // Data
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.image = '';
        _this.actionBrowseHover = false;
        return _this;
    }
    // Events
    ImagePicker.prototype.onFileChange = function (e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
        this.createImage(files[0]);
    };
    ImagePicker.prototype.createImage = function (file) {
        var _this = this;
        var image = new Image();
        var reader = new FileReader();
        reader.onload = function (e) {
            _this.image = e.target.result;
        };
        reader.readAsDataURL(file);
    };
    ImagePicker.prototype.removeImage = function (e) {
        this.image = '';
    };
    ImagePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], ImagePicker);
    return ImagePicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (ImagePicker);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryTime = /** @class */ (function (_super) {
    __extends(EntryTime, _super);
    function EntryTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = (_this.initialValue || "").toString();
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryTime.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryTime.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTime.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-time-" + this.size : "c-entry-time";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTime.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-time": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-time--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTime.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTime.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryTime.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$form.$emit("change", { target: this, name: this.name, value: this.value });
            }
        }
        this.hasFocus = isFocus;
    };
    EntryTime.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            this.validate();
            this.showErrors = true;
        }
    };
    EntryTime.prototype.onKeyEnter = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.$refs.input.blur();
            if (this.submitOnEnter) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
        }
    };
    // Validation
    EntryTime.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryTime.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTime.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTime.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTime.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTime.prototype, "submitOnEnter", void 0);
    EntryTime = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryTime);
    return EntryTime;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryTime);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_dom__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EntryUpload = /** @class */ (function (_super) {
    __extends(EntryUpload, _super);
    function EntryUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = (_this.initialValue || "").toString();
        _this.valid = false;
        _this.hasFocus = 0;
        _this.showErrors = false;
        _this.showFilePicker = false;
        _this.isFileWord = false;
        _this.isFilePowerpoint = false;
        _this.isFileExcel = false;
        return _this;
    }
    EntryUpload.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryUpload.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryUpload.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-upload": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-upload--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryUpload.prototype, "fileTypeClassName", {
        get: function () {
            return {
                "file-type": true,
                "word": this.isFileWord,
                "powerpoint": this.isFilePowerpoint,
                "excel": this.isFileExcel
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryUpload.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryUpload.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryUpload.prototype.onFocus = function (input) {
        if (input > 0) {
            this.hasFocus = input;
            this.showErrors = false;
        }
        else {
            if (!this.showFilePicker) {
                this.hasFocus = 0;
                this.showErrors = true;
            }
        }
    };
    EntryUpload.prototype.onShowFilePicker = function () {
        var _this = this;
        if (!this.showFilePicker) {
            if (this.hasFocus === 0) {
                this.onFocus(1);
            }
            this.showFilePicker = true;
        }
        else {
            this.showFilePicker = false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_dom__["b" /* E */])(document).once('click', function (evt) {
            if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_3__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                _this.showFilePicker = false;
                return true;
            }
            return false;
        });
    };
    // Validation
    EntryUpload.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryUpload.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryUpload.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryUpload.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryUpload.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryUpload.prototype, "submitOnEnter", void 0);
    EntryUpload = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryUpload);
    return EntryUpload;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryUpload);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var FilePicker = /** @class */ (function (_super) {
    __extends(FilePicker, _super);
    function FilePicker() {
        // Data
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actionBrowseHover = false;
        return _this;
    }
    FilePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], FilePicker);
    return FilePicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (FilePicker);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__html_editor__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var EntryHtml = /** @class */ (function (_super) {
    __extends(EntryHtml, _super);
    function EntryHtml() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue;
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryHtml.prototype.onInitialValueChanged = function (newValue) {
        this.setValue(newValue);
        this.validate();
    };
    EntryHtml.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    EntryHtml.prototype.mounted = function () {
        var textarea = this.$refs.textarea;
        var editor = this.$refs.editor;
        if (editor instanceof HTMLElement && textarea instanceof HTMLTextAreaElement && !this.editorView) {
            this.editorView = Object(__WEBPACK_IMPORTED_MODULE_3__html_editor__["a" /* createEditor */])(editor, textarea.value, this.handleTransaction, this.handleFocus, this.handleBlur);
            this.domSerializer = __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["DOMSerializer"].fromSchema(this.editorView.state.schema);
        }
    };
    EntryHtml.prototype.handleTransaction = function (transaction) {
        // Manage editor transaction.
        var newState = this.editorView.state.apply(transaction);
        this.editorView.updateState(newState);
        // Get HTML from editor.
        this.value = this.getHTML();
        if (this.emitOnInput) {
            this.$emit("change", this.value);
        }
        this.validate();
    };
    EntryHtml.prototype.getHTML = function () {
        var tmp = document.createElement('div');
        tmp.appendChild(this.domSerializer.serializeFragment(this.editorView.state.doc.content));
        var html = tmp.innerHTML;
        if (html.trim() == '<p></p>') {
            return null;
        }
        return html;
    };
    Object.defineProperty(EntryHtml.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || (this.$form && this.$form.readonly);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryHtml.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-html": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-html--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryHtml.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryHtml.prototype, "hasValue", {
        get: function () {
            return this.value != null;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryHtml.prototype.handleFocus = function (view, event) {
        this.onFocus(true);
        return false;
    };
    EntryHtml.prototype.handleBlur = function (view, event) {
        this.onFocus(false);
        return false;
    };
    EntryHtml.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$emit("change", this.value);
            }
        }
        this.hasFocus = isFocus;
    };
    // Validation
    EntryHtml.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || this.value != null;
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntryHtml.prototype.setValue = function (value) {
        if (value != this.value) {
            var content = document.createElement("div");
            content.innerHTML = value || '';
            var doc = __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["DOMParser"].fromSchema(this.editorView.state.schema).parse(content);
            var newState = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["EditorState"].create({ schema: this.editorView.state.schema, doc: doc, plugins: this.editorView.state.plugins });
            this.editorView.updateState(newState);
            this.value = value;
            this.validate();
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryHtml.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryHtml.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryHtml.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryHtml.prototype, "emitOnInput", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryHtml.prototype, "onInitialValueChanged", null);
    EntryHtml = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryHtml);
    return EntryHtml;
}(__WEBPACK_IMPORTED_MODULE_4__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryHtml);


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(58);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(60);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wok-form" }, [
    _c(
      "form",
      {
        ref: "form",
        attrs: {
          name: _vm.name,
          method: _vm.method,
          action: _vm.action,
          enctype: _vm.enctype
        },
        on: {
          submit: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            _vm.onSubmit($event)
          },
          click: _vm.onButtonClick
        }
      },
      [
        _vm._t("header-actions"),
        _vm._v(" "),
        _vm._t("default"),
        _vm._v(" "),
        _vm._t("primary-actions")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49f8f026", esExports)
  }
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa18930_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_vue__ = __webpack_require__(52);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa18930_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/row.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4fa18930", Component.options)
  } else {
    hotAPI.reload("data-v-4fa18930", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["row", _vm.variant ? "row--" + _vm.variant : null] },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fa18930", esExports)
  }
}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actions_row_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b476d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_actions_row_vue__ = __webpack_require__(54);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actions_row_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b476d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_actions_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/actions-row.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d0b476d0", Component.options)
  } else {
    hotAPI.reload("data-v-d0b476d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["row row--actions", _vm.variant ? "row--" + _vm.variant : null] },
    [
      _c("div", { class: _vm.getClassName("left") }, [
        _c("div", { staticClass: "content" }, [_vm._t("left")], 2)
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.getClassName("center") }, [
        _c("div", { staticClass: "content" }, [_vm._t("center")], 2)
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.getClassName("right") }, [
        _c("div", { staticClass: "content" }, [_vm._t("right")], 2)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0b476d0", esExports)
  }
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pill_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1114221b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pill_vue__ = __webpack_require__(56);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1114221b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/pill.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1114221b", Component.options)
  } else {
    hotAPI.reload("data-v-1114221b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "wok-pill",
        _vm.variant ? "wok-pill--" + _vm.variant : null,
        _vm.spacing ? "spacing--" + _vm.spacing : null,
        _vm.rounded ? "rounded" : null
      ]
    },
    [_c("div", { staticClass: "content" }, [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1114221b", esExports)
  }
}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pill_switch_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a80c2d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pill_switch_vue__ = __webpack_require__(58);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pill_switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a80c2d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pill_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/pill-switch.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a80c2d6", Component.options)
  } else {
    hotAPI.reload("data-v-2a80c2d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "wok-pill",
        _vm.variant ? "wok-pill--" + _vm.variant : null,
        _vm.spacing ? "spacing--" + _vm.spacing : null,
        _vm.rounded ? "rounded" : null
      ]
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("form-row", { attrs: { variant: "switch-title" } }, [
            _c("div", { staticClass: "c-form-title-switch" }, [
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  {
                    class: [
                      "form-title",
                      _vm.variant ? "form-title--" + _vm.variant : null
                    ]
                  },
                  [_c("h2", [_vm._v(_vm._s(_vm.title))])]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "switch" }, [
                  _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.options, function(o, i) {
                      return _c("div", { key: i, staticClass: "switch-item" }, [
                        _c("input", {
                          attrs: {
                            type: "radio",
                            name: _vm.name,
                            id: _vm.getId(o)
                          },
                          domProps: {
                            value: o.value,
                            checked: _vm.value === o.value
                          },
                          on: { change: _vm.onChange }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            class: { active: _vm.value === o.value },
                            attrs: { for: _vm.getId(o) }
                          },
                          [_vm._v(_vm._s(o.label))]
                        )
                      ])
                    })
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slot-fade", mode: "out-in" } },
            _vm._l(_vm.optionsCount, function(i) {
              return _vm.slotIsVisible(i)
                ? _c(
                    "div",
                    { key: i, staticClass: "slot-wrapper" },
                    [_vm._t(_vm.slotName(i))],
                    2
                  )
                : _vm._e()
            })
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a80c2d6", esExports)
  }
}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_title_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3d3e9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_title_vue__ = __webpack_require__(60);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3d3e9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/texts/form-title.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b3d3e9e", Component.options)
  } else {
    hotAPI.reload("data-v-6b3d3e9e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-form-title" }, [
    _c(
      "div",
      {
        class: ["form-title", _vm.variant ? "form-title--" + _vm.variant : null]
      },
      [_c("h2", [_vm._t("default")], 2)]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b3d3e9e", esExports)
  }
}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_text_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a9ea564_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_text_vue__ = __webpack_require__(62);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a9ea564_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/texts/form-text.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a9ea564", Component.options)
  } else {
    hotAPI.reload("data-v-4a9ea564", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-form-text" }, [
    _c(
      "div",
      {
        class: ["form-text", _vm.variant ? "form-text--" + _vm.variant : null]
      },
      [_c("h3", [_vm._t("default")], 2)]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a9ea564", esExports)
  }
}

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_spacer_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6332915f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_spacer_vue__ = __webpack_require__(64);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_spacer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6332915f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_spacer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-spacer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6332915f", Component.options)
  } else {
    hotAPI.reload("data-v-6332915f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _c("div", { class: _vm.entryClassName }, [
      _c("span", { staticClass: "spacer" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6332915f", esExports)
  }
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "input",
            attrs: {
              type: "text",
              id: _vm.entryId,
              name: _vm.name,
              placeholder: _vm.hasValue ? null : _vm.placeholder || _vm.label
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.onInput,
              keyup: function($event) {
                if (!("button" in $event) && $event.keyCode !== 13) {
                  return null
                }
                _vm.onKeyEnter($event)
              },
              focus: function($event) {
                _vm.onFocus(true)
              },
              blur: function($event) {
                _vm.onFocus(false)
              }
            }
          })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b54aec0", esExports)
  }
}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_textarea_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea37b2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_textarea_vue__ = __webpack_require__(67);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_textarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea37b2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_textarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-textarea.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ea37b2a6", Component.options)
  } else {
    hotAPI.reload("data-v-ea37b2a6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isReadonly
    ? _c("div", { class: _vm.cellClassName }, [
        _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("textarea", {
            ref: "textarea",
            attrs: {
              id: _vm.entryId,
              name: _vm.name,
              placeholder: _vm.hasValue ? null : _vm.placeholder || _vm.label
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.onInput,
              focus: function($event) {
                _vm.onFocus(true)
              },
              blur: function($event) {
                _vm.onFocus(false)
              }
            }
          })
        ])
      ])
    : _c("div", { class: _vm.cellClassName }, [
        _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea37b2a6", esExports)
  }
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_password_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d7918e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_password_vue__ = __webpack_require__(69);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d7918e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-password.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23d7918e", Component.options)
  } else {
    hotAPI.reload("data-v-23d7918e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "password",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-password" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-password" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23d7918e", esExports)
  }
}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_mail_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e9d7ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_mail_vue__ = __webpack_require__(71);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_mail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e9d7ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_mail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-mail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24e9d7ac", Component.options)
  } else {
    hotAPI.reload("data-v-24e9d7ac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "text",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-mail" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-mail" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e9d7ac", esExports)
  }
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_phone_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8fb35ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_phone_vue__ = __webpack_require__(73);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_phone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8fb35ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_phone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-phone.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c8fb35ea", Component.options)
  } else {
    hotAPI.reload("data-v-c8fb35ea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "text",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-phone" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-phone" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8fb35ea", esExports)
  }
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_pnr_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d64411_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_pnr_vue__ = __webpack_require__(75);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_pnr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d64411_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_pnr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-pnr.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59d64411", Component.options)
  } else {
    hotAPI.reload("data-v-59d64411", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-entry-pnr" }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show" }, [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show" }, [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("div", { staticClass: "input-wrapper" }, [
            _c("input", {
              ref: "input",
              attrs: {
                type: "text",
                id: _vm.entryId,
                name: _vm.name,
                placeholder: _vm.hasValue1 ? null : _vm.placeholder,
                maxlength: "4"
              },
              domProps: { value: _vm.value1 },
              on: {
                paste: _vm.onPaste,
                input: _vm.onInput1,
                keyup: function($event) {
                  if (!("button" in $event) && $event.keyCode !== 13) {
                    return null
                  }
                  _vm.onKeyEnter($event)
                },
                focus: function($event) {
                  _vm.onFocus(true)
                },
                blur: function($event) {
                  _vm.onFocus(false)
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("–")]),
            _vm._v(" "),
            _c("input", {
              ref: "input",
              attrs: {
                type: "text",
                id: _vm.entryId,
                name: _vm.name,
                placeholder: _vm.hasValue2 ? null : _vm.placeholder,
                maxlength: "4"
              },
              domProps: { value: _vm.value2 },
              on: {
                input: _vm.onInput2,
                keyup: function($event) {
                  if (!("button" in $event) && $event.keyCode !== 13) {
                    return null
                  }
                  _vm.onKeyEnter($event)
                },
                focus: function($event) {
                  _vm.onFocus(true)
                },
                blur: function($event) {
                  _vm.onFocus(false)
                }
              }
            })
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59d64411", esExports)
  }
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_euro_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff79b40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_euro_vue__ = __webpack_require__(77);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_euro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff79b40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_euro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-euro.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ff79b40", Component.options)
  } else {
    hotAPI.reload("data-v-3ff79b40", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "text",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-euro" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-euro" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ff79b40", esExports)
  }
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_color_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eea5480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_color_vue__ = __webpack_require__(79);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_color_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eea5480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_color_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-color.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4eea5480", Component.options)
  } else {
    hotAPI.reload("data-v-4eea5480", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-color" },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "readonly-value" }, [
                  _vm._v(_vm._s(_vm.value))
                ])
              ]),
              _vm._v(" "),
              _vm._m(1)
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c(
              "label",
              { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
              [_vm._v(_vm._s(_vm.label))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-color" }, [
                  !_vm.lite
                    ? _c("button", {
                        class: { open: _vm.showColorPicker },
                        attrs: { type: "button" },
                        on: { click: _vm.onShowColorPicker }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("input", {
                  ref: "input",
                  attrs: {
                    type: "text",
                    id: _vm.entryId,
                    name: _vm.name,
                    placeholder: _vm.hasValue
                      ? null
                      : _vm.placeholder || _vm.label
                  },
                  domProps: { value: _vm.value },
                  on: {
                    input: _vm.onInput,
                    keyup: function($event) {
                      if (!("button" in $event) && $event.keyCode !== 13) {
                        return null
                      }
                      _vm.onKeyEnter($event)
                    },
                    focus: function($event) {
                      _vm.onFocus(true)
                    },
                    blur: function($event) {
                      _vm.onFocus(false)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action" }, [
                _c("button", {
                  key: _vm.value,
                  staticClass: "action-color",
                  style: _vm.selectedColor,
                  attrs: { type: "button" },
                  on: { click: _vm.onShowColorPicker }
                })
              ])
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.showColorPicker ? _c("color-picker") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-color" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action" }, [
      _c("button", { staticClass: "action-color", attrs: { type: "button" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eea5480", esExports)
  }
}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_color_picker_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f8d8bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_picker_vue__ = __webpack_require__(81);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_color_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f8d8bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/color-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62f8d8bb", Component.options)
  } else {
    hotAPI.reload("data-v-62f8d8bb", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "color-popup" }, [
      _c("div", { staticClass: "content" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62f8d8bb", esExports)
  }
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_select_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d24a3a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_select_vue__ = __webpack_require__(83);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d24a3a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-select.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d24a3a2", Component.options)
  } else {
    hotAPI.reload("data-v-3d24a3a2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.displayValue))
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              attrs: { name: _vm.name, id: _vm.entryId },
              domProps: { value: _vm.value },
              on: {
                focus: function($event) {
                  _vm.hasFocus = true
                },
                blur: function($event) {
                  _vm.hasFocus = false
                },
                change: _vm.onChange
              }
            },
            _vm._l(_vm.optionItems, function(o) {
              return _c(
                "option",
                { key: o.value, domProps: { value: o.value } },
                [_vm._v(_vm._s(o.label))]
              )
            })
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d24a3a2", esExports)
  }
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_checkbox_group_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3cadcb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_checkbox_group_vue__ = __webpack_require__(85);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_checkbox_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3cadcb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_checkbox_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-checkbox-group.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f3cadcb0", Component.options)
  } else {
    hotAPI.reload("data-v-f3cadcb0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _c(
      "div",
      { class: _vm.entryClassName },
      [
        _c("label", [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _vm._l(_vm.optionItems, function(o, i) {
          return _c("div", { key: i, staticClass: "entry-check-item" }, [
            _c("input", {
              attrs: { type: "checkbox", name: _vm.name, id: _vm.getId(o) },
              domProps: {
                value: o.value,
                checked:
                  !!_vm.value &&
                  _vm.value.some(function(x) {
                    return x == o.value
                  })
              },
              on: { change: _vm.onChange }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm.getId(o) } }, [
              _vm._v(_vm._s(o.label))
            ])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3cadcb0", esExports)
  }
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_radio_group_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc8c62ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_radio_group_vue__ = __webpack_require__(87);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_radio_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc8c62ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_radio_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-radio-group.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fc8c62ec", Component.options)
  } else {
    hotAPI.reload("data-v-fc8c62ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _c(
      "div",
      { class: _vm.entryClassName },
      [
        _c("label", [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _vm._l(_vm.optionItems, function(o, i) {
          return _c("div", { key: i, staticClass: "entry-radio-item" }, [
            _c("input", {
              attrs: { type: "radio", name: _vm.name, id: _vm.getId(o) },
              domProps: { value: o.value, checked: o.value === _vm.value },
              on: { change: _vm.onChange }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm.getId(o) } }, [
              _vm._v(_vm._s(o.label))
            ])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc8c62ec", esExports)
  }
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_date_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59032aa1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_date_vue__ = __webpack_require__(89);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_date_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59032aa1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_date_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-date.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59032aa1", Component.options)
  } else {
    hotAPI.reload("data-v-59032aa1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.cellClassName },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show" }, [_vm._v(_vm._s(_vm.label))]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "readonly-value" }, [
                  _vm._v(_vm._s(_vm.displayValue))
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c("label", { class: { show: _vm.hasDisplayValue } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-calendar" }, [
                  _c("button", {
                    class: { open: _vm.showCalendar },
                    attrs: { type: "button" },
                    on: { click: _vm.onShowCalendar }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input" },
                [
                  _c("input", {
                    attrs: {
                      type: "text",
                      placeholder: _vm.hasValue
                        ? null
                        : _vm.placeholder || _vm.label
                    },
                    domProps: { value: _vm.displayValue },
                    on: {
                      focus: function($event) {
                        _vm.onFocus(1)
                      },
                      blur: function($event) {
                        _vm.onFocus(0)
                      },
                      input: _vm.onInput
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: _vm.name },
                    domProps: { value: _vm.value }
                  }),
                  _vm._v(" "),
                  !_vm.showCalendar && _vm.valid
                    ? [
                        _c("button", {
                          staticClass: "prev",
                          attrs: { type: "button" },
                          on: { click: _vm.prevDay }
                        }),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "next",
                          attrs: { type: "button" },
                          on: { click: _vm.nextDay }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showCalendar
            ? _c("date-picker", {
                attrs: { initialValue: _vm.valid ? _vm.value : null },
                on: { change: _vm.onPickerChange }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-calendar" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59032aa1", esExports)
  }
}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_picker_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51de5a5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_picker_vue__ = __webpack_require__(91);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51de5a5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/date-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51de5a5a", Component.options)
  } else {
    hotAPI.reload("data-v-51de5a5a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-popup" }, [
    _vm.showDays
      ? _c("div", { staticClass: "calendar-days" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", {
              staticClass: "prev-btn",
              on: { click: _vm.prevMonth }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "switch", on: { click: _vm.setShowYears } },
              [_vm._v(_vm._s(_vm.headerMonth) + " " + _vm._s(_vm.headerYear))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "next-btn", on: { click: _vm.nextMonth } })
          ]),
          _vm._v(" "),
          _c("table", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              { on: { click: _vm.setCurrent } },
              _vm._l(_vm.calendarWeeks, function(w) {
                return _c(
                  "tr",
                  _vm._l(w, function(d) {
                    return _c(
                      "td",
                      {
                        class: {
                          "not-current-month": !d.isCurrentMonth,
                          "current-day": d.isCurrentDay,
                          today: d.isToday
                        },
                        attrs: { "data-date": d.isoDate }
                      },
                      [_vm._v(_vm._s(d.dayOfMonth))]
                    )
                  })
                )
              })
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showYears
      ? _c("div", { staticClass: "calendar-years" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", {
              staticClass: "prev-btn",
              on: { click: _vm.prevDecades }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "switch" }, [
              _vm._v(_vm._s(_vm.headerDecade))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "next-btn",
              on: { click: _vm.nextDecades }
            })
          ]),
          _vm._v(" "),
          _c("table", [
            _c("tbody", { on: { click: _vm.setCurrentYear } }, [
              _c("tr", [
                _c(
                  "td",
                  _vm._l(_vm.calendarYears, function(y) {
                    return _c("span", { attrs: { "data-year": y } }, [
                      _vm._v(_vm._s(y))
                    ])
                  })
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.daysNames, function(d) {
          return _c("th", { staticClass: "dow" }, [_vm._v(_vm._s(d))])
        })
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51de5a5a", esExports)
  }
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_period_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0a0474_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_period_vue__ = __webpack_require__(93);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_period_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0a0474_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_period_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-period.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b0a0474", Component.options)
  } else {
    hotAPI.reload("data-v-5b0a0474", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.cellClassName },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show" }, [_vm._v(_vm._s(_vm.label))]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input first" }, [
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("div", { staticClass: "from-wrapper" }, [
                    _c("span", { staticClass: "from" }, [
                      _vm._v(_vm._s(_vm.labelFrom))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("span", { staticClass: "readonly-value" }, [
                      _vm._v(_vm._s(_vm.displayFrom))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input second" }, [
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("div", { staticClass: "from-wrapper" }, [
                    _c("span", { staticClass: "from" }, [
                      _vm._v(_vm._s(_vm.labelTo))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("span", { staticClass: "readonly-value" }, [
                      _vm._v(_vm._s(_vm.displayTo))
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c("label", [_vm._v(_vm._s(_vm.label))]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-calendar" }, [
                  _c("button", {
                    class: { open: _vm.showCalendar },
                    attrs: { type: "button" },
                    on: { click: _vm.onShowCalendar }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "input first",
                    { active: _vm.hasFocus === 1 && _vm.showCalendar }
                  ]
                },
                [
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("div", { staticClass: "from-wrapper" }, [
                      _c("span", { staticClass: "from" }, [
                        _vm._v(_vm._s(_vm.labelFrom))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-wrapper" }, [
                      _c("input", {
                        attrs: { type: "text" },
                        domProps: { value: _vm.displayFrom },
                        on: {
                          focus: function($event) {
                            _vm.onFocus(1)
                          },
                          blur: function($event) {
                            _vm.onFocus(0)
                          },
                          input: _vm.onInput1
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: _vm.input1Name },
                        domProps: { value: _vm.from }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "input second",
                    {
                      input: true,
                      active: _vm.hasFocus === 2 && _vm.showCalendar
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("div", { staticClass: "to-wrapper" }, [
                      _c("span", { staticClass: "to" }, [
                        _vm._v(_vm._s(_vm.labelTo))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-wrapper" }, [
                      _c("input", {
                        attrs: { type: "text" },
                        domProps: { value: _vm.displayTo },
                        on: {
                          focus: function($event) {
                            _vm.onFocus(2)
                          },
                          blur: function($event) {
                            _vm.onFocus(0)
                          },
                          input: _vm.onInput2
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: _vm.input2Name },
                        domProps: { value: _vm.to }
                      })
                    ])
                  ])
                ]
              )
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showCalendar
            ? _c("period-picker", {
                attrs: {
                  initialFromValue: _vm.valid ? _vm.from : null,
                  initialToValue: _vm.valid ? _vm.to : null,
                  initialActivePeriodFrom: _vm.hasFocus === 1
                },
                on: {
                  "change-from": _vm.onPickerChangeFrom,
                  "change-to": _vm.onPickerChangeTo
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-calendar" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b0a0474", esExports)
  }
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_period_picker_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2f8127_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_period_picker_vue__ = __webpack_require__(95);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_period_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2f8127_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_period_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/period-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c2f8127", Component.options)
  } else {
    hotAPI.reload("data-v-0c2f8127", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-popup" }, [
    _vm.showDays
      ? _c("div", { staticClass: "calendar-days" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", {
              staticClass: "prev-btn",
              on: { click: _vm.prevMonth }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "switch", on: { click: _vm.setShowYears } },
              [
                _vm._v(
                  _vm._s(_vm.headerMonth(0)) + " " + _vm._s(_vm.headerYear(0))
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "switch", on: { click: _vm.setShowYears } },
              [
                _vm._v(
                  _vm._s(_vm.headerMonth(1)) + " " + _vm._s(_vm.headerYear(1))
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "next-btn", on: { click: _vm.nextMonth } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-wrapper" }, [
            _c("table", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                { on: { click: _vm.setCurrent } },
                _vm._l(_vm.calendarWeeks(0), function(w) {
                  return _c(
                    "tr",
                    [
                      _vm._l(w, function(d) {
                        return [
                          d.isCurrentMonth
                            ? _c(
                                "td",
                                {
                                  class: {
                                    "period-from-day": d.isPeriodFrom,
                                    "period-to-day": d.isPeriodTo,
                                    "in-period": d.isInPeriod,
                                    today: d.isToday
                                  },
                                  attrs: { "data-date": d.isoDate }
                                },
                                [_vm._v(_vm._s(d.dayOfMonth))]
                              )
                            : _c("td", { staticClass: "not-current-month" })
                        ]
                      })
                    ],
                    2
                  )
                })
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-wrapper" }, [
            _c("table", [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                { on: { click: _vm.setCurrent } },
                _vm._l(_vm.calendarWeeks(1), function(w) {
                  return _c(
                    "tr",
                    [
                      _vm._l(w, function(d) {
                        return [
                          d.isCurrentMonth
                            ? _c(
                                "td",
                                {
                                  class: {
                                    "period-from-day": d.isPeriodFrom,
                                    "period-to-day": d.isPeriodTo,
                                    "in-period": d.isInPeriod,
                                    today: d.isToday
                                  },
                                  attrs: { "data-date": d.isoDate }
                                },
                                [_vm._v(_vm._s(d.dayOfMonth))]
                              )
                            : _c("td", { staticClass: "not-current-month" })
                        ]
                      })
                    ],
                    2
                  )
                })
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showYears
      ? _c("div", { staticClass: "calendar-years" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", {
              staticClass: "prev-btn",
              on: { click: _vm.prevDecades }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "switch" }, [
              _vm._v(_vm._s(_vm.headerDecade))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "next-btn",
              on: { click: _vm.nextDecades }
            })
          ]),
          _vm._v(" "),
          _c("table", [
            _c("tbody", { on: { click: _vm.setCurrentYear } }, [
              _c("tr", [
                _c(
                  "td",
                  _vm._l(_vm.calendarYears, function(y) {
                    return _c("span", { attrs: { "data-year": y } }, [
                      _vm._v(_vm._s(y))
                    ])
                  })
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.daysNames, function(d) {
          return _c("th", { staticClass: "dow" }, [_vm._v(_vm._s(d))])
        })
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.daysNames, function(d) {
          return _c("th", { staticClass: "dow" }, [_vm._v(_vm._s(d))])
        })
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c2f8127", esExports)
  }
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_image_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6ffdb10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_image_vue__ = __webpack_require__(97);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6ffdb10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-image.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b6ffdb10", Component.options)
  } else {
    hotAPI.reload("data-v-b6ffdb10", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-image" },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "readonly-value" }, [
                  _vm._v(_vm._s(_vm.value))
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c(
              "label",
              { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
              [_vm._v(_vm._s(_vm.label))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-image" }, [
                  _c("button", {
                    class: { open: _vm.showImagePicker },
                    attrs: { type: "button" },
                    on: { click: _vm.onShowImagePicker }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input", on: { click: _vm.onShowImagePicker } },
                [
                  _c("input", {
                    ref: "input",
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: _vm.entryId,
                      name: _vm.name,
                      placeholder: _vm.hasValue
                        ? null
                        : _vm.placeholder || _vm.label
                    },
                    domProps: { value: _vm.value },
                    on: {
                      focus: function($event) {
                        _vm.onFocus(true)
                      },
                      blur: function($event) {
                        _vm.onFocus(false)
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              false
                ? _c("div", { staticClass: "preview" }, [_vm._m(1)])
                : _vm._e()
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.showImagePicker ? _c("image-picker") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-image" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "img-placeholder" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6ffdb10", esExports)
  }
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_picker_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c07f3c3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_picker_vue__ = __webpack_require__(99);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c07f3c3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/image-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c07f3c3", Component.options)
  } else {
    hotAPI.reload("data-v-6c07f3c3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-popup" }, [
    !_vm.image
      ? _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "preview" }, [
            _c(
              "div",
              { class: { upload: true, fill: _vm.actionBrowseHover } },
              [
                _c("input", {
                  attrs: { type: "file", name: "ip1", id: "ip1" },
                  on: { change: _vm.onFileChange }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "btn-nobg--browse",
                    attrs: { for: "ip1" },
                    on: {
                      mouseover: function($event) {
                        _vm.actionBrowseHover = true
                      },
                      mouseleave: function($event) {
                        _vm.actionBrowseHover = false
                      }
                    }
                  },
                  [_vm._v("Aggiungi immagine")]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      : _c("div", { staticClass: "content" }, [
          _c("div", { class: { preview: true, img: _vm.image } }, [
            _c("div", { staticClass: "upload" }, [
              _c("img", { attrs: { src: _vm.image } })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action" }, [
            _c(
              "button",
              { staticClass: "btn-nobg--download", attrs: { type: "button" } },
              [_vm._v("Download")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-nobg--delete",
                attrs: { type: "button" },
                on: { click: _vm.removeImage }
              },
              [_vm._v("Cancella")]
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action" }, [
      _c(
        "button",
        {
          staticClass: "btn-nobg--download disabled",
          attrs: { type: "button" }
        },
        [_vm._v("Download")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-nobg--delete disabled", attrs: { type: "button" } },
        [_vm._v("Cancella")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c07f3c3", esExports)
  }
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_time_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7255e640_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_time_vue__ = __webpack_require__(101);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_time_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7255e640_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_time_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-time.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7255e640", Component.options)
  } else {
    hotAPI.reload("data-v-7255e640", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "text",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-time" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-time" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7255e640", esExports)
  }
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_upload_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a47cb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_upload_vue__ = __webpack_require__(103);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a47cb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-upload.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35a47cb4", Component.options)
  } else {
    hotAPI.reload("data-v-35a47cb4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-upload" },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "readonly-value" }, [
                  _vm._v(_vm._s(_vm.value))
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c(
              "label",
              { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
              [_vm._v(_vm._s(_vm.label))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-upload" }, [
                  _c("button", {
                    class: { open: _vm.showFilePicker },
                    attrs: { type: "button" },
                    on: { click: _vm.onShowFilePicker }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input", on: { click: _vm.onShowFilePicker } },
                [
                  _c("input", {
                    ref: "input",
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: _vm.entryId,
                      name: _vm.name,
                      placeholder: _vm.hasValue
                        ? null
                        : _vm.placeholder || _vm.label
                    },
                    domProps: { value: _vm.value },
                    on: {
                      focus: function($event) {
                        _vm.onFocus(true)
                      },
                      blur: function($event) {
                        _vm.onFocus(false)
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              false
                ? _c("div", { class: _vm.fileTypeClassName }, [
                    _c("div", { staticClass: "content" })
                  ])
                : _vm._e()
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.showFilePicker ? _c("file-picker") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-upload" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a47cb4", esExports)
  }
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_picker_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf297068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_file_picker_vue__ = __webpack_require__(105);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf297068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_file_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/file-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bf297068", Component.options)
  } else {
    hotAPI.reload("data-v-bf297068", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-popup" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "preview" }, [
        _c("div", { class: { upload: true, fill: _vm.actionBrowseHover } }, [
          _c("input", { attrs: { type: "file", name: "ip1", id: "ip1" } }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn-nobg--browse",
              attrs: { for: "ip1" },
              on: {
                mouseover: function($event) {
                  _vm.actionBrowseHover = true
                },
                mouseleave: function($event) {
                  _vm.actionBrowseHover = false
                }
              }
            },
            [
              _vm._v(
                "\n                    Aggiungi documento\n                "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action" }, [
      _c(
        "button",
        {
          staticClass: "btn-nobg--download disabled",
          attrs: { type: "button" }
        },
        [_vm._v("Download")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-nobg--delete disabled", attrs: { type: "button" } },
        [_vm._v("Cancella")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf297068", esExports)
  }
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_html_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be207c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_html_vue__ = __webpack_require__(116);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_html_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be207c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_html_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-html.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4be207c4", Component.options)
  } else {
    hotAPI.reload("data-v-4be207c4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setup */
/* unused harmony export schema */
/* harmony export (immutable) */ __webpack_exports__["a"] = createEditor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_history__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_menu__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menu__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keymap__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inputrules__ = __webpack_require__(113);
/* unused harmony reexport buildMenuItems */
/* unused harmony reexport buildKeymap */
/* unused harmony reexport buildInputRules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prosemirror_view__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prosemirror_model__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prosemirror_schema_list__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prosemirror_schema_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prosemirror_schema_list__);




//import { dropCursor } from 'prosemirror-dropcursor'






// !! This module exports helper functions for deriving a set of basic
// menu items, input rules, or key bindings from a schema. These
// values need to know about the schema for two reasons—they need
// access to specific instances of node and mark types, and they need
// to know which of the node and mark types that they know about are
// actually present in the schema.
//
// The `exampleSetup` plugin ties these together into a plugin that
// will automatically enable this basic functionality in an editor.
// :: (Object) → [Plugin]
// A convenience plugin that bundles together a simple menu with basic
// key bindings, input rules, and styling for the example schema.
// Probably only useful for quickly setting up a passable
// editor—you'll need more control over your settings in most
// real-world situations.
//
//   options::- The following options are recognized:
//
//     schema:: Schema
//     The schema to generate key bindings and menu items for.
//
//     mapKeys:: ?Object
//     Can be used to [adjust](#example-setup.buildKeymap) the key bindings created.
//
//     menuBar:: ?bool
//     Set to false to disable the menu bar.
//
//     menuContent:: [[MenuItem]]
//     Can be used to override the menu content.
function setup(options) {
    var plugins = [
        Object(__WEBPACK_IMPORTED_MODULE_8__inputrules__["a" /* buildInputRules */])(options.schema),
        Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(Object(__WEBPACK_IMPORTED_MODULE_7__keymap__["a" /* buildKeymap */])(options.schema, options.mapKeys)),
        Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__["baseKeymap"]),
        //dropCursor(),
        Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor__["gapCursor"])(),
        Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_history__["history"])()
    ];
    if (options.menuBar !== false) {
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_menu__["menuBar"])({
            floating: false,
            content: options.menuContent || Object(__WEBPACK_IMPORTED_MODULE_6__menu__["a" /* buildMenuItems */])(options.schema).fullMenu
        }));
    }
    return plugins.concat(new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Plugin"]({
        props: {
            attributes: { class: 'html-editor-wrapper' }
        }
    }));
}
// Default editor





// Mix the nodes from prosemirror-schema-list into the basic schema to
// create a schema with list support.
var schema = new __WEBPACK_IMPORTED_MODULE_10_prosemirror_model__["Schema"]({
    nodes: Object(__WEBPACK_IMPORTED_MODULE_12_prosemirror_schema_list__["addListNodes"])(__WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic__["schema"].spec.nodes, "paragraph block*", "block"),
    marks: __WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic__["schema"].spec.marks
});
function createEditor(node, initialContent, handleTransaction, handleFocus, handleBlur) {
    var content = document.createElement("div");
    content.innerHTML = initialContent;
    return new __WEBPACK_IMPORTED_MODULE_9_prosemirror_view__["EditorView"](node, {
        state: __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["EditorState"].create({
            doc: __WEBPACK_IMPORTED_MODULE_10_prosemirror_model__["DOMParser"].fromSchema(schema).parse(content),
            plugins: setup({ schema: schema })
        }),
        dispatchTransaction: handleTransaction,
        handleDOMEvents: {
            focus: handleFocus,
            blur: handleBlur
        }
    });
}


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(62);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMenuItems;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_schema_list__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_schema_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_schema_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prompt__ = __webpack_require__(111);





// Helpers to create specific types of items
function canInsert(state, nodeType) {
    var $from = state.selection.$from;
    for (var d = $from.depth; d >= 0; d--) {
        var index = $from.index(d);
        if ($from.node(d).canReplaceWith(index, index, nodeType)) {
            return true;
        }
    }
    return false;
}
function insertImageItem(nodeType) {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["MenuItem"]({
        title: 'Insert image',
        label: 'Image',
        enable: function (state) { return canInsert(state, nodeType); },
        run: function (state, _, view) {
            var _a = state.selection, from = _a.from, to = _a.to, attrs = null;
            if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"] && state.selection.node.type == nodeType)
                attrs = state.selection.node.attrs;
            Object(__WEBPACK_IMPORTED_MODULE_4__prompt__["b" /* openPrompt */])({
                title: 'Insert image',
                fields: {
                    src: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({ label: 'Location', required: true, value: attrs && attrs.src }),
                    title: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({ label: 'Title', value: attrs && attrs.title }),
                    alt: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({
                        label: 'Description',
                        value: attrs ? attrs.alt : state.doc.textBetween(from, to, ' ')
                    })
                },
                callback: function (attrs) {
                    view.dispatch(view.state.tr.replaceSelectionWith(nodeType.createAndFill(attrs)));
                    view.focus();
                }
            });
        }
    });
}
function cmdItem(cmd, options) {
    var passedOptions = {
        label: options.title,
        run: cmd
    };
    for (var prop in options)
        passedOptions[prop] = options[prop];
    if ((!options.enable || options.enable === true) && !options.select)
        passedOptions[options.enable ? 'enable' : 'select'] = function (state) { return cmd(state); };
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["MenuItem"](passedOptions);
}
function markActive(state, type) {
    var _a = state.selection, from = _a.from, $from = _a.$from, to = _a.to, empty = _a.empty;
    if (empty) {
        return type.isInSet(state.storedMarks || $from.marks());
    }
    else {
        return state.doc.rangeHasMark(from, to, type);
    }
}
function markItem(markType, options) {
    var passedOptions = {
        active: function (state) { return markActive(state, markType); },
        enable: true
    };
    for (var prop in options) {
        passedOptions[prop] = options[prop];
    }
    return cmdItem(Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__["toggleMark"])(markType), passedOptions);
}
function linkItem(markType) {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["MenuItem"]({
        title: 'Add or remove link',
        icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].link,
        active: function (state) { return markActive(state, markType); },
        enable: function (state) { return !state.selection.empty; },
        run: function (state, dispatch, view) {
            if (markActive(state, markType)) {
                Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__["toggleMark"])(markType)(state, dispatch);
                return true;
            }
            Object(__WEBPACK_IMPORTED_MODULE_4__prompt__["b" /* openPrompt */])({
                title: 'Create a link',
                fields: {
                    href: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({
                        label: 'Link target',
                        required: true
                    }),
                    title: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({ label: 'Title' })
                },
                callback: function (attrs) {
                    Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__["toggleMark"])(markType, attrs)(view.state, view.dispatch);
                    view.focus();
                }
            });
        }
    });
}
function wrapListItem(nodeType, options) {
    return cmdItem(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_schema_list__["wrapInList"])(nodeType, options.attrs), options);
}
// :: (Schema) → Object
// Given a schema, look for default mark and node types in it and
// return an object with relevant menu items relating to those marks:
//
// **`toggleStrong`**`: MenuItem`
//   : A menu item to toggle the [strong mark](#schema-basic.StrongMark).
//
// **`toggleEm`**`: MenuItem`
//   : A menu item to toggle the [emphasis mark](#schema-basic.EmMark).
//
// **`toggleCode`**`: MenuItem`
//   : A menu item to toggle the [code font mark](#schema-basic.CodeMark).
//
// **`toggleLink`**`: MenuItem`
//   : A menu item to toggle the [link mark](#schema-basic.LinkMark).
//
// **`insertImage`**`: MenuItem`
//   : A menu item to insert an [image](#schema-basic.Image).
//
// **`wrapBulletList`**`: MenuItem`
//   : A menu item to wrap the selection in a [bullet list](#schema-list.BulletList).
//
// **`wrapOrderedList`**`: MenuItem`
//   : A menu item to wrap the selection in an [ordered list](#schema-list.OrderedList).
//
// **`wrapBlockQuote`**`: MenuItem`
//   : A menu item to wrap the selection in a [block quote](#schema-basic.BlockQuote).
//
// **`makeParagraph`**`: MenuItem`
//   : A menu item to set the current textblock to be a normal
//     [paragraph](#schema-basic.Paragraph).
//
// **`makeCodeBlock`**`: MenuItem`
//   : A menu item to set the current textblock to be a
//     [code block](#schema-basic.CodeBlock).
//
// **`makeHead[N]`**`: MenuItem`
//   : Where _N_ is 1 to 6. Menu items to set the current textblock to
//     be a [heading](#schema-basic.Heading) of level _N_.
//
// **`insertHorizontalRule`**`: MenuItem`
//   : A menu item to insert a horizontal rule.
//
// The return value also contains some prefabricated menu elements and
// menus, that you can use instead of composing your own menu from
// scratch:
//
// **`insertMenu`**`: Dropdown`
//   : A dropdown containing the `insertImage` and
//     `insertHorizontalRule` items.
//
// **`typeMenu`**`: Dropdown`
//   : A dropdown containing the items for making the current
//     textblock a paragraph, code block, or heading.
//
// **`fullMenu`**`: [[MenuElement]]`
//   : An array of arrays of menu elements for use as the full menu
//     for, for example the [menu bar](https://github.com/prosemirror/prosemirror-menu#user-content-menubar).
function buildMenuItems(schema) {
    var r = {}, type;
    if (type = schema.marks.strong) {
        r.toggleStrong = markItem(type, {
            title: 'Toggle strong style',
            icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].strong
        });
    }
    if (type = schema.marks.em) {
        r.toggleEm = markItem(type, {
            title: 'Toggle emphasis',
            icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].em
        });
    }
    if (type = schema.marks.link) {
        r.toggleLink = linkItem(type);
    }
    if (type = schema.nodes.bullet_list) {
        r.wrapBulletList = wrapListItem(type, {
            title: 'Wrap in bullet list',
            icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].bulletList
        });
    }
    if (type = schema.nodes.ordered_list) {
        r.wrapOrderedList = wrapListItem(type, {
            title: 'Wrap in ordered list',
            icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].orderedList
        });
    }
    /* if (type = schema.nodes.image)
        r.insertImage = insertImageItem(type) */
    /* if (type = schema.marks.code)
        r.toggleCode = markItem(type, { title: 'Toggle code font', icon: icons.code }) */
    /* if (type = schema.nodes.blockquote)
        r.wrapBlockQuote = wrapItem(type, {
            title: 'Wrap in block quote',
            icon: icons.blockquote
        }) */
    /* if (type = schema.nodes.paragraph)
        r.makeParagraph = blockTypeItem(type, {
            title: 'Change to paragraph',
            label: 'Plain'
        }) */
    /* if (type = schema.nodes.code_block)
        r.makeCodeBlock = blockTypeItem(type, {
            title: 'Change to code block',
            label: 'Code'
        }) */
    /* if (type = schema.nodes.heading)
        for (let i = 1; i <= 10; i++)
            r['makeHead' + i] = blockTypeItem(type, {
                title: 'Change to heading ' + i,
                label: 'Level ' + i,
                attrs: { level: i }
            }) */
    /* if (type = schema.nodes.horizontal_rule) {
        let hr = type
        r.insertHorizontalRule = new MenuItem(<any>{
            title: 'Insert horizontal rule',
            label: 'Horizontal rule',
            enable(state: any) { return canInsert(state, hr) },
            run(state: any, dispatch: any) { dispatch(state.tr.replaceSelectionWith(hr.create())) }
        })
    } */
    var cut = function (arr) { return arr.filter(function (x) { return x; }); };
    r.fullMenu = [cut([r.toggleStrong, r.toggleEm, r.toggleCode, r.toggleLink, __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["undoItem"], __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["redoItem"], r.wrapBulletList, r.wrapOrderedList])];
    return r;
}


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = openPrompt;
/* unused harmony export Field */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextField; });
/* unused harmony export SelectField */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var prefix = "html-editor-popup";
function openPrompt(options) {
    var wrapper = document.body.appendChild(document.createElement("div"));
    wrapper.className = prefix;
    var mouseOutside = function (e) { if (!wrapper.contains(e.target))
        close(); };
    setTimeout(function () { return window.addEventListener("mousedown", mouseOutside); }, 50);
    var close = function () {
        window.removeEventListener("mousedown", mouseOutside);
        if (wrapper.parentNode)
            wrapper.parentNode.removeChild(wrapper);
    };
    var domFields = [];
    for (var name_1 in options.fields)
        domFields.push(options.fields[name_1].render());
    var submitButton = document.createElement("button");
    submitButton.type = "submit";
    submitButton.className = prefix + "-submit";
    submitButton.textContent = "OK";
    var cancelButton = document.createElement("button");
    cancelButton.type = "button";
    cancelButton.className = prefix + "-cancel";
    cancelButton.textContent = "Cancel";
    cancelButton.addEventListener("click", close);
    var form = wrapper.appendChild(document.createElement("form"));
    if (options.title)
        form.appendChild(document.createElement("h5")).textContent = options.title;
    domFields.forEach(function (field) {
        form.appendChild(document.createElement("div")).appendChild(field);
    });
    var buttons = form.appendChild(document.createElement("div"));
    buttons.className = prefix + "-buttons";
    buttons.appendChild(submitButton);
    buttons.appendChild(document.createTextNode(" "));
    buttons.appendChild(cancelButton);
    var box = wrapper.getBoundingClientRect();
    wrapper.style.top = ((window.innerHeight - box.height) / 2) + "px";
    wrapper.style.left = ((window.innerWidth - box.width) / 2) + "px";
    var submit = function () {
        var params = getValues(options.fields, domFields);
        if (params) {
            close();
            options.callback(params);
        }
    };
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        submit();
    });
    form.addEventListener("keydown", function (e) {
        if (e.keyCode == 27) {
            e.preventDefault();
            close();
        }
        else if (e.keyCode == 13 && !(e.ctrlKey || e.metaKey || e.shiftKey)) {
            e.preventDefault();
            submit();
        }
        else if (e.keyCode == 9) {
            window.setTimeout(function () {
                if (!wrapper.contains(document.activeElement))
                    close();
            }, 500);
        }
    });
    var input = form.elements[0];
    if (input)
        input.focus();
}
function getValues(fields, domFields) {
    var result = Object.create(null), i = 0;
    for (var name_2 in fields) {
        var field = fields[name_2], dom = domFields[i++];
        var value = field.read(dom), bad = field.validate(value);
        if (bad) {
            reportInvalid(dom, bad);
            return null;
        }
        result[name_2] = field.clean(value);
    }
    return result;
}
function reportInvalid(dom, message) {
    // FIXME this is awful and needs a lot more work
    var parent = dom.parentNode;
    var msg = parent.appendChild(document.createElement("div"));
    msg.style.left = (dom.offsetLeft + dom.offsetWidth + 2) + "px";
    msg.style.top = (dom.offsetTop - 5) + "px";
    msg.className = "html-editor-invalid";
    msg.textContent = message;
    setTimeout(function () { return parent.removeChild(msg); }, 1500);
}
// ::- The type of field that `FieldPrompt` expects to be passed to it.
var Field = /** @class */ (function () {
    // :: (Object)
    // Create a field with the given options. Options support by all
    // field types are:
    //
    // **`value`**`: ?any`
    //   : The starting value for the field.
    //
    // **`label`**`: string`
    //   : The label for the field.
    //
    // **`required`**`: ?bool`
    //   : Whether the field is required.
    //
    // **`validate`**`: ?(any) → ?string`
    //   : A function to validate the given value. Should return an
    //     error message if it is not valid.
    function Field(options) {
        this.options = options;
    }
    // render:: (state: EditorState, props: Object) → dom.Node
    // Render the field to the DOM. Should be implemented by all subclasses.
    // :: (dom.Node) → any
    // Read the field's value from its DOM node.
    Field.prototype.read = function (dom) { return dom.value; };
    // :: (any) → ?string
    // A field-type-specific validation function.
    Field.prototype.validateType = function (_value) { };
    Field.prototype.validate = function (value) {
        if (!value && this.options.required)
            return "Required field";
        return this.validateType(value) || (this.options.validate && this.options.validate(value));
    };
    Field.prototype.clean = function (value) {
        return this.options.clean ? this.options.clean(value) : value;
    };
    return Field;
}());

// ::- A field class for single-line text fields.
var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextField.prototype.render = function () {
        var input = document.createElement("input");
        input.type = "text";
        input.placeholder = this.options.label;
        input.value = this.options.value || "";
        input.autocomplete = "off";
        return input;
    };
    return TextField;
}(Field));

// ::- A field class for dropdown fields based on a plain `<select>`
// tag. Expects an option `options`, which should be an array of
// `{value: string, label: string}` objects, or a function taking a
// `ProseMirror` instance and returning such an array.
var SelectField = /** @class */ (function (_super) {
    __extends(SelectField, _super);
    function SelectField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectField.prototype.render = function () {
        var _this = this;
        var select = document.createElement("select");
        this.options.options.forEach(function (o) {
            var opt = select.appendChild(document.createElement("option"));
            opt.value = o.value;
            opt.selected = o.value == _this.options.value;
            opt.label = o.label;
        });
        return select;
    };
    return SelectField;
}(Field));



/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildKeymap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_inputrules__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_inputrules__);




var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : false;
// :: (Schema, ?Object) → Object
// Inspect the given schema looking for marks and nodes from the
// basic schema, and if found, add key bindings related to them.
// This will add:
//
// * **Mod-b** for toggling [strong](#schema-basic.StrongMark)
// * **Mod-i** for toggling [emphasis](#schema-basic.EmMark)
// * **Mod-`** for toggling [code font](#schema-basic.CodeMark)
// * **Ctrl-Shift-0** for making the current textblock a paragraph
// * **Ctrl-Shift-1** to **Ctrl-Shift-Digit6** for making the current
//   textblock a heading of the corresponding level
// * **Ctrl-Shift-Backslash** to make the current textblock a code block
// * **Ctrl-Shift-8** to wrap the selection in an ordered list
// * **Ctrl-Shift-9** to wrap the selection in a bullet list
// * **Ctrl->** to wrap the selection in a block quote
// * **Enter** to split a non-empty textblock in a list item while at
//   the same time splitting the list item
// * **Mod-Enter** to insert a hard break
// * **Mod-_** to insert a horizontal rule
// * **Backspace** to undo an input rule
// * **Alt-ArrowUp** to `joinUp`
// * **Alt-ArrowDown** to `joinDown`
// * **Mod-BracketLeft** to `lift`
// * **Escape** to `selectParentNode`
//
// You can suppress or map these bindings by passing a `mapKeys`
// argument, which maps key names (say `"Mod-B"` to either `false`, to
// remove the binding, or a new key name string.
function buildKeymap(schema, mapKeys) {
    var keys = {}, type;
    function bind(key, cmd) {
        if (mapKeys) {
            var mapped = mapKeys[key];
            if (mapped === false) {
                return;
            }
            if (mapped) {
                key = mapped;
            }
        }
        keys[key] = cmd;
    }
    bind("Mod-z", __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__["undo"]);
    bind("Shift-Mod-z", __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__["redo"]);
    bind("Backspace", __WEBPACK_IMPORTED_MODULE_3_prosemirror_inputrules__["undoInputRule"]);
    if (!mac) {
        bind("Mod-y", __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__["redo"]);
    }
    bind("Alt-ArrowUp", __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["joinUp"]);
    bind("Alt-ArrowDown", __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["joinDown"]);
    bind("Mod-BracketLeft", __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["lift"]);
    bind("Escape", __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["selectParentNode"]);
    if (type = schema.marks.strong) {
        bind("Mod-b", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(type));
    }
    if (type = schema.marks.em) {
        bind("Mod-i", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(type));
    }
    if (type = schema.marks.code) {
        bind("Mod-`", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(type));
    }
    if (type = schema.nodes.bullet_list) {
        bind("Shift-Ctrl-8", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["wrapInList"])(type));
    }
    if (type = schema.nodes.ordered_list) {
        bind("Shift-Ctrl-9", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["wrapInList"])(type));
    }
    if (type = schema.nodes.blockquote) {
        bind("Ctrl->", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["wrapIn"])(type));
    }
    if (type = schema.nodes.hard_break) {
        var br_1 = type, cmd = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["chainCommands"])(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["exitCode"], function (state, dispatch) {
            dispatch(state.tr.replaceSelectionWith(br_1.create()).scrollIntoView());
            return true;
        });
        bind("Mod-Enter", cmd);
        bind("Shift-Enter", cmd);
        if (mac) {
            bind("Ctrl-Enter", cmd);
        }
    }
    if (type = schema.nodes.list_item) {
        bind("Enter", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["splitListItem"])(type));
        bind("Mod-[", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["liftListItem"])(type));
        bind("Mod-]", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["sinkListItem"])(type));
    }
    if (type = schema.nodes.paragraph) {
        bind("Shift-Ctrl-0", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["setBlockType"])(type));
    }
    if (type = schema.nodes.code_block) {
        bind("Shift-Ctrl-\\", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["setBlockType"])(type));
    }
    if (type = schema.nodes.heading) {
        for (var i = 1; i <= 6; i++) {
            bind("Shift-Ctrl-" + i, Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["setBlockType"])(type, { level: i }));
        }
    }
    if (type = schema.nodes.horizontal_rule) {
        var hr_1 = type;
        bind("Mod-_", function (state, dispatch) {
            dispatch(state.tr.replaceSelectionWith(hr_1.create()).scrollIntoView());
            return true;
        });
    }
    return keys;
}


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blockQuoteRule */
/* unused harmony export orderedListRule */
/* unused harmony export bulletListRule */
/* unused harmony export codeBlockRule */
/* unused harmony export headingRule */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildInputRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__);

// : (NodeType) → InputRule
// Given a blockquote node type, returns an input rule that turns `'> '`
// at the start of a textblock into a blockquote.
function blockQuoteRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["wrappingInputRule"])(/^\s*>\s$/, nodeType);
}
// : (NodeType) → InputRule
// Given a list node type, returns an input rule that turns a number
// followed by a dot at the start of a textblock into an ordered list.
function orderedListRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["wrappingInputRule"])(/^(\d+)\.\s$/, nodeType, function (match) { return ({ order: +match[1] }); }, function (match, node) { return node.childCount + node.attrs.order == +match[1]; });
}
// : (NodeType) → InputRule
// Given a list node type, returns an input rule that turns a bullet
// (dash, plush, or asterisk) at the start of a textblock into a
// bullet list.
function bulletListRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["wrappingInputRule"])(/^\s*([-+*])\s$/, nodeType);
}
// : (NodeType) → InputRule
// Given a code block node type, returns an input rule that turns a
// textblock starting with three backticks into a code block.
function codeBlockRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["textblockTypeInputRule"])(/^```$/, nodeType);
}
// : (NodeType, number) → InputRule
// Given a node type and a maximum level, creates an input rule that
// turns up to that number of `#` characters followed by a space at
// the start of a textblock into a heading whose level corresponds to
// the number of `#` signs.
function headingRule(nodeType, maxLevel) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["textblockTypeInputRule"])(new RegExp('^(#{1,' + maxLevel + '})\\s$'), nodeType, function (match) { return ({ level: match[1].length }); });
}
// : (Schema) → Plugin
// A set of input rules for creating the basic block quotes, lists,
// code blocks, and heading.
function buildInputRules(schema) {
    var rules = __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["smartQuotes"].concat(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["ellipsis"], __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["emDash"]), type;
    if (type = schema.nodes.blockquote) {
        rules.push(blockQuoteRule(type));
    }
    if (type = schema.nodes.ordered_list) {
        rules.push(orderedListRule(type));
    }
    if (type = schema.nodes.bullet_list) {
        rules.push(bulletListRule(type));
    }
    if (type = schema.nodes.code_block) {
        rules.push(codeBlockRule(type));
    }
    if (type = schema.nodes.heading) {
        rules.push(headingRule(type, 6));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["inputRules"])({ rules: rules });
}


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(14);

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(63);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-entry-html" }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            ref: "textarea",
            staticStyle: { display: "none" },
            attrs: { id: _vm.entryId, name: _vm.name },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.value = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { ref: "editor" })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4be207c4", esExports)
  }
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=pack.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(8);

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content
}

OrderedMap.prototype = {
  constructor: OrderedMap,

  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i
    return -1
  },

  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found = this.find(key)
    return found == -1 ? undefined : this.content[found + 1]
  },

  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this
    var found = self.find(key), content = self.content.slice()
    if (found == -1) {
      content.push(newKey || key, value)
    } else {
      content[found + 1] = value
      if (newKey) content[found] = newKey
    }
    return new OrderedMap(content)
  },

  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found = this.find(key)
    if (found == -1) return this
    var content = this.content.slice()
    content.splice(found, 2)
    return new OrderedMap(content)
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content))
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice()
    content.push(key, value)
    return new OrderedMap(content)
  },

  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice()
    var found = without.find(place)
    content.splice(found == -1 ? content.length : found, 0, key, value)
    return new OrderedMap(content)
  },

  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1])
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map) {
    map = OrderedMap.from(map)
    if (!map.size) return this
    return new OrderedMap(map.content.concat(this.subtract(map).content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map) {
    map = OrderedMap.from(map)
    if (!map.size) return this
    return new OrderedMap(this.subtract(map).content.concat(map.content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map) {
    var result = this
    map = OrderedMap.from(map)
    for (var i = 0; i < map.content.length; i += 2)
      result = result.remove(map.content[i])
    return result
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1
  }
}

// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value
  var content = []
  if (value) for (var prop in value) content.push(prop, value[prop])
  return new OrderedMap(content)
}

module.exports = OrderedMap


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorTransform = __webpack_require__(7);
var prosemirrorModel = __webpack_require__(6);

var olDOM = ["ol", 0];
var ulDOM = ["ul", 0];
var liDOM = ["li", 0];

// :: NodeSpec
// An ordered list [node spec](#model.NodeSpec). Has a single
// attribute, `order`, which determines the number at which the list
// starts counting, and defaults to 1. Represented as an `<ol>`
// element.
var orderedList = {
  attrs: {order: {default: 1}},
  parseDOM: [{tag: "ol", getAttrs: function getAttrs(dom) {
    return {order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1}
  }}],
  toDOM: function toDOM(node) {
    return node.attrs.order == 1 ? olDOM : ["ol", {start: node.attrs.order}, 0]
  }
};

// :: NodeSpec
// A bullet list node spec, represented in the DOM as `<ul>`.
var bulletList = {
  parseDOM: [{tag: "ul"}],
  toDOM: function toDOM() { return ulDOM }
};

// :: NodeSpec
// A list item (`<li>`) spec.
var listItem = {
  parseDOM: [{tag: "li"}],
  toDOM: function toDOM() { return liDOM },
  defining: true
};

function add(obj, props) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  for (var prop$1 in props) { copy[prop$1] = props[prop$1]; }
  return copy
}

// :: (OrderedMap<NodeSpec>, string, ?string) → OrderedMap<NodeSpec>
// Convenience function for adding list-related node types to a map
// specifying the nodes for a schema. Adds
// [`orderedList`](#schema-list.orderedList) as `"ordered_list"`,
// [`bulletList`](#schema-list.bulletList) as `"bullet_list"`, and
// [`listItem`](#schema-list.listItem) as `"list_item"`.
//
// `itemContent` determines the content expression for the list items.
// If you want the commands defined in this module to apply to your
// list structure, it should have a shape like `"paragraph block*"` or
// `"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
// given to assign a group name to the list node types, for example
// `"block"`.
function addListNodes(nodes, itemContent, listGroup) {
  return nodes.append({
    ordered_list: add(orderedList, {content: "list_item+", group: listGroup}),
    bullet_list: add(bulletList, {content: "list_item+", group: listGroup}),
    list_item: add(listItem, {content: itemContent})
  })
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function wrapInList(listType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), doJoin = false, outerRange = range;
    if (!range) { return false }
    // This is at the top of an existing list item
    if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
      // Don't do anything if this is the top of the list
      if ($from.index(range.depth - 1) == 0) { return false }
      var $insert = state.doc.resolve(range.start - 2);
      outerRange = new prosemirrorModel.NodeRange($insert, $insert, range.depth);
      if (range.endIndex < range.parent.childCount)
        { range = new prosemirrorModel.NodeRange($from, state.doc.resolve($to.end(range.depth)), range.depth); }
      doJoin = true;
    }
    var wrap = prosemirrorTransform.findWrapping(outerRange, listType, attrs, range);
    if (!wrap) { return false }
    if (dispatch) { dispatch(doWrapInList(state.tr, range, wrap, doJoin, listType).scrollIntoView()); }
    return true
  }
}

function doWrapInList(tr, range, wrappers, joinBefore, listType) {
  var content = prosemirrorModel.Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = prosemirrorModel.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  tr.step(new prosemirrorTransform.ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end,
                                new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true));

  var found = 0;
  for (var i$1 = 0; i$1 < wrappers.length; i$1++) { if (wrappers[i$1].type == listType) { found = i$1 + 1; } }
  var splitDepth = wrappers.length - found;

  var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
  for (var i$2 = range.startIndex, e = range.endIndex, first = true; i$2 < e; i$2++, first = false) {
    if (!first && prosemirrorTransform.canSplit(tr.doc, splitPos, splitDepth)) {
      tr.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent.child(i$2).nodeSize;
  }
  return tr
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Build a command that splits a non-empty textblock at the top level
// of a list item by also splitting that list item.
function splitListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var node = ref.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) { return false }
    var grandParent = $from.node(-1);
    if (grandParent.type != itemType) { return false }
    if ($from.parent.content.size == 0) {
      // In an empty block. If this is a nested list, the wrapping
      // list item should be split. Otherwise, bail out and let next
      // command handle lifting.
      if ($from.depth == 2 || $from.node(-3).type != itemType ||
          $from.index(-2) != $from.node(-2).childCount - 1) { return false }
      if (dispatch) {
        var wrap = prosemirrorModel.Fragment.empty, keepItem = $from.index(-1) > 0;
        // Build a fragment containing empty versions of the structure
        // from the outer list item to the parent node of the cursor
        for (var d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--)
          { wrap = prosemirrorModel.Fragment.from($from.node(d).copy(wrap)); }
        // Add a second list item with an empty default start node
        wrap = wrap.append(prosemirrorModel.Fragment.from(itemType.createAndFill()));
        var tr$1 = state.tr.replace($from.before(keepItem ? null : -1), $from.after(-3), new prosemirrorModel.Slice(wrap, keepItem ? 3 : 2, 2));
        tr$1.setSelection(state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
        dispatch(tr$1.scrollIntoView());
      }
      return true
    }
    var nextType = $to.pos == $from.end() ? grandParent.defaultContentType(0) : null;
    var tr = state.tr.delete($from.pos, $to.pos);
    var types = nextType && [null, {type: nextType}];
    if (!prosemirrorTransform.canSplit(tr.doc, $from.pos, 2, types)) { return false }
    if (dispatch) { dispatch(tr.split($from.pos, 2, types).scrollIntoView()); }
    return true
  }
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function liftListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    if (!dispatch) { return true }
    if ($from.node(range.depth - 1).type == itemType) // Inside a parent list
      { return liftToOuterList(state, dispatch, itemType, range) }
    else // Outer list node
      { return liftOutOfList(state, dispatch, range) }
  }
}

function liftToOuterList(state, dispatch, itemType, range) {
  var tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
  if (end < endOfList) {
    // There are siblings after the lifted items, which must become
    // children of the last item
    tr.step(new prosemirrorTransform.ReplaceAroundStep(end - 1, endOfList, end, endOfList,
                                  new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new prosemirrorModel.NodeRange(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
  }
  dispatch(tr.lift(range, prosemirrorTransform.liftTarget(range)).scrollIntoView());
  return true
}

function liftOutOfList(state, dispatch, range) {
  var tr = state.tr, list = range.parent;
  // Merge the list items into a single big item
  for (var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    tr.delete(pos - 1, pos + 1);
  }
  var $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
  var atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
  var parent = $start.node(-1), indexBefore = $start.index(-1);
  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1,
                         item.content.append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list))))
    { return false }
  var start = $start.pos, end = start + item.nodeSize;
  // Strip off the surrounding list. At the sides where we're not at
  // the end of the list, the existing list is closed. At sides where
  // this is the end, it is overwritten to its end.
  tr.step(new prosemirrorTransform.ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1,
                                new prosemirrorModel.Slice((atStart ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty)))
                                          .append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty))),
                                          atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
  dispatch(tr.scrollIntoView());
  return true
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to sink the list item around the selection down
// into an inner list.
function sinkListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    var startIndex = range.startIndex;
    if (startIndex == 0) { return false }
    var parent = range.parent, nodeBefore = parent.child(startIndex - 1);
    if (nodeBefore.type != itemType) { return false }

    if (dispatch) {
      var nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
      var inner = prosemirrorModel.Fragment.from(nestedBefore ? itemType.create() : null);
      var slice = new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(itemType.create(null, prosemirrorModel.Fragment.from(parent.copy(inner)))),
                            nestedBefore ? 3 : 1, 0);
      var before = range.start, after = range.end;
      dispatch(state.tr.step(new prosemirrorTransform.ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after,
                                                   before, after, slice, 1, true))
               .scrollIntoView());
    }
    return true
  }
}

exports.orderedList = orderedList;
exports.bulletList = bulletList;
exports.listItem = listItem;
exports.addListNodes = addListNodes;
exports.wrapInList = wrapInList;
exports.splitListItem = splitListItem;
exports.liftListItem = liftListItem;
exports.sinkListItem = sinkListItem;
//# sourceMappingURL=schema-list.js.map


/***/ }),
/* 57 */
/***/ (function(module, exports) {

var GOOD_LEAF_SIZE = 200

// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var RopeSequence = function RopeSequence () {};

RopeSequence.prototype.append = function append (other) {
  if (!other.length) { return this }
  other = RopeSequence.from(other)

  return (!this.length && other) ||
    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
    this.appendInner(other)
};

// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
RopeSequence.prototype.prepend = function prepend (other) {
  if (!other.length) { return this }
  return RopeSequence.from(other).append(this)
};

RopeSequence.prototype.appendInner = function appendInner (other) {
  return new Append(this, other)
};

// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
RopeSequence.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from >= to) { return RopeSequence.empty }
  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
};

// :: (number) → T
// Retrieve the element at the given position from this rope.
RopeSequence.prototype.get = function get (i) {
  if (i < 0 || i >= this.length) { return undefined }
  return this.getInner(i)
};

// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
RopeSequence.prototype.forEach = function forEach (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from <= to)
    { this.forEachInner(f, from, to, 0) }
  else
    { this.forEachInvertedInner(f, from, to, 0) }
};

// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
RopeSequence.prototype.map = function map (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  var result = []
  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to)
  return result
};

// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
RopeSequence.from = function from (values) {
  if (values instanceof RopeSequence) { return values }
  return values && values.length ? new Leaf(values) : RopeSequence.empty
};

var Leaf = (function (RopeSequence) {
  function Leaf(values) {
    RopeSequence.call(this)
    this.values = values
  }

  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Leaf.prototype.constructor = Leaf;

  var prototypeAccessors = { length: {},depth: {} };

  Leaf.prototype.flatten = function flatten () {
    return this.values
  };

  Leaf.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    return new Leaf(this.values.slice(from, to))
  };

  Leaf.prototype.getInner = function getInner (i) {
    return this.values[i]
  };

  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var this$1 = this;

    for (var i = from; i < to; i++)
      { if (f(this$1.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var this$1 = this;

    for (var i = from - 1; i >= to; i--)
      { if (f(this$1.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.leafAppend = function leafAppend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(this.values.concat(other.flatten())) }
  };

  Leaf.prototype.leafPrepend = function leafPrepend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(other.flatten().concat(this.values)) }
  };

  prototypeAccessors.length.get = function () { return this.values.length };

  prototypeAccessors.depth.get = function () { return 0 };

  Object.defineProperties( Leaf.prototype, prototypeAccessors );

  return Leaf;
}(RopeSequence));

// :: RopeSequence
// The empty rope sequence.
RopeSequence.empty = new Leaf([])

var Append = (function (RopeSequence) {
  function Append(left, right) {
    RopeSequence.call(this)
    this.left = left
    this.right = right
    this.length = left.length + right.length
    this.depth = Math.max(left.depth, right.depth) + 1
  }

  if ( RopeSequence ) Append.__proto__ = RopeSequence;
  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Append.prototype.constructor = Append;

  Append.prototype.flatten = function flatten () {
    return this.left.flatten().concat(this.right.flatten())
  };

  Append.prototype.getInner = function getInner (i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
  };

  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var leftLen = this.left.length
    if (from < leftLen &&
        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
      { return false }
    if (to > leftLen &&
        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
      { return false }
  };

  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var leftLen = this.left.length
    if (from > leftLen &&
        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
      { return false }
    if (to < leftLen &&
        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
      { return false }
  };

  Append.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    var leftLen = this.left.length
    if (to <= leftLen) { return this.left.slice(from, to) }
    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
  };

  Append.prototype.leafAppend = function leafAppend (other) {
    var inner = this.right.leafAppend(other)
    if (inner) { return new Append(this.left, inner) }
  };

  Append.prototype.leafPrepend = function leafPrepend (other) {
    var inner = this.left.leafPrepend(other)
    if (inner) { return new Append(inner, this.right) }
  };

  Append.prototype.appendInner = function appendInner (other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
      { return new Append(this.left, new Append(this.right, other)) }
    return new Append(this, other)
  };

  return Append;
}(RopeSequence));

module.exports = RopeSequence


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var crel = _interopDefault(__webpack_require__(59));
var prosemirrorCommands = __webpack_require__(11);
var prosemirrorHistory = __webpack_require__(12);
var prosemirrorState = __webpack_require__(5);

var SVG = "http://www.w3.org/2000/svg";
var XLINK = "http://www.w3.org/1999/xlink";

var prefix$1 = "ProseMirror-icon";

function hashPath(path) {
  var hash = 0;
  for (var i = 0; i < path.length; i++)
    { hash = (((hash << 5) - hash) + path.charCodeAt(i)) | 0; }
  return hash
}

function getIcon(icon) {
  var node = document.createElement("div");
  node.className = prefix$1;
  if (icon.path) {
    var name = "pm-icon-" + hashPath(icon.path).toString(16);
    if (!document.getElementById(name)) { buildSVG(name, icon); }
    var svg = node.appendChild(document.createElementNS(SVG, "svg"));
    svg.style.width = (icon.width / icon.height) + "em";
    var use = svg.appendChild(document.createElementNS(SVG, "use"));
    use.setAttributeNS(XLINK, "href", /([^#]*)/.exec(document.location)[1] + "#" + name);
  } else if (icon.dom) {
    node.appendChild(icon.dom.cloneNode(true));
  } else {
    node.appendChild(document.createElement("span")).textContent = icon.text || '';
    if (icon.css) { node.firstChild.style.cssText = icon.css; }
  }
  return node
}

function buildSVG(name, data) {
  var collection = document.getElementById(prefix$1 + "-collection");
  if (!collection) {
    collection = document.createElementNS(SVG, "svg");
    collection.id = prefix$1 + "-collection";
    collection.style.display = "none";
    document.body.insertBefore(collection, document.body.firstChild);
  }
  var sym = document.createElementNS(SVG, "symbol");
  sym.id = name;
  sym.setAttribute("viewBox", "0 0 " + data.width + " " + data.height);
  var path = sym.appendChild(document.createElementNS(SVG, "path"));
  path.setAttribute("d", data.path);
  collection.appendChild(sym);
}

var prefix = "ProseMirror-menu";

// ::- An icon or label that, when clicked, executes a command.
var MenuItem = function MenuItem(spec) {
  // :: MenuItemSpec
  // The spec used to create the menu item.
  this.spec = spec;
};

// :: (EditorView) → {dom: dom.Node, update: (EditorState) → bool}
// Renders the icon according to its [display
// spec](#menu.MenuItemSpec.display), and adds an event handler which
// executes the command when the representation is clicked.
MenuItem.prototype.render = function render (view) {
  var spec = this.spec;
  var dom = spec.render ? spec.render(view)
      : spec.icon ? getIcon(spec.icon)
      : spec.label ? crel("div", null, translate(view, spec.label))
      : null;
  if (!dom) { throw new RangeError("MenuItem without icon or label property") }
  if (spec.title) {
    var title = (typeof spec.title === "function" ? spec.title(view.state) : spec.title);
    dom.setAttribute("title", translate(view, title));
  }
  if (spec.class) { dom.classList.add(spec.class); }
  if (spec.css) { dom.style.cssText += spec.css; }

  dom.addEventListener("mousedown", function (e) {
    e.preventDefault();
    spec.run(view.state, view.dispatch, view, e);
  });

  function update(state) {
    if (spec.select) {
      var selected = spec.select(state);
      dom.style.display = selected ? "" : "none";
      if (!selected) { return false }
    }
    var enabled = true;
    if (spec.enable) {
      enabled = spec.enable(state) || false;
      setClass(dom, prefix + "-disabled", !enabled);
    }
    if (spec.active) {
      var active = enabled && spec.active(state) || false;
      setClass(dom, prefix + "-active", active);
    }
    return true
  }

  return {dom: dom, update: update}
};

function translate(view, text) {
  return view._props.translate ? view._props.translate(text) : text
}

// MenuItemSpec:: interface
// The configuration object passed to the `MenuItem` constructor.
//
//   run:: (EditorState, (Transaction), EditorView, dom.Event)
//   The function to execute when the menu item is activated.
//
//   select:: ?(EditorState) → bool
//   Optional function that is used to determine whether the item is
//   appropriate at the moment. Deselected items will be hidden.
//
//   enable:: ?(EditorState) → bool
//   Function that is used to determine if the item is enabled. If
//   given and returning false, the item will be given a disabled
//   styling.
//
//   active:: ?(EditorState) → bool
//   A predicate function to determine whether the item is 'active' (for
//   example, the item for toggling the strong mark might be active then
//   the cursor is in strong text).
//
//   render:: ?(EditorView) → dom.Node
//   A function that renders the item. You must provide either this,
//   [`icon`](#menu.MenuItemSpec.icon), or [`label`](#MenuItemSpec.label).
//
//   icon:: ?Object
//   Describes an icon to show for this item. The object may specify
//   an SVG icon, in which case its `path` property should be an [SVG
//   path
//   spec](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d),
//   and `width` and `height` should provide the viewbox in which that
//   path exists. Alternatively, it may have a `text` property
//   specifying a string of text that makes up the icon, with an
//   optional `css` property giving additional CSS styling for the
//   text. _Or_ it may contain `dom` property containing a DOM node.
//
//   label:: ?string
//   Makes the item show up as a text label. Mostly useful for items
//   wrapped in a [drop-down](#menu.Dropdown) or similar menu. The object
//   should have a `label` property providing the text to display.
//
//   title:: ?union<string, (EditorState) → string>
//   Defines DOM title (mouseover) text for the item.
//
//   class:: ?string
//   Optionally adds a CSS class to the item's DOM representation.
//
//   css:: ?string
//   Optionally adds a string of inline CSS to the item's DOM
//   representation.
//
//   execEvent:: ?string
//   Defines which event on the command's DOM representation should
//   trigger the execution of the command. Defaults to mousedown.

var lastMenuEvent = {time: 0, node: null};
function markMenuEvent(e) {
  lastMenuEvent.time = Date.now();
  lastMenuEvent.node = e.target;
}
function isMenuEvent(wrapper) {
  return Date.now() - 100 < lastMenuEvent.time &&
    lastMenuEvent.node && wrapper.contains(lastMenuEvent.node)
}

// ::- A drop-down menu, displayed as a label with a downwards-pointing
// triangle to the right of it.
var Dropdown = function Dropdown(content, options) {
  this.options = options || {};
  this.content = Array.isArray(content) ? content : [content];
};

// :: (EditorView) → {dom: dom.Node, update: (EditorState)}
// Render the dropdown menu and sub-items.
Dropdown.prototype.render = function render (view) {
    var this$1 = this;

  var content = renderDropdownItems(this.content, view);

  var label = crel("div", {class: prefix + "-dropdown " + (this.options.class || ""),
                           style: this.options.css},
                   translate(view, this.options.label));
  if (this.options.title) { label.setAttribute("title", translate(view, this.options.title)); }
  var wrap = crel("div", {class: prefix + "-dropdown-wrap"}, label);
  var open = null, listeningOnClose = null;
  var close = function () {
    if (open && open.close()) {
      open = null;
      window.removeEventListener("mousedown", listeningOnClose);
    }
  };
  label.addEventListener("mousedown", function (e) {
    e.preventDefault();
    markMenuEvent(e);
    if (open) {
      close();
    } else {
      open = this$1.expand(wrap, content.dom);
      window.addEventListener("mousedown", listeningOnClose = function () {
        if (!isMenuEvent(wrap)) { close(); }
      });
    }
  });

  function update(state) {
    var inner = content.update(state);
    wrap.style.display = inner ? "" : "none";
    return inner
  }

  return {dom: wrap, update: update}
};

Dropdown.prototype.expand = function expand (dom, items) {
  var menuDOM = crel("div", {class: prefix + "-dropdown-menu " + (this.options.class || "")}, items);

  var done = false;
  function close() {
    if (done) { return }
    done = true;
    dom.removeChild(menuDOM);
    return true
  }
  dom.appendChild(menuDOM);
  return {close: close, node: menuDOM}
};

function renderDropdownItems(items, view) {
  var rendered = [], updates = [];
  for (var i = 0; i < items.length; i++) {
    var ref = items[i].render(view);
    var dom = ref.dom;
    var update = ref.update;
    rendered.push(crel("div", {class: prefix + "-dropdown-item"}, dom));
    updates.push(update);
  }
  return {dom: rendered, update: combineUpdates(updates, rendered)}
}

function combineUpdates(updates, nodes) {
  return function (state) {
    var something = false;
    for (var i = 0; i < updates.length; i++) {
      var up = updates[i](state);
      nodes[i].style.display = up ? "" : "none";
      if (up) { something = true; }
    }
    return something
  }
}

// ::- Represents a submenu wrapping a group of elements that start
// hidden and expand to the right when hovered over or tapped.
var DropdownSubmenu = function DropdownSubmenu(content, options) {
  this.options = options || {};
  this.content = Array.isArray(content) ? content : [content];
};

// :: (EditorView) → {dom: dom.Node, update: (EditorState) → bool}
// Renders the submenu.
DropdownSubmenu.prototype.render = function render (view) {
  var items = renderDropdownItems(this.content, view);

  var label = crel("div", {class: prefix + "-submenu-label"}, translate(view, this.options.label));
  var wrap = crel("div", {class: prefix + "-submenu-wrap"}, label,
                 crel("div", {class: prefix + "-submenu"}, items.dom));
  var listeningOnClose = null;
  label.addEventListener("mousedown", function (e) {
    e.preventDefault();
    markMenuEvent(e);
    setClass(wrap, prefix + "-submenu-wrap-active");
    if (!listeningOnClose)
      { window.addEventListener("mousedown", listeningOnClose = function () {
        if (!isMenuEvent(wrap)) {
          wrap.classList.remove(prefix + "-submenu-wrap-active");
          window.removeEventListener("mousedown", listeningOnClose);
          listeningOnClose = null;
        }
      }); }
  });

  function update(state) {
    var inner = items.update(state);
    wrap.style.display = inner ? "" : "none";
    return inner
  }
  return {dom: wrap, update: update}
};

// :: (EditorView, [union<MenuElement, [MenuElement]>]) → {dom: ?dom.DocumentFragment, update: (EditorState) → bool}
// Render the given, possibly nested, array of menu elements into a
// document fragment, placing separators between them (and ensuring no
// superfluous separators appear when some of the groups turn out to
// be empty).
function renderGrouped(view, content) {
  var result = document.createDocumentFragment();
  var updates = [], separators = [];
  for (var i = 0; i < content.length; i++) {
    var items = content[i], localUpdates = [], localNodes = [];
    for (var j = 0; j < items.length; j++) {
      var ref = items[j].render(view);
      var dom = ref.dom;
      var update$1 = ref.update;
      var span = crel("span", {class: prefix + "item"}, dom);
      result.appendChild(span);
      localNodes.push(span);
      localUpdates.push(update$1);
    }
    if (localUpdates.length) {
      updates.push(combineUpdates(localUpdates, localNodes));
      if (i < content.length - 1)
        { separators.push(result.appendChild(separator())); }
    }
  }

  function update(state) {
    var something = false, needSep = false;
    for (var i = 0; i < updates.length; i++) {
      var hasContent = updates[i](state);
      if (i) { separators[i - 1].style.display = needSep && hasContent ? "" : "none"; }
      needSep = hasContent;
      if (hasContent) { something = true; }
    }
    return something
  }
  return {dom: result, update: update}
}

function separator() {
  return crel("span", {class: prefix + "separator"})
}

// :: Object
// A set of basic editor-related icons. Contains the properties
// `join`, `lift`, `selectParentNode`, `undo`, `redo`, `strong`, `em`,
// `code`, `link`, `bulletList`, `orderedList`, and `blockquote`, each
// holding an object that can be used as the `icon` option to
// `MenuItem`.
var icons = {
  join: {
    width: 800, height: 900,
    path: "M0 75h800v125h-800z M0 825h800v-125h-800z M250 400h100v-100h100v100h100v100h-100v100h-100v-100h-100z"
  },
  lift: {
    width: 1024, height: 1024,
    path: "M219 310v329q0 7-5 12t-12 5q-8 0-13-5l-164-164q-5-5-5-13t5-13l164-164q5-5 13-5 7 0 12 5t5 12zM1024 749v109q0 7-5 12t-12 5h-987q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h987q7 0 12 5t5 12zM1024 530v109q0 7-5 12t-12 5h-621q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h621q7 0 12 5t5 12zM1024 310v109q0 7-5 12t-12 5h-621q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h621q7 0 12 5t5 12zM1024 91v109q0 7-5 12t-12 5h-987q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h987q7 0 12 5t5 12z"
  },
  selectParentNode: {text: "\u2b1a", css: "font-weight: bold"},
  undo: {
    width: 1024, height: 1024,
    path: "M761 1024c113-206 132-520-313-509v253l-384-384 384-384v248c534-13 594 472 313 775z"
  },
  redo: {
    width: 1024, height: 1024,
    path: "M576 248v-248l384 384-384 384v-253c-446-10-427 303-313 509-280-303-221-789 313-775z"
  },
  strong: {
    width: 805, height: 1024,
    path: "M317 869q42 18 80 18 214 0 214-191 0-65-23-102-15-25-35-42t-38-26-46-14-48-6-54-1q-41 0-57 5 0 30-0 90t-0 90q0 4-0 38t-0 55 2 47 6 38zM309 442q24 4 62 4 46 0 81-7t62-25 42-51 14-81q0-40-16-70t-45-46-61-24-70-8q-28 0-74 7 0 28 2 86t2 86q0 15-0 45t-0 45q0 26 0 39zM0 950l1-53q8-2 48-9t60-15q4-6 7-15t4-19 3-18 1-21 0-19v-37q0-561-12-585-2-4-12-8t-25-6-28-4-27-2-17-1l-2-47q56-1 194-6t213-5q13 0 39 0t38 0q40 0 78 7t73 24 61 40 42 59 16 78q0 29-9 54t-22 41-36 32-41 25-48 22q88 20 146 76t58 141q0 57-20 102t-53 74-78 48-93 27-100 8q-25 0-75-1t-75-1q-60 0-175 6t-132 6z"
  },
  em: {
    width: 585, height: 1024,
    path: "M0 949l9-48q3-1 46-12t63-21q16-20 23-57 0-4 35-165t65-310 29-169v-14q-13-7-31-10t-39-4-33-3l10-58q18 1 68 3t85 4 68 1q27 0 56-1t69-4 56-3q-2 22-10 50-17 5-58 16t-62 19q-4 10-8 24t-5 22-4 26-3 24q-15 84-50 239t-44 203q-1 5-7 33t-11 51-9 47-3 32l0 10q9 2 105 17-1 25-9 56-6 0-18 0t-18 0q-16 0-49-5t-49-5q-78-1-117-1-29 0-81 5t-69 6z"
  },
  code: {
    width: 896, height: 1024,
    path: "M608 192l-96 96 224 224-224 224 96 96 288-320-288-320zM288 192l-288 320 288 320 96-96-224-224 224-224-96-96z"
  },
  link: {
    width: 951, height: 1024,
    path: "M832 694q0-22-16-38l-118-118q-16-16-38-16-24 0-41 18 1 1 10 10t12 12 8 10 7 14 2 15q0 22-16 38t-38 16q-8 0-15-2t-14-7-10-8-12-12-10-10q-18 17-18 41 0 22 16 38l117 118q15 15 38 15 22 0 38-14l84-83q16-16 16-38zM430 292q0-22-16-38l-117-118q-16-16-38-16-22 0-38 15l-84 83q-16 16-16 38 0 22 16 38l118 118q15 15 38 15 24 0 41-17-1-1-10-10t-12-12-8-10-7-14-2-15q0-22 16-38t38-16q8 0 15 2t14 7 10 8 12 12 10 10q18-17 18-41zM941 694q0 68-48 116l-84 83q-47 47-116 47-69 0-116-48l-117-118q-47-47-47-116 0-70 50-119l-50-50q-49 50-118 50-68 0-116-48l-118-118q-48-48-48-116t48-116l84-83q47-47 116-47 69 0 116 48l117 118q47 47 47 116 0 70-50 119l50 50q49-50 118-50 68 0 116 48l118 118q48 48 48 116z"
  },
  bulletList: {
    width: 768, height: 896,
    path: "M0 512h128v-128h-128v128zM0 256h128v-128h-128v128zM0 768h128v-128h-128v128zM256 512h512v-128h-512v128zM256 256h512v-128h-512v128zM256 768h512v-128h-512v128z"
  },
  orderedList: {
    width: 768, height: 896,
    path: "M320 512h448v-128h-448v128zM320 768h448v-128h-448v128zM320 128v128h448v-128h-448zM79 384h78v-256h-36l-85 23v50l43-2v185zM189 590c0-36-12-78-96-78-33 0-64 6-83 16l1 66c21-10 42-15 67-15s32 11 32 28c0 26-30 58-110 112v50h192v-67l-91 2c49-30 87-66 87-113l1-1z"
  },
  blockquote: {
    width: 640, height: 896,
    path: "M0 448v256h256v-256h-128c0 0 0-128 128-128v-128c0 0-256 0-256 256zM640 320v-128c0 0-256 0-256 256v256h256v-256h-128c0 0 0-128 128-128z"
  }
};

// :: MenuItem
// Menu item for the `joinUp` command.
var joinUpItem = new MenuItem({
  title: "Join with above block",
  run: prosemirrorCommands.joinUp,
  select: function (state) { return prosemirrorCommands.joinUp(state); },
  icon: icons.join
});

// :: MenuItem
// Menu item for the `lift` command.
var liftItem = new MenuItem({
  title: "Lift out of enclosing block",
  run: prosemirrorCommands.lift,
  select: function (state) { return prosemirrorCommands.lift(state); },
  icon: icons.lift
});

// :: MenuItem
// Menu item for the `selectParentNode` command.
var selectParentNodeItem = new MenuItem({
  title: "Select parent node",
  run: prosemirrorCommands.selectParentNode,
  select: function (state) { return prosemirrorCommands.selectParentNode(state); },
  icon: icons.selectParentNode
});

// :: MenuItem
// Menu item for the `undo` command.
var undoItem = new MenuItem({
  title: "Undo last change",
  run: prosemirrorHistory.undo,
  enable: function (state) { return prosemirrorHistory.undo(state); },
  icon: icons.undo
});

// :: MenuItem
// Menu item for the `redo` command.
var redoItem = new MenuItem({
  title: "Redo last undone change",
  run: prosemirrorHistory.redo,
  enable: function (state) { return prosemirrorHistory.redo(state); },
  icon: icons.redo
});

// :: (NodeType, Object) → MenuItem
// Build a menu item for wrapping the selection in a given node type.
// Adds `run` and `select` properties to the ones present in
// `options`. `options.attrs` may be an object or a function, as in
// `toggleMarkItem`.
function wrapItem(nodeType, options) {
  var passedOptions = {
    run: function run(state, dispatch) {
      // FIXME if (options.attrs instanceof Function) options.attrs(state, attrs => wrapIn(nodeType, attrs)(state))
      return prosemirrorCommands.wrapIn(nodeType, options.attrs)(state, dispatch)
    },
    select: function select(state) {
      return prosemirrorCommands.wrapIn(nodeType, options.attrs instanceof Function ? null : options.attrs)(state)
    }
  };
  for (var prop in options) { passedOptions[prop] = options[prop]; }
  return new MenuItem(passedOptions)
}

// :: (NodeType, Object) → MenuItem
// Build a menu item for changing the type of the textblock around the
// selection to the given type. Provides `run`, `active`, and `select`
// properties. Others must be given in `options`. `options.attrs` may
// be an object to provide the attributes for the textblock node.
function blockTypeItem(nodeType, options) {
  var command = prosemirrorCommands.setBlockType(nodeType, options.attrs);
  var passedOptions = {
    run: command,
    enable: function enable(state) { return command(state) },
    active: function active(state) {
      var ref = state.selection;
      var $from = ref.$from;
      var to = ref.to;
      var node = ref.node;
      if (node) { return node.hasMarkup(nodeType, options.attrs) }
      return to <= $from.end() && $from.parent.hasMarkup(nodeType, options.attrs)
    }
  };
  for (var prop in options) { passedOptions[prop] = options[prop]; }
  return new MenuItem(passedOptions)
}

// Work around classList.toggle being broken in IE11
function setClass(dom, cls, on) {
  if (on) { dom.classList.add(cls); }
  else { dom.classList.remove(cls); }
}

var prefix$2 = "ProseMirror-menubar";

function isIOS() {
  if (typeof navigator == "undefined") { return false }
  var agent = navigator.userAgent;
  return !/Edge\/\d/.test(agent) && /AppleWebKit/.test(agent) && /Mobile\/\w+/.test(agent)
}

// :: (Object) → Plugin
// A plugin that will place a menu bar above the editor. Note that
// this involves wrapping the editor in an additional `<div>`.
//
//   options::-
//   Supports the following options:
//
//     content:: [[MenuElement]]
//     Provides the content of the menu, as a nested array to be
//     passed to `renderGrouped`.
//
//     floating:: ?bool
//     Determines whether the menu floats, i.e. whether it sticks to
//     the top of the viewport when the editor is partially scrolled
//     out of view.
function menuBar(options) {
  return new prosemirrorState.Plugin({
    view: function view(editorView) { return new MenuBarView(editorView, options) }
  })
}

var MenuBarView = function MenuBarView(editorView, options) {
  var this$1 = this;

  this.editorView = editorView;
  this.options = options;

  this.wrapper = crel("div", {class: prefix$2 + "-wrapper"});
  this.menu = this.wrapper.appendChild(crel("div", {class: prefix$2}));
  this.menu.className = prefix$2;
  this.spacer = null;

  editorView.dom.parentNode.replaceChild(this.wrapper, editorView.dom);
  this.wrapper.appendChild(editorView.dom);

  this.maxHeight = 0;
  this.widthForMaxHeight = 0;
  this.floating = false;

  var ref = renderGrouped(this.editorView, this.options.content);
  var dom = ref.dom;
  var update = ref.update;
  this.contentUpdate = update;
  this.menu.appendChild(dom);
  this.update();

  if (options.floating && !isIOS()) {
    this.updateFloat();
    var potentialScrollers = getAllWrapping(this.wrapper);
    this.scrollFunc = function (e) {
      var root = this$1.editorView.root;
      if (!(root.body || root).contains(this$1.wrapper)) {
          potentialScrollers.forEach(function (el) { return el.removeEventListener("scroll", this$1.scrollFunc); });
      } else {
          this$1.updateFloat(e.target.getBoundingClientRect && e.target);
      }
    };
    potentialScrollers.forEach(function (el) { return el.addEventListener('scroll', this$1.scrollFunc); });
  }
};

MenuBarView.prototype.update = function update () {
  this.contentUpdate(this.editorView.state);

  if (this.floating) {
    this.updateScrollCursor();
  } else {
    if (this.menu.offsetWidth != this.widthForMaxHeight) {
      this.widthForMaxHeight = this.menu.offsetWidth;
      this.maxHeight = 0;
    }
    if (this.menu.offsetHeight > this.maxHeight) {
      this.maxHeight = this.menu.offsetHeight;
      this.menu.style.minHeight = this.maxHeight + "px";
    }
  }
};

MenuBarView.prototype.updateScrollCursor = function updateScrollCursor () {
  var selection = this.editorView.root.getSelection();
  if (!selection.focusNode) { return }
  var rects = selection.getRangeAt(0).getClientRects();
  var selRect = rects[selectionIsInverted(selection) ? 0 : rects.length - 1];
  if (!selRect) { return }
  var menuRect = this.menu.getBoundingClientRect();
  if (selRect.top < menuRect.bottom && selRect.bottom > menuRect.top) {
    var scrollable = findWrappingScrollable(this.wrapper);
    if (scrollable) { scrollable.scrollTop -= (menuRect.bottom - selRect.top); }
  }
};

MenuBarView.prototype.updateFloat = function updateFloat (scrollAncestor) {
  var parent = this.wrapper, editorRect = parent.getBoundingClientRect(),
      top = scrollAncestor ? Math.max(0, scrollAncestor.getBoundingClientRect().top) : 0;

  if (this.floating) {
    if (editorRect.top >= top || editorRect.bottom < this.menu.offsetHeight + 10) {
      this.floating = false;
      this.menu.style.position = this.menu.style.left = this.menu.style.top = this.menu.style.width = "";
      this.menu.style.display = "";
      this.spacer.parentNode.removeChild(this.spacer);
      this.spacer = null;
    } else {
      var border = (parent.offsetWidth - parent.clientWidth) / 2;
      this.menu.style.left = (editorRect.left + border) + "px";
      this.menu.style.display = (editorRect.top > window.innerHeight ? "none" : "");
      if (scrollAncestor) { this.menu.style.top = top + "px"; }
    }
  } else {
    if (editorRect.top < top && editorRect.bottom >= this.menu.offsetHeight + 10) {
      this.floating = true;
      var menuRect = this.menu.getBoundingClientRect();
      this.menu.style.left = menuRect.left + "px";
      this.menu.style.width = menuRect.width + "px";
      if (scrollAncestor) { this.menu.style.top = top + "px"; }
      this.menu.style.position = "fixed";
      this.spacer = crel("div", {class: prefix$2 + "-spacer", style: ("height: " + (menuRect.height) + "px")});
      parent.insertBefore(this.spacer, this.menu);
    }
  }
};

MenuBarView.prototype.destroy = function destroy () {
  if (this.wrapper.parentNode)
    { this.wrapper.parentNode.replaceChild(this.editorView.dom, this.wrapper); }
};

// Not precise, but close enough
function selectionIsInverted(selection) {
  if (selection.anchorNode == selection.focusNode) { return selection.anchorOffset > selection.focusOffset }
  return selection.anchorNode.compareDocumentPosition(selection.focusNode) == Node.DOCUMENT_POSITION_FOLLOWING
}

function findWrappingScrollable(node) {
  for (var cur = node.parentNode; cur; cur = cur.parentNode)
    { if (cur.scrollHeight > cur.clientHeight) { return cur } }
}

function getAllWrapping(node) {
    var res = [window];
    for (var cur = node.parentNode; cur; cur = cur.parentNode)
        { res.push(cur); }
    return res
}

// !! This module defines a number of building blocks for ProseMirror
// menus, along with a [menu bar](#menu.menuBar) implementation.

// MenuElement:: interface
// The types defined in this module aren't the only thing you can
// display in your menu. Anything that conforms to this interface can
// be put into a menu structure.
//
//   render:: (pm: EditorView) → {dom: dom.Node, update: (EditorState) → bool}
//   Render the element for display in the menu. Must return a DOM
//   element and a function that can be used to update the element to
//   a new state. The `update` function will return false if the
//   update hid the entire element.

exports.MenuItem = MenuItem;
exports.Dropdown = Dropdown;
exports.DropdownSubmenu = DropdownSubmenu;
exports.renderGrouped = renderGrouped;
exports.icons = icons;
exports.joinUpItem = joinUpItem;
exports.liftItem = liftItem;
exports.selectParentNodeItem = selectParentNodeItem;
exports.undoItem = undoItem;
exports.redoItem = redoItem;
exports.wrapItem = wrapItem;
exports.blockTypeItem = blockTypeItem;
exports.menuBar = menuBar;
//# sourceMappingURL=index.js.map


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

//Copyright (C) 2012 Kory Nunn

//Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

//The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

//THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

/*

    This code is not formatted for readability, but rather run-speed and to assist compilers.

    However, the code's intention should be transparent.

    *** IE SUPPORT ***

    If you require this library to work in IE7, add the following after declaring crel.

    var testDiv = document.createElement('div'),
        testLabel = document.createElement('label');

    testDiv.setAttribute('class', 'a');
    testDiv['className'] !== 'a' ? crel.attrMap['class'] = 'className':undefined;
    testDiv.setAttribute('name','a');
    testDiv['name'] !== 'a' ? crel.attrMap['name'] = function(element, value){
        element.id = value;
    }:undefined;


    testLabel.setAttribute('for', 'a');
    testLabel['htmlFor'] !== 'a' ? crel.attrMap['for'] = 'htmlFor':undefined;



*/

(function (root, factory) {
    if (true) {
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        define(factory);
    } else {
        root.crel = factory();
    }
}(this, function () {
    var fn = 'function',
        obj = 'object',
        nodeType = 'nodeType',
        textContent = 'textContent',
        setAttribute = 'setAttribute',
        attrMapString = 'attrMap',
        isNodeString = 'isNode',
        isElementString = 'isElement',
        d = typeof document === obj ? document : {},
        isType = function(a, type){
            return typeof a === type;
        },
        isNode = typeof Node === fn ? function (object) {
            return object instanceof Node;
        } :
        // in IE <= 8 Node is an object, obviously..
        function(object){
            return object &&
                isType(object, obj) &&
                (nodeType in object) &&
                isType(object.ownerDocument,obj);
        },
        isElement = function (object) {
            return crel[isNodeString](object) && object[nodeType] === 1;
        },
        isArray = function(a){
            return a instanceof Array;
        },
        appendChild = function(element, child) {
            if (isArray(child)) {
                child.map(function(subChild){
                    appendChild(element, subChild);
                });
                return;
            }
            if(!crel[isNodeString](child)){
                child = d.createTextNode(child);
            }
            element.appendChild(child);
        };


    function crel(){
        var args = arguments, //Note: assigned to a variable to assist compilers. Saves about 40 bytes in closure compiler. Has negligable effect on performance.
            element = args[0],
            child,
            settings = args[1],
            childIndex = 2,
            argumentsLength = args.length,
            attributeMap = crel[attrMapString];

        element = crel[isElementString](element) ? element : d.createElement(element);
        // shortcut
        if(argumentsLength === 1){
            return element;
        }

        if(!isType(settings,obj) || crel[isNodeString](settings) || isArray(settings)) {
            --childIndex;
            settings = null;
        }

        // shortcut if there is only one child that is a string
        if((argumentsLength - childIndex) === 1 && isType(args[childIndex], 'string') && element[textContent] !== undefined){
            element[textContent] = args[childIndex];
        }else{
            for(; childIndex < argumentsLength; ++childIndex){
                child = args[childIndex];

                if(child == null){
                    continue;
                }

                if (isArray(child)) {
                  for (var i=0; i < child.length; ++i) {
                    appendChild(element, child[i]);
                  }
                } else {
                  appendChild(element, child);
                }
            }
        }

        for(var key in settings){
            if(!attributeMap[key]){
                if(isType(settings[key],fn)){
                    element[key] = settings[key];
                }else{
                    element[setAttribute](key, settings[key]);
                }
            }else{
                var attr = attributeMap[key];
                if(typeof attr === fn){
                    attr(element, settings[key]);
                }else{
                    element[setAttribute](attr, settings[key]);
                }
            }
        }

        return element;
    }

    // Used for mapping one kind of attribute to the supported version of that in bad browsers.
    crel[attrMapString] = {};

    crel[isElementString] = isElement;

    crel[isNodeString] = isNode;

    if(typeof Proxy !== 'undefined'){
        crel.proxy = new Proxy(crel, {
            get: function(target, key){
                !(key in crel) && (crel[key] = crel.bind(null, key));
                return crel[key];
            }
        });
    }

    return crel;
}));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = __webpack_require__(5);
var prosemirrorTransform = __webpack_require__(7);

// ::- Input rules are regular expressions describing a piece of text
// that, when typed, causes something to happen. This might be
// changing two dashes into an emdash, wrapping a paragraph starting
// with `"> "` into a blockquote, or something entirely different.
var InputRule = function InputRule(match, handler) {
  this.match = match;
  this.handler = typeof handler == "string" ? stringHandler(handler) : handler;
};

function stringHandler(string) {
  return function(state, match, start, end) {
    var insert = string;
    if (match[1]) {
      var offset = match[0].lastIndexOf(match[1]);
      insert += match[0].slice(offset + match[1].length);
      start += offset;
      var cutOff = start - end;
      if (cutOff > 0) {
        insert = match[0].slice(offset - cutOff, offset) + insert;
        start = end;
      }
    }
    var marks = state.doc.resolve(start).marks();
    return state.tr.replaceWith(start, end, state.schema.text(insert, marks))
  }
}

var MAX_MATCH = 500;

// :: (config: {rules: [InputRule]}) → Plugin
// Create an input rules plugin. When enabled, it will cause text
// input that matches any of the given rules to trigger the rule's
// action.
function inputRules(ref) {
  var rules = ref.rules;

  return new prosemirrorState.Plugin({
    state: {
      init: function init() { return null },
      apply: function apply(tr, prev) {
        var stored = tr.getMeta(this);
        if (stored) { return stored }
        return tr.selectionSet || tr.docChanged ? null : prev
      }
    },

    props: {
      handleTextInput: function handleTextInput(view, from, to, text) {
        var this$1 = this;

        var state = view.state, $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) { return false }
        var textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset,
                                                  null, "\ufffc") + text;
        for (var i = 0; i < rules.length; i++) {
          var match = rules[i].match.exec(textBefore);
          var tr = match && rules[i].handler(state, match, from - (match[0].length - text.length), to);
          if (!tr) { continue }
          view.dispatch(tr.setMeta(this$1, {transform: tr, from: from, to: to, text: text}));
          return true
        }
        return false
      }
    },

    isInputRules: true
  })
}

// :: (EditorState, ?(Transaction)) → bool
// This is a command that will undo an input rule, if applying such a
// rule was the last thing that the user did.
function undoInputRule(state, dispatch) {
  var plugins = state.plugins;
  for (var i = 0; i < plugins.length; i++) {
    var plugin = plugins[i], undoable = (void 0);
    if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
      if (dispatch) {
        var tr = state.tr, toUndo = undoable.transform;
        for (var j = toUndo.steps.length - 1; j >= 0; j--)
          { tr.step(toUndo.steps[j].invert(toUndo.docs[j])); }
        var marks = tr.doc.resolve(undoable.from).marks();
        dispatch(tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks)));
      }
      return true
    }
  }
  return false
}

// :: InputRule Converts double dashes to an emdash.
var emDash = new InputRule(/--$/, "—");
// :: InputRule Converts three dots to an ellipsis character.
var ellipsis = new InputRule(/\.\.\.$/, "…");
// :: InputRule “Smart” opening double quotes.
var openDoubleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(")$/, "“");
// :: InputRule “Smart” closing double quotes.
var closeDoubleQuote = new InputRule(/"$/, "”");
// :: InputRule “Smart” opening single quotes.
var openSingleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(')$/, "‘");
// :: InputRule “Smart” closing single quotes.
var closeSingleQuote = new InputRule(/'$/, "’");

// :: [InputRule] Smart-quote related input rules.
var smartQuotes = [openDoubleQuote, closeDoubleQuote, openSingleQuote, closeSingleQuote];

// :: (RegExp, NodeType, ?union<Object, ([string]) → ?Object>, ?([string], Node) → bool) → InputRule
// Build an input rule for automatically wrapping a textblock when a
// given string is typed. The `regexp` argument is
// directly passed through to the `InputRule` constructor. You'll
// probably want the regexp to start with `^`, so that the pattern can
// only occur at the start of a textblock.
//
// `nodeType` is the type of node to wrap in. If it needs attributes,
// you can either pass them directly, or pass a function that will
// compute them from the regular expression match.
//
// By default, if there's a node with the same type above the newly
// wrapped node, the rule will try to [join](#transform.Transform.join) those
// two nodes. You can pass a join predicate, which takes a regular
// expression match and the node before the wrapped node, and can
// return a boolean to indicate whether a join should happen.
function wrappingInputRule(regexp, nodeType, getAttrs, joinPredicate) {
  return new InputRule(regexp, function (state, match, start, end) {
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var tr = state.tr.delete(start, end);
    var $start = tr.doc.resolve(start), range = $start.blockRange(), wrapping = range && prosemirrorTransform.findWrapping(range, nodeType, attrs);
    if (!wrapping) { return null }
    tr.wrap(range, wrapping);
    var before = tr.doc.resolve(start - 1).nodeBefore;
    if (before && before.type == nodeType && prosemirrorTransform.canJoin(tr.doc, start - 1) &&
        (!joinPredicate || joinPredicate(match, before)))
      { tr.join(start - 1); }
    return tr
  })
}

// :: (RegExp, NodeType, ?union<Object, ([string]) → ?Object>) → InputRule
// Build an input rule that changes the type of a textblock when the
// matched text is typed into it. You'll usually want to start your
// regexp with `^` to that it is only matched at the start of a
// textblock. The optional `getAttrs` parameter can be used to compute
// the new node's attributes, and works the same as in the
// `wrappingInputRule` function.
function textblockTypeInputRule(regexp, nodeType, getAttrs) {
  return new InputRule(regexp, function (state, match, start, end) {
    var $start = state.doc.resolve(start);
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) { return null }
    return state.tr
      .delete(start, end)
      .setBlockType(start, start, nodeType, attrs)
  })
}

exports.InputRule = InputRule;
exports.inputRules = inputRules;
exports.undoInputRule = undoInputRule;
exports.emDash = emDash;
exports.ellipsis = ellipsis;
exports.openDoubleQuote = openDoubleQuote;
exports.closeDoubleQuote = closeDoubleQuote;
exports.openSingleQuote = openSingleQuote;
exports.closeSingleQuote = closeSingleQuote;
exports.smartQuotes = smartQuotes;
exports.wrappingInputRule = wrappingInputRule;
exports.textblockTypeInputRule = textblockTypeInputRule;
//# sourceMappingURL=index.js.map


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'",
  229: "q"
}
var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ";",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: "\"",
  229: "Q"
}

var chrome = typeof navigator != "undefined" && /Chrome\/(\d+)/.exec(navigator.userAgent)
var safari = typeof navigator != "undefined" && /Apple Computer/.test(navigator.vendor)
var gecko = typeof navigator != "undefined" && /Gecko\/\d+/.test(navigator.userAgent)
var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform)
var brokenModifierNames = chrome && (mac || +chrome[1] < 57) || gecko && mac

// Fill in the digit keys
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i)

// The function keys
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i

// And the alphabetic keys
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32)
  shift[i] = String.fromCharCode(i)
}

// For each code that doesn't have a shift-equivalent, copy the base name
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code]

function keyName(event) {
  // Don't trust event.key in Chrome when there are modifiers until
  // they fix https://bugs.chromium.org/p/chromium/issues/detail?id=633838
  var ignoreKey = brokenModifierNames && (event.ctrlKey || event.altKey || event.metaKey) ||
    safari && event.shiftKey && event.key && event.key.length == 1
  var name = (!ignoreKey && event.key) ||
    (event.shiftKey ? shift : base)[event.keyCode] ||
    event.key || "Unidentified"
  // Edge sometimes produces wrong names (Issue #3)
  if (name == "Esc") name = "Escape"
  if (name == "Del") name = "Delete"
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
  if (name == "Left") name = "ArrowLeft"
  if (name == "Up") name = "ArrowUp"
  if (name == "Right") name = "ArrowRight"
  if (name == "Down") name = "ArrowDown"
  return name
}

module.exports = keyName
keyName.base = base
keyName.shift = shift


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorKeymap = __webpack_require__(13);
var prosemirrorState = __webpack_require__(5);
var prosemirrorView = __webpack_require__(14);
var prosemirrorModel = __webpack_require__(6);

// ::- Gap cursor selections are represented using this class. Its
// `$anchor` and `$head` properties both point at the cursor position.
var GapCursor = (function (Selection$$1) {
  function GapCursor($pos) {
    Selection$$1.call(this, $pos, $pos);
  }

  if ( Selection$$1 ) GapCursor.__proto__ = Selection$$1;
  GapCursor.prototype = Object.create( Selection$$1 && Selection$$1.prototype );
  GapCursor.prototype.constructor = GapCursor;

  GapCursor.prototype.map = function map (doc, mapping) {
    var $pos = doc.resolve(mapping.map(this.head));
    return GapCursor.valid($pos) ? new GapCursor($pos) : Selection$$1.near($pos)
  };

  GapCursor.prototype.content = function content () { return prosemirrorModel.Slice.empty };

  GapCursor.prototype.eq = function eq (other) {
    return other instanceof GapCursor && other.head == this.head
  };

  GapCursor.prototype.toJSON = function toJSON () {
    return {type: "gapcursor", pos: this.head}
  };

  GapCursor.fromJSON = function fromJSON (doc, json) {
    if (typeof json.pos != "number") { throw new RangeError("Invalid input for GapCursor.fromJSON") }
    return new GapCursor(doc.resolve(json.pos))
  };

  GapCursor.prototype.getBookmark = function getBookmark () { return new GapBookmark(this.anchor) };

  GapCursor.valid = function valid ($pos) {
    var parent = $pos.parent;
    if (parent.isTextblock || !closedBefore($pos) || !closedAfter($pos)) { return false }
    var override = parent.type.spec.allowGapCursor;
    if (override != null) { return override }
    var deflt = parent.contentMatchAt($pos.index()).defaultType;
    return deflt && deflt.isTextblock
  };

  GapCursor.findFrom = function findFrom ($pos, dir, mustMove) {
    if (!mustMove && GapCursor.valid($pos)) { return $pos }

    var pos = $pos.pos, next = null;
    // Scan up from this position
    for (var d = $pos.depth;; d--) {
      var parent = $pos.node(d);
      if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
        next = parent.maybeChild(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
        break
      } else if (d == 0) {
        return null
      }
      pos += dir;
      var $cur = $pos.doc.resolve(pos);
      if (GapCursor.valid($cur)) { return $cur }
    }

    // And then down into the next node
    for (;;) {
      next = dir > 0 ? next.firstChild : next.lastChild;
      if (!next) { break }
      pos += dir;
      var $cur$1 = $pos.doc.resolve(pos);
      if (GapCursor.valid($cur$1)) { return $cur$1 }
    }

    return null
  };

  return GapCursor;
}(prosemirrorState.Selection));

GapCursor.prototype.visible = false;

prosemirrorState.Selection.jsonID("gapcursor", GapCursor);

var GapBookmark = function GapBookmark(pos) {
  this.pos = pos;
};
GapBookmark.prototype.map = function map (mapping) {
  return new GapBookmark(mapping.map(this.pos))
};
GapBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.pos);
  return GapCursor.valid($pos) ? new GapCursor($pos) : prosemirrorState.Selection.near($pos)
};

function closedBefore($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index = $pos.index(d);
    // At the start of this parent, look at next one
    if (index == 0) { continue }
    // See if the node before (or its first ancestor) is closed
    for (var before = $pos.node(d).child(index - 1);; before = before.lastChild) {
      if (before.isTextblock) { return false }
      if (before.childCount == 0 || before.isAtom || before.type.spec.isolating) { return true }
    }
  }
  // Hit start of document
  return true
}

function closedAfter($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index = $pos.indexAfter(d), parent = $pos.node(d);
    if (index == parent.childCount) { continue }
    for (var after = parent.child(index);; after = after.firstChild) {
      if (after.isTextblock) { return false }
      if (after.childCount == 0 || after.isAtom || after.type.spec.isolating) { return true }
    }
  }
  return true
}

// :: () → Plugin
// Create a gap cursor plugin. When enabled, this will capture clicks
// near and arrow-key-motion past places that don't have a normally
// selectable position nearby, and create a gap cursor selection for
// them. The cursor is drawn as an element with class
// `ProseMirror-gapcursor`. You can either include
// `style/gapcursor.css` from the package's directory or add your own
// styles to make it visible.
var gapCursor = function() {
  return new prosemirrorState.Plugin({
    props: {
      decorations: drawGapCursor,

      createSelectionBetween: function createSelectionBetween(_view, $anchor, $head) {
        if ($anchor.pos == $head.pos && GapCursor.valid($head)) { return new GapCursor($head) }
      },

      handleClick: handleClick,
      handleKeyDown: handleKeyDown
    }
  })
};

var handleKeyDown = prosemirrorKeymap.keydownHandler({
  "ArrowLeft": arrow("horiz", -1),
  "ArrowRight": arrow("horiz", 1),
  "ArrowUp": arrow("vert", -1),
  "ArrowDown": arrow("vert", 1)
});

function arrow(axis, dir) {
  var dirStr = axis == "vert" ? (dir > 0 ? "down" : "up") : (dir > 0 ? "right" : "left");
  return function(state, dispatch, view) {
    var sel = state.selection;
    var $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
    if (sel instanceof prosemirrorState.TextSelection) {
      if (!view.endOfTextblock(dirStr)) { return false }
      mustMove = false;
      $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
    }
    var $found = GapCursor.findFrom($start, dir, mustMove);
    if (!$found) { return false }
    if (dispatch) { dispatch(state.tr.setSelection(new GapCursor($found))); }
    return true
  }
}

function handleClick(view, pos, event) {
  var $pos = view.state.doc.resolve(pos);
  if (!GapCursor.valid($pos)) { return false }
  var ref = view.posAtCoords({left: event.clientX, top: event.clientY});
  var inside = ref.inside;
  if (inside > -1 && prosemirrorState.NodeSelection.isSelectable(view.state.doc.nodeAt(inside))) { return false }
  view.dispatch(view.state.tr.setSelection(new GapCursor($pos)));
  return true
}

function drawGapCursor(state) {
  if (!(state.selection instanceof GapCursor)) { return null }
  var node = document.createElement("div");
  node.className = "ProseMirror-gapcursor";
  return prosemirrorView.DecorationSet.create(state.doc, [prosemirrorView.Decoration.widget(state.selection.head, node, {key: "gapcursor"})])
}

exports.gapCursor = gapCursor;
exports.GapCursor = GapCursor;
//# sourceMappingURL=index.js.map


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__(6);

// :: Object
// [Specs](#model.NodeSpec) for the nodes defined in this schema.
var nodes = {
  // :: NodeSpec The top level document node.
  doc: {
    content: "block+"
  },

  // :: NodeSpec A plain paragraph textblock. Represented in the DOM
  // as a `<p>` element.
  paragraph: {
    content: "inline*",
    group: "block",
    parseDOM: [{tag: "p"}],
    toDOM: function toDOM() { return ["p", 0] }
  },

  // :: NodeSpec A blockquote (`<blockquote>`) wrapping one or more blocks.
  blockquote: {
    content: "block+",
    group: "block",
    defining: true,
    parseDOM: [{tag: "blockquote"}],
    toDOM: function toDOM() { return ["blockquote", 0] }
  },

  // :: NodeSpec A horizontal rule (`<hr>`).
  horizontal_rule: {
    group: "block",
    parseDOM: [{tag: "hr"}],
    toDOM: function toDOM() { return ["hr"] }
  },

  // :: NodeSpec A heading textblock, with a `level` attribute that
  // should hold the number 1 to 6. Parsed and serialized as `<h1>` to
  // `<h6>` elements.
  heading: {
    attrs: {level: {default: 1}},
    content: "inline*",
    group: "block",
    defining: true,
    parseDOM: [{tag: "h1", attrs: {level: 1}},
               {tag: "h2", attrs: {level: 2}},
               {tag: "h3", attrs: {level: 3}},
               {tag: "h4", attrs: {level: 4}},
               {tag: "h5", attrs: {level: 5}},
               {tag: "h6", attrs: {level: 6}}],
    toDOM: function toDOM(node) { return ["h" + node.attrs.level, 0] }
  },

  // :: NodeSpec A code listing. Disallows marks or non-text inline
  // nodes by default. Represented as a `<pre>` element with a
  // `<code>` element inside of it.
  code_block: {
    content: "text*",
    marks: "",
    group: "block",
    code: true,
    defining: true,
    parseDOM: [{tag: "pre", preserveWhitespace: "full"}],
    toDOM: function toDOM() { return ["pre", ["code", 0]] }
  },

  // :: NodeSpec The text node.
  text: {
    group: "inline"
  },

  // :: NodeSpec An inline image (`<img>`) node. Supports `src`,
  // `alt`, and `href` attributes. The latter two default to the empty
  // string.
  image: {
    inline: true,
    attrs: {
      src: {},
      alt: {default: null},
      title: {default: null}
    },
    group: "inline",
    draggable: true,
    parseDOM: [{tag: "img[src]", getAttrs: function getAttrs(dom) {
      return {
        src: dom.getAttribute("src"),
        title: dom.getAttribute("title"),
        alt: dom.getAttribute("alt")
      }
    }}],
    toDOM: function toDOM(node) { return ["img", node.attrs] }
  },

  // :: NodeSpec A hard line break, represented in the DOM as `<br>`.
  hard_break: {
    inline: true,
    group: "inline",
    selectable: false,
    parseDOM: [{tag: "br"}],
    toDOM: function toDOM() { return ["br"] }
  }
};

// :: Object [Specs](#model.MarkSpec) for the marks in the schema.
var marks = {
  // :: MarkSpec A link. Has `href` and `title` attributes. `title`
  // defaults to the empty string. Rendered and parsed as an `<a>`
  // element.
  link: {
    attrs: {
      href: {},
      title: {default: null}
    },
    inclusive: false,
    parseDOM: [{tag: "a[href]", getAttrs: function getAttrs(dom) {
      return {href: dom.getAttribute("href"), title: dom.getAttribute("title")}
    }}],
    toDOM: function toDOM(node) { return ["a", node.attrs] }
  },

  // :: MarkSpec An emphasis mark. Rendered as an `<em>` element.
  // Has parse rules that also match `<i>` and `font-style: italic`.
  em: {
    parseDOM: [{tag: "i"}, {tag: "em"}, {style: "font-style=italic"}],
    toDOM: function toDOM() { return ["em"] }
  },

  // :: MarkSpec A strong mark. Rendered as `<strong>`, parse rules
  // also match `<b>` and `font-weight: bold`.
  strong: {
    parseDOM: [{tag: "strong"},
               // This works around a Google Docs misbehavior where
               // pasted content will be inexplicably wrapped in `<b>`
               // tags with a font-weight normal.
               {tag: "b", getAttrs: function (node) { return node.style.fontWeight != "normal" && null; }},
               {style: "font-weight", getAttrs: function (value) { return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null; }}],
    toDOM: function toDOM() { return ["strong"] }
  },

  // :: MarkSpec Code font mark. Represented as a `<code>` element.
  code: {
    parseDOM: [{tag: "code"}],
    toDOM: function toDOM() { return ["code"] }
  }
};

// :: Schema
// This schema rougly corresponds to the document schema used by
// [CommonMark](http://commonmark.org/), minus the list elements,
// which are defined in the [`prosemirror-schema-list`](#schema-list)
// module.
//
// To reuse elements from this schema, extend or read from its
// `spec.nodes` and `spec.marks` [properties](#model.Schema.spec).
var schema = new prosemirrorModel.Schema({nodes: nodes, marks: marks});

exports.nodes = nodes;
exports.marks = marks;
exports.schema = schema;
//# sourceMappingURL=schema-basic.js.map


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WokCharts", [], factory);
	else if(typeof exports === 'object')
		exports["WokCharts"] = factory();
	else
		root["WokCharts"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = scaleToViewBox;
/* harmony export (immutable) */ __webpack_exports__["d"] = scaleValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = safeMax;
/* harmony export (immutable) */ __webpack_exports__["b"] = safeMin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__matrix__ = __webpack_require__(9);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};

function scaleToViewBox(points, width, height, xMargin, vMin, vMax) {
    if (xMargin === void 0) { xMargin = 0; }
    var xs = points.map(function (p) { return p[0]; });
    var ys = points.map(function (p) { return p[1]; });
    var xMin = Math.min.apply(Math, __spread(xs)) - xMargin;
    var xMax = Math.max.apply(Math, __spread(xs)) + xMargin;
    var yMin = Math.min.apply(Math, __spread(ys));
    var yMax = Math.max.apply(Math, __spread(ys));
    if (vMin != undefined) {
        yMin = Math.min(yMin, vMin);
    }
    if (vMax != undefined) {
        yMax = Math.max(yMax, vMax);
    }
    if (yMin == yMax) {
        if (yMax == 0) {
            yMax = 1;
        }
        else if (yMax > 0) {
            yMin = 0;
        }
        else {
            yMax = 0;
        }
    }
    var sx = xMax > xMin ? width / (xMax - xMin) : 1;
    var sy = yMax > yMin ? height / (yMax - yMin) : 1;
    var matrix = new __WEBPACK_IMPORTED_MODULE_0__matrix__["a" /* MatrixBuilder3 */]()
        .translate(-xMin, -yMin)
        .scale(sx, -sy)
        .translate(0, height)
        .build();
    return points.map(function (p) {
        if (p[1] === null) {
            p = Object(__WEBPACK_IMPORTED_MODULE_0__matrix__["b" /* multiplyVectorMatrix */])([p[0], 0], matrix);
            return [p[0], null];
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_0__matrix__["b" /* multiplyVectorMatrix */])(p, matrix).splice(0, 2);
        }
    });
}
function scaleValue(value, min, max, l) {
    if (l === void 0) { l = 1; }
    return (value - min) / (max - min) * l;
}
function safeMax() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var v = -Infinity;
    try {
        for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
            var a = args_1_1.value;
            if (Array.isArray(a)) {
                v = a.reduce(function (m, x) { return x != null && x > m ? x : m; }, v);
            }
            else if (typeof a == 'number' && a > v) {
                v = a;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return v;
    var e_1, _a;
}
function safeMin() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var v = Infinity;
    try {
        for (var args_2 = __values(args), args_2_1 = args_2.next(); !args_2_1.done; args_2_1 = args_2.next()) {
            var a = args_2_1.value;
            if (Array.isArray(a)) {
                v = a.reduce(function (m, x) { return x != null && x < m ? x : m; }, v);
            }
            else if (typeof a == 'number' && a < v) {
                v = a;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (args_2_1 && !args_2_1.done && (_a = args_2.return)) _a.call(args_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return v;
    var e_2, _a;
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = currency;
/* harmony export (immutable) */ __webpack_exports__["c"] = pixel;
/* unused harmony export percent */
/* harmony export (immutable) */ __webpack_exports__["b"] = human;
function currency(value) {
    var precision = 2;
    var symbol = "€ ";
    var thousand = ".";
    var decimal = ",";
    var v = value ? value : 0;
    var sign = v < 0 ? "-" : "";
    var i = parseInt(Math.abs(v.toFixed(precision)) + "", 10) + "";
    var j = i.length > 3 ? i.length % 3 : 0;
    return symbol + sign + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (precision ? decimal + Math.abs(v - parseInt(sign + i)).toFixed(precision).slice(precision) : "");
}
function pixel(value) {
    return value ? value.toFixed(0) : 0;
}
function percent(value) {
    var precision = 2;
    var symbol = "%";
    var decimal = ",";
    var v = value ? value.toFixed(precision) : 0.00;
    return (v + "").replace('.', decimal) + symbol;
}
function human(value) {
    if (value >= 1000000) {
        return Math.round(value / 1000000) + 'M';
    }
    else if (value >= 1000) {
        return Math.round(value / 1000) + 'k';
    }
    else {
        return value;
    }
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(6);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bar_chart_bar_chart_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bar_chart_double_bar_chart_double_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_chart_horizontal_bar_chart_horizontal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bullet_graph_bullet_graph_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mini_bar_mini_bar_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spark_line_spark_line_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__radar_chart_radar_chart_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vertical_line_chart_vertical_line_chart_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scatter_plot_scatter_plot_vue__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarChart", function() { return __WEBPACK_IMPORTED_MODULE_0__bar_chart_bar_chart_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarChartDouble", function() { return __WEBPACK_IMPORTED_MODULE_1__bar_chart_double_bar_chart_double_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarChartHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_2__bar_chart_horizontal_bar_chart_horizontal_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BulletGraph", function() { return __WEBPACK_IMPORTED_MODULE_3__bullet_graph_bullet_graph_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MiniBar", function() { return __WEBPACK_IMPORTED_MODULE_4__mini_bar_mini_bar_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SparkLine", function() { return __WEBPACK_IMPORTED_MODULE_5__spark_line_spark_line_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadarChart", function() { return __WEBPACK_IMPORTED_MODULE_6__radar_chart_radar_chart_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalLineChart", function() { return __WEBPACK_IMPORTED_MODULE_7__vertical_line_chart_vertical_line_chart_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScatterPlot", function() { return __WEBPACK_IMPORTED_MODULE_8__scatter_plot_scatter_plot_vue__["a"]; });
// Import, then re-export all default WokCharts widgets.









// WokCharts Vue plugin, to automatically register all components.
/* harmony default export */ __webpack_exports__["default"] = ({
    install: function (V, options) {
        V.component("bar-chart", __WEBPACK_IMPORTED_MODULE_0__bar_chart_bar_chart_vue__["a" /* default */]);
        V.component("bar-chart-double", __WEBPACK_IMPORTED_MODULE_1__bar_chart_double_bar_chart_double_vue__["a" /* default */]);
        V.component("bar-chart-horizontal", __WEBPACK_IMPORTED_MODULE_2__bar_chart_horizontal_bar_chart_horizontal_vue__["a" /* default */]);
        V.component("bullet-graph", __WEBPACK_IMPORTED_MODULE_3__bullet_graph_bullet_graph_vue__["a" /* default */]);
        V.component("mini-bar", __WEBPACK_IMPORTED_MODULE_4__mini_bar_mini_bar_vue__["a" /* default */]);
        V.component("spark-line", __WEBPACK_IMPORTED_MODULE_5__spark_line_spark_line_vue__["a" /* default */]);
        V.component("radar-chart", __WEBPACK_IMPORTED_MODULE_6__radar_chart_radar_chart_vue__["a" /* default */]);
        V.component("vertical-line-chart", __WEBPACK_IMPORTED_MODULE_7__vertical_line_chart_vertical_line_chart_vue__["a" /* default */]);
        V.component("scatter-plot", __WEBPACK_IMPORTED_MODULE_8__scatter_plot_scatter_plot_vue__["a" /* default */]);
    }
});
// Also export all components.



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28de6830_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_vue__ = __webpack_require__(10);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28de6830_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/bar-chart/bar-chart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28de6830", Component.options)
  } else {
    hotAPI.reload("data-v-28de6830", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_filters__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var BarChart = /** @class */ (function (_super) {
    __extends(BarChart, _super);
    function BarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BarChart.prototype, "vMax", {
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["a" /* safeMax */])(this.values, this.target, this.targetGlobal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "scaleTop", {
        get: function () {
            if (this.scales) {
                return this.scales.slice(-1)[0];
            }
            if (this.autoScalesMax > 0) {
                return this.autoScalesMax;
            }
            var top = Math.ceil(this.vMax + (this.topSpace * this.vMax / this.chartHeight));
            if (this.autoScales > 0) {
                return top - (top % (this.autoScales - 1)) + this.autoScales - 1;
            }
            return top;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "responsiveWidth", {
        get: function () {
            if (this.width < window.innerWidth) {
                return this.width;
            }
            else {
                return window.innerWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "viewBox", {
        get: function () {
            var w = this.responsiveWidth;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "barThickness", {
        get: function () {
            var gaps = this.values.length * this.barGaps;
            var t = (this.chartWidth - gaps) / this.values.length;
            return t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "chartHeight", {
        get: function () {
            return this.height - 70;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "chartWidth", {
        get: function () {
            return this.responsiveWidth - 60;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "points", {
        get: function () {
            var points = this.values.map(function (y, x) { return [x, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "targets", {
        get: function () {
            if (this.target && this.target.length > 0) {
                var targets = this.target.map(function (y, x) { return [x, y]; });
                return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(targets, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "scalesPoints", {
        get: function () {
            if (this.scales && this.scales.length > 0) {
                var l = this.scales.length;
                var points = [];
                for (var i = 0; i < l; i++) {
                    points.push([this.scales[i], (l - i) * (this.chartHeight / (l - 1)) - (this.chartHeight / (l - 1))]);
                }
                return points;
            }
            if (this.autoScales > 0) {
                var l = this.autoScales - 1, max = this.scaleTop;
                var points = [];
                for (var i = 0; i <= l; i++) {
                    var v = this.scaleTop / l * i;
                    points.push([v, (1 - (v / max)) * this.chartHeight]);
                }
                return points;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "labels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "targetGlobal", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "scales", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChart.prototype, "autoScales", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChart.prototype, "autoScalesMax", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], BarChart.prototype, "valueLabels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: true })
    ], BarChart.prototype, "xSeparators", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 100 })
    ], BarChart.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChart.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChart.prototype, "padding", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChart.prototype, "topSpace", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 12 })
    ], BarChart.prototype, "barGaps", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], BarChart.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BarChart.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'grey' })
    ], BarChart.prototype, "targetColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(255,35,65)' })
    ], BarChart.prototype, "targetGlobalColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BarChart.prototype, "axisColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(213,218,223)' })
    ], BarChart.prototype, "xSeparatorsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(213,218,223)' })
    ], BarChart.prototype, "ySeparatorsColor", void 0);
    BarChart = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({ filters: { currency: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["a" /* currency */], pixel: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["c" /* pixel */], human: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["b" /* human */] } })
    ], BarChart);
    return BarChart;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (BarChart);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Identity3D */
/* harmony export (immutable) */ __webpack_exports__["b"] = multiplyVectorMatrix;
/* unused harmony export multiplyMatrixMatrix */
/* unused harmony export multiplyMatrices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MatrixBuilder3; });
var Identity3D = [1, 0, 0, 0, 1, 0, 0, 0, 1];
function multiplyVectorMatrix(v, m) {
    var x = v[0], y = v[1], z = v[2] || 1;
    return [
        x * m[0] + y * m[3] + z * m[6],
        x * m[1] + y * m[4] + z * m[7],
        x * m[2] + y * m[5] + z * m[8]
    ];
}
function multiplyMatrixMatrix(m, n) {
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5], m6 = m[6], m7 = m[7], m8 = m[8];
    var n0 = n[0], n1 = n[1], n2 = n[2], n3 = n[3], n4 = n[4], n5 = n[5], n6 = n[6], n7 = n[7], n8 = n[8];
    return [
        m0 * n0 + m1 * n3 + m2 * n6,
        m0 * n1 + m1 * n4 + m2 * n7,
        m0 * n2 + m1 * n5 + m2 * n8,
        m3 * n0 + m4 * n3 + m5 * n6,
        m3 * n1 + m4 * n4 + m5 * n7,
        m3 * n2 + m4 * n5 + m5 * n8,
        m6 * n0 + m7 * n3 + m8 * n6,
        m6 * n1 + m7 * n4 + m8 * n7,
        m6 * n2 + m7 * n5 + m8 * n8
    ];
}
function multiplyMatrices(ms) {
    if (!ms) {
        throw Error("ms: argument can't be null");
    }
    if (ms.length > 0) {
        var m = ms[0];
        for (var i = 1; i < ms.length; i++) {
            m = multiplyMatrixMatrix(m, ms[i]);
        }
        return m;
    }
    return Identity3D;
}
var MatrixBuilder3 = /** @class */ (function () {
    function MatrixBuilder3(m) {
        if (m === void 0) { m = Identity3D; }
        this.m = m;
    }
    MatrixBuilder3.prototype.scale = function (x, y) {
        this.m = multiplyMatrixMatrix(this.m, [
            x, 0, 0,
            0, y, 0,
            0, 0, 1
        ]);
        return this;
    };
    MatrixBuilder3.prototype.rotate = function (a) {
        this.m = multiplyMatrixMatrix(this.m, [
            Math.cos(a), Math.sin(a), 0,
            -Math.sin(a), Math.cos(a), 0,
            0, 0, 1
        ]);
        return this;
    };
    MatrixBuilder3.prototype.translate = function (x, y) {
        this.m = multiplyMatrixMatrix(this.m, [
            1, 0, 0,
            0, 1, 0,
            x, y, 1
        ]);
        return this;
    };
    MatrixBuilder3.prototype.build = function () {
        return this.m;
    };
    return MatrixBuilder3;
}());



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bar-chart",
      style:
        "padding: " +
        _vm.padding +
        "px;" +
        " background-color: " +
        _vm.bgColor +
        ";"
    },
    [
      _c("svg", { attrs: { version: "1.1", viewBox: _vm.viewBox } }, [
        _c(
          "g",
          { staticClass: "graph", attrs: { transform: "translate(40, 30)" } },
          [
            _vm._l(_vm.points, function(p, i) {
              return i > 0 && _vm.xSeparators
                ? _c("g", { key: p + i, staticClass: "x-separators" }, [
                    _c("line", {
                      attrs: {
                        stroke: _vm.xSeparatorsColor,
                        "stroke-width": "1",
                        x1: p[0] - _vm.barThickness / 2 - _vm.barGaps / 2,
                        y1: "0",
                        x2: p[0] - _vm.barThickness / 2 - _vm.barGaps / 2,
                        y2: _vm.chartHeight,
                        "shape-rendering": "crispEdges"
                      }
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        stroke: _vm.xSeparatorsColor,
                        "stroke-width": "1",
                        x1: _vm.chartWidth - 0.5,
                        y1: "0",
                        x2: _vm.chartWidth - 0.5,
                        y2: _vm.chartHeight,
                        "shape-rendering": "crispEdges"
                      }
                    })
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(_vm.scalesPoints, function(s, i) {
              return i != 0
                ? _c("g", { key: s + i, staticClass: "y-separators" }, [
                    _c("line", {
                      attrs: {
                        stroke: _vm.ySeparatorsColor,
                        "stroke-width": "1",
                        "stroke-linecap": "round",
                        "stroke-dasharray": _vm.xSeparators ? (0.5, 3) : null,
                        x1: "0",
                        y1: s[1] - 0.5,
                        x2: _vm.chartWidth,
                        y2: s[1] - 0.5
                      }
                    })
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(_vm.points, function(k, i) {
              return _c("g", { key: k + i, staticClass: "column" }, [
                _vm.points[i] !== null
                  ? _c("rect", {
                      staticClass: "bar",
                      staticStyle: { transition: "all 0.3s" },
                      attrs: {
                        fill: _vm.barColor,
                        x: _vm.points[i][0] - _vm.barThickness / 2,
                        y: _vm.points[i][1],
                        width: _vm.barThickness,
                        height: _vm.chartHeight - _vm.points[i][1]
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.target && _vm.target.length > 0
                  ? _c("rect", {
                      staticClass: "target",
                      staticStyle: { transition: "all 0.3s" },
                      attrs: {
                        fill: _vm.targetColor,
                        x: _vm.targets[i][0] - _vm.barThickness / 2 - 3,
                        y: _vm._f("pixel")(_vm.targets[i][1]),
                        width: _vm.barThickness + 6,
                        height: "1",
                        "shape-rendering": "crispEdges"
                      }
                    })
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            _vm.targetGlobal != null
              ? _c("line", {
                  staticClass: "target-global",
                  attrs: {
                    "stroke-width": "2",
                    stroke: _vm.targetGlobalColor,
                    x1: "0",
                    y1:
                      (1 - _vm.targetGlobal / _vm.scaleTop) * _vm.chartHeight -
                      0.5,
                    x2: _vm.chartWidth,
                    y2:
                      (1 - _vm.targetGlobal / _vm.scaleTop) * _vm.chartHeight -
                      0.5,
                    "shape-rendering": "crispEdges"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.valueLabels
              ? _c(
                  "g",
                  { staticClass: "value-labels" },
                  _vm._l(_vm.points, function(k, i) {
                    return _vm.values[i] > 0
                      ? _c(
                          "text",
                          {
                            key: k + i,
                            staticClass: "value-label",
                            staticStyle: {
                              "font-size": "12px",
                              "font-family": "'Fira Sans'",
                              "font-weight": "500"
                            },
                            attrs: {
                              fill: _vm.barColor,
                              transform:
                                "rotate(-60," +
                                _vm.points[i][0] +
                                "," +
                                (_vm.points[i][1] - 3) +
                                ")",
                              x: _vm.points[i][0],
                              y: _vm.points[i][1] - 3
                            }
                          },
                          [_vm._v(_vm._s(_vm.values[i]))]
                        )
                      : _vm._e()
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            _c("line", {
              staticClass: "y-axis",
              attrs: {
                "stroke-width": "1",
                stroke: _vm.axisColor,
                x1: "0",
                y1: "0",
                x2: "0",
                y2: _vm.chartHeight + 0.5,
                "shape-rendering": "crispEdges"
              }
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "x-axis",
              attrs: {
                "stroke-width": "1",
                stroke: _vm.axisColor,
                x1: "0",
                y1: _vm.chartHeight + 0.5,
                x2: _vm.chartWidth,
                y2: _vm.chartHeight + 0.5,
                "shape-rendering": "crispEdges"
              }
            }),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "x-labels" },
              _vm._l(_vm.labels, function(l, i) {
                return _c(
                  "text",
                  {
                    key: l + i,
                    staticStyle: {
                      "font-size": "13px",
                      "text-transform": "lowercase",
                      "font-variant": "small-caps",
                      "font-family": "'Fira Sans'",
                      "font-weight": "300"
                    },
                    attrs: {
                      fill: "black",
                      "text-anchor": "middle",
                      x:
                        i * (_vm.chartWidth / _vm.labels.length) +
                        _vm.chartWidth / (_vm.labels.length * 2),
                      y: _vm.chartHeight + 20
                    }
                  },
                  [_vm._v(_vm._s(l))]
                )
              })
            ),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "y-labels" },
              _vm._l(_vm.scalesPoints, function(s, i) {
                return _c(
                  "text",
                  {
                    key: s + i,
                    staticStyle: {
                      "font-size": "12px",
                      "font-family": "'Fira Sans'",
                      "font-weight": "300"
                    },
                    attrs: {
                      fill: "black",
                      "text-anchor": "end",
                      x: "-8",
                      y: s[1] + 3
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("human")(s[0])))]
                )
              })
            )
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28de6830", esExports)
  }
}

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_double_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9e81d34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_double_vue__ = __webpack_require__(13);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_double_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9e81d34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_double_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/bar-chart-double/bar-chart-double.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e9e81d34", Component.options)
  } else {
    hotAPI.reload("data-v-e9e81d34", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_filters__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};




var BarChartDouble = /** @class */ (function (_super) {
    __extends(BarChartDouble, _super);
    function BarChartDouble() {
        // Props definitions.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Reactive data
        _this.stepLastEvent = null;
        _this.stepValue = null;
        _this.stepTarget = null;
        _this.isLeftCol = false;
        _this.scales = [1000, 10000, 50000, 100000, 200000, 300000, 500000, 1000000];
        return _this;
    }
    Object.defineProperty(BarChartDouble.prototype, "vMax", {
        get: function () {
            var values1 = this.values1.filter(function (x) { return x != null; });
            var values2 = this.values2.filter(function (x) { return x != null; });
            var target2 = this.target2.filter(function (x) { return x != null; });
            return Math.max.apply(Math, __spread(values1, values2, target2));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "scaleTop", {
        get: function () {
            var s = this.scales[0];
            for (var i = 1; i < this.scales.length; i++) {
                if (s >= this.vMax) {
                    return s;
                }
                ;
                s = this.scales[i];
            }
            return s;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "viewBox", {
        // Generated properties
        get: function () {
            var w = this.width;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "barThickness", {
        get: function () {
            var gaps = this.values1.length * this.barGaps;
            var t = (this.chartWidth - gaps) / this.values1.length;
            return t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "chartHeight", {
        get: function () {
            return this.height - 70;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "chartWidth", {
        get: function () {
            return this.width - 60;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "points1", {
        get: function () {
            var vs = this.values1;
            var points = vs.map(function (y, x) { return [x, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "points2", {
        get: function () {
            var vs = this.values2;
            var points = vs.map(function (y, x) { return [x, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "targets2", {
        get: function () {
            var vs = this.target2;
            var targets = vs.map(function (y, x) { return [x, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(targets, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
        },
        enumerable: true,
        configurable: true
    });
    // Methods
    BarChartDouble.prototype.updated = function () {
        if (this.stepLastEvent && this.stepLastEvent.target instanceof SVGElement) {
            var label = document.querySelector(".step-label");
            var yPos = this.stepLastEvent.target.getAttribute("y");
            var xPos = this.stepLastEvent.target.getAttribute("x");
            var height = this.stepLastEvent.target.getAttribute("height");
            var width = this.stepLastEvent.target.getAttribute("width");
            this.stepValue = parseFloat(this.stepLastEvent.target.getAttribute("data-value"));
            this.stepTarget = parseFloat(this.stepLastEvent.target.getAttribute("data-target"));
            label.style.left = parseInt(xPos) + parseInt(width) + 59 + 'px';
            label.style.top = parseInt(yPos) + (parseInt(height) / 2) + 43 + 'px';
            label.style.transform = 'translateY(-50%)';
        }
    };
    BarChartDouble.prototype.onStepOver = function (evt) {
        if (evt.target instanceof SVGElement && this.stepLastEvent === null) {
            this.stepLastEvent = evt;
        }
    };
    BarChartDouble.prototype.onStepOut = function (evt) {
        if (evt.target instanceof SVGElement) {
            this.stepLastEvent = null;
        }
    };
    BarChartDouble.prototype.onLeftColOver = function (evt) {
        if (evt.target instanceof SVGElement && this.stepLastEvent === null) {
            this.stepLastEvent = evt;
            this.isLeftCol = true;
        }
    };
    BarChartDouble.prototype.onLeftColOut = function (evt) {
        if (evt.target instanceof SVGElement) {
            this.stepLastEvent = null;
            this.isLeftCol = false;
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 100 })
    ], BarChartDouble.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartDouble.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BarChartDouble.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'grey' })
    ], BarChartDouble.prototype, "barColorTwo", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'grey' })
    ], BarChartDouble.prototype, "targetColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 12 })
    ], BarChartDouble.prototype, "barGaps", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BarChartDouble.prototype, "axisColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(200,200,200)' })
    ], BarChartDouble.prototype, "xSeparatorsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(200,200,200)' })
    ], BarChartDouble.prototype, "ySeparatorsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], BarChartDouble.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "icon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "labels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "values1", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "values2", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "target2", void 0);
    BarChartDouble = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({ filters: { currency: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["a" /* currency */], pixel: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["c" /* pixel */], human: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["b" /* human */] } })
    ], BarChartDouble);
    return BarChartDouble;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (BarChartDouble);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bar-chart-double" }, [
    _c(
      "svg",
      {
        style: "padding:2px;background-color:" + _vm.bgColor + ";",
        attrs: { version: "1.1", viewBox: _vm.viewBox }
      },
      [
        _c(
          "g",
          { staticClass: "graph", attrs: { transform: "translate(40, 40)" } },
          [
            _vm._l(_vm.points1, function(p, i) {
              return i > 0
                ? _c("g", { key: i, staticClass: "x-separators" }, [
                    _c("line", {
                      attrs: {
                        stroke: _vm.xSeparatorsColor,
                        "stroke-width": "1",
                        x1: p[0] - _vm.barThickness / 2 - _vm.barGaps / 2,
                        y1: "0",
                        x2: p[0] - _vm.barThickness / 2 - _vm.barGaps / 2,
                        y2: _vm.chartHeight,
                        "shape-rendering": "crispEdges"
                      }
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        stroke: _vm.xSeparatorsColor,
                        "stroke-width": "1",
                        x1: _vm.chartWidth - 0.5,
                        y1: "0",
                        x2: _vm.chartWidth - 0.5,
                        y2: _vm.chartHeight,
                        "shape-rendering": "crispEdges"
                      }
                    })
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(10, function(j) {
              return _c("g", { key: j, staticClass: "y-separators" }, [
                _c("line", {
                  attrs: {
                    stroke: _vm.ySeparatorsColor,
                    "stroke-width": "1",
                    "stroke-linecap": "round",
                    "stroke-dasharray": "0.5, 3",
                    x1: "0",
                    y1: j * (_vm.chartHeight / 10) - _vm.chartHeight / 10 - 0.5,
                    x2: _vm.chartWidth,
                    y2: j * (_vm.chartHeight / 10) - _vm.chartHeight / 10 - 0.5
                  }
                })
              ])
            }),
            _vm._v(" "),
            _vm._l(_vm.points1.length, function(k, i) {
              return _c("g", { key: i, staticClass: "column-left" }, [
                _vm.points1[i] !== null
                  ? _c("rect", {
                      staticClass: "bar",
                      staticStyle: { transition: "all 0.3s" },
                      attrs: {
                        fill: _vm.barColor,
                        x: _vm.points1[i][0] - _vm.barThickness / 2,
                        y: _vm.points1[i][1],
                        width: _vm.barThickness / 3,
                        height: _vm.chartHeight - _vm.points1[i][1]
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "col-bg",
                  attrs: {
                    fill: _vm.barColorTwo,
                    x: _vm.points1[i][0] - _vm.barThickness / 3 - _vm.barGaps,
                    y: "0",
                    width: _vm.barThickness / 3 + _vm.barGaps,
                    height: _vm.chartHeight
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "col-event",
                  staticStyle: { cursor: "pointer" },
                  attrs: {
                    fill: "transparent",
                    x: _vm.points1[i][0] - _vm.barThickness / 3 - _vm.barGaps,
                    y: "0",
                    width: _vm.barThickness / 3 + _vm.barGaps,
                    height: _vm.chartHeight,
                    "data-value": _vm.values1[i]
                  },
                  on: {
                    mouseover: _vm.onLeftColOver,
                    mouseout: _vm.onLeftColOut
                  }
                })
              ])
            }),
            _vm._v(" "),
            _vm._l(_vm.points2.length, function(k, i) {
              return _c("g", { key: i, staticClass: "column-right" }, [
                _vm.points2[i] !== null
                  ? _c("rect", {
                      staticClass: "bar",
                      staticStyle: { transition: "all 0.3s" },
                      attrs: {
                        fill: _vm.barColorTwo,
                        x:
                          _vm.points2[i][0] -
                          _vm.barThickness / 6 +
                          _vm.barThickness / 3,
                        y: _vm.points2[i][1],
                        width: _vm.barThickness / 3,
                        height: _vm.chartHeight - _vm.points2[i][1]
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "target",
                  staticStyle: { transition: "all 0.3s" },
                  attrs: {
                    fill: _vm.targetColor,
                    x:
                      _vm.targets2[i][0] -
                      _vm.barThickness / 6 +
                      _vm.barThickness / 3 -
                      3,
                    y: _vm._f("pixel")(_vm.targets2[i][1]),
                    width: _vm.barThickness / 3 + 6,
                    height: "1",
                    "shape-rendering": "crispEdges"
                  }
                }),
                _vm._v(" "),
                (_vm.points2[i][1] !== _vm.chartHeight) |
                (_vm.targets2[i][1] !== _vm.chartHeight)
                  ? _c("g", { staticClass: "difference" }, [
                      _c("line", {
                        attrs: {
                          stroke: _vm.targetColor,
                          "stroke-width": "1",
                          x1: _vm.points2[i][0] + _vm.barThickness / 3,
                          y1: _vm.targets2[i][1],
                          x2: _vm.points2[i][0] + _vm.barThickness / 3,
                          y2: _vm.points2[i][1]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          staticClass: "arrow-top",
                          attrs: {
                            transform:
                              "translate(" +
                              (_vm.points2[i][0] + _vm.barThickness / 3) +
                              "," +
                              _vm.targets2[i][1] +
                              ")"
                          }
                        },
                        [
                          _c("polygon", {
                            attrs: {
                              points: "-3,4 0,0 3,4",
                              fill: _vm.targetColor
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          staticClass: "arrow-bottom",
                          attrs: {
                            transform:
                              "translate(" +
                              (_vm.points2[i][0] + _vm.barThickness / 3) +
                              "," +
                              _vm.points2[i][1] +
                              ")"
                          }
                        },
                        [
                          _c("polygon", {
                            attrs: {
                              points: "-3,-4 0,0 3,-4",
                              fill: _vm.targetColor
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "col-bg",
                  attrs: {
                    fill: _vm.barColor,
                    x: _vm.points2[i][0] + _vm.barThickness / 3 - _vm.barGaps,
                    y: "0",
                    width: _vm.barThickness / 3 + _vm.barGaps,
                    height: _vm.chartHeight
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "col-event",
                  staticStyle: { cursor: "pointer" },
                  attrs: {
                    fill: "transparent",
                    x: _vm.points2[i][0] + _vm.barThickness / 3 - _vm.barGaps,
                    y: "0",
                    width: _vm.barThickness / 3 + _vm.barGaps,
                    height: _vm.chartHeight,
                    "data-value": _vm.values2[i],
                    "data-target": _vm.target2[i]
                  },
                  on: { mouseover: _vm.onStepOver, mouseout: _vm.onStepOut }
                })
              ])
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "y-axis",
              attrs: {
                "stroke-width": "1",
                stroke: _vm.axisColor,
                x1: "0",
                y1: "-10",
                x2: "0",
                y2: _vm.chartHeight + 0.5,
                "shape-rendering": "crispEdges"
              }
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "x-axis",
              attrs: {
                "stroke-width": "1",
                stroke: _vm.axisColor,
                x1: "0",
                y1: _vm.chartHeight + 0.5,
                x2: _vm.chartWidth,
                y2: _vm.chartHeight + 0.5,
                "shape-rendering": "crispEdges"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              staticClass: "chart-icon-bg",
              attrs: { cx: "0", cy: "-20", r: "10", fill: _vm.axisColor }
            }),
            _vm._v(" "),
            _c("image", {
              attrs: {
                "xlink:href": _vm.icon,
                x: "-5.5",
                y: "-25.5",
                width: "10",
                height: "10"
              }
            }),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "x-labels" },
              _vm._l(_vm.labels, function(l, i) {
                return _c(
                  "text",
                  {
                    key: i,
                    staticStyle: {
                      "font-size": "13px",
                      "text-transform": "lowercase",
                      "font-variant": "small-caps",
                      "font-family": "'Fira Sans'",
                      "font-weight": "300"
                    },
                    attrs: {
                      fill: "black",
                      "text-anchor": "middle",
                      x:
                        i * (_vm.chartWidth / _vm.labels.length) +
                        _vm.chartWidth / (_vm.labels.length * 2),
                      y: _vm.chartHeight + 20
                    }
                  },
                  [_vm._v(_vm._s(l))]
                )
              })
            ),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "y-labels" },
              _vm._l(10, function(j) {
                return _c(
                  "text",
                  {
                    key: j,
                    staticStyle: {
                      "font-size": "12px",
                      "font-family": "'Fira Sans'",
                      "font-weight": "300"
                    },
                    attrs: {
                      fill: "black",
                      "text-anchor": "end",
                      x: "-8",
                      y: _vm.chartHeight - j * (_vm.chartHeight / 10) + 3
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("human")(_vm.scaleTop / 10 * j)))]
                )
              })
            )
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !!_vm.stepLastEvent,
            expression: "!!stepLastEvent"
          }
        ],
        staticClass: "step-label"
      },
      [
        _vm.isLeftCol
          ? _c(
              "div",
              {
                staticClass: "step-label-values",
                style: "color:" + _vm.barColor + ";"
              },
              [
                _c("div", { staticClass: "step-label-row" }, [
                  _c("div", { staticClass: "step-label-title" }, [
                    _vm._v("Fatturato:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-label-value" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.stepValue)))
                  ])
                ])
              ]
            )
          : _c(
              "div",
              {
                staticClass: "step-label-values",
                style: "color:" + _vm.barColor + ";"
              },
              [
                _c("div", { staticClass: "step-label-row" }, [
                  _c("div", { staticClass: "step-label-title" }, [
                    _vm._v("Consuntivato:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-label-value" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.stepValue)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "step-label-row" }, [
                  _c("div", { staticClass: "step-label-title" }, [
                    _vm._v("Ordinato:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-label-value" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.stepTarget)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "step-label-row" }, [
                  _c("div", { staticClass: "step-label-title" }, [
                    _vm._v("Differenza:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-label-value" }, [
                    _vm._v(
                      _vm._s(_vm._f("currency")(_vm.stepValue - _vm.stepTarget))
                    )
                  ])
                ])
              ]
            )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9e81d34", esExports)
  }
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_horizontal_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a81c74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_horizontal_vue__ = __webpack_require__(16);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_horizontal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a81c74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_horizontal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/bar-chart-horizontal/bar-chart-horizontal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-87a81c74", Component.options)
  } else {
    hotAPI.reload("data-v-87a81c74", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var BarChartHorizontal = /** @class */ (function (_super) {
    __extends(BarChartHorizontal, _super);
    function BarChartHorizontal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BarChartHorizontal.prototype, "responsiveWidth", {
        get: function () {
            if (this.width < window.innerWidth) {
                return this.width;
            }
            else {
                return window.innerWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartHorizontal.prototype, "height", {
        get: function () {
            return this.paddingTop + this.paddingBottom + (this.barThickness + this.barGaps) * this.points.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartHorizontal.prototype, "viewBox", {
        get: function () {
            var w = this.responsiveWidth;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartHorizontal.prototype, "plotPoints", {
        get: function () {
            var _this = this;
            var ps = {};
            ps = (this.points.map(function (v, i) {
                var w = _this.responsiveWidth - _this.paddingLeft - _this.paddingRight;
                var hs = (_this.height - _this.paddingTop - _this.paddingBottom - (_this.barThickness)) / (_this.points.length - 1);
                return {
                    x: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["d" /* scaleValue */])(v.value, _this.rangeMin, _this.rangeMax, w) + _this.paddingLeft,
                    y: (hs * i + _this.paddingTop)
                };
            }));
            return ps;
        },
        enumerable: true,
        configurable: true
    });
    BarChartHorizontal.prototype.barLabelsXPos = function (value) {
        if (value == 0) {
            return 0;
        }
        else if (value > 90) {
            return -8;
        }
        else {
            return 8;
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], BarChartHorizontal.prototype, "points", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChartHorizontal.prototype, "rangeMin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 100 })
    ], BarChartHorizontal.prototype, "rangeMax", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 700 })
    ], BarChartHorizontal.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartHorizontal.prototype, "paddingTop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartHorizontal.prototype, "paddingRight", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartHorizontal.prototype, "paddingBottom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 80 })
    ], BarChartHorizontal.prototype, "paddingLeft", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 30 })
    ], BarChartHorizontal.prototype, "barThickness", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartHorizontal.prototype, "barGaps", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], BarChartHorizontal.prototype, "showMarkers", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgba(0,0,0,0.05)' })
    ], BarChartHorizontal.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'coral' })
    ], BarChartHorizontal.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 16 })
    ], BarChartHorizontal.prototype, "pointsLabelsTextSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 30 })
    ], BarChartHorizontal.prototype, "pointsLabelsImageSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(100,100,100)' })
    ], BarChartHorizontal.prototype, "pointsLabelsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(50,50,50)' })
    ], BarChartHorizontal.prototype, "barLabelsColor", void 0);
    BarChartHorizontal = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], BarChartHorizontal);
    return BarChartHorizontal;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (BarChartHorizontal);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bar-chart-horizontal" }, [
    _c(
      "svg",
      {
        style: "background-color: " + _vm.bgColor + ";",
        attrs: {
          version: "1.1",
          width: _vm.responsiveWidth,
          height: _vm.height,
          viewBox: _vm.viewBox
        }
      },
      [
        _c(
          "g",
          { staticClass: "points" },
          _vm._l(_vm.plotPoints, function(p, index) {
            return _c("rect", {
              key: index + "_value",
              staticClass: "value_bar",
              attrs: {
                fill: _vm.barColor,
                x: _vm.paddingLeft,
                y: p.y,
                stroke: _vm.barColor,
                width: p.x - _vm.paddingLeft,
                height: _vm.barThickness
              }
            })
          })
        ),
        _vm._v(" "),
        _vm._l(_vm.plotPoints, function(p, index) {
          return _c(
            "g",
            {
              key: index + "_value_label",
              staticClass: "labels",
              attrs: {
                transform: "translate(0, " + (p.y + _vm.barThickness / 2) + ")"
              }
            },
            [
              _c(
                "text",
                {
                  attrs: {
                    x: p.x,
                    y: "0",
                    dx: _vm.barLabelsXPos(_vm.points[index].value),
                    dy: "5",
                    "text-anchor":
                      _vm.points[index].value > 90 ? "end" : "start",
                    "font-size": _vm.pointsLabelsTextSize,
                    fill: _vm.barLabelsColor
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.points[index].value) +
                      "%\n            "
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.showMarkers
                ? _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.paddingLeft - 24,
                        y: "0",
                        dy: "5",
                        "font-size": _vm.pointsLabelsTextSize,
                        "text-anchor": "end",
                        fill: _vm.pointsLabelsColor
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.points[index].label) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMarkers
                ? _c("image", {
                    attrs: {
                      "xlink:href": _vm.points[index].markerUrl,
                      height: _vm.pointsLabelsImageSize,
                      width: _vm.pointsLabelsImageSize,
                      x: _vm.paddingLeft - _vm.pointsLabelsImageSize - 20,
                      y: -(_vm.pointsLabelsImageSize / 2)
                    }
                  })
                : _vm._e()
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87a81c74", esExports)
  }
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bullet_graph_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d83bd86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bullet_graph_vue__ = __webpack_require__(19);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bullet_graph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d83bd86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bullet_graph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/bullet-graph/bullet-graph.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d83bd86", Component.options)
  } else {
    hotAPI.reload("data-v-0d83bd86", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var BulletGraph = /** @class */ (function (_super) {
    __extends(BulletGraph, _super);
    function BulletGraph() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BulletGraph.prototype, "viewBox", {
        // Generated properties
        get: function () {
            var w = this.width;
            var h = this.height;
            if (this.showLabels) {
                h = this.height * 2;
            }
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 100 })
    ], BulletGraph.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 20 })
    ], BulletGraph.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(220,220,220)' })
    ], BulletGraph.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(80,80,80)' })
    ], BulletGraph.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BulletGraph.prototype, "strokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(150,150,150)' })
    ], BulletGraph.prototype, "labelColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], BulletGraph.prototype, "showLabels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BulletGraph.prototype, "values", void 0);
    BulletGraph = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], BulletGraph);
    return BulletGraph;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (BulletGraph);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bullet-graph", staticStyle: { "font-size": "0" } },
    [
      _c(
        "svg",
        {
          style: _vm.showLabels ? "padding: 2px 14px;" : "padding: 2px;",
          attrs: { version: "1.1", viewBox: _vm.viewBox }
        },
        [
          _c("rect", {
            staticClass: "bg",
            attrs: {
              fill: _vm.bgColor,
              x: "0",
              y: "0",
              width: _vm.width,
              height: _vm.height
            }
          }),
          _vm._v(" "),
          _c("rect", {
            staticClass: "bar",
            attrs: {
              fill: _vm.barColor,
              x: "0",
              y: _vm.height / 4,
              width: _vm.values[0],
              height: _vm.height / 2,
              "shape-rendering": "crispEdges"
            }
          }),
          _vm._v(" "),
          _c("line", {
            attrs: {
              x1: _vm.values[1] + 0.5,
              y1: "0",
              x2: _vm.values[1] + 0.5,
              y2: _vm.height,
              stroke: _vm.strokeColor,
              "stroke-width": "1"
            }
          }),
          _vm._v(" "),
          _vm.showLabels
            ? _c("g", { staticClass: "percentage-labels" }, [
                _c("g", { staticClass: "label-lines" }, [
                  _c("line", {
                    attrs: {
                      x1: "0.5",
                      y1: _vm.height,
                      x2: "0.5",
                      y2: _vm.height + 5,
                      stroke: _vm.labelColor,
                      "stroke-width": "1"
                    }
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: {
                      x1: _vm.width / 2 + 0.5,
                      y1: _vm.height,
                      x2: _vm.width / 2 + 0.5,
                      y2: _vm.height + 5,
                      stroke: _vm.labelColor,
                      "stroke-width": "1"
                    }
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: {
                      x1: _vm.width - 0.5,
                      y1: _vm.height,
                      x2: _vm.width - 0.5,
                      y2: _vm.height + 5,
                      stroke: _vm.labelColor,
                      "stroke-width": "1"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("g", { staticClass: "label-texts" }, [
                  _c(
                    "text",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "font-family": "'Fira Sans'",
                        "font-weight": "300"
                      },
                      attrs: {
                        x: "0",
                        y: _vm.height,
                        dy: "16",
                        fill: _vm.labelColor,
                        "text-anchor": "middle"
                      }
                    },
                    [_vm._v("0%")]
                  ),
                  _vm._v(" "),
                  _c(
                    "text",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "font-family": "'Fira Sans'",
                        "font-weight": "300"
                      },
                      attrs: {
                        x: _vm.width / 2,
                        y: _vm.height,
                        dy: "16",
                        fill: _vm.labelColor,
                        "text-anchor": "middle"
                      }
                    },
                    [_vm._v("50%")]
                  ),
                  _vm._v(" "),
                  _c(
                    "text",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "font-family": "'Fira Sans'",
                        "font-weight": "300"
                      },
                      attrs: {
                        x: _vm.width,
                        y: _vm.height,
                        dy: "16",
                        fill: _vm.labelColor,
                        "text-anchor": "middle"
                      }
                    },
                    [_vm._v("100%")]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d83bd86", esExports)
  }
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_mini_bar_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21daf074_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_mini_bar_vue__ = __webpack_require__(22);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_mini_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21daf074_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_mini_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/mini-bar/mini-bar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21daf074", Component.options)
  } else {
    hotAPI.reload("data-v-21daf074", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var MiniBar = /** @class */ (function (_super) {
    __extends(MiniBar, _super);
    function MiniBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MiniBar.prototype, "viewBox", {
        // Generated properties
        get: function () {
            var w = this.width;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MiniBar.prototype, "barThickness", {
        get: function () {
            var gaps = 0;
            if (this.gaps) {
                gaps = this.values.length * 2;
            }
            var t = (this.width - gaps) / this.values.length;
            return t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MiniBar.prototype, "points", {
        get: function () {
            var points = this.values.map(function (y, i) { return [i, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.width, this.height, 0.5, this.vMin, this.vMax);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 100 })
    ], MiniBar.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], MiniBar.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'black' })
    ], MiniBar.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(220,220,220)' })
    ], MiniBar.prototype, "axisColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], MiniBar.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], MiniBar.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], MiniBar.prototype, "vMin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], MiniBar.prototype, "vMax", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: true })
    ], MiniBar.prototype, "gaps", void 0);
    MiniBar = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], MiniBar);
    return MiniBar;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (MiniBar);


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "mini-bar", staticStyle: { "font-size": "0" } },
      [
        _c(
          "svg",
          {
            style: "padding:2px;background-color:" + _vm.bgColor + ";",
            attrs: { version: "1.1", viewBox: _vm.viewBox }
          },
          [
            _vm._l(_vm.points, function(p) {
              return p[1] != null && p[1] != _vm.height
                ? _c("rect", {
                    key: p[0],
                    attrs: {
                      x: p[0] - _vm.barThickness / 2,
                      y: p[1],
                      width: _vm.barThickness,
                      height: _vm.height - p[1],
                      fill: _vm.barColor
                    }
                  })
                : _vm._e()
            }),
            _vm._v(" "),
            _c("line", {
              attrs: {
                x1: "0",
                y1: _vm.height - 0.5,
                x2: _vm.width,
                y2: _vm.height - 0.5,
                "stroke-width": "1",
                stroke: _vm.axisColor
              }
            })
          ],
          2
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21daf074", esExports)
  }
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_spark_line_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9ead34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_spark_line_vue__ = __webpack_require__(25);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_spark_line_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9ead34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_spark_line_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/spark-line/spark-line.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e9ead34", Component.options)
  } else {
    hotAPI.reload("data-v-6e9ead34", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var SparkLine = /** @class */ (function (_super) {
    __extends(SparkLine, _super);
    function SparkLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SparkLine.prototype, "viewBox", {
        // Generated properties
        get: function () {
            var w = this.width;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SparkLine.prototype, "pathD", {
        get: function () {
            var ps = this.transformValues();
            var d = "";
            var start = true;
            for (var i = 0; i < ps.length; i++) {
                if (ps[i][1] === null) {
                    start = true;
                }
                else {
                    if (start) {
                        d += " M " + ps[i][0] + " " + ps[i][1];
                        start = false;
                    }
                    else {
                        d += " L " + ps[i][0] + " " + ps[i][1];
                    }
                }
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    SparkLine.prototype.transformValues = function () {
        var vs = this.values;
        var points = vs.map(function (y, x) { return [x, y]; });
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.width, this.height, 0, this.vMin, this.vMax);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 100 })
    ], SparkLine.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 20 })
    ], SparkLine.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], SparkLine.prototype, "strokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], SparkLine.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], SparkLine.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], SparkLine.prototype, "vMin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], SparkLine.prototype, "vMax", void 0);
    SparkLine = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], SparkLine);
    return SparkLine;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (SparkLine);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sparkline" }, [
    _c(
      "svg",
      {
        style: "padding:2px;background-color:" + _vm.bgColor + ";",
        attrs: { version: "1.1", viewBox: _vm.viewBox }
      },
      [
        _c("path", {
          attrs: {
            d: _vm.pathD,
            stroke: _vm.strokeColor,
            "stroke-width": "1",
            fill: "transparent"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e9ead34", esExports)
  }
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_radar_chart_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078c9d54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_radar_chart_vue__ = __webpack_require__(28);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_radar_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078c9d54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_radar_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/radar-chart/radar-chart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-078c9d54", Component.options)
  } else {
    hotAPI.reload("data-v-078c9d54", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


function valueToPoint(value, index, count, diameter, xoffset, yoffset) {
    if (xoffset === void 0) { xoffset = 0; }
    if (yoffset === void 0) { yoffset = 0; }
    var r = diameter / 2;
    var angle = ((Math.PI * 2) / count) * index - (Math.PI / 2);
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var tx = r + value * r * cos + xoffset;
    var ty = r + value * r * sin + yoffset;
    return [tx, ty];
}
function scaleValues(values, min, max) {
    if (min === void 0) { min = 0.1; }
    if (max === void 0) { max = 0.9; }
    var l = max - min;
    var pointsMax = __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["a" /* safeMax */].apply(void 0, __spread(values));
    return values.map(function (x) { return x.map(function (p) {
        var s = p / pointsMax;
        return l * s + min;
    }); });
}
var RadarChart = /** @class */ (function (_super) {
    __extends(RadarChart, _super);
    function RadarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RadarChart.prototype, "responsiveSize", {
        /*  @Watch('values')
         watchValues(newValue: number[][], oldValue: number[][]) {
             console.log("WATCH", oldValue);
         } */
        get: function () {
            var d = this.diameter;
            var s = d + (d / 6);
            var ms = window.innerWidth - 80;
            var md = ms * 6 / 7;
            if (s < ms) {
                return {
                    size: s,
                    diameter: d
                };
            }
            else {
                return {
                    size: ms,
                    diameter: md
                };
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "viewBox", {
        get: function () {
            return '0 0 ' + this.responsiveSize.size + ' ' + this.responsiveSize.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "labels", {
        get: function () {
            return this.markersColors.map(function (l) { return ({ color: l }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "valuesIndices", {
        get: function () {
            return Array.from(new Array(this.values.length), function (v, i) { return i; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "scaledValues", {
        get: function () {
            return scaleValues(this.values);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "labelPoints", {
        get: function () {
            var count = this.labels.length;
            var diameter = this.responsiveSize.diameter + (this.responsiveSize.diameter / 12);
            var offset = this.responsiveSize.diameter / 24;
            return this.labels.map(function (l, index) {
                var point = valueToPoint(1, index, count, diameter, offset, offset);
                return __assign({}, l, { x: point[0], y: point[1] });
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "axisPoints", {
        get: function () {
            var count = this.labels.length;
            var diameter = this.responsiveSize.diameter;
            var offset = this.responsiveSize.diameter / 12;
            return this.labels.map(function (l, index) {
                var point = valueToPoint(1, index, count, diameter, offset, offset);
                return {
                    x: point[0],
                    y: point[1]
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    RadarChart.prototype.points = function (index) {
        var count = this.scaledValues[index].length;
        var diameter = this.responsiveSize.diameter;
        var offset = this.responsiveSize.diameter / 12;
        return 'M' + this.scaledValues[index].map(function (v, i) {
            var point = valueToPoint(v, i, count, diameter, offset, offset);
            return point[0] + ' ' + point[1] + ',';
        }).join(' ');
    };
    RadarChart.prototype.pointsCaps = function (index) {
        var count = this.scaledValues[index].length;
        var diameter = this.responsiveSize.diameter;
        var offset = this.responsiveSize.diameter / 12;
        return this.scaledValues[index].map(function (v, i) {
            var point = valueToPoint(v, i, count, diameter, offset, offset);
            return {
                x: point[0],
                y: point[1]
            };
        });
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 250 })
    ], RadarChart.prototype, "diameter", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(150,150,150)' })
    ], RadarChart.prototype, "strokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], RadarChart.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], RadarChart.prototype, "valuesLabels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], RadarChart.prototype, "shapeColors", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], RadarChart.prototype, "markersColors", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(55,71,79' })
    ], RadarChart.prototype, "labelsColor", void 0);
    RadarChart = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], RadarChart);
    return RadarChart;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (RadarChart);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "radar-chart" }, [
    _c(
      "svg",
      {
        attrs: {
          version: "1.1",
          width: _vm.responsiveSize.size,
          height: _vm.responsiveSize.size,
          viewBox: _vm.viewBox
        }
      },
      [
        _vm._l(_vm.labelPoints, function(l, key) {
          return _c("circle", {
            key: key + "_marker",
            staticClass: "marker",
            attrs: {
              cx: l.x,
              cy: l.y,
              r: _vm.responsiveSize.diameter / 24,
              fill: l.color
            }
          })
        }),
        _vm._v(" "),
        _vm._l(_vm.axisPoints, function(p, key) {
          return _c("line", {
            key: key + "_axis",
            staticClass: "axis",
            attrs: {
              x1: p.x,
              y1: p.y,
              x2:
                _vm.responsiveSize.diameter / 2 +
                _vm.responsiveSize.diameter / 12,
              y2:
                _vm.responsiveSize.diameter / 2 +
                _vm.responsiveSize.diameter / 12,
              "stroke-width": "1",
              stroke: _vm.strokeColor
            }
          })
        }),
        _vm._v(" "),
        _vm._l(_vm.valuesIndices, function(index) {
          return _c(
            "g",
            { key: index + "_shape_group", staticClass: "shape-group" },
            [
              _c("path", {
                staticClass: "shape",
                staticStyle: { transition: "0.6s" },
                attrs: { d: _vm.points(index), fill: _vm.shapeColors[index] }
              }),
              _vm._v(" "),
              _vm._l(_vm.pointsCaps(index), function(point, key) {
                return _c("circle", {
                  key: key + "_shape_point",
                  staticClass: "shape-point",
                  attrs: {
                    cx: point.x,
                    cy: point.y,
                    r: "2",
                    fill: _vm.shapeColors[index]
                  }
                })
              })
            ],
            2
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.valuesLabels && _vm.valuesLabels.length > 0
      ? _c(
          "div",
          { staticClass: "labels-group" },
          _vm._l(_vm.labelPoints, function(l, key) {
            return _c(
              "div",
              {
                key: key + "_label",
                staticClass: "label-container",
                style: "top: " + l.y + "px; left: " + l.x + "px;"
              },
              [
                _c("div", {
                  class: ["label", "anchor-" + _vm.valuesLabels[key].anchor],
                  style: "color: " + _vm.labelsColor,
                  domProps: { innerHTML: _vm._s(_vm.valuesLabels[key].name) }
                })
              ]
            )
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-078c9d54", esExports)
  }
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_vertical_line_chart_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a817c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_vertical_line_chart_vue__ = __webpack_require__(31);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_vertical_line_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a817c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_vertical_line_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/vertical-line-chart/vertical-line-chart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-96a817c0", Component.options)
  } else {
    hotAPI.reload("data-v-96a817c0", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var VerticalLineChart = /** @class */ (function (_super) {
    __extends(VerticalLineChart, _super);
    function VerticalLineChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VerticalLineChart.prototype, "responsiveWidth", {
        get: function () {
            if (this.width < window.innerWidth) {
                return this.width;
            }
            else {
                return window.innerWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLineChart.prototype, "viewBox", {
        get: function () {
            var w = this.responsiveWidth;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLineChart.prototype, "valuesIndices", {
        get: function () {
            return Array.from(new Array(this.values.length), function (v, i) { return i; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLineChart.prototype, "points", {
        get: function () {
            var _this = this;
            var ps = [];
            for (var i = 0; i < this.values.length; i++) {
                ps.push(this.values[i].map(function (v, i) {
                    var w = _this.responsiveWidth - _this.paddingLeft - _this.paddingRight;
                    var hs = (_this.height - _this.paddingTop - _this.paddingBottom) / (_this.values[0].length - 1);
                    return [Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["d" /* scaleValue */])(v, _this.rangeMin, _this.rangeMax, w) + _this.paddingLeft, (hs * i + _this.paddingTop)];
                }));
            }
            return ps;
        },
        enumerable: true,
        configurable: true
    });
    VerticalLineChart.prototype.line = function (index) {
        return 'M' + this.points[index].map(function (xy) { return xy[0] + ' ' + xy[1]; }).join(',');
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VerticalLineChart.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VerticalLineChart.prototype, "valuesLabelsText", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VerticalLineChart.prototype, "valuesLabelsImage", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VerticalLineChart.prototype, "rangeLabels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 0 })
    ], VerticalLineChart.prototype, "rangeMin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 100 })
    ], VerticalLineChart.prototype, "rangeMax", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 700 })
    ], VerticalLineChart.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 400 })
    ], VerticalLineChart.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], VerticalLineChart.prototype, "paddingTop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], VerticalLineChart.prototype, "paddingRight", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], VerticalLineChart.prototype, "paddingBottom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 80 })
    ], VerticalLineChart.prototype, "paddingLeft", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(150,150,150)' })
    ], VerticalLineChart.prototype, "axisColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: function () { return ['coral']; } })
    ], VerticalLineChart.prototype, "valuesColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(150,150,150)' })
    ], VerticalLineChart.prototype, "rangeLabelsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(50,50,50)' })
    ], VerticalLineChart.prototype, "valuesLabelsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 11 })
    ], VerticalLineChart.prototype, "rangeLabelsSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 16 })
    ], VerticalLineChart.prototype, "valuesLabelsTextSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 18 })
    ], VerticalLineChart.prototype, "valuesLabelsImageSize", void 0);
    VerticalLineChart = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], VerticalLineChart);
    return VerticalLineChart;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (VerticalLineChart);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vertical-line-chart" }, [
    _c(
      "svg",
      {
        attrs: {
          version: "1.1",
          width: _vm.responsiveWidth,
          height: _vm.height,
          viewBox: _vm.viewBox
        }
      },
      [
        _c(
          "g",
          { staticClass: "axis" },
          _vm._l(_vm.values[0], function(v, key) {
            return _c("line", {
              key: key + "_axis",
              attrs: {
                stroke: _vm.axisColor,
                "stroke-width": "1",
                "stroke-linecap": "round",
                x1: _vm.paddingLeft,
                y1:
                  _vm.paddingTop +
                  key *
                    ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                      (_vm.values[0].length - 1)),
                x2: _vm.responsiveWidth - _vm.paddingRight,
                y2:
                  _vm.paddingTop +
                  key *
                    ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                      (_vm.values[0].length - 1))
              }
            })
          })
        ),
        _vm._v(" "),
        _vm._l(_vm.valuesLabelsText, function(v, key) {
          return _vm.valuesLabelsText
            ? _c(
                "g",
                {
                  key: key + "_value_label",
                  staticClass: "value-label",
                  attrs: {
                    transform:
                      "translate(0, " +
                      (_vm.paddingTop +
                        key *
                          ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                            (_vm.values[0].length - 1))) +
                      ")"
                  }
                },
                [
                  _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.paddingLeft - 24,
                        y: "0",
                        dy: "4",
                        "font-size": _vm.valuesLabelsTextSize,
                        "text-anchor": "end",
                        fill: _vm.valuesLabelsColor
                      }
                    },
                    [
                      _vm._v(
                        "\n                " + _vm._s(v) + "\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.valuesLabelsImage, function(v, key) {
          return _vm.valuesLabelsImage
            ? _c(
                "g",
                {
                  key: key + "_value_label",
                  staticClass: "value-label",
                  attrs: {
                    transform:
                      "translate(0, " +
                      (_vm.paddingTop +
                        key *
                          ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                            (_vm.values[0].length - 1))) +
                      ")"
                  }
                },
                [
                  _c("circle", {
                    attrs: {
                      cx: _vm.paddingLeft - _vm.valuesLabelsImageSize - 18,
                      cy: "0",
                      r: _vm.valuesLabelsImageSize,
                      fill: "grey"
                    }
                  })
                ]
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.values[0], function(v, key) {
          return _vm.rangeLabels
            ? _c(
                "g",
                {
                  key: key + "_range_label",
                  staticClass: "range-label",
                  attrs: {
                    transform:
                      "translate(0, " +
                      (_vm.paddingTop +
                        key *
                          ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                            (_vm.values[0].length - 1))) +
                      ")"
                  }
                },
                [
                  _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.paddingLeft,
                        y: "0",
                        dy: "14",
                        "font-size": _vm.rangeLabelsSize,
                        "text-anchor": "start",
                        fill: _vm.rangeLabelsColor
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.rangeLabels[0]) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.responsiveWidth - _vm.paddingRight,
                        y: "0",
                        dy: "14",
                        "font-size": _vm.rangeLabelsSize,
                        "text-anchor": "end",
                        fill: _vm.rangeLabelsColor
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.rangeLabels[1]) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.valuesIndices, function(index) {
          return _c(
            "g",
            { key: index + "_value_group", staticClass: "value-group" },
            [
              _c("path", {
                attrs: {
                  d: _vm.line(index),
                  stroke: _vm.valuesColor[index],
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-dasharray": "1, 4",
                  fill: "transparent"
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.points[index], function(v, key) {
                return _c("circle", {
                  key: key + "_rhombus",
                  attrs: {
                    cx: v[0],
                    cy: v[1],
                    r: "3",
                    fill: _vm.valuesColor[index]
                  }
                })
              })
            ],
            2
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96a817c0", esExports)
  }
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_scatter_plot_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1161c2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_scatter_plot_vue__ = __webpack_require__(34);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_scatter_plot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1161c2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_scatter_plot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scatter-plot/scatter-plot.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1161c2a6", Component.options)
  } else {
    hotAPI.reload("data-v-1161c2a6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ScatterPlot = /** @class */ (function (_super) {
    __extends(ScatterPlot, _super);
    function ScatterPlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ScatterPlot.prototype, "responsiveWidth", {
        get: function () {
            if (this.width < window.innerWidth) {
                return this.width;
            }
            else {
                return window.innerWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScatterPlot.prototype, "dataBox", {
        get: function () {
            return {
                xMin: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["b" /* safeMin */])(this.values.map(function (v) { return v.x; })),
                xMax: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["a" /* safeMax */])(this.values.map(function (v) { return v.x; })),
                yMin: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["b" /* safeMin */])(this.values.map(function (v) { return v.y; })),
                yMax: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["a" /* safeMax */])(this.values.map(function (v) { return v.y; }))
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScatterPlot.prototype, "viewBox", {
        get: function () {
            return '0 0 ' + this.responsiveWidth + ' ' + this.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScatterPlot.prototype, "points", {
        get: function () {
            var _this = this;
            var p = this.padding + (this.markerWidth / 2);
            return this.values.map(function (v) { return [
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["d" /* scaleValue */])(v.x, _this.dataBox.xMin, _this.dataBox.xMax, _this.responsiveWidth - p * 2) + p,
                _this.height - Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["d" /* scaleValue */])(v.y, _this.dataBox.yMin, _this.dataBox.yMax, _this.height - p * 2) - p
            ]; });
        },
        enumerable: true,
        configurable: true
    });
    ScatterPlot.prototype.markerFill = function (index) {
        var v = this.values[index];
        if (v.markerUrl) {
            return "url(#image" + index + ")";
        }
        else {
            return this.markerBgColor;
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], ScatterPlot.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(200,200,200)' })
    ], ScatterPlot.prototype, "markerStrokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 1 })
    ], ScatterPlot.prototype, "markerStrokeWidth", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 50 })
    ], ScatterPlot.prototype, "markerWidth", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'grey' })
    ], ScatterPlot.prototype, "markerBgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 500 })
    ], ScatterPlot.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 300 })
    ], ScatterPlot.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], ScatterPlot.prototype, "padding", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], ScatterPlot.prototype, "bgColor", void 0);
    ScatterPlot = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], ScatterPlot);
    return ScatterPlot;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (ScatterPlot);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scatter-plot" }, [
    _c(
      "svg",
      {
        style: "background-color: " + _vm.bgColor,
        attrs: {
          version: "1.1",
          width: _vm.responsiveWidth,
          height: _vm.height,
          viewBox: _vm.viewBox
        }
      },
      [
        _c(
          "defs",
          _vm._l(_vm.values, function(v, key) {
            return v.markerUrl
              ? _c(
                  "pattern",
                  {
                    key: "image" + key,
                    attrs: {
                      id: "image" + key,
                      height: "1",
                      width: "1",
                      x: "0",
                      y: "0",
                      patternContentUnits: "objectBoundingBox"
                    }
                  },
                  [
                    _c("image", {
                      attrs: {
                        x: "0",
                        y: "0",
                        height: "1",
                        width: "1",
                        "xlink:href": v.markerUrl
                      }
                    })
                  ]
                )
              : _vm._e()
          })
        ),
        _vm._v(" "),
        _vm._l(_vm.points, function(p, key) {
          return _c("image", {
            key: "circle" + key,
            class: _vm.values[key].class,
            attrs: {
              "xlink:href": _vm.values[key].markerUrl,
              height: _vm.markerWidth,
              width: _vm.markerWidth,
              x: p[0] - _vm.markerWidth / 2,
              y: p[1] - _vm.markerWidth / 2
            }
          })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1161c2a6", esExports)
  }
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=pack.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(7);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076ef3da_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076ef3da_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076ef3da_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading-spinner"})])])}
var staticRenderFns = []


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export yesNo */
/* unused harmony export twoDigits */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dndg_helpers_filters__ = __webpack_require__(69);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

function yesNo(value) {
    return value ? 'Sì' : 'No';
}
function twoDigits(value) {
    var res = value.toString();
    if (value < 10) {
        res = '0' + value.toString();
    }
    return res;
}
/* harmony default export */ __webpack_exports__["a"] = (__assign({ 
    // Filters
    yesNo: yesNo,
    twoDigits: twoDigits }, __WEBPACK_IMPORTED_MODULE_0__dndg_helpers_filters__["a" /* default */]));


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export currency */
/* unused harmony export percent */
/* unused harmony export human */
/* unused harmony export isoDate */
/* unused harmony export localizedDate */
/* unused harmony export year */
/* unused harmony export month */
/* unused harmony export monthNameShort */
/* unused harmony export monthNameFull */
/* unused harmony export day */
/* unused harmony export dayNameShort */
/* unused harmony export dayNameFull */
/* unused harmony export timeShort */
/* unused harmony export timeFull */
/* unused harmony export timeFromNow */
/* unused harmony export ifEmpty */
/* unused harmony export isNullOrWhitespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

function currency(value, d, t, precision) {
    if (d === void 0) { d = ','; }
    if (t === void 0) { t = '.'; }
    if (precision === void 0) { precision = 2; }
    var v = value ? value : 0;
    var s = v < 0 ? "-" : "";
    var i = parseInt(Math.abs(v.toFixed(precision)) + "", 10) + "";
    var j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (precision ? d + Math.abs(v - parseInt(s + i)).toFixed(precision).slice(precision) : "");
}
function percent(value) {
    var precision = 2;
    var symbol = "%";
    var decimal = ",";
    var v = value ? value.toFixed(precision) : 0.00;
    return (v + "").replace('.', decimal) + symbol;
}
function human(value) {
    if (value >= 1000000) {
        return Math.round(value / 1000000) + 'M';
    }
    else if (value >= 1000) {
        return Math.round(value / 1000) + 'k';
    }
    else {
        return value;
    }
}
function isoDate(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("YYYY-MM-DD");
}
function localizedDate(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("L");
}
function year(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("YYYY");
}
function month(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("MM");
}
function monthNameShort(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("MMM");
}
function monthNameFull(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("MMMM");
}
function day(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("DD");
}
function dayNameShort(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("ddd");
}
function dayNameFull(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("dddd");
}
function timeShort(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("hh:mm");
}
function timeFull(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.format("hh:mm:ss");
}
function timeFromNow(dt, nullValue) {
    if (nullValue === void 0) { nullValue = ''; }
    if (!dt) {
        return nullValue;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(dt)) {
        dt = __WEBPACK_IMPORTED_MODULE_0_moment___default()(dt);
    }
    return dt.fromNow();
}
function ifEmpty(value, emptyResult) {
    return isNullOrWhitespace(value) && emptyResult || value;
}
function isNullOrWhitespace(text) {
    if (text) {
        return text.toString().trim() == '';
    }
    return true;
}
/* harmony default export */ __webpack_exports__["a"] = ({
    // Filters
    currency: currency,
    percent: percent,
    human: human,
    isoDate: isoDate,
    localizedDate: localizedDate,
    year: year,
    month: month,
    monthNameShort: monthNameShort,
    monthNameFull: monthNameFull,
    day: day,
    dayNameShort: dayNameShort,
    dayNameFull: dayNameFull,
    timeShort: timeShort,
    timeFull: timeFull,
    timeFromNow: timeFromNow,
    ifEmpty: ifEmpty,
    // Utilities
    isNullOrWhitespace: isNullOrWhitespace
});


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkResult */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dndg_access_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__surveys_actions__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__signup_actions__ = __webpack_require__(73);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

// Mutations
function setLang(state, lang) {
    state.lang = lang;
    __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale(lang);
}
function setDevelopment(state, isDevelopment) {
    state.isDevelopment = isDevelopment;
}
function setLoading(state, isLoading) {
    state.isLoading = isLoading;
}
function setMobile(state, isMobile) {
    state.isMobile = isMobile;
}
function setUIMessage(state, message) {
    state.uiMessage = message;
}
function clearUIMessage(state) {
    state.uiMessage = null;
}
function setTheme(state, theme) {
    state.theme = theme;
}
function clearTheme(state) {
    state.theme = null;
}
function resetUI(state) {
}
function updateAuthentication(state, update) {
    if (update.result == "OK" && !!update.user) {
        state.isAuthenticated = true;
        state.loggedUser = update.user;
    }
    else {
        state.isAuthenticated = false;
        state.loggedUser = null;
    }
}
// Error management
function checkResult(ctx, result) {
    if (result.result == "OK") {
        return result.data || true;
    }
    else {
        //ctx.dispatch('showError', result);
        return false;
    }
}
// Initial state and store options.
var state = {
    isDevelopment: true,
    isLoading: false,
    isMobile: false,
    isAuthenticated: false,
    loggedUser: null,
    lang: null,
    uiMessage: null,
    theme: null
};
// Import mutationsm actions and getters from specific application parts.



/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: __assign({}, __WEBPACK_IMPORTED_MODULE_1__dndg_access_actions__, __WEBPACK_IMPORTED_MODULE_2__surveys_actions__, __WEBPACK_IMPORTED_MODULE_3__signup_actions__),
    mutations: {
        resetUI: resetUI,
        setDevelopment: setDevelopment,
        setLang: setLang,
        setMobile: setMobile,
        setLoading: setLoading,
        setUIMessage: setUIMessage,
        clearUIMessage: clearUIMessage,
        setTheme: setTheme,
        clearTheme: clearTheme,
        updateAuthentication: updateAuthentication
    }
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(27);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["listSurveys"] = listSurveys;
/* harmony export (immutable) */ __webpack_exports__["loadSurveyLanding"] = loadSurveyLanding;
/* harmony export (immutable) */ __webpack_exports__["loadSurvey"] = loadSurvey;
/* harmony export (immutable) */ __webpack_exports__["updateSurveyResult"] = updateSurveyResult;
/* harmony export (immutable) */ __webpack_exports__["updateSurveyResultShare"] = updateSurveyResultShare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__ = __webpack_require__(10);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function listSurveys(ctx) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result, resultData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/surveys";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["b" /* get */])(endpoint).then(function (res) { return res.data; })];
                case 1:
                    result = _a.sent();
                    resultData = Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["a" /* checkResult */])(ctx, result);
                    if (resultData) {
                    }
                    return [2 /*return*/, resultData];
            }
        });
    });
}
function loadSurveyLanding(ctx, data) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result, resultData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/surveys/" + data.slug + "/landing";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["b" /* get */])(endpoint).then(function (res) { return res.data; })];
                case 1:
                    result = _a.sent();
                    resultData = Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["a" /* checkResult */])(ctx, result);
                    return [2 /*return*/, resultData];
            }
        });
    });
}
function loadSurvey(ctx, data) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result, resultData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/surveys/" + data.slug;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["b" /* get */])(endpoint).then(function (res) { return res.data; })];
                case 1:
                    result = _a.sent();
                    resultData = Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["a" /* checkResult */])(ctx, result);
                    return [2 /*return*/, resultData];
            }
        });
    });
}
function updateSurveyResult(ctx, data) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/surveys/" + data.slug + "/results";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["c" /* post */])(endpoint, data.result)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["a" /* checkResult */])(ctx, result)];
            }
        });
    });
}
function updateSurveyResultShare(ctx, data) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/surveys/" + data.slug + "/results/share";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["c" /* post */])(endpoint)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["a" /* checkResult */])(ctx, result)];
            }
        });
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["loadRegistrationData"] = loadRegistrationData;
/* harmony export (immutable) */ __webpack_exports__["updateRegistrationData"] = updateRegistrationData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__ = __webpack_require__(10);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

function loadRegistrationData(ctx) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/registration";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["b" /* get */])(endpoint).then(function (res) { return res.data; })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["a" /* checkResult */])(ctx, result)];
            }
        });
    });
}
function updateRegistrationData(ctx, args) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = "/_api/v1/registration";
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["c" /* post */])(endpoint, args.data).then(function (res) { return res.data; })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_0__dndg_helpers_api__["a" /* checkResult */])(ctx, result)];
            }
        });
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.themeClasses},[_c('transition',{attrs:{"name":"fade-page","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initRoutes;
/* harmony export (immutable) */ __webpack_exports__["b"] = routeParams;
/* unused harmony export homeRouteName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dndg_access__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_app_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__signup_signup_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__signup_survey_landing_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__signup_repubblica_landing_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__signup_register_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__about_about_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__privacy_policy_privacy_policy_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__surveys_survey_chooser_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__surveys_survey_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__surveys_results_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__surveys_partitometro_info_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__surveys_partitometro_affinita_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__surveys_europartitometro_info_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_page404_vue__ = __webpack_require__(131);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};















// By default we export a function that returns the routes and
// let us use the injected store when needed.
var basePath = '/:lang/';
var homeRouteName = 'survey-chooser';
function initRoutes(store) {
    return [
        {
            path: basePath + 'access',
            component: __WEBPACK_IMPORTED_MODULE_0__dndg_access__["a" /* Access */],
            props: function (route) { return ({
                bannerSrc: '/_assets/resources/banner.jpg',
                bannerMobileSrc: '/_assets/resources/banner_mobile.jpg'
            }); },
            children: Object(__WEBPACK_IMPORTED_MODULE_0__dndg_access__["b" /* createRoutes */])(routeParams, homeRouteName)
        },
        {
            path: basePath,
            component: __WEBPACK_IMPORTED_MODULE_1__home_app_vue__["a" /* default */],
            children: [
                {
                    path: 'signup',
                    name: 'signup',
                    component: __WEBPACK_IMPORTED_MODULE_2__signup_signup_vue__["a" /* default */]
                },
                {
                    path: 'register',
                    name: 'register',
                    component: __WEBPACK_IMPORTED_MODULE_5__signup_register_vue__["a" /* default */]
                },
                {
                    path: 'about',
                    name: 'about',
                    component: __WEBPACK_IMPORTED_MODULE_6__about_about_vue__["a" /* default */]
                },
                {
                    path: 'privacy-policy',
                    name: 'privacy-policy',
                    component: __WEBPACK_IMPORTED_MODULE_7__privacy_policy_privacy_policy_vue__["a" /* default */]
                },
                {
                    path: 'survey-chooser',
                    name: 'survey-chooser',
                    component: __WEBPACK_IMPORTED_MODULE_8__surveys_survey_chooser_vue__["a" /* default */]
                },
                {
                    path: ':slug/play',
                    name: 'survey',
                    component: __WEBPACK_IMPORTED_MODULE_9__surveys_survey_vue__["a" /* default */]
                },
                {
                    path: ':slug/landing',
                    name: 'survey-landing',
                    component: __WEBPACK_IMPORTED_MODULE_3__signup_survey_landing_vue__["a" /* default */]
                },
                {
                    path: ':slug/results',
                    name: 'results',
                    component: __WEBPACK_IMPORTED_MODULE_10__surveys_results_vue__["a" /* default */]
                },
                {
                    path: ':slug/repubblica',
                    name: 'repubblica-landing',
                    component: __WEBPACK_IMPORTED_MODULE_4__signup_repubblica_landing_vue__["a" /* default */]
                },
                {
                    path: 'partitometro/info',
                    name: 'partitometro-info',
                    component: __WEBPACK_IMPORTED_MODULE_11__surveys_partitometro_info_vue__["a" /* default */]
                },
                {
                    path: 'partitometro/affinita',
                    name: 'partitometro-affinita',
                    component: __WEBPACK_IMPORTED_MODULE_12__surveys_partitometro_affinita_vue__["a" /* default */]
                },
                {
                    path: 'europartitometro/info',
                    name: 'europartitometro-info',
                    component: __WEBPACK_IMPORTED_MODULE_13__surveys_europartitometro_info_vue__["a" /* default */]
                },
                {
                    path: '*',
                    name: '404',
                    component: __WEBPACK_IMPORTED_MODULE_14__common_page404_vue__["a" /* default */]
                }
            ]
        }
    ];
}
function routeParams(route, params) {
    return __assign({ lang: route.params.lang }, params);
}



/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__access_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__signin_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__password_recovery_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__password_update_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__access_vue__["a"]; });
/* unused harmony reexport actions */





function createRoutes(routeParams, successRouteName) {
    return [
        {
            path: 'signin',
            name: 'access-signin',
            component: __WEBPACK_IMPORTED_MODULE_1__signin_vue__["a" /* default */],
            props: function (route) { return ({
                successRoute: { name: successRouteName, params: routeParams(route) },
                passwordRecoveryRoute: { name: 'access-password-recovery', params: routeParams(route) }
            }); }
        },
        {
            path: 'password-recovery',
            name: 'access-password-recovery',
            component: __WEBPACK_IMPORTED_MODULE_2__password_recovery_vue__["a" /* default */],
            props: function (route) { return ({
                signinRoute: { name: 'access-signin', params: routeParams(route) },
                updateLinkPrefix: route.path.replace('access/password-recovery', '')
            }); }
        },
        {
            path: 'password-update',
            name: 'access-password-update',
            component: __WEBPACK_IMPORTED_MODULE_3__password_update_vue__["a" /* default */],
            props: function (route) { return ({
                signinRoute: { name: 'access-signin', params: routeParams(route) },
                passwordRecoveryRoute: { name: 'access-password-recovery', params: routeParams(route) }
            }); }
        }
    ];
}



/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_access_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a61608a0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_access_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_access_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a61608a0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_access_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a61608a0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_access_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"access"},[_c('div',{staticClass:"row banner"},[_c('div',{staticClass:"c-banner"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.bannerSrc}})])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-page","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signin_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660d96b2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signin_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660d96b2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660d96b2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_vm._m(0),_vm._v(" "),_c('wok-form',{ref:"form",on:{"submit":_vm.onSubmit}},[_c('wok-pill',{attrs:{"variant":"login"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.accessError)?_c('form-row',{attrs:{"variant":"message"}},[_c('form-text',{attrs:{"variant":"error"}},[_vm._v("E-mail or password invalid.")])],1):_vm._e(),_vm._v(" "),(_vm.showPasswordUpdateMessage)?_c('form-row',{attrs:{"variant":"message"}},[_c('form-text',{attrs:{"variant":"ok"}},[_vm._v("Password update correctly! Proceed to sign in.")])],1):_vm._e()],1),_vm._v(" "),_c('form-row',[_c('entry-mail',{attrs:{"name":"username","label":"E-mail","mandatory":"true","size":"12","emitOnInput":true},on:{"valid-change":_vm.onUsernameValid},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('form-row',[_c('entry-password',{attrs:{"name":"password","label":"Password","mandatory":"true","size":"12","emitOnInput":true},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('wok-pill',{attrs:{"slot":"primary-actions","variant":"clear"},slot:"primary-actions"},[_c('actions-row',{attrs:{"size":"0/12/0"}},[_c('button',{staticClass:"btn-normal--primary",attrs:{"slot":"center","type":"submit","disabled":!_vm.submitEnabled},slot:"center"},[_vm._v("\n                    Sign In\n                ")])]),_vm._v(" "),_c('actions-row',{attrs:{"size":"0/12/0"}},[_c('router-link',{staticClass:"forgot-password",attrs:{"slot":"center","to":_vm.passwordRecoveryRoute},slot:"center"},[_vm._v("\n                    Need to setup your password?\n                ")])],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"c-welcome"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Welcome!")])])])])}]


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_password_recovery_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_815fba44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_recovery_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_password_recovery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_815fba44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_recovery_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_815fba44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_recovery_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.emailSubmitted)?_c('div',{key:_vm.emailSubmitted},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-welcome"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Setup your access credentials.")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-intro-text"},[_c('div',{staticClass:"content"},[_vm._v("Please, insert your e-mail address."),_c('br'),_vm._v(" "),_c('em',[_vm._v("We will send you an e-mail with a link to continue and safely setup your password.")])])])]),_vm._v(" "),_c('wok-form',{key:_vm.emailSubmitted,on:{"submit":_vm.onSubmit}},[_c('wok-pill',{attrs:{"variant":"login"}},[_c('form-row',[_c('entry-mail',{attrs:{"name":"email","label":"E-mail","mandatory":"true","size":"12","emitOnInput":true,"initialValue":_vm.email},on:{"valid-change":_vm.onEmailValidChange},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('wok-pill',{attrs:{"slot":"primary-actions","variant":"clear"},slot:"primary-actions"},[_c('actions-row',{attrs:{"size":"0/12/0"}},[_c('button',{staticClass:"btn-normal--primary",attrs:{"slot":"center","type":"submit","disabled":!_vm.submitEnabled},slot:"center"},[_vm._v("\n                            Proceed to setup your password\n                        ")])]),_vm._v(" "),_c('actions-row',{attrs:{"size":"0/12/0"}},[_c('router-link',{staticClass:"btn-backlink",attrs:{"slot":"center","to":_vm.signinRoute},slot:"center"},[_vm._v("I've changed my mind")])],1)],1)],1)],1):_c('div',{key:_vm.emailSubmitted,staticClass:"message-box"},[_c('div',{staticClass:"message message--ok"},[_c('h3',{staticClass:"message-title"},[_vm._v("E-mail sent")]),_vm._v(" "),_c('p',{staticClass:"message-text"},[_vm._v("We've sent you an e-mail to the following address: "),_c('strong',[_vm._v(_vm._s(_vm.email))]),_vm._v("."),_c('br'),_vm._v("\n                    Please, follow the instructions in the message to continue and setup your password."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('em',[_vm._v("Didn't received the e-mail? Please, check your spam folder."),_c('br'),_vm._v("\n                    The e-mail address entered was wrong? "),_c('button',{staticClass:"link",attrs:{"type":"button"},on:{"click":function($event){_vm.emailSubmitted = false}}},[_vm._v("Restart the process")])]),_vm._v(".\n                ")])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_password_update_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d94a900_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_update_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_password_update_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d94a900_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_update_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d94a900_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_update_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.passwordUpdateError)?_c('div',{key:_vm.passwordUpdateError},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-welcome"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Configure your access credentials")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-intro-text"},[_c('div',{staticClass:"content"},[_vm._v("Choose a password.")])])]),_vm._v(" "),_c('wok-form',{on:{"submit":_vm.onSubmit}},[_c('wok-pill',{attrs:{"variant":"login"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.passwordMismatch)?_c('form-row',{attrs:{"variant":"message"}},[_c('form-text',{attrs:{"variant":"error"}},[_vm._v("Passwords don't match. Please retry.")])],1):_vm._e()],1),_vm._v(" "),_c('form-row',[_c('entry-password',{attrs:{"name":"password1","label":"Password","mandatory":"true","size":"12","emitOnInput":true},on:{"change":_vm.onPasswordChange},model:{value:(_vm.password1),callback:function ($$v) {_vm.password1=$$v},expression:"password1"}})],1),_vm._v(" "),_c('form-row',[_c('entry-password',{attrs:{"name":"password2","label":"Ripeti password","mandatory":"true","size":"12","emitOnInput":true},on:{"change":_vm.onPasswordChange},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}})],1)],1),_vm._v(" "),_c('wok-pill',{attrs:{"slot":"primary-actions","variant":"clear"},slot:"primary-actions"},[_c('actions-row',{attrs:{"size":"0/12/0"}},[_c('button',{staticClass:"btn-normal--primary",attrs:{"slot":"center","disabled":!_vm.submitEnabled,"type":"submit"},slot:"center"},[_vm._v("\n                            Save\n                        ")])]),_vm._v(" "),_c('actions-row',{attrs:{"size":"0/12/0"}},[_c('router-link',{staticClass:"btn-backlink",attrs:{"slot":"center","to":_vm.signinRoute},slot:"center"},[_vm._v("\n                            I've changed my mind\n                        ")])],1)],1)],1)],1):_c('div',{key:_vm.passwordUpdateError,staticClass:"message-box"},[_c('div',{staticClass:"message message--error"},[_c('h3',{staticClass:"message-title"},[_vm._v("Ops! There was an error.")]),_vm._v(" "),_c('p',{staticClass:"message-text"},[_vm._v("This token is not valid anymore."),_c('br'),_vm._v(" "),_c('router-link',{staticClass:"link",attrs:{"to":_vm.passwordRecoveryRoute}},[_vm._v("Re-try")]),_vm._v(" writing your e-mail address in the \"configure yor password\" page.\n                ")],1)])])])],1)}
var staticRenderFns = []


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb9fe772_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb9fe772_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb9fe772_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(96)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4af095_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4af095_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4af095_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_wrapper_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policy_popup_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_path_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu_vue__ = __webpack_require__(92);
/* unused harmony reexport AppWrapper */
/* unused harmony reexport PolicyPopup */
/* unused harmony reexport PagePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__menu_vue__["a"]; });







/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(4))(47);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"policy-popup"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"policy-popup"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"text"},[_vm._t("default",[_vm._v("Accept cookies?")])],2),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.showRefuseButton)?_c('button',{staticClass:"refuse",on:{"click":_vm.onRefuse}},[_vm._t("refuse",[_vm._v("no")])],2):_vm._e(),_vm._v(" "),_c('button',{staticClass:"agree",on:{"click":_vm.onAgree}},[_vm._t("agree",[_vm._v("yes")])],2)])])])])}
var staticRenderFns = []


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_path_vue__ = __webpack_require__(28);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe12db3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_path_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_path_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe12db3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_path_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe12db3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_path_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPagePath)?_c('div',{class:['page-path', _vm.variant]},_vm._l((_vm.navigation),function(n,key){return _c('div',{key:key,staticClass:"route-element"},[(n.route)?_c('router-link',{attrs:{"to":n.route}},[_vm._v(_vm._s(n.title))]):_c('span',[_vm._v(_vm._s(n.title))])],1)})):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330496bc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330496bc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330496bc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMenu)?_c('div',{staticClass:"menu"},[_c('div',{staticClass:"action",on:{"click":function($event){_vm.showMenuPopup = !_vm.showMenuPopup}}},[_c('div',{staticClass:"hamburger-container"},[_c('div',{class:['hamburger', { 'open': _vm.showMenuPopup }]})])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showMenuPopup)?_c('div',{staticClass:"menu-popup"},_vm._l((_vm.items),function(i,key){return (!i.test || i.test(_vm.$route, _vm.$store))?_c('div',{key:key,staticClass:"menu-item",on:{"click":function($event){_vm.onMenuItemClick()}}},[(i.route)?_c('router-link',{staticClass:"link",attrs:{"to":i.route}},[_vm._v(_vm._s(i.title))]):_vm._e(),_vm._v(" "),(i.action)?_c('button',{staticClass:"link",on:{"click":function($event){i.action()}}},[_vm._v(_vm._s(i.title))]):_vm._e()],1):_vm._e()})):_vm._e()])],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-page"}},[(!_vm.isPopup)?_c('header',[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-identity"},[_c('div',{staticClass:"content"},[_c('router-link',{attrs:{"to":_vm.link('survey-chooser')}},[_c('img',{staticClass:"logo-white",attrs:{"src":"/_assets/resources/likeyouth_logo_white.svg","alt":"LikeYouth Logo"}}),_vm._v(" "),_c('img',{staticClass:"logo-color",attrs:{"src":"/_assets/resources/likeyouth_logo_color.svg","alt":"LikeYouth Logo"}})])],1)]),_vm._v(" "),_c('div',{staticClass:"c-menu"},[_c('div',{staticClass:"content"},[_c('navigation-menu',{attrs:{"items":_vm.navigation}})],1)])])])]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"fade-page","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('policy-popup',{attrs:{"hideRefuseButton":"true","gaAccount":"UA-113454339-1"}},[_c('i18n',{attrs:{"path":"policyPopupText","tag":"div"}},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.privacyPopupLink}},[_vm._v("privacy policy")])],1),_vm._v(" "),_c('template',{slot:"agree"},[_vm._v(_vm._s(_vm.$t('policyPopupYes')))])],2)],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"policyPopupText":"Questo sito utilizza cookies tecnici e di terze parti per funzionalità quali la condivisione sui social network e/o la visualizzazione di media. Utilizzando questo sito acconsenti all\u0027utilizzo dei cookie di terze parti. Per maggiori informazioni consulta la {0}.","policyPopupYes":"OK"},"en":{"policyPopupText":"This site uses technical and third-party cookies for features such as sharing on social networks and / or media viewing. By using this site you consent to the use of third-party cookies. For more information see {0}.","policyPopupYes":"OK"}}')
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3022512d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signup_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3022512d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signup_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3022512d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signup_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(99)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup"},[_c('div',{staticClass:"main-wrapper"},[(_vm.isMobile)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-info"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('pageTitle'))}}),_vm._v(" "),_c('h3',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.$t('pageSubtitle'))}})]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('form',{attrs:{"method":"POST","action":"/signin-facebook-request"}},[_c('input',{attrs:{"name":"state","type":"hidden"},domProps:{"value":_vm.state}}),_vm._v(" "),_c('input',{attrs:{"name":"r","type":"hidden"},domProps:{"value":_vm.r}}),_vm._v(" "),_c('input',{attrs:{"name":"fbpixelid","type":"hidden"},domProps:{"value":_vm.fbpixelid}}),_vm._v(" "),_c('input',{attrs:{"name":"lang","type":"hidden"},domProps:{"value":_vm.lang}}),_vm._v(" "),_c('button',{class:['btn-signup', { 'login': _vm.isLogin }],attrs:{"type":"submit"},on:{"click":function($event){_vm.isLogin = true;}}},[_vm._v("\n                                "+_vm._s(_vm.isLogin ? _vm.$t('textLoginLoading') : _vm.$t('textLogin'))+"\n                            ")])]),_vm._v(" "),_c('button',{staticClass:"btn-share",attrs:{"type":"button"},on:{"click":_vm.onShare}},[_vm._v(_vm._s(_vm.$t('textShare')))])])])]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"c-cover"},[_vm._m(1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cover-mobile"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"cover-image",attrs:{"src":"/_assets/resources/cover_girl.png","alt":"LikeYouth Illustration"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"cover-image",attrs:{"src":"/_assets/resources/cover_girl.png","alt":"LikeYouth Illustration"}})])}]


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Il tuo stile di vita corrisponde al tuo profilo social? E l’immagine che hai di te stesso deriva dal confronto con persone fisiche o con il popolo della rete?","pageSubtitle":"Per avere una risposta a queste domande, sei tu che devi rispondere a qualche domanda.<br /> Sarà semplice, veloce e divertente.","textLogin":"Accedi con Facebook","textLoginLoading":"Accesso in corso...","textShare":"Condividi su Facebook"},"en":{"pageTitle":"Does your Facebook profile actually reflects who you are? Is what people find on your social media platforms an accurate portrayal of who you truly are?","pageSubtitle":"Compare your points of view with the others! Find out now! It’s fast and fun!","textLogin":"Login with Facebook","textLoginLoading":"Logging in...","textShare":"Share on Facebook"}}')
}


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_survey_landing_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e75717d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_landing_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_survey_landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e75717d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_landing_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e75717d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_landing_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(102)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup survey-landing"},[_c('div',{staticClass:"main-wrapper"},[(_vm.isMobile)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-cover-mobile"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"cover-image",attrs:{"src":_vm.coverImage,"alt":"LikeYouth Illustration"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-info"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title-container"},[_c('h1',{staticClass:"survey-title"},[_vm._v(_vm._s(_vm.getText(_vm.survey.texts, 'Title')))]),_vm._v(" "),_c('h3',{staticClass:"survey-subtitle"},[_vm._v(_vm._s(_vm.getText(_vm.survey.texts, 'Tagline')))]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.callToAction))])]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('form',{attrs:{"method":"POST","action":"/signin-facebook-request"}},[_c('input',{attrs:{"name":"state","type":"hidden"},domProps:{"value":_vm.state}}),_vm._v(" "),_c('input',{attrs:{"name":"lang","type":"hidden"},domProps:{"value":_vm.lang}}),_vm._v(" "),_c('input',{attrs:{"name":"r","type":"hidden"},domProps:{"value":_vm.r}}),_vm._v(" "),_c('input',{attrs:{"name":"s","type":"hidden"},domProps:{"value":_vm.slug}}),_vm._v(" "),_c('input',{attrs:{"name":"fbpixelid","type":"hidden"},domProps:{"value":_vm.fbpixelid}}),_vm._v(" "),_c('button',{class:['btn-signup', { 'login': _vm.isLogin }],attrs:{"type":"submit"},on:{"click":function($event){_vm.isLogin = true;}}},[_vm._v("\n                                "+_vm._s(_vm.isLogin ? _vm.$t('textLoginLoading') : _vm.$t('textLogin'))+"\n                            ")])]),_vm._v(" "),_c('button',{staticClass:"btn-share",attrs:{"type":"button"},on:{"click":_vm.onShare}},[_vm._v(_vm._s(_vm.$t('textShare')))])])])]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"c-cover"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"cover-image",attrs:{"src":_vm.coverImage,"alt":"LikeYouth Illustration"}})])]):_vm._e()])])])}
var staticRenderFns = []


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"likeyouthDescription":"Like Youth è un’applicazione interattiva che ti permette di scoprire quanto i tuoi like su Facebook corrispondono ai tuoi interessi.","textLogin":"Accedi con Facebook","textLoginLoading":"Accesso in corso...","textShare":"Condividi su Facebook"},"en":{"likeyouthDescription":"Like Youth è un’applicazione interattiva che ti permette di scoprire quanto i tuoi like su Facebook corrispondono ai tuoi interessi.","textLogin":"Login with Facebook","textLoginLoading":"Logging in...","textShare":"Share on Facebook"}}')
}


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_repubblica_landing_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f38a66b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_repubblica_landing_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_repubblica_landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f38a66b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_repubblica_landing_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f38a66b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_repubblica_landing_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup repubblica-landing"},[_c('div',{staticClass:"main-wrapper"},[(_vm.isMobile)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-cover-mobile"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"cover-image",attrs:{"src":_vm.coverImage,"alt":"LikeYouth Illustration"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-info"},[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"action"},[_c('form',{attrs:{"method":"POST","action":"/signin-facebook-request"}},[_c('input',{attrs:{"name":"state","type":"hidden"},domProps:{"value":_vm.state}}),_vm._v(" "),_c('input',{attrs:{"name":"lang","type":"hidden"},domProps:{"value":_vm.lang}}),_vm._v(" "),_c('button',{class:['btn-signup', { 'login': _vm.isLogin }],attrs:{"type":"submit"},on:{"click":function($event){_vm.isLogin = true;}}},[_vm._v("\n                                "+_vm._s(_vm.isLogin ? 'Accesso in corso...' : 'Accedi con Facebook')+"\n                            ")])])])])]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"c-cover"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"cover-image",attrs:{"src":_vm.coverImage,"alt":"LikeYouth Illustration"}})])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container"},[_c('h1',{staticClass:"survey-title"},[_vm._v("EuroPartitometro")]),_vm._v(" "),_c('h3',{staticClass:"survey-subtitle"},[_vm._v("Visualizza i tuoi risultati completi:"),_c('br'),_vm._v(" mappa di posizionamento e affinità con ogni partito.")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Prova l'EuroPartitometro!")])])}]


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eeffe06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eeffe06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eeffe06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(108)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arrayEquals */
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* unused harmony export parseID */
/* unused harmony export parseDateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

function arrayEquals(a, b) {
    if (a === b)
        return true;
    if (a == null || b == null)
        return false;
    if (a.length != b.length)
        return false;
    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
function copyArray(src) {
    var dst = [];
    for (var i = 0; i < src.length; i++) {
        dst.push(copy(src[i]));
    }
    return dst;
}
function copyObject(src, props) {
    var dst = {};
    for (var k in src) {
        if (src.hasOwnProperty(k) && (!props || props.indexOf(k) != -1)) {
            var v = src[k];
            if (v) {
                if (Array.isArray(v)) {
                    dst[k] = copyArray(v);
                    continue;
                }
                if (typeof v == 'object') {
                    dst[k] = copyObject(v);
                    continue;
                }
            }
            dst[k] = v;
        }
    }
    return dst;
}
function copy(src, props) {
    if (src) {
        if (Array.isArray(src)) {
            return copyArray(src);
        }
        if (typeof src == 'object') {
            return copyObject(src, props);
        }
    }
    return src;
}
function parseID(id) {
    switch (typeof id) {
        case 'string':
            return parseInt(id);
        case 'number':
            return id;
        default:
            return 0;
    }
}
function parseDateKey(day) {
    if (!__WEBPACK_IMPORTED_MODULE_0_moment___default.a.isMoment(day)) {
        day = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day, 'YYYY-MM-DD');
    }
    return day;
}


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isRegistered)?_c('div',{staticClass:"registration"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('title')))]),_vm._v(" "),_c('div',{staticClass:"main-wrapper narrow"},[_c('wok-form',{on:{"submit":_vm.onSubmit}},[_c('wok-pill',{attrs:{"variant":"clear","spacing":"clear"}},[_c('form-row',[_c('entry-text',{attrs:{"name":"name","label":_vm.$t('fieldName'),"size":"12"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.firstName),callback:function ($$v) {_vm.$set(_vm.model, "firstName", $$v)},expression:"model.firstName"}})],1),_vm._v(" "),_c('form-row',[_c('entry-text',{attrs:{"name":"lastName","label":_vm.$t('fieldLastName'),"size":"12"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.lastName),callback:function ($$v) {_vm.$set(_vm.model, "lastName", $$v)},expression:"model.lastName"}})],1),_vm._v(" "),_c('form-row',[_c('entry-mail',{attrs:{"name":"email","label":_vm.$t('fieldEmail'),"size":"12","readonly":true},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1),_vm._v(" "),_c('form-row',[_c('entry-date',{attrs:{"name":"birthDate","label":_vm.$t('fieldBirthDate'),"size":"12"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.birthdate),callback:function ($$v) {_vm.$set(_vm.model, "birthdate", $$v)},expression:"model.birthdate"}})],1),_vm._v(" "),_c('form-row',[_c('entry-select',{attrs:{"name":"gender","label":_vm.$t('fieldGender'),"size":"12"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.gender),callback:function ($$v) {_vm.$set(_vm.model, "gender", $$v)},expression:"model.gender"}},[_c('option',{attrs:{"value":"M"}},[_vm._v(_vm._s(_vm.$t('optionGender_M')))]),_vm._v(" "),_c('option',{attrs:{"value":"F"}},[_vm._v(_vm._s(_vm.$t('optionGender_F')))])])],1),_vm._v(" "),_c('form-row',[_c('entry-select',{attrs:{"name":"qualification","label":_vm.$t('fieldQualification'),"size":"12"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.qualification),callback:function ($$v) {_vm.$set(_vm.model, "qualification", $$v)},expression:"model.qualification"}},[_c('option',{attrs:{"value":"other"}},[_vm._v(_vm._s(_vm.$t('optionQualification_other')))]),_vm._v(" "),_c('option',{attrs:{"value":"worker"}},[_vm._v(_vm._s(_vm.$t('optionQualification_worker')))]),_vm._v(" "),_c('option',{attrs:{"value":"student"}},[_vm._v(_vm._s(_vm.$t('optionQualification_student')))]),_vm._v(" "),_c('option',{attrs:{"value":"student-worker"}},[_vm._v(_vm._s(_vm.$t('optionQualification_student-worker')))]),_vm._v(" "),_c('option',{attrs:{"value":"unemployed-seeking"}},[_vm._v(_vm._s(_vm.$t('optionQualification_unemployed-seeking')))]),_vm._v(" "),_c('option',{attrs:{"value":"unemployed"}},[_vm._v(_vm._s(_vm.$t('optionQualification_unemployed')))])])],1),_vm._v(" "),_c('form-row',[(_vm.lang == 'it')?[_c('entry-text',{attrs:{"name":"zip","label":_vm.$t('fieldZip'),"size":"4"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.zip),callback:function ($$v) {_vm.$set(_vm.model, "zip", $$v)},expression:"model.zip"}}),_vm._v(" "),_c('entry-text',{attrs:{"name":"city","label":_vm.$t('fieldCity'),"size":"4"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.city),callback:function ($$v) {_vm.$set(_vm.model, "city", $$v)},expression:"model.city"}}),_vm._v(" "),_c('entry-text',{attrs:{"name":"province","label":_vm.$t('fieldProvince'),"size":"4"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.province),callback:function ($$v) {_vm.$set(_vm.model, "province", $$v)},expression:"model.province"}})]:_vm._e(),_vm._v(" "),(_vm.lang == 'en')?[_c('entry-text',{attrs:{"name":"country","label":_vm.$t('fieldCountry'),"size":"12"},on:{"valid-change":_vm.onValidChange},model:{value:(_vm.model.country),callback:function ($$v) {_vm.$set(_vm.model, "country", $$v)},expression:"model.country"}})]:_vm._e()],2),_vm._v(" "),_c('form-row',[_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSubmitEnabled),expression:"isSubmitEnabled"}],ref:"privacy",attrs:{"type":"checkbox","name":"privacy","id":"c_privacy"},domProps:{"checked":Array.isArray(_vm.isSubmitEnabled)?_vm._i(_vm.isSubmitEnabled,null)>-1:(_vm.isSubmitEnabled)},on:{"change":function($event){var $$a=_vm.isSubmitEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSubmitEnabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSubmitEnabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSubmitEnabled=$$c}}}}),_vm._v(" "),_c('i18n',{staticClass:"privacy",attrs:{"path":"privacy","tag":"label","for":"c_privacy"}},[_c('router-link',{staticClass:"link",attrs:{"to":{name: 'privacy-policy', query: { popup: true }}}},[_vm._v("privacy policy")])],1)],1)])],1),_vm._v(" "),_c('wok-pill',{attrs:{"slot":"primary-actions","variant":"clear"},slot:"primary-actions"},[_c('actions-row',{attrs:{"size":"0/12/0"}},[_c('button',{staticClass:"btn-normal--primary",attrs:{"slot":"center","type":"submit","disabled":!_vm.isSubmitEnabled},slot:"center"},[_vm._v("\n                        "+_vm._s(_vm.$t('actionRegister'))+"\n                    ")])])],1)],1)],1)]):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"title":"Facebook ci ha fornito i seguenti dati. Sono corretti?","fieldName":"Nome","fieldLastName":"Cognome","fieldEmail":"Email","fieldBirthDate":"Data di nascita","fieldGender":"Sei","fieldQualification":"Al momento, la tua condizione lavorativa è","fieldZip":"CAP","fieldCity":"Città","fieldProvince":"Provincia","actionRegister":"Registrati","privacy":"Accetto le condizioni previste nella {0} dell\u0027applicazione","optionQualification_other":"Altro","optionQualification_worker":"Lavoratore","optionQualification_student":"Studente","optionQualification_student-worker":"Studente lavoratore","optionQualification_unemployed-seeking":"Disoccupato in cerca di occupazione","optionQualification_unemployed":"Disoccupato non in cerca di occupazione","optionGender_M":"Maschio","optionGender_F":"Femmina"},"en":{"title":"Facebook provided us with the following data. Are they correct?","fieldName":"Name","fieldLastName":"Last name","fieldEmail":"Email","fieldBirthDate":"Date of birth","fieldGender":"Gender","fieldQualification":"What is your present work situation","fieldZip":"Zip","fieldCity":"City","fieldProvince":"State or Province","fieldCountry":"Country","actionRegister":"Register","privacy":"I agree to the {0}","optionQualification_other":"Other","optionQualification_worker":"Employed","optionQualification_student":"Student","optionQualification_student-worker":"Student with part time employment","optionQualification_unemployed-seeking":"Unemployed but looking for work","optionQualification_unemployed":"Unemployed but NOT looking for work","optionGender_M":"Male","optionGender_F":"Female"}}')
}


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f19cc54_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f19cc54_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f19cc54_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper narrow"},[(_vm.lang == 'it')?_c('div',{staticClass:"about"},[_c('h1',{staticClass:"title"},[_vm._v("About")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            LikeYouth è parte di un progetto scientifico che si propone di affrontare il problema della disoccupazione giovanile, migliorando la comprensione dei fattori che determinano la ricerca attiva di lavoro. I dati comportamentali dei social media ci aiutano a comprendere meglio i fattori che scatenano l'attivazione e la partecipazione delle comunità di giovani e la loro integrazione nel mercato del lavoro tenendo conto delle loro attitudini socio-culturali. Utilizzando l'applicazione partecipi ad un progetto esclusivamente scientifico senza alcun collegamento ad attività commerciali o di lucro.\n        ")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Questo progetto e' una collaborazione tra ISI Data Science Lab (Dr. Kyriaki Kalimeri, Dr. Ciro Cattuto), Universita cattolica del sacro cuore (Alessandro Rosina, Andrea Bonanomi) e Istituto Toniolo (Filippo Casonatto).\n        ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("Credits")]),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.lang == 'en')?_c('div',{staticClass:"about"},[_c('h1',{staticClass:"title"},[_vm._v("About Us")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            LikeYouth is part of a scientific project that aims at tackling the problem of youth unemployment, improving the current understanding of factors driving active job search.\n            Social media behavioural data helps us better understand what triggers the engagement and activation of young communities towards their integration in the job market taking into consideration their socio-cultural preferences.\n            By entering the application you participate in a purely scientific project without any connection to commercial activities or interests.\n        ")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            This project is a collaboration between ISI Data Science Lab (Dr. Kyriaki Kalimeri, Dr. Ciro Cattuto), Universita cattolica del sacro cuore (Alessandro Rosina, Andrea Bonanomi) and Istituto Toniolo (Filippo Casonatto).\n        ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("Credits")]),_vm._v(" "),_vm._m(3)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_c('strong',[_c('a',{staticClass:"link",attrs:{"href":"https://isi.it","target":"_blank","title":"ISI Foundation website"}},[_vm._v("ISI Foundation")])]),_c('br'),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"https://www.isi.it/en/people/ciro-cattuto","target":"_blank","title":"ISI Foundation website – Cattuto profile"}},[_vm._v("Dr. Ciro Cattuto")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"https://www.isi.it/en/people/kyriaki-kalimeri","target":"_blank","title":"ISI Foundation website – Kalimeri profile"}},[_vm._v("Dr. Eng. Kyriaki Kalimeri")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Design, identità visiva, illustrazioni, progettazione software, sviluppo e messa in opera a cura di "),_c('strong',[_c('a',{staticClass:"link",attrs:{"href":"https://dndg.it","target":"_blank","title":"DNDG website"}},[_vm._v("DNDG srl")])]),_vm._v(".\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_c('strong',[_c('a',{staticClass:"link",attrs:{"href":"https://isi.it","target":"_blank","title":"ISI Foundation website"}},[_vm._v("ISI Foundation")])]),_c('br'),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"https://www.isi.it/en/people/ciro-cattuto","target":"_blank","title":"ISI Foundation website – Cattuto profile"}},[_vm._v("Dr. Ciro Cattuto")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"https://www.isi.it/en/people/kyriaki-kalimeri","target":"_blank","title":"ISI Foundation website – Kalimeri profile"}},[_vm._v("Dr. Eng. Kyriaki Kalimeri")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Design, visual identity, illustrations, software design, development and implementation by "),_c('strong',[_c('a',{staticClass:"link",attrs:{"href":"https://dndg.it","target":"_blank","title":"DNDG website"}},[_vm._v("DNDG srl")])]),_vm._v(".\n        ")])}]


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacy_policy_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aeb84dc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_policy_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacy_policy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aeb84dc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_policy_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aeb84dc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacy_policy_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['privacy-policy', { 'popup': _vm.isPopup }]},[(_vm.isPopup)?_c('div',{staticClass:"popup-header"},[_c('div',{staticClass:"main-wrapper"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.onCloseClick()}}},[_vm._v("×")])])]):_vm._e(),_vm._v(" "),(_vm.lang == 'it')?_c('div',{staticClass:"main-wrapper narrow"},[_c('h1',{staticClass:"title"},[_vm._v("Privacy policy")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Titolari")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("I titolari del trattamento dei tuoi dati sono:")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Dati")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Tratteremo i seguenti dati:")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Finalità")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("I tuoi dati verranno trattati con le seguenti finalità:")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Natura ed effetti del conferimento")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Modalità")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("I tuoi dati verranno:")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Comunicazione a terzi")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            I tuoi dati potranno essere comunicati e diffusi, ma solo in forma anonima ed aggregata, attraverso il nostro sito e/o in altro modo come dati a supporto di pubblicazioni scientifiche e/o volumi tematici. Potremo anche:\n        ")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Diritti")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Ti ricordiamo, inoltre, che la legge tutela i tuoi diritti di accesso, aggiornamento, rettifica dati ed opposizione al trattamento. Essi comprendono, a titolo meramente esemplificativo, i diritti di ottenere la conferma dell’esistenza di dati che ti riguardano e la loro comunicazione in forma intelligibile, l’indicazione dell’origine dei dati, delle finalità e modalità di trattamento, l’aggiornamento, la rettificazione o l’integrazione dei dati, la cancellazione, la trasformazione in forma anonima o il blocco dei dati personali trattati in violazione di legge, ed il diritto di opporsi, in tutto o in parte, al relativo utilizzo.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Informazioni sui cookie")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Se scegli di cancellare i cookie, le eventuali preferenze andranno perdute. Inoltre, se blocchi i cookie del tutto, il sito potrebbe non funzionare bene.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Servizi di terzi")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',{staticClass:"text-small"},[_vm._v("[Versione 1.1 del 08/02/2018]")])]):_vm._e(),_vm._v(" "),(_vm.lang == 'en')?_c('div',{staticClass:"main-wrapper narrow"},[_c('h1',{staticClass:"title"},[_vm._v("Privacy policy")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Controllers")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            We hereby inform you that the controllers for the processing of your data are:\n        ")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Data")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("We will process the following data:")]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Purposes")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Your data will be processed with the following purposes:")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Nature and effects of the provision")]),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Processing methods")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Your data will be:")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Communication to third parties")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Your data may be passed on, but only in anonymous and aggregate form, through our website and / or in any other way as data in support of scientific publications and / or thematic volumes. We may also:\n        ")]),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Rights")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            We remind you also that the law protects your right to access, update, correct and object to the processing of your data. These rights include, but are not limited to, the right to obtain confirmation of whether or not data concerning you exist and to be informed of them in intelligible form, information about the source of the data, the purposes and methods of processing, the updating, correction or integration of your data, the erasure, transformation in an anonymous form or blocking of personal data processed unlawfully, and the right to object, in whole or in part, to their use.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Information about Cookies")]),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            If you choose to delete cookies, any preferences will be lost. In addition, if you block all cookies, the site might not work properly.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Third Party Services")]),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('p',{staticClass:"text-small"},[_vm._v("[Version 1.1 of 8/2/2018]")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_c('strong',[_vm._v("Fondazione ISI - Istituto per l’Interscambio Scientifico")]),_c('br'),_vm._v("\n                Via Chisola n. 5, 10126, Torino"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Tel:")]),_vm._v(" +39 011 6603090"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Fax:")]),_vm._v(" +39 011 6600049"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Email:")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"mailto:isi@isi.it"}},[_vm._v("isi@isi.it")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('strong',[_vm._v("Istituto Giuseppe Toniolo di Studi Superiori")]),_c('br'),_vm._v(" \n                Largo A. Gemelli, 1, Milano"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Tel:")]),_vm._v(" +39 02 72342292"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Fax:")]),_vm._v(" +39 02 72342772"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Email:")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"mailto:direzione.toniolo@unicatt.it"}},[_vm._v("direzione.toniolo@unicatt.it")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Fondazione ISI ha, tra gli altri, incaricato Roberto Palermo (domiciliato presso Fondazione ISI) quale responsabile del trattamento dei tuoi dati."),_c('br'),_vm._v("\n            Puoi richiederci via email l’elenco completo ed aggiornato dei responsabili del trattamento dei tuoi dati."),_c('br'),_vm._v("\n            Ti informiamo che tratteremo i tuoi dati con liceità e correttezza nel pieno rispetto dei tuoi diritti ed in particolare della tua riservatezza.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Dati di registrazione")]),_vm._v(" - Quando ti registri, acquisiamo i tuoi dati (username, password, indirizzo e-mail, nome e cognome, data di nascita, ecc.).\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Dati di navigazione")]),_vm._v(" - Quando ti colleghi al nostro sistema, questo registra automaticamente le informazioni che il tuo sistema ci invia. Queste informazioni possono riguardare i contenuti caricati, le operazioni svolte, l’indirizzo IP ed il MAC Address dai quali ti colleghi, la data e l’ora della tua richiesta, la tua posizione, ecc.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Dati del questionario “Indagine Giovani”")]),_vm._v(" - Se accedi al sito tramite link dopo aver risposto al questionario “Indagine Giovani” proposto dall’Istituto Toniolo, acquisiamo i dati delle tue risposte al questionario.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Dati del questionario “Partitometro”")]),_vm._v(" - Se accedi al sito tramite link dopo aver risposto al questionario “Partitometro” proposto da Repubblica, acquisiamo i dati delle tue risposte al questionario dalla domanda 1 alla 15.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Cookie")]),_vm._v(" - Quando utilizzi i nostri servizi possiamo inviare uno o più cookie (piccoli file di testo contenente una stringa di caratteri alfanumerici) al tuo dispositivo. Utilizziamo cookie di sessione che si cancellano dopo la chiusura del browser.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Comunicazioni")]),_vm._v(" - Quando ci invii un’email od un’altra comunicazione registriamo la comunicazione stessa.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_vm._v("\n                Fornirti i nostri servizi e farti utilizzare l’applicazione LikeYouth.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Realizzare attività di ricerca scientifica.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Proteggere e migliorare i nostri servizi e svilupparne di nuovi.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Proteggere il funzionamento tecnico del nostro sistema informatico.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Adempiere ad obblighi di legge e/o ottemperare ad ordini provenienti da pubbliche autorità, inclusa l’autorità giudiziaria.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Pubblicare analisi statistiche e rappresentazioni grafiche dei risultati delle attività ma solo in forma aggregata ed anonima.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            I tuoi dati potranno essere conservati e trattati per ulteriori scopi di ricerca scientifica."),_c('br'),_vm._v("\n            Tratteremo i tuoi dati anche per informarti sui nostri servizi e sulle novità disponibili nel nostro sito ma l’adesione a queste finalità di trattamento è facoltativa e se ci negherai il tuo consenso non potremo darvi corso e potrai contattarci in qualsiasi momento per chiederci di interromperla.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Il conferimento dei dati di registrazione e di navigazione e dei cookie di sessione è obbligatorio ed indispensabile per consentirci di erogarti i nostri servizi e se rifiuti di conferirci i tuoi dati non potremo erogarti i nostri servizi."),_c('br'),_vm._v("\n            Il conferimento degli altri dati è facoltativo ma senza di quelli potremmo non essere in grado di fornirti certi servizi o certe funzionalità dei servizi.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_vm._v("\n                Raccolti per via telematica.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Conservati in modalità digitale presso server nella nostra disponibilità.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Protetti da rischi di distruzione, modifica, cancellazione e accessi non autorizzati mediante efficienti misure di sicurezza di carattere fisico, logico e organizzativo.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Trattati, con modalità anche cartacea, nella misura, con le modalità e nei tempi strettamente necessari per dare esecuzione alle finalità sopra indicate.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_vm._v("\n                Comunicare i tuoi dati a soggetti terzi che collaborano con noi e provvedono a trattare fasi dei processi necessari al corretto espletamento delle nostre attività.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Comunicare i tuoi dati a terzi per adempiere ad obblighi di legge o per ottemperare ad ordini provenienti da pubbliche autorità, inclusa l’autorità giudiziaria.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Puoi controllare e/o sopprimere i cookie a piacimento – per saperne di più, consulta il sito "),_c('a',{attrs:{"href":"http://www.allaboutcookies.org/","target":"_blank","title":"All About Cookies website"}},[_vm._v("www.allaboutcookies.org")]),_vm._v(". Puoi cancellare i cookie già presenti sul tuo dispositivo e impostare la maggior parte dei browser in modo da bloccarne l’installazione. La maggior parte dei browser consente di:\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_vm._v("\n                Visualizzare i cookie presenti e cancellarli singolarmente.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Bloccare i cookie di terzi.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Bloccare i cookie di particolari siti.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Bloccare l’installazione di tutti i cookie.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Cancellare tutti i cookie alla chiusura del browser.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Utilizziamo i seguenti servizi per trattare i tuoi dati."),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Applicazione facebook")]),_vm._v(" – Servizio fornito da Facebook Inc. tramite i suoi sistemi informativi che ci consente di acquisire dati dal tuo account sul social network Facebook."),_c('br'),_vm._v("\n            Permessi Facebook richiesti: Informazioni di base, Mi Piace.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Informazioni di base")]),_vm._v(" - Le informazioni di base dell’utente registrato su Facebook che normalmente includono i seguenti dati: id, nome, immagine, genere e lingua di localizzazione. Se hai reso disponibili pubblicamente dati ulteriori, gli stessi saranno acquisiti.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Mi Piace")]),_vm._v(" - Fornisce accesso alla lista di tutte le pagine che l’utente ha contrassegnato con il Mi Piace.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_c('strong',[_vm._v("Google Analytics")]),_vm._v(" – Servizio fornito da Google Inc. tramite i suoi sistemi informativi che ci consente di raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come gli stessi visitano il sito."),_c('br'),_vm._v("\n            La cookie policy di Google Analytics può essere visionata all'indirizzo "),_c('a',{attrs:{"href":"https://support.google.com/analytics/answer/6004245","target":"_blank"}},[_vm._v("https://support.google.com/analytics/answer/6004245")]),_vm._v(". \n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_c('strong',[_vm._v("ISI Foundation - Institute for Scientific Interchange")]),_c('br'),_vm._v(" \n                Via Chisola n. 5, 10126, Torino"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Tel:")]),_vm._v(" +39 011 6603090"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Fax:")]),_vm._v(" +39 011 6600049"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Email:")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"mailto:isi@isi.it"}},[_vm._v("isi@isi.it")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('strong',[_vm._v("Giuseppe Toniolo Institute for Higher Studies")]),_c('br'),_vm._v(" \n                Largo A. Gemelli, 1, Milan"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Tel:")]),_vm._v(" +39 02 72342292"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Fax:")]),_vm._v(" +39 02 72342772"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Email:")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"mailto:direzione.toniolo@unicatt.it"}},[_vm._v("direzione.toniolo@unicatt.it")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Foundation) as responsible for the processing of your data."),_c('br'),_vm._v("\n            You can ask by email the complete and updated list of those responsible for the processing of your data."),_c('br'),_vm._v("\n            We inform you that we will process your data in accordance with applicable laws and regulations and in full respect of your rights and, in particular, your privacy.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Registration information")]),_vm._v(" - When you register, we record your information (username, password, e-mail address, name and surname, date of birth, etc.).\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Browsing data")]),_vm._v(" - When you connect to our system, this will automatically record information that your device sends us. This information may relate to the content loaded, the operations performed by you, the IP address and MAC address from which you access the site, the date and time of your request, your location, etc.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Data from the “Indagine Giovani” survey")]),_vm._v(" - If you access the site through a link after responding to the “Indagine Giovani” survey proposed by the Institute Toniolo, we acquire the data of your answers to the survey.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Cookies")]),_vm._v(" - When you use our services we may send one or more cookies (small text files containing a string of alphanumeric characters) to your device. We use session cookies that are deleted once you close your browser.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Communications")]),_vm._v(" - When you send us an email or other communication we record and store such communication.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_vm._v("\n                Provide you with our services and with the LikeYouth application.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Undertake scientific research.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Protect and improve our services and develop new ones.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Protect the technical operation of our computer system.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Fulfill legal obligations and / or comply with orders from public authorities, including the judicial authorities.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Publish statistics and graphic representations of the results of activities but only in aggregate and anonymous form.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Your data may be stored and processed for further scientific research purposes."),_c('br'),_vm._v("\n            We will process your information also to inform you about our services and news in our website, but the provision of your consent to the data processing for this purpose is optional and if you will deny your consent we will not proceed. You can contact us at any time requesting to terminate the processing.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            Provision of the registration information, browsing data and session cookies it is mandatory and essential for us to provide you with our services. Upon denial to bestow these information we will not be able to provide you with our services."),_c('br'),_vm._v("\n            The provision of other data is optional but without them we may not be able to provide certain services or certain functionalities of our services.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_vm._v("\n                Collected electronically.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Stored digitally at our servers.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Protected from risk of destruction, modification, deletion and unauthorized access by means of efficient physical, logical and organizational security.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Further processed, including in hardcopy, to the extent and in the manner and time strictly necessary to implement the above-mentioned purposes.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_vm._v("\n                Communicate your data to third parties who work with us and deal with phases of the processes necessary for the proper performance of our activities.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Communicate your data to third parties that comply with legal obligations or that comply with order from public authorities, including the judicial authorities.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            You can control and / or delete the cookies at will - to learn more, please visit the website "),_c('a',{attrs:{"href":"http://www.allaboutcookies.org/","target":"_blank","title":"All About Cookies website"}},[_vm._v("www.allaboutcookies.org")]),_vm._v(". You can delete cookies already stored on your device and set most browsers to block their installation. Most browsers allow you to:\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_vm._v("\n                View the cookies and delete them individually.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Block third-party cookies.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Block cookies from particular sites.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Block the installation of all cookies.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_vm._v("\n                Delete all cookies when you close your browser.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v("\n            We use the following services to process your data."),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Facebook application")]),_vm._v(" – Service provided by Facebook Inc. through its information systems that allows us to record data from your account on the social network Facebook."),_c('br'),_vm._v("\n            Facebook permits required: Basic Information, Like.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},[_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Basic Information")]),_vm._v(" - The basic user information registered on Facebook normally include the following data: id, name, picture, gender and localization language. If you made publicly available more data, such data will be acquired.\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('em',[_vm._v("Like")]),_vm._v(" - Provides access to the list of all pages that the user marked with Like.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_c('strong',[_vm._v("Google Analytics")]),_vm._v(" – Service provided by Google Inc. through its information systems that allows us to collect information, in aggregate form, on the number of users and on how they visit the site."),_c('br'),_vm._v("\n            The Google Analytics cookie policy can be viewed at "),_c('a',{attrs:{"href":"https://support.google.com/analytics/answer/6004245","target":"_blank"}},[_vm._v("https://support.google.com/analytics/answer/6004245")]),_vm._v(".\n\n        ")])}]


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_survey_chooser_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d69a52b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_chooser_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_survey_chooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d69a52b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_chooser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d69a52b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_chooser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(115)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-chooser"},_vm._l((_vm.surveys),function(s,index){return _c('div',{key:s.id,class:'survey theme-color-' + s.slug},[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-survey-index"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm._f("twoDigits")(index + 1))+". —")])]),_vm._v(" "),_c('div',{staticClass:"c-survey-title"},[_c('div',{staticClass:"content"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.getSurveyTitle(s)))]),_vm._v(" "),_c('h3',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.getSurveyTagline(s)))]),_vm._v(" "),(s.isComplete)?_c('h4',{staticClass:"completed"},[_vm._v(_vm._s(_vm.$t('textComplete'))+" "+_vm._s(_vm._f("timeFromNow")(s.updateStamp)))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"c-survey-actions"},[(!s.isComplete)?_c('div',{staticClass:"content"},[_c('router-link',{staticClass:"btn-ghost icon-after-start",attrs:{"to":_vm.link('survey', { slug: s.slug })}},[_vm._v("\n                            "+_vm._s(_vm.$t('actionStart'))+"\n                        ")])],1):_c('div',{staticClass:"content"},[_c('div',{staticClass:"action"},[_c('router-link',{staticClass:"btn-ghost icon-before-results",attrs:{"to":_vm.link('results', { slug: s.slug })}},[_vm._v(_vm._s(_vm.$t('textResults')))])],1),_vm._v(" "),_c('div',{staticClass:"action"},[_c('router-link',{staticClass:"btn-ghost icon-before-survey",attrs:{"to":_vm.link('survey', { slug: s.slug })}},[_vm._v(_vm._s(_vm.$t('textPlayAgain')))])],1)])])])])])}))}
var staticRenderFns = []


/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"actionStart":"Inizia","textComplete":"Completato","textResults":"Risultati","textPlayAgain":"Riprova"},"en":{"actionStart":"Start","textComplete":"Completed","textResults":"Results","textPlayAgain":"Replay"}}')
}


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_survey_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658db0fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_survey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658db0fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658db0fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_survey_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(118)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey"},[_c('div',{staticClass:"navigation-slider"},[_c('button',{class:{ 'btn-prev': true, 'active': _vm.showPrev },on:{"click":_vm.onPrev}},[_vm._v(_vm._s(_vm.$t('actionPrev')))]),_vm._v(" "),_c('div',{staticClass:"counter"},[_vm._v(_vm._s(_vm.itemIndex + 1)+" / "+_vm._s(_vm.itemsSections && _vm.itemsSections.length))]),_vm._v(" "),_c('button',{class:{ 'btn-next': true, 'active': _vm.showNext },on:{"click":_vm.onNext}},[_vm._v(_vm._s(_vm.$t('actionNext')))])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":_vm.transitionName}},_vm._l((_vm.itemsSections),function(s){return (_vm.isItemVisible(s))?_c('div',{key:s.item.id,class:_vm.slideClasses},[(_vm.slideLayout == 'image')?[_c('div',{staticClass:"main-wrapper align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-text"},[_c('div',{staticClass:"content"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.getText(s.section.texts, 'Title'))}})])]),_vm._v(" "),_c('div',{staticClass:"c-survey"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"picture"},[_c('img',{attrs:{"src":("/_assets/resources/surveys/" + _vm.slug + "/" + (s.item.themeParameters.ImageName) + ".jpg")}})]),_vm._v(" "),_c('h1',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.getText(s.item.texts, 'Title')))]),_vm._v(" "),_c('div',{staticClass:"fields"},_vm._l((_vm.itemOptions),function(o){return _c('div',{key:o.id,class:{ field: true, hidden: o.value == 0 }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data[s.item.key]),expression:"data[s.item.key]"}],attrs:{"type":"radio","id":((s.item.key) + "__" + (o.value))},domProps:{"value":o.value,"checked":_vm._q(_vm.data[s.item.key],o.value)},on:{"change":[function($event){_vm.$set(_vm.data, s.item.key, o.value)},_vm.onOptionChange]}}),_vm._v(" "),_c('label',{attrs:{"for":((s.item.key) + "__" + (o.value))},on:{"click":_vm.onOptionClick}},[_vm._v(_vm._s(_vm.getText(o.texts, 'Title')))])])}))])])])])]:(_vm.slideLayout == 'default')?[_c('div',{staticClass:"main-wrapper align"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-text"},[_c('div',{staticClass:"content"},[_c('h2',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.getText(s.section.texts, 'Title'))}}),_vm._v(" "),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.getText(s.section.texts, 'Description'))}}),_vm._v(" "),_c('h1',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.getText(s.item.texts, 'Title')))])])]),_vm._v(" "),(_vm.slideHasImage)?_c('div',{staticClass:"c-picture"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":("/_assets/resources/surveys/" + _vm.slug + "/" + (s.item.themeParameters.ImageName))}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-survey"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"fields"},_vm._l((_vm.itemOptions),function(o){return _c('div',{key:o.id,class:{ field: true, hidden: o.value == 0 }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data[s.item.key]),expression:"data[s.item.key]"}],attrs:{"type":"radio","id":((s.item.key) + "__" + (o.value))},domProps:{"value":o.value,"checked":_vm._q(_vm.data[s.item.key],o.value)},on:{"change":[function($event){_vm.$set(_vm.data, s.item.key, o.value)},_vm.onOptionChange]}}),_vm._v(" "),_c('label',{attrs:{"for":((s.item.key) + "__" + (o.value))},on:{"click":_vm.onOptionClick}},[_vm._v(_vm._s(_vm.getText(o.texts, 'Title')))])])}))])])])])]:_vm._e()],2):_vm._e()}))],1)])}
var staticRenderFns = []


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"actionPrev":"Precedente","actionNext":"Successivo"},"en":{"actionPrev":"Previous","actionNext":"Next"}}')
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_results_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3084394b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_results_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3084394b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_results_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3084394b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_results_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(124)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sortByAttribute */
/* unused harmony export bigFive */
/* unused harmony export threeF */
/* unused harmony export moralFoundation */
/* unused harmony export fakeNews */
/* unused harmony export art */
/* unused harmony export lifeWork */
/* unused harmony export partitometro */
/* unused harmony export europartitometro */
/* harmony export (immutable) */ __webpack_exports__["a"] = abacusBySurvey;
function sortByAttribute(arr, attribute) {
    return arr.sort(function (a, b) {
        return (a[attribute] < b[attribute]) ? 1 : (a[attribute] > b[attribute]) ? -1 : 0;
    });
}
function getTextByMeanAndStd(lang, survey, y, mean, std) {
    var text = survey.texts[lang].Widgets.OwnResultsScoreTexts.split('|');
    if (y < mean - std) {
        return text[0];
    }
    if (y > mean - std) {
        return text[2];
    }
    return text[1];
}
function getTextByResultRange(lang, survey, y) {
    var text = survey.texts[lang].Widgets.OwnResultsScoreTexts.split('|');
    var ranges = survey.texts[lang].Widgets.ResultsRanges;
    for (var i = 0; i < ranges.length; i++) {
        if (y >= ranges[i][0] && y <= ranges[i][1]) {
            return text[i];
        }
    }
}
function bigFive(x) {
    var _a = x.slice(), q1 = _a[0], q2 = _a[1], q3 = _a[2], q4 = _a[3], q5 = _a[4], q6 = _a[5], q7 = _a[6], q8 = _a[7], q9 = _a[8], q10 = _a[9];
    var extraversion = q1 + (8 - q6);
    var agreeableness = q7 + (8 - q2);
    var conscientiousness = q3 + (8 - q8);
    var stability = q9 + (8 - q4);
    var openness = q5 + (8 - q10);
    var levels = [{ 'level': 'bigfive-extraversion', 'points': extraversion },
        { 'level': 'bigfive-agreeableness', 'points': agreeableness },
        { 'level': 'bigfive-conscientiousness', 'points': conscientiousness },
        { 'level': 'bigfive-stability', 'points': stability },
        { 'level': 'bigfive-openness', 'points': openness }];
    var y = [extraversion, agreeableness, conscientiousness, stability, openness];
    var bestMatch = sortByAttribute(levels, 'points')[0].level;
    return { 'y': y, 'bestMatch': bestMatch };
}
function threeF(x) {
    var _a = x.slice(), q1 = _a[0], q2 = _a[1], q3 = _a[2], q4 = _a[3], q5 = _a[4], q6 = _a[5], q7 = _a[6], q8 = _a[7], q9 = _a[8], q10 = _a[9];
    var doer = (q1 + q2 + (6 - q3)) / 3;
    var dreamer = (q4 + q5 + q6) / 3;
    var believer = (q7 + q8 + q9) / 3;
    var happiness = q10;
    var levels = [{ 'level': '3f-doer', 'points': doer },
        { 'level': '3f-dreamer', 'points': dreamer },
        { 'level': '3f-believer', 'points': believer },
        { 'level': '3f-happiness', 'points': happiness }];
    var y = [doer, dreamer, believer, happiness];
    var bestMatch = sortByAttribute(levels, 'points')[0].level;
    return { 'y': y, 'bestMatch': bestMatch };
}
function moralFoundation(x) {
    var _a = x.slice(), mf1 = _a[0], mf2 = _a[1], mf3 = _a[2], mf4 = _a[3], mf5 = _a[4], mf7 = _a[5], mf8 = _a[6], mf9 = _a[7], mf10 = _a[8], mf11 = _a[9], mf17 = _a[10], mf18 = _a[11], mf19 = _a[12], mf20 = _a[13], mf21 = _a[14], mf23 = _a[15], mf24 = _a[16], mf25 = _a[17], mf26 = _a[18], mf27 = _a[19];
    var care = mf1 + mf7 + mf17 + mf23;
    var fair = mf2 + mf8 + mf18 + mf24;
    var loyalty = mf3 + mf9 + mf19 + mf25;
    var authority = mf4 + mf10 + mf20 + mf26;
    var purity = mf5 + mf11 + mf21 + mf27;
    var levels = [{ 'level': 'mf-care', 'points': care },
        { 'level': 'mf-fair', 'points': fair },
        { 'level': 'mf-loyalty', 'points': loyalty },
        { 'level': 'mf-authority', 'points': authority },
        { 'level': 'mf-purity', 'points': purity }];
    var y = [care, fair, loyalty, authority, purity];
    var bestMatch = sortByAttribute(levels, 'points')[0].level;
    return { 'y': y, 'bestMatch': bestMatch };
}
function fakeNews(x) {
    var _a = x.slice(), q1 = _a[0], q2 = _a[1], q3 = _a[2], q4 = _a[3], q5 = _a[4], q6 = _a[5], q7 = _a[6], q8 = _a[7];
    var y = ((5 - q1) + (5 - q2) + (5 - q3) + q4 + (6 - q5) + q6 + (6 - q7) + (5 - q8));
    return { y: y };
}
function art(x) {
    var _a = x.slice(), q1 = _a[0], q2 = _a[1], q3 = _a[2], q4 = _a[3], q5 = _a[4], q6 = _a[5];
    var y = (q1 + q2 + q3 + q4 + q5 + q6) / 6;
    return { y: y };
}
function lifeWork(x) {
    var _a = x.slice(), q1 = _a[0], q2 = _a[1], q3 = _a[2], q4 = _a[3], q5 = _a[4], q6 = _a[5];
    var y = (q1 + q2 + (6 - q3) + q4 + q5 + q6) / 6;
    return { y: y };
}
function partitometro(x) {
    var _a = x.slice(), eq1 = _a[0], eq2 = _a[1], fe1 = _a[2], fe2 = _a[3], gov = _a[4], imm1 = _a[5], imm2 = _a[6], pot = _a[7], pres = _a[8], sic = _a[9], suc = _a[10], tr1 = _a[11], tr2 = _a[12], ue = _a[13], univ = _a[14];
    x = [tr1, tr2, fe1, fe2, imm1, imm2, eq1, eq2, suc, pot, sic, univ, pres, gov, ue];
    var wx = [0.908030375668787, 0.987633632399048, 0.902129995569227, 0.937270737426711, -0.872254367507232, 0.98324043897986, -0.629290698097671, -0.678484021729118, 0.316879305882864, 0.92736969368567, 0.930422029183613, -0.805863003983494, -0.772978814333193, -0.630010329448491, -0.792197388868114];
    var wy = [-0.189289598926039, -0.024030132682149, 0.229864884268728, 0.146732363467913, 0.348999576147727, 0.011799613322714, -0.744838745898707, -0.528815942886341, 0.768069227994776, 0.339705541398833, -0.28887677963632, -0.47520534012785, 0.598407150792707, 0.725148709911155, 0.551838161664377];
    var m = [3.5485520097726, 3.32694923138923, 2.72789804919156, 3.1008967480994, 2.79718014676547, 3.01821148045976, 3.92163130173604, 3.83201364738186, 2.74735732680962, 2.60405495631466, 3.45973542730829, 3.64514629162681, 2.21373815126727, 1.79995818085903, 2.19930964134248];
    var fixX = [3, 3, 2, 2, 5, 5, 2, 2, 1, 1, 1, 1, 1, 1, 1];
    var rX = [];
    for (var i = 0; i < 15; i++) {
        rX.push(wx[i] * (x[i] - m[i]) * fixX[i]);
    }
    var rYpres = wy[12] * (x[12] - m[12]);
    if (x[12] == 1) {
        rYpres = rYpres * 10;
    }
    var rYgov = wy[13] * (x[13] - m[13]);
    if (x[13] == 1) {
        rYgov = rYgov * 10;
    }
    var rYue = wy[14] * (x[14] - m[14]);
    if (x[14] == 1) {
        rYue = rYue * 10;
    }
    var rY = [wy[0] * (x[0] - m[0]),
        wy[1] * (x[1] - m[1]),
        wy[2] * (x[2] - m[2]),
        wy[3] * (x[3] - m[3]),
        wy[4] * (x[4] - m[4]) * 2,
        wy[5] * (x[5] - m[5]) * 2,
        wy[6] * (x[6] - m[6]) * 2,
        wy[7] * (x[7] - m[7]) * 2,
        wy[8] * (x[8] - m[8]) * 2,
        wy[9] * (x[9] - m[9]),
        wy[10] * (x[10] - m[10]),
        wy[11] * (x[11] - m[11]) * 2,
        rYpres,
        rYgov,
        rYue
    ];
    var x0 = rX.reduce(function (a, b) { return a + b; }, 0) / 15;
    var y0 = rY.reduce(function (a, b) { return a + b; }, 0) / 15;
    var xPD = -1.23716845309642;
    var xLEGA = 1.101;
    var xSINISTRA = -2.001;
    var xM5S = -0.04834559276989;
    var xFI = 0.40421901657437;
    var xFdI = 0.920596616395224;
    var xDESTRA = 0.922;
    var yPD = 0.099294426300892;
    var yLEGA = -0.501;
    var ySINISTRA = -0.311;
    var yM5S = -0.955;
    var yFI = -0.140727941192889;
    var yFdI = 0.154132714076589;
    var yDESTRA = 0.463582017383125;
    var dpPD = Math.pow(Math.pow(xPD - x0, 2) + Math.pow(yPD - y0, 2), 0.8);
    var dpLEGA = Math.pow(Math.pow(xLEGA - x0, 2) + Math.pow(yLEGA - y0, 2), 0.8);
    var dpSINISTRA = Math.pow(Math.pow(xSINISTRA - x0, 2) + Math.pow(ySINISTRA - y0, 2), 0.8);
    var dpM5S = Math.pow(Math.pow(xM5S - x0, 2) + Math.pow(yM5S - y0, 2), 0.8);
    var dpFI = Math.pow(Math.pow(xFI - x0, 2) + Math.pow(yFI - y0, 2), 0.8);
    var dpFdI = Math.pow(Math.pow(xFdI - x0, 2) + Math.pow(yFdI - y0, 2), 0.8);
    var dpDESTRA = Math.pow(Math.pow(xDESTRA - x0, 2) + Math.pow(yDESTRA - y0, 2), 0.8);
    var dp = dpPD + dpLEGA + dpSINISTRA + dpM5S + dpFI + dpFdI + dpDESTRA;
    var dPD = 1 / dp / dpPD;
    var dLEGA = 1 / dp / dpLEGA;
    var dSINISTRA = 1 / dp / dpSINISTRA;
    var dM5S = 1 / dp / dpM5S;
    var dFI = 1 / dp / dpFI;
    var dFdI = 1 / dp / dpFdI;
    var dDESTRA = 1 / dp / dpDESTRA;
    var d = dPD + dLEGA + dSINISTRA + dM5S + dFI + dFdI + dDESTRA;
    var aPD = dPD / d;
    var aLEGA = dLEGA / d;
    var aSINISTRA = dSINISTRA / d;
    var aM5S = dM5S / d;
    var aFI = dFI / d;
    var aFdI = dFdI / d;
    var aDESTRA = dDESTRA / d;
    var overlap = '';
    var overlapPercent = 0.9;
    var y = [aPD, aLEGA, aSINISTRA, aM5S, aFI, aFdI, aDESTRA];
    y.forEach(function (x) {
        if (x >= overlapPercent) {
            overlap = 'overlap';
        }
    });
    var xy = [{ 'label': 'pd', 'x': xPD, 'y': yPD },
        { 'label': 'lega', 'x': xLEGA, 'y': yLEGA },
        { 'label': 'sinistra', 'x': xSINISTRA, 'y': ySINISTRA },
        { 'label': 'm5s', 'x': xM5S, 'y': yM5S },
        { 'label': 'fi', 'x': xFI, 'y': yFI },
        { 'label': 'fdi', 'x': xFdI, 'y': yFdI },
        { 'label': 'destra', 'x': xDESTRA, 'y': yDESTRA },
        { 'label': 'you', 'x': x0, 'y': y0, 'class': overlap }];
    var affinity = [{ 'label': 'pd', 'value': aPD },
        { 'label': 'lega', 'value': aLEGA },
        { 'label': 'sinistra', 'value': aSINISTRA },
        { 'label': 'm5s', 'value': aM5S },
        { 'label': 'fi', 'value': aFI },
        { 'label': 'fdi', 'value': aFdI },
        { 'label': 'destra', 'value': aDESTRA }];
    var podium = sortByAttribute(affinity, 'value').slice(0, 3);
    var rankings = sortByAttribute(affinity, 'value');
    var tradizionalismo = (tr1 + tr2) / 2;
    var libertarismo = (fe1 + fe2) / 2;
    var accettazione = (imm1 + 6 - imm2) / 2;
    var egualitarismo = (eq1 + eq2) / 2;
    var potenza = pot;
    var universalismo = univ;
    var successo = suc;
    var sicurezza = sic;
    var fiducia = (pres + gov + ue) / 3;
    var y1 = [tradizionalismo, libertarismo, accettazione, egualitarismo, potenza, universalismo, successo, sicurezza, fiducia];
    var avgTradizionalismo = 3.437751;
    var avgLibertarismo = 2.914397;
    var avgAccettazione = 2.889484;
    var avgEgualitarismo = 3.876822;
    var avgPotenza = 2.604055;
    var avgUniversalismo = 3.645146;
    var avgSuccesso = 2.747357;
    var avgSicurezza = 3.459735;
    var avgFiducia = 2.071002;
    var y2 = [avgTradizionalismo, avgLibertarismo, avgAccettazione, avgEgualitarismo, avgPotenza, avgUniversalismo, avgSuccesso, avgSicurezza, avgFiducia];
    return { 'y': y, 'xy': xy, 'podium': podium, 'rankings': rankings, 'y1': y1, 'y2': y2 };
}
function europartitometro(x) {
    // From repubblica example URL
    // http://localhost:8080/it/europartitometro/feed/repubblica?ius=1&ue1=1&ue2=1&min=1&toll=1&tr=1&imm1=1&nat=1&ue3=1&imm2=1&sic=1&op=1&dxsx=1&gov=1&redd=1
    var _a = x.slice(), dxsx = _a[0], gov = _a[1], imm1 = _a[2], imm2 = _a[3], ius = _a[4], min = _a[5], nat = _a[6], op = _a[7], redd = _a[8], sic = _a[9], toll = _a[10], tr = _a[11], ue1 = _a[12], ue2 = _a[13], ue3 = _a[14];
    x = [ius, ue1, ue2, min, toll, tr, imm1, nat, ue3, imm2, sic, op, dxsx, gov, redd];
    //console.log(x);
    var wx = [
        -0.869161896124557,
        -0.696033145823991,
        -0.767583329839787,
        -0.93542480002175,
        -0.830963135587569,
        0.77436022300893,
        0.881634199400479,
        -0.816550581326006,
        0.851548203257597,
        0.866281670519318,
        0.916128916659223,
        -0.058541277339562,
        0.422017086322485,
        0.63128260284417,
        0.296425073639361
    ];
    var wy = [
        -0.413129680936013,
        -0.688664193130569,
        -0.583912459399183,
        -0.064303354756776,
        -0.508231369277383,
        0.424304883664908,
        0.347935165141936,
        0.02087712889177,
        0.465992392913144,
        0.431542840845917,
        0.373502838917498,
        0.972136397110655,
        0.802579970286608,
        0.761988566230128,
        0.829013663027135
    ];
    var m = [
        3.56363599665859,
        3.13818868639502,
        3.57148600161794,
        3.94238758897343,
        4.05943284029033,
        3.28220266387742,
        2.79446767397362,
        3.9610602834195,
        2.48978504786416,
        2.90420081985212,
        3.13848615398927,
        2.80197767382844,
        3.19376831558715,
        2.52461827596469,
        2.89870887129163
    ];
    var rX = [];
    for (var i = 0; i < 15; i++) {
        rX.push(wx[i] * (x[i] - m[i]) * 1.5);
    }
    var rY = [wy[0] * (x[0] - m[0]) * 1.5,
        wy[1] * (x[1] - m[1]) * 1.5,
        wy[2] * (x[2] - m[2]) * 1.5,
        wy[3] * (x[3] - m[3]) * 1.5,
        wy[4] * (x[4] - m[4]) * 1.5,
        wy[5] * (x[5] - m[5]) * 1.5,
        wy[6] * (x[6] - m[6]) * 1.5,
        wy[7] * (x[7] - m[7]) * 1.5,
        wy[8] * (x[8] - m[8]) * 1.5,
        wy[9] * (x[9] - m[9]) * 1.5,
        wy[10] * (x[10] - m[10]) * 1.5,
        wy[11] * (x[11] - m[11]) * 3,
        wy[12] * (x[12] - m[12]) * 3,
        wy[13] * (x[13] - m[13]) * 3,
        wy[14] * (x[14] - m[14]) * 3
    ];
    var x0 = rX.reduce(function (a, b) { return a + b; }, 0) / 15;
    var y0 = rY.reduce(function (a, b) { return a + b; }, 0) / 15;
    var xSINISTRA = -1.493;
    var xPD = -0.708;
    var xPIUEU = -0.414;
    var xVERDI = -1.376;
    var xM5S = 0.098;
    var xFI = 0.485;
    var xFdI = 1.197;
    var xLEGA = 0.902;
    var ySINISTRA = -0.011;
    var yPD = -0.936;
    var yPIUEU = -1.506;
    var yVERDI = 0.337;
    var yM5S = 1.161;
    var yFI = -0.404;
    var yFdI = -0.317;
    var yLEGA = 0.347;
    var dpSINISTRA = Math.pow(Math.pow(xSINISTRA - x0, 2) + Math.pow(ySINISTRA - y0, 2), 0.8);
    var dpPD = Math.pow(Math.pow(xPD - x0, 2) + Math.pow(yPD - y0, 2), 0.8);
    var dpPIUEU = Math.pow(Math.pow(xPIUEU - x0, 2) + Math.pow(yPIUEU - y0, 2), 0.8);
    var dpVERDI = Math.pow(Math.pow(xVERDI - x0, 2) + Math.pow(yVERDI - y0, 2), 0.8);
    var dpM5S = Math.pow(Math.pow(xM5S - x0, 2) + Math.pow(yM5S - y0, 2), 0.8);
    var dpFI = Math.pow(Math.pow(xFI - x0, 2) + Math.pow(yFI - y0, 2), 0.8);
    var dpFdI = Math.pow(Math.pow(xFdI - x0, 2) + Math.pow(yFdI - y0, 2), 0.8);
    var dpLEGA = Math.pow(Math.pow(xLEGA - x0, 2) + Math.pow(yLEGA - y0, 2), 0.8);
    var dp = dpSINISTRA + dpPD + dpPIUEU + dpVERDI + dpM5S + dpFI + dpFdI + dpLEGA;
    //console.log(dpSINISTRA, dpPD, dpPIUEU, dpVERDI, dpM5S, dpFI, dpFdI, dpLEGA);
    //console.log(dp);
    var dSINISTRA = 1 / dp / dpSINISTRA;
    var dPD = 1 / dp / dpPD;
    var dPIUEU = 1 / dp / dpPIUEU;
    var dVERDI = 1 / dp / dpVERDI;
    var dM5S = 1 / dp / dpM5S;
    var dFI = 1 / dp / dpFI;
    var dFdI = 1 / dp / dpFdI;
    var dLEGA = 1 / dp / dpLEGA;
    var d = dSINISTRA + dPD + dPIUEU + dVERDI + dM5S + dFI + dFdI + dLEGA;
    //console.log(dSINISTRA, dPD, dPIUEU, dVERDI, dM5S, dFI, dFdI, dLEGA);
    //console.log(d);
    var aSINISTRA = dSINISTRA / d;
    var aPD = dPD / d;
    var aPIUEU = dPIUEU / d;
    var aVERDI = dVERDI / d;
    var aM5S = dM5S / d;
    var aFI = dFI / d;
    var aFdI = dFdI / d;
    var aLEGA = dLEGA / d;
    var overlap = '';
    var overlapPercent = 0.9;
    var y = [aSINISTRA, aPD, aPIUEU, aVERDI, aM5S, aFI, aFdI, aLEGA];
    //console.log(y);
    y.forEach(function (x) {
        if (x >= overlapPercent) {
            overlap = 'overlap';
        }
    });
    var xy = [
        { 'label': 'sinistra', 'x': xSINISTRA, 'y': ySINISTRA },
        { 'label': 'pd', 'x': xPD, 'y': yPD },
        { 'label': 'piueu', 'x': xPIUEU, 'y': yPIUEU },
        { 'label': 'verdi', 'x': xVERDI, 'y': yVERDI },
        { 'label': 'm5s', 'x': xM5S, 'y': yM5S },
        { 'label': 'fi', 'x': xFI, 'y': yFI },
        { 'label': 'fdi', 'x': xFdI, 'y': yFdI },
        { 'label': 'lega', 'x': xLEGA, 'y': yLEGA },
        { 'label': 'you', 'x': x0, 'y': y0, 'class': overlap }
    ];
    var affinity = [
        { 'label': 'sinistra', 'value': aSINISTRA },
        { 'label': 'pd', 'value': aPD },
        { 'label': 'piueu', 'value': aPIUEU },
        { 'label': 'verdi', 'value': aVERDI },
        { 'label': 'm5s', 'value': aM5S },
        { 'label': 'fi', 'value': aFI },
        { 'label': 'fdi', 'value': aFdI },
        { 'label': 'lega', 'value': aLEGA }
    ];
    var rankings = sortByAttribute(affinity, 'value');
    return { 'xy': xy, 'y': y, 'rankings': rankings };
}
function abacusBySurvey(lang, survey, x, stats, fbId) {
    switch (survey.slug) {
        case 'facebook': {
            return {
                plots: ['radar', 'radar-filters', 'levels'],
                y1: x,
                y2: stats.facebook,
                y1Title: survey.texts[lang].Widgets.OwnResultsLegend,
                y2Title: survey.texts[lang].Widgets.OthersResultsLegend,
                y2FiltersTitle: {
                    'it': 'Le risposte degli altri',
                    'en': 'Others\' answers'
                },
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                yLabels: {
                    'it': [
                        'Cibo',
                        'Cultura e Spettacolo',
                        'Animali e Natura',
                        'Viaggi',
                        'Sport',
                        'Scienze e Tecnologia',
                        'Politica, Società e Informazione',
                        'Istruzione',
                        'Lavoro',
                        'Shopping',
                        'Salute e Benessere',
                        'Hobby'
                    ],
                    'en': [
                        'Food',
                        'Culture and entertainment',
                        'Animals and nature',
                        'Travel',
                        'Sports',
                        'Science and technology',
                        'Politics, society and information',
                        'Education',
                        'Business',
                        'Shopping',
                        'Health and wellness',
                        'Hobbies'
                    ]
                },
                radarLabels: {
                    'it': [
                        { name: 'Cibo', anchor: 'top' },
                        { name: 'Cultura&nbsp;e<br /> Spettacolo', anchor: 'top' },
                        { name: 'Animali&nbsp;e<br /> Natura', anchor: 'top' },
                        { name: 'Viaggi', anchor: 'top' },
                        { name: 'Sport', anchor: 'bottom' },
                        { name: 'Scienze&nbsp;e<br /> Tecnologia', anchor: 'bottom-right' },
                        { name: 'Politica, Società<br /> e Informazione', anchor: 'bottom' },
                        { name: 'Istruzione', anchor: 'bottom-left' },
                        { name: 'Lavoro', anchor: 'bottom' },
                        { name: 'Shopping', anchor: 'top' },
                        { name: 'Salute&nbsp;e<br /> Benessere', anchor: 'top' },
                        { name: 'Hobby', anchor: 'top' }
                    ],
                    'en': [
                        { name: 'Food', anchor: 'top' },
                        { name: 'Culture&nbsp;and<br /> entertainment', anchor: 'top' },
                        { name: 'Animals&nbsp;and<br /> nature', anchor: 'top' },
                        { name: 'Travel', anchor: 'top' },
                        { name: 'Sports', anchor: 'bottom' },
                        { name: 'Science&nbsp;and<br /> technology', anchor: 'bottom-right' },
                        { name: 'Politics, society<br /> and information', anchor: 'bottom' },
                        { name: 'Education', anchor: 'bottom-left' },
                        { name: 'Business', anchor: 'bottom' },
                        { name: 'Shopping', anchor: 'top' },
                        { name: 'Health&nbsp;and<br /> wellness', anchor: 'top' },
                        { name: 'Hobbies', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(163,138,124)',
                    'rgb(253,103,84)',
                    'rgb(113,131,41)',
                    'rgb(84,171,174)',
                    'rgb(252,160,45)',
                    'rgb(122,152,151)',
                    'rgb(106,181,252)',
                    'rgb(57,182,173)',
                    'rgb(253,137,114)',
                    'rgb(254,201,68)',
                    'rgb(157,157,156)'
                ],
                ageFilter: {
                    'it': {
                        title: 'Età',
                        ageRange1: '18-24',
                        ageRange2: '24-29',
                        ageRange3: '30+'
                    },
                    'en': {
                        title: 'Age',
                        ageRange1: '18-24',
                        ageRange2: '24-29',
                        ageRange3: '30+'
                    }
                },
                genderFilter: {
                    'it': {
                        title: 'Sesso',
                        gender1: 'Maschio',
                        gender2: 'Femmina'
                    },
                    'en': {
                        title: 'Gender',
                        gender1: 'Male',
                        gender2: 'Female'
                    }
                },
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: 5,
                levelsPaddingLeft: 275,
                levelsRowHeight: 35
            };
        }
        case 'moral-foundations': {
            var r = moralFoundation(x);
            var o = moralFoundation(stats.median);
            return {
                plots: ['radar', 'levels'],
                y1: r.y,
                y2: o.y,
                y1Title: survey.texts[lang].Widgets.OwnResultsLegend,
                y2Title: survey.texts[lang].Widgets.OthersResultsLegend,
                scoreDescription: survey.texts[lang].Widgets['OwnResultsText:' + r.bestMatch],
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                yLabels: {
                    'it': ['Cura', 'Equità', 'Lealtà', 'Rispetto', 'Purezza'],
                    'en': ['Care', 'Fairness', 'Loyalty', 'Authority', 'Purity']
                },
                radarLabels: {
                    'it': [
                        { name: 'Cura', anchor: 'top' },
                        { name: 'Equità', anchor: 'top' },
                        { name: 'Lealtà', anchor: 'bottom' },
                        { name: 'Rispetto', anchor: 'bottom' },
                        { name: 'Purezza', anchor: 'top' }
                    ],
                    'en': [
                        { name: 'Care', anchor: 'top' },
                        { name: 'Fairness', anchor: 'top' },
                        { name: 'Loyalty', anchor: 'bottom' },
                        { name: 'Authority', anchor: 'bottom' },
                        { name: 'Purity', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(253,137,114)',
                    'rgb(113,131,41)',
                    'rgb(254,201,68)',
                    'rgb(57,182,173)'
                ],
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: 30,
                levelsRangeLabels: ['0', '30'],
                levelsPaddingLeft: 100
            };
        }
        case 'bigfive': {
            var r = bigFive(x);
            var o = bigFive(stats.median);
            return {
                plots: ['radar', 'levels'],
                y1: r.y,
                y2: o.y,
                y1Title: survey.texts[lang].Widgets.OwnResultsLegend,
                y2Title: survey.texts[lang].Widgets.OthersResultsLegend,
                scoreDescription: survey.texts[lang].Widgets['OwnResultsText:' + r.bestMatch],
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                yLabels: {
                    'it': ['Estroversione', 'Amicalità', 'Affidabilità', 'Stabilità emotiva', 'Disponibile a nuove esperienze'],
                    'en': ['Extraversion', 'Agreeableness', 'Conscientiousness', 'Emotional stability', 'Openness to experience']
                },
                radarLabels: {
                    'it': [
                        { name: 'Estroversione', anchor: 'top' },
                        { name: 'Amicalità', anchor: 'top' },
                        { name: 'Affidabilità', anchor: 'bottom' },
                        { name: 'Stabilità emotiva', anchor: 'bottom' },
                        { name: 'Disponibile<br /> a nuove<br /> esperienze', anchor: 'top' }
                    ],
                    'en': [
                        { name: 'Extraversion', anchor: 'top' },
                        { name: 'Agreeableness', anchor: 'top' },
                        { name: 'Conscientiousness', anchor: 'bottom' },
                        { name: 'Emotional stability', anchor: 'bottom' },
                        { name: 'Openness<br /> to experience', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(253,137,114)',
                    'rgb(113,131,41)',
                    'rgb(254,201,68)',
                    'rgb(57,182,173)'
                ],
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: Math.max.apply(Math, r.y.concat(o.y)),
                levelsPaddingLeft: 268
            };
        }
        case '3f': {
            var r = threeF(x);
            var o = threeF(stats.median);
            return {
                plots: ['radar', 'levels'],
                y1: r.y,
                y2: o.y,
                y1Title: survey.texts[lang].Widgets.OwnResultsLegend,
                y2Title: survey.texts[lang].Widgets.OthersResultsLegend,
                scoreDescription: survey.texts[lang].Widgets['OwnResultsText:' + r.bestMatch],
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                yLabels: {
                    'it': ['Fare', 'Fiducia', 'Futuro', 'Felicità'],
                    'en': ['Doer', 'Dreamer', 'Believer', 'Happiness']
                },
                radarLabels: {
                    'it': [
                        { name: 'Fare', anchor: 'top' },
                        { name: 'Fiducia', anchor: 'top' },
                        { name: 'Futuro', anchor: 'bottom' },
                        { name: 'Felicità', anchor: 'top' }
                    ],
                    'en': [
                        { name: 'Doer', anchor: 'top' },
                        { name: 'Dreamer', anchor: 'top' },
                        { name: 'Believer', anchor: 'bottom' },
                        { name: 'Happiness', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(253,137,114)',
                    'rgb(113,131,41)',
                    'rgb(254,201,68)'
                ],
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: Math.max.apply(Math, r.y.concat(o.y)),
                levelsPaddingLeft: 110
            };
        }
        case 'life-work': {
            var r = lifeWork(x);
            return {
                plots: ['image'],
                y1: r.y,
                scoreTitle: survey.texts[lang].Widgets.OwnResultsLegend + ' ' + r.y.toFixed(1),
                scoreDescription: getTextByMeanAndStd(lang, survey, r.y, lifeWork(stats.mean).y, lifeWork(stats.std).y),
                image: survey.themeParameters.ResultsImageName
            };
        }
        case 'art': {
            var r = art(x);
            return {
                plots: ['image'],
                y1: r.y,
                scoreTitle: survey.texts[lang].Widgets.OwnResultsLegend + ' ' + r.y.toFixed(1),
                scoreDescription: getTextByMeanAndStd(lang, survey, r.y, art(stats.mean).y, art(stats.std).y),
                image: survey.themeParameters.ResultsImageName
            };
        }
        case 'fake-news': {
            var r = fakeNews(x);
            return {
                plots: ['image'],
                y1: r.y,
                scoreTitle: survey.texts[lang].Widgets.OwnResultsLegend + ' ' + r.y.toFixed(0) + ' su 36',
                scoreDescription: getTextByResultRange(lang, survey, r.y),
                image: survey.themeParameters.ResultsImageName
            };
        }
        case 'partitometro': {
            var r = partitometro(x);
            var rankingsLabels = [];
            r.xy.forEach(function (x) {
                if (x.label == 'you') {
                    x.markerUrl = "https://graph.facebook.com/" + fbId + "/picture?type=large";
                }
                else {
                    x.markerUrl = "/_assets/resources/surveys/partitometro/" + x.label + ".png";
                }
            });
            r.rankings.forEach(function (x) {
                x.value = (x.value * 100).toFixed(2);
                x.markerUrl = "/_assets/resources/surveys/partitometro/" + x.label + ".png";
            });
            return {
                plots: ['rankings', 'scatter', 'podium', 'radar', 'levels'],
                y1: r.y1,
                y2: r.y2,
                xy: r.xy,
                y1Title: 'Le tue risposte',
                y2Title: 'Le risposte degli altri',
                scoreDescription: 'E infine, ecco chi sei e quali i tratti valoriali che ti contraddistinguono. Confrontati con gli altri rispondenti! Se vuoi saperne di più su ogni tratto, <a class="survey-info-link-inline" href="/it/partitometro/affinita">clicca qui.</a>',
                scatterDescription: 'Ecco il tuo posizionamento nella mappa di tutti i partiti. L’asse orizzontale indica lo spettro politico da sinistra a destra, l’asse verticale riflette la fiducia verso le istituzioni.',
                rankingsDescription: 'Qual è la tua percentuale di affinità con ogni partito?<br/><br/><br/>',
                podiumDescription: 'Ecco il podio dei 3 partiti più affini al tuo profilo di risposta.<br/><br/><br/>',
                note: '* Il simbolo di Liberi e Uguali indica il posizionamento degli elettori di LeU ma anche degli altri partiti di sinistra.',
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                rankingLabels: [
                    'PD',
                    'LEGA',
                    'SINISTRA',
                    'M5S',
                    'FI',
                    'FDI',
                    'DESTRA'
                ],
                yLabels: {
                    'it': [
                        'Tradizionalismo',
                        'Libertarismo',
                        'Accettazione',
                        'Egualitarismo',
                        'Potenza',
                        'Universalismo',
                        'Successo',
                        'Sicurezza',
                        'Fiducia'
                    ]
                },
                radarLabels: {
                    'it': [
                        { name: 'Tradizionalismo', anchor: 'top' },
                        { name: 'Libertarismo', anchor: 'top' },
                        { name: 'Accettazione', anchor: 'top' },
                        { name: 'Egualitarismo', anchor: 'bottom' },
                        { name: 'Potenza', anchor: 'bottom' },
                        { name: 'Universalismo', anchor: 'bottom' },
                        { name: 'Successo', anchor: 'bottom' },
                        { name: 'Sicurezza', anchor: 'top' },
                        { name: 'Fiducia', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(163,138,124)',
                    'rgb(253,103,84)',
                    'rgb(113,131,41)',
                    'rgb(84,171,174)',
                    'rgb(252,160,45)',
                    'rgb(106,181,252)',
                    'rgb(57,182,173)',
                    'rgb(253,137,114)'
                ],
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: 5,
                levelsRangeLabels: ['0', '5'],
                levelsPaddingLeft: 150,
                levelsRowHeight: 40,
                scatterBg: 'rgba(240, 191, 155,0.2)',
                scatterLink: 'partitometro-info',
                barChartHorizontalBg: 'rgba(240, 191, 155,0.2)',
                barChartHorizontalBarColor: 'rgb(254,196,82)',
                rankings: r.rankings,
                podium: r.podium,
                podiumBgColors: [
                    'rgba(240,191,155,0.5)',
                    'rgba(240,191,155,0.4)',
                    'rgba(240,191,155,0.3)'
                ],
                podiumLabelsColor: 'rgb(229,158,109)'
            };
        }
        case 'europartitometro': {
            var r = europartitometro(x);
            r.xy.forEach(function (x) {
                if (x.label == 'you') {
                    x.markerUrl = "https://graph.facebook.com/" + fbId + "/picture?type=large";
                }
                else {
                    x.markerUrl = "/_assets/resources/surveys/europartitometro/" + x.label + ".png";
                }
            });
            r.rankings.forEach(function (x) {
                x.value = (x.value * 100).toFixed(2);
                x.markerUrl = "/_assets/resources/surveys/europartitometro/" + x.label + ".png";
            });
            return {
                plots: ['scatter', 'rankings'],
                xy: r.xy,
                scatterDescription: 'Ecco il tuo posizionamento nella mappa di tutti i partiti.',
                rankingsDescription: 'Qual è la tua percentuale di affinità con ogni partito?',
                rankingLabels: [
                    'SINISTRA',
                    'PD',
                    'PIUEU',
                    'VERDI',
                    'M5S',
                    'FI',
                    'FDI',
                    'LEGA'
                ],
                scatterBg: '#F2F5F9',
                scatterLink: 'europartitometro-info',
                barChartHorizontalBg: '#F2F5F9',
                barChartHorizontalBarColor: '#FFD617',
                rankings: r.rankings
            };
        }
        default:
            return null;
    }
}


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_podium_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0975b952_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podium_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_podium_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0975b952_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podium_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0975b952_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podium_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"podium"},[_c('div',{staticClass:"second",style:(("background-color: " + (_vm.bgColors[1]) + ";"))},[_c('div',{staticClass:"value"},[_c('img',{attrs:{"src":_vm.values[1].markerUrl}})]),_vm._v(" "),_c('div',{staticClass:"label",style:(("color: " + _vm.labelsColor + ";"))},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"first",style:(("background-color: " + (_vm.bgColors[0]) + ";"))},[_c('div',{staticClass:"value"},[_c('img',{attrs:{"src":_vm.values[0].markerUrl}})]),_vm._v(" "),_c('div',{staticClass:"label",style:(("color: " + _vm.labelsColor + ";"))},[_vm._v("1\n            "),_c('img',{staticClass:"crown",attrs:{"src":"/_assets/resources/surveys/partitometro/podium_crown.svg"}})])]),_vm._v(" "),_c('div',{staticClass:"third",style:(("background-color: " + (_vm.bgColors[2]) + ";"))},[_c('div',{staticClass:"value"},[_c('img',{attrs:{"src":_vm.values[2].markerUrl}})]),_vm._v(" "),_c('div',{staticClass:"label",style:(("color: " + _vm.labelsColor + ";"))},[_vm._v("3")])])])}
var staticRenderFns = []


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results"},[_c('div',{class:("survey theme-color-" + (_vm.survey.slug))},[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-survey-title"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.getText(_vm.survey.texts, 'Title')))])])]),_vm._v(" "),_c('div',{staticClass:"c-survey-actions desktop-area"},[_c('div',{staticClass:"content"},[_c('button',{staticClass:"btn-ghost icon-before-share",attrs:{"type":"button"},on:{"click":_vm.onShare}},[_vm._v(_vm._s(_vm.$t('textShare')))]),_vm._v(" "),_c('router-link',{staticClass:"btn-ghost icon-before-survey",attrs:{"to":_vm.link('survey', { slug: _vm.routeSlug })}},[_vm._v(_vm._s(_vm.$t('textPlayAgain')))]),_vm._v(" "),_c('router-link',{staticClass:"btn-ghost icon-after-start",attrs:{"to":_vm.link('survey-chooser')}},[_vm._v(_vm._s(_vm.$t('textExplore')))])],1)])])])]),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"main-wrapper"},[_c('div',{class:['row', { 'image-layout': _vm.results.plots[0] == 'image' }]},[(_vm.showTexts)?_c('div',{staticClass:"c-text"},[_c('div',{staticClass:"content"},[(_vm.results.scoreTitle)?_c('h2',{staticClass:"score-title"},[_vm._v(_vm._s(_vm.results.scoreTitle))]):_vm._e(),_vm._v(" "),(_vm.plotDescription)?_c('h3',{staticClass:"score-description",domProps:{"innerHTML":_vm._s(_vm.plotDescription)}}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showActions)?_c('div',{staticClass:"c-actions"},[_c('div',{staticClass:"content"},[_c('button',{staticClass:"btn-prev-extended",attrs:{"disabled":_vm.disablePrev},on:{"click":_vm.onPrev}},[_vm._v(_vm._s(_vm.$t('actionPrev')))]),_vm._v(" "),_c('span',{staticClass:"counter"},[_vm._v(_vm._s(_vm.itemIndex + 1)+" / "+_vm._s(_vm.results.plots.length))]),_vm._v(" "),_c('button',{staticClass:"btn-next-extended",attrs:{"disabled":_vm.disableNext},on:{"click":_vm.onNext}},[_vm._v(_vm._s(_vm.$t('actionNext')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-chart"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"chart-container"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},_vm._l((_vm.results.plots),function(plot){return (_vm.isItemVisible(plot))?_c('div',{key:plot,staticClass:"chart"},[(plot == 'image')?_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":("/_assets/resources/results/" + (_vm.results.image))}})]):(plot == 'radar')?_c('div',{staticClass:"radar-chart-container"},[_c('radar-chart',{attrs:{"diameter":350,"values":[_vm.results.y2, _vm.results.y1],"shapeColors":_vm.results.radarShapeColors,"markersColors":_vm.results.radarLabelColors,"valuesLabels":_vm.results.radarLabels[_vm.lang]}}),_vm._v(" "),(_vm.results.y2Title)?_c('div',{staticClass:"legend-container"},[_c('div',{staticClass:"legend"},[_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"color",style:(("background-color: " + (_vm.results.y1LegendColor) + ";"))}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.results.y1Title))])]),_vm._v(" "),_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"color",style:(("background-color: " + (_vm.results.y2LegendColor) + ";"))}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.results.y2Title))])])])]):_vm._e()],1):(plot == 'radar-filters')?_c('div',{staticClass:"radar-chart-container"},[_c('radar-chart',{attrs:{"diameter":350,"values":[_vm.fakeFilterResults, _vm.results.y1],"shapeColors":_vm.results.radarShapeColors,"markersColors":_vm.results.radarLabelColors,"valuesLabels":_vm.results.radarLabels[_vm.lang]}}),_vm._v(" "),_c('div',{staticClass:"legend-container"},[_c('div',{staticClass:"legend"},[_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"color",style:(("background-color: " + (_vm.results.y1LegendColor) + ";"))}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.results.y1Title))])]),_vm._v(" "),_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"color",style:(("background-color: " + (_vm.results.y2LegendColor) + ";"))}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.results.y2FiltersTitle[_vm.lang]))])])]),_c('div',{staticClass:"filters"},[_c('div',{staticClass:"filter-item"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.results.ageFilter[_vm.lang].title))]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ageRange1),expression:"ageRange1"}],attrs:{"type":"checkbox","id":"age-range-1","name":"age-range-1","value":"18-24"},domProps:{"checked":Array.isArray(_vm.ageRange1)?_vm._i(_vm.ageRange1,"18-24")>-1:(_vm.ageRange1)},on:{"change":function($event){var $$a=_vm.ageRange1,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="18-24",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ageRange1=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ageRange1=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ageRange1=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"label",attrs:{"for":"age-range-1"}},[_vm._v(_vm._s(_vm.results.ageFilter[_vm.lang].ageRange1))])]),_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ageRange2),expression:"ageRange2"}],attrs:{"type":"checkbox","id":"age-range-2","name":"age-range-2","value":"25-29"},domProps:{"checked":Array.isArray(_vm.ageRange2)?_vm._i(_vm.ageRange2,"25-29")>-1:(_vm.ageRange2)},on:{"change":function($event){var $$a=_vm.ageRange2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="25-29",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ageRange2=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ageRange2=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ageRange2=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"label",attrs:{"for":"age-range-2"}},[_vm._v(_vm._s(_vm.results.ageFilter[_vm.lang].ageRange2))])]),_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ageRange3),expression:"ageRange3"}],attrs:{"type":"checkbox","id":"age-range-3","name":"age-range-3","value":"30+"},domProps:{"checked":Array.isArray(_vm.ageRange3)?_vm._i(_vm.ageRange3,"30+")>-1:(_vm.ageRange3)},on:{"change":function($event){var $$a=_vm.ageRange3,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="30+",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ageRange3=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ageRange3=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ageRange3=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"label",attrs:{"for":"age-range-3"}},[_vm._v(_vm._s(_vm.results.ageFilter[_vm.lang].ageRange3))])])])]),_c('div',{staticClass:"filter-item"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.results.genderFilter[_vm.lang].title))]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender1),expression:"gender1"}],attrs:{"type":"checkbox","id":"gender-1","name":"gender-1","value":"male"},domProps:{"checked":Array.isArray(_vm.gender1)?_vm._i(_vm.gender1,"male")>-1:(_vm.gender1)},on:{"change":function($event){var $$a=_vm.gender1,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="male",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.gender1=$$a.concat([$$v]))}else{$$i>-1&&(_vm.gender1=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.gender1=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"label",attrs:{"for":"gender-1"}},[_vm._v(_vm._s(_vm.results.genderFilter[_vm.lang].gender1))])]),_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender2),expression:"gender2"}],attrs:{"type":"checkbox","id":"gender-2","name":"gender-2","value":"female"},domProps:{"checked":Array.isArray(_vm.gender2)?_vm._i(_vm.gender2,"female")>-1:(_vm.gender2)},on:{"change":function($event){var $$a=_vm.gender2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="female",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.gender2=$$a.concat([$$v]))}else{$$i>-1&&(_vm.gender2=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.gender2=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"label",attrs:{"for":"gender-2"}},[_vm._v(_vm._s(_vm.results.genderFilter[_vm.lang].gender2))])])])])])])],1):(plot == 'levels')?_c('div',{staticClass:"vertical-line-chart-container"},[_c('vertical-line-chart',{attrs:{"values":_vm.resultsY,"height":_vm.levelsChartHeight,"paddingLeft":_vm.results.levelsPaddingLeft,"valuesLabelsText":_vm.results.yLabels[_vm.lang],"valuesColor":_vm.results.levelsLineColors,"rangeLabels":_vm.results.levelsRangeLabels,"rangeMin":_vm.results.levelsRangeMin,"rangeMax":_vm.results.levelsRangeMax}}),_vm._v(" "),(_vm.results.y2Title)?_c('div',{staticClass:"legend"},[_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"color",style:(("background-color: " + (_vm.results.y1LegendColor) + ";"))}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.results.y1Title))])]),_vm._v(" "),_c('div',{staticClass:"legend-item"},[_c('div',{staticClass:"color",style:(("background-color: " + (_vm.results.y2LegendColor) + ";"))}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.results.y2Title))])])]):_vm._e()],1):(plot == 'scatter')?_c('div',{staticClass:"scatter-plot-container"},[(_vm.results.scatterLink)?_c('router-link',{staticClass:"survey-info-link",attrs:{"to":_vm.partitometroLink}},[_vm._v("Come funziona?")]):_vm._e(),_vm._v(" "),_c('scatter-plot',{attrs:{"width":665,"height":458,"values":_vm.results.xy,"markerWidth":_vm.isMobile ? 40 : 64,"bgColor":_vm.results.scatterBg}}),_vm._v(" "),(_vm.results.note)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-note"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.results.note)}})])]):_vm._e()],1):(plot == 'podium')?_c('div',{staticClass:"podium-container"},[_c('podium',{attrs:{"values":_vm.results.podium,"bgColors":_vm.results.podiumBgColors,"labelsColor":_vm.results.podiumLabelsColor}}),_vm._v(" "),(_vm.results.note)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-note"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.results.note)}})])]):_vm._e()],1):(plot == 'rankings')?_c('div',{staticClass:"rankings-container"},[_c('bar-chart-horizontal',{attrs:{"points":_vm.results.rankings,"showMarkers":true,"bgColor":_vm.results.barChartHorizontalBg,"barColor":_vm.results.barChartHorizontalBarColor,"paddingTop":30,"paddingBottom":30,"paddingLeft":_vm.isMobile ? 75 : 90,"barGaps":25,"pointsLabelsImageSize":_vm.isMobile ? 40 : 50}}),_vm._v(" "),(_vm.results.note)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-note"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.results.note)}})])]):_vm._e()],1):_vm._e()]):_vm._e()}))],1)])])])]):_vm._e(),_vm._v(" "),_c('div',{class:("survey theme-color-" + (_vm.survey.slug) + " mobile-area")},[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-survey-actions"},[_c('div',{staticClass:"content"},[_c('button',{staticClass:"btn-ghost icon-before-share",on:{"click":_vm.onShare}},[_vm._v(_vm._s(_vm.$t('textShare')))]),_vm._v(" "),_c('router-link',{staticClass:"btn-ghost icon-before-survey",attrs:{"to":_vm.link('survey', { slug: _vm.routeSlug })}},[_vm._v(_vm._s(_vm.$t('textPlayAgain')))]),_vm._v(" "),_c('router-link',{staticClass:"btn-ghost icon-after-start",attrs:{"to":_vm.link('survey-chooser')}},[_vm._v(_vm._s(_vm.$t('textExplore')))])],1)])])])])])}
var staticRenderFns = []


/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"textShare":"Condividi su Facebook","textExplore":"Altri questionari","textPlayAgain":"Riprova","levelsRangeMin":"poco","levelsRangeMax":"molto","actionPrev":"Precedente","actionNext":"Successivo"},"en":{"textShare":"Share on Facebook","textExplore":"More questionnaires","textPlayAgain":"Replay","levelsRangeMin":"few","levelsRangeMax":"much","actionPrev":"Previous","actionNext":"Next"}}')
}


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partitometro_info_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdca487_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partitometro_info_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partitometro_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdca487_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partitometro_info_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdca487_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partitometro_info_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-info"},[_c('div',{staticClass:"popup-header"},[_c('div',{staticClass:"main-wrapper"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.onCloseClick()}}},[_vm._v("×")])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper narrow"},[_c('h1',{staticClass:"title"},[_vm._v("Partitometro")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Cos'è")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Si tratta di un test che aiuta a capire quali partiti/movimenti, tra quelli principali che si presentano alle imminenti elezioni, sono più vicini ai propri tratti valoriali, morali, etici, comportamentali e psicologici. Consiste, di fatto, in una misura di orientamento al voto in base a domande scientificamente validate sui “"),_c('em',[_vm._v("core political values")]),_vm._v("”."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n            Gli utenti rispondono a 15 domande e il risultato viene proiettato in una mappa in due dimensioni in cui sono collocati i diversi partiti. I partiti risultano posizionati sulla base delle risposte alle 15 domande fornite da un campione rappresentativo di oltre 5000 giovani in età 18-35 anni. Il posizionamento è stato poi successivamente testato anche sugli over 35. Il test aiuta a individuare le differenze tra i partiti sulla base dei tratti valoriali che li contraddistinguono, con un approccio scientifico e metodologicamente validato dal Laboratorio di statistica applicata dell’Università Cattolica del Sacro Cuore di Milano e dall’Osservatorio giovani dell’Istituto Toniolo.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Cosa non è")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Il test non è un sondaggio e non ha fini di previsione dell’esito delle elezioni.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Le domande poste")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Un’ampia e consolidata letteratura scientifica mostra come sul processo decisionale del voto agisca un insieme di dimensioni psicologiche, valoriali, morali, etiche e comportamentali. Shalom Schwartz nel 1992 ha validato una scala a 41 item che misura i “"),_c('em',[_vm._v("Core Political Values")]),_vm._v("”, ovvero quei tratti e valori che hanno un ruolo di rilievo nel descrivere le peculiarità dei diversi schieramenti politici e che guidano l’elettore spesso più dei contenuti specifici del programma elettorale contingente. Tale approccio è stato poi adattato e aggiornato per l’Italia da Vittorio Caprara (2006). Il modello utilizzato è quello prototipico dei sistemi valoriali di Schwartz e Caprara, completato con qualche domanda costruita ad hoc, più vicina alla scena politica italiana contemporanea.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Metodologia")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            La mappa di posizionamento dei partiti è stata realizzata mediante una "),_c('em',[_vm._v("Categorical Principal Components Analysis")]),_vm._v(" sulle dimensioni di interesse e rappresenta, in uno spazio bi-dimensionale, il posizionamento dei partiti rispetto a specifici tratti valoriali. È importante sottolineare che la “mappa” non posiziona il partito in sé, quanto il profilo degli elettori di un certo partito dal momento che è realizzata sulle risposte dei cittadini con diritto di voto e non teoricamente sulle opinioni di esperti o sulle indicazioni di esponenti/leader delle forze politiche. Il posizionamento dell’utente è dato da una combinazione lineare delle risposte standardizzate su scala z (pesate per i baricentri degli item nelle due dimensioni) e indica la prossimità/affinità del rispondente con il profilo dell’elettore tipo di ciascun partito/movimento.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Campione")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Il modello "),_c('em',[_vm._v("Categorical Principal Components Analysis")]),_vm._v(" è stato stimato a partire dai dati di un campione rappresentativo di oltre 5000 giovani italiani di età compresa tra i 18 e i 35 anni dell’indagine Rapporto Giovani 2017, di cui circa 4500 usati come training set e 500 come test set per un’ulteriore ponderazione delle risposte, al fine di massimizzare l’efficienza del modello.\n        ")])])}]


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partitometro_affinita_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b01282f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partitometro_affinita_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partitometro_affinita_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b01282f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partitometro_affinita_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b01282f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partitometro_affinita_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-info"},[_c('div',{staticClass:"popup-header"},[_c('div',{staticClass:"main-wrapper"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.onCloseClick()}}},[_vm._v("×")])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper narrow"},[_c('h1',{staticClass:"title"},[_vm._v("Partitometro")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Tratti valoriali")]),_vm._v(" "),_c('p',{staticClass:"text spaced"},[_c('strong',[_vm._v("Tradizionalismo")]),_vm._v(" = rispetto e accettazione delle tradizioni"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Libertarismo")]),_vm._v(" = Atteggiamento libertario e liberale"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Accettazione")]),_vm._v(" = Accettazione degli immigrati"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Egualitarismo")]),_vm._v(" = Uguaglianza di tutti gli esseri umani"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Potenza")]),_vm._v(" = status sociale e prestigio"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Universalismo")]),_vm._v(" = rispetto e protezione degli uomini e della natura"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Successo")]),_vm._v(" = successo personale"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Sicurezza")]),_vm._v(" = incolumità e stabilità della società e della propria persona"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Fiducia")]),_vm._v(" = Fiducia nelle Istituzioni\n        ")])])}]


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_europartitometro_info_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66089a1a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_europartitometro_info_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_europartitometro_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66089a1a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_europartitometro_info_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66089a1a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_europartitometro_info_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-info"},[_c('div',{staticClass:"popup-header"},[_c('div',{staticClass:"main-wrapper"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.onCloseClick()}}},[_vm._v("×")])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper narrow"},[_c('h1',{staticClass:"title"},[_vm._v("EuroPartitometro")]),_vm._v(" "),_c('h3',{staticClass:"subtitle"},[_vm._v("Valuta la tua vicinanza al profilo di elettore dei principali simboli in campo per le elezioni europee")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Cos'è")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            L’EuroPartitometro non è un test sul gradimento delle forze politiche, indica piuttosto la vicinanza del rispondente al profilo di elettore dei vari partiti/movimenti costruito su un set di domande (relative a dimensioni valoriali, psicologiche e comportamentali, oltre che a opinioni su temi rilevanti del dibattito pubblico). Consente quindi di individuare quanto l’insieme delle risposte date sia prossimo a quello che caratterizza gli elettori che si riconoscono nelle principali forze in campo alle elezioni europee del 26 maggio 2019. I simboli presi in considerazione sono quelli che secondo i sondaggi più accreditati ottengono una intenzione di voto superiore a 1,5% e per i quali è stato possibile costruire profili con certa robustezza statistica. Si tratta in particolare di: Lega, Movimento 5 stelle, Partito democratico, Forza Italia, Fratelli d’Italia, +Europa, La sinistra, Europa verde. Va quindi ribadito che non si tratta di un test completo su tutti i partiti/movimenti, ma consente al singolo rispondente di vedere, qualsiasi sia la sua intenzione di voto (compresa l’astensione), quanto sui temi proposti egli abbia una posizione più o meno simile ai potenziali votanti dei simboli sopra elencati."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n            Gli utenti rispondono a 15 domande e il risultato viene sintetizzato in una mappa in due dimensioni. Il posizionamento dell’utente stabilisce la vicinanza/lontananza dai simboli (che risultano posizionati sulla base delle risposte alle 15 domande fornite da un campione rappresentativo di oltre 1500 cittadini in età 18-35 anni). Il posizionamento è stato poi successivamente testato anche sugli over 35. L’EuroPartitometro aiuta a individuare le differenze tra gli elettori dei partiti sulla base dei tratti che li contraddistinguono, con un approccio metodologicamente validato dall’Osservatorio Giovani dell’Istituto Toniolo.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Cosa non è")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Il test non è un sondaggio e non ha fini di previsione dell’esito delle elezioni. \n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Le domande poste")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            Un’ampia e consolidata letteratura scientifica mostra come sul processo decisionale del voto agisca un insieme di dimensioni psicologiche, valoriali, morali, etiche e comportamentali. Shalom Schwartz nel 1992 ha validato una scala a 41 item che misura i «"),_c('em',[_vm._v("Core Political Values")]),_vm._v("», ovvero quei tratti e valori che hanno un ruolo di rilievo nel descrivere le peculiarità dei diversi schieramenti politici e che guidano l’elettore spesso più dei contenuti specifici del programma elettorale contingente. Tale approccio è stato poi adattato e aggiornato per l’Italia da Vittorio Caprara (2006). Il modello di base utilizzato è quello prototipico dei sistemi valoriali di Schwartz e Caprara, completato con una serie di domande costruite ad hoc e scelte tra circa 80 quesiti testati possibili, più vicine alla scena politica italiana contemporanea e maggiormente discriminanti per la caratterizzazione delle diverse forze politiche.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Metodologia")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            la distanza tra l’utente e ogni partito è determinata da una mappa di posizionamento dei partiti, realizzata mediante una "),_c('em',[_vm._v("Categorical Principal Components Analysis")]),_vm._v(" sulle dimensioni di interesse. La mappa rappresenta, in uno spazio bi-dimensionale, il posizionamento dei partiti rispetto a specifici tratti. È importante sottolineare che la “distanza” non è da intendersi tra l’utente e il partito in sé, quanto tra l’utente e il profilo medio degli elettori che si riconoscono nel partito, dal momento che è realizzata sulle risposte dei cittadini con diritto di voto e non sulle opinioni di esperti, o desunte dai programmi dei partiti, o sulle indicazioni di esponenti/leader delle forze politiche. Il posizionamento dell’utente è dato da una combinazione lineare delle risposte standardizzate su scala z (pesate per i baricentri degli item nelle due dimensioni) e indica la prossimità/affinità del rispondente con il profilo dell’elettore tipo di ciascun partito/movimento. In tal senso il modello è totalmente "),_c('em',[_vm._v("data-driven")]),_vm._v(", e non è guidato da nessun elemento di soggettività.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Il campione di base")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            il modello "),_c('em',[_vm._v("Categorical Principal Components Analysis")]),_vm._v(" è stato stimato a partire dai dati di un campione rappresentativo di oltre 1500 giovani italiani di età compresa tra i 18 e i 35 anni. I dati sono stati raccolti all’interno di un’indagine condotta da Ipsos per l’Osservatorio Giovani tra il 30 aprile e il 3 maggio 2019. 1400 soggetti sono stati usati come training set e 100 come test set. Inoltre il modello è stato testato su circa 100 elettori di differenti età per un’ulteriore ponderazione delle risposte, al fine di massimizzare l’efficienza della previsione. \n        ")]),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('p',{staticClass:"text"},[_c('strong',[_vm._v("Andrea Bonanomi")]),_c('br'),_vm._v("\n            Ricercatore di Statistica Sociale"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Facoltà Di Psicologia, Università Cattolica del Sacro Cuore di Milano")])]),_vm._v(" "),_c('p',{staticClass:"text"},[_c('strong',[_vm._v("Alessandro Rosina")]),_c('br'),_vm._v("\n            Professore Ordinario di Statistica Sociale e Demografia"),_c('br'),_vm._v(" "),_c('em',[_vm._v("Facoltà di Economia, Università Cattolica del Sacro Cuore di Milano")])])])}]


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page404_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc8b01e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page404_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc8b01e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page404_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc8b01e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page404_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(133)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"error-code"},[_vm._v(_vm._s(_vm.$t('errorCode')))]),_vm._v(" "),_c('p',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.$t('errorMessage')))]),_vm._v(" "),_c('router-link',{staticClass:"btn-ghost icon-after-start",attrs:{"to":_vm.link('survey-chooser')}},[_vm._v(_vm._s(_vm.$t('actionText')))])],1)])}
var staticRenderFns = []


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"errorCode":"Errore 404","errorMessage":"Ops, qualcosa è andato storto.","actionText":"Torna alla home"},"en":{"errorCode":"Error 404","errorMessage":"Ops, something went wrong.","actionText":"Back to home"}}')
}


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initDetector;
function initDetector(callback) {
    var detector = document.createElement('div');
    detector.id = 'detector';
    document.body.appendChild(detector);
    var oldW = -1;
    function detect() {
        var w = detector.clientWidth;
        if (w != oldW) {
            oldW = w;
            callback(w);
        }
    }
    window.addEventListener('resize', detect);
    detect();
}


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = {"it":{},"en":{}}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js